export const pirithData = {
    "02-saranagamanam": {
        "labels": [
            [
                0.306631,
                8.202377
            ],
            [
                8.611218,
                16.788042
            ],
            [
                17.222436,
                26.319153
            ],
            [
                27.647887,
                34.138242
            ],
            [
                34.700398,
                41.369621
            ],
            [
                41.752909,
                48.601
            ],
            [
                48.984288,
                57.161113
            ],
            [
                57.544401,
                65.440147
            ],
            [
                65.848989,
                74.230234
            ],
            [
                74.639075,
                82.764794
            ],
            [
                83.199188,
                91.197144
            ],
            [
                91.605985,
                100.038335
            ]
        ],
        "text": [
            [
                {
                    "pali": "නමො තස්ස භගවතො අරහතො සම්මා සම්බුද්ධස්ස",
                    "sinh": "ඒ භාග්‍යවත් අර්හත් සම්මා සම්බුදුරජාණන් වහන්සේට නමස්කාර වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නමො තස්ස භගවතො අරහතො සම්මා සම්බුද්ධස්ස",
                    "sinh": "ඒ භාග්‍යවත් අර්හත් සම්මා සම්බුදුරජාණන් වහන්සේට නමස්කාර වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නමො තස්ස භගවතො අරහතො සම්මා සම්බුද්ධස්ස",
                    "sinh": "ඒ භාග්‍යවත් අර්හත් සම්මා සම්බුදුරජාණන් වහන්සේට නමස්කාර වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බුද්ධං සරණං ගච්ඡාමි.",
                    "sinh": "බුදුන් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ධම්මං සරණං ගච්ඡාමි.",
                    "sinh": "දහම් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සංඝං සරණං ගච්ඡාමි.",
                    "sinh": "සඟුන් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දුතියම්පි බුද්ධං සරණං ගච්ඡාමි.",
                    "sinh": "දෙවනුව ද බුදුන් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දුතියම්පි ධම්මං සරණං ගච්ඡාමි.",
                    "sinh": "දෙවනුව ද දහම් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දුතියම්පි සංඝං සරණං ගච්ඡාමි.",
                    "sinh": "දෙවනුව ද සඟුන් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තතියම්පි බුද්ධං සරණං ගච්ඡාමි.",
                    "sinh": "තෙවනුව ද බුදුන් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තතියම්පි ධම්මං සරණං ගච්ඡාමි.",
                    "sinh": "තෙවනුව ද දහම් සරණ කොට යමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තතියම්පි සංඝං සරණං ගච්ඡාමි.",
                    "sinh": "තෙවනුව ද සඟුන් සරණ කොට යමි.",
                    "span": 1
                }
            ]
        ]
    },
    "03-dasasikkhapadani": {
        "labels": [
            [
                0.464348,
                9.095761
            ],
            [
                9.560109,
                17.699859
            ],
            [
                18.191522,
                26.877563
            ],
            [
                27.369226,
                35.345088
            ],
            [
                35.809436,
                47.554713
            ],
            [
                48.019061,
                56.404642
            ],
            [
                56.868991,
                68.614267
            ],
            [
                69.297132,
                84.32016
            ],
            [
                85.38543,
                95.19137
            ],
            [
                95.683033,
                106.882017
            ]
        ],
        "text": [
            [
                {
                    "pali": "පාණාතිපාතා",
                    "sinh": "ප්‍රාණඝාතයෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අදින්නාද‍ානා",
                    "sinh": "නුදුන් දෙය ගැනීමෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අබ්‍රහ්මචරියා",
                    "sinh": "අබ්‍රහ්මචරියාවෙන් (මෙවුන්දමෙහි හැසිරීමෙන්)",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මුසාවාද‍ා",
                    "sinh": "මුසාවාදයෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුරාමෙරය මජ්ජපමාදට්ඨානා",
                    "sinh": "මදයට හා ප්‍රමාදයට කාරණ වූ රහමෙරින්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විකාලභොජනා",
                    "sinh": "විකල් බොජුනෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නච්ච ගීත වාදිත විසූක දස්සනා",
                    "sinh": "නැටීම, ගැයීම, වැයීම, විසුලු බැලීම යන මෙයින්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මාලා ගන්ධවිලේපන ධාරණ මණ්ඩන විභූසනට්ඨානා",
                    "sinh": "මල්, ගඳ, විලවුන් ද‍ැරීම, සැරසීම, වෙසෙසින් සැරසීම යන කාරණයෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උච්චාසයන මහාසයනා",
                    "sinh": "උසසුන් මහ අස්නෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජාතරූප රජත පටිග්ගහණා",
                    "sinh": "රන්, රිදී, මසු, කහවණු පිළිගැනීමෙන්",
                    "span": 1
                },
                {
                    "pali": "වෙරමණී සික්ඛාපදං",
                    "sinh": "වැළකීමේ ශික්ෂා පදය",
                    "span": 1
                }
            ]
        ]
    },
    "04-samanera-panha": {
        "labels": [
            [
                0.511942,
                12.684794
            ],
            [
                13.253619,
                22.354816
            ],
            [
                22.8952,
                31.512896
            ],
            [
                32.024839,
                43.145364
            ],
            [
                43.571983,
                53.441094
            ],
            [
                53.924595,
                64.931356
            ],
            [
                65.301092,
                74.203201
            ],
            [
                74.629819,
                85.494374
            ],
            [
                85.892551,
                94.652454
            ],
            [
                95.079072,
                111.205257
            ]
        ],
        "text": [
            [
                {
                    "pali": "එක නාම කිං?",
                    "sinh": "(මේ සසුනෙහි) එක නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "සබ්බේ සත්තා",
                    "sinh": "හැම සත්හු",
                    "span": 1
                },
                {
                    "pali": "ආහාරට්ඨිතිකා",
                    "sinh": "ආහාර හේතුවෙන් සිටිති",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ද්වෙ නාම කිං?",
                    "sinh": "දෙක නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "නාමඤ්ච රූපඤ්ච",
                    "sinh": "නාමය හා රූපයයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තීණි නාම කිම?",
                    "sinh": "තුන නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "තිස්සෝ වෙදනා",
                    "sinh": "(සුඛ, දූඃඛ, උපෙක්ෂා යන) තුන් වෙදනාවෝ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චත්තාරි නාම කිං?",
                    "sinh": "සතර නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "චත්තාරි අරිය සච්චානි",
                    "sinh": "(දූඃඛ, සමුදය, නිරොධ, මාර්ග යන) සතර ආර්ය සත්‍යයෝ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පඤ්ච නාම කිං?",
                    "sinh": "පස නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "පඤ්චුපාද‍ානක්ඛන්ධා",
                    "sinh": "(රූප, වෙදනා, සංඥා, සංස්කාර, විඥාන යන) පස් උපාද‍ානස්කන්ධයෝ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඡනාම කිං?",
                    "sinh": "සය නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "ඡඅඡ්ඣත්තිකානි ආයතනානි",
                    "sinh": "(චක්ඛු, සොත, ඝාන, ජිව්හා, කාය, මන යන) ආධ්‍යාත්මික ආයතනයෝ සය ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සත්ත නාම කිං?",
                    "sinh": "සත නම්?",
                    "span": 1
                },
                {
                    "pali": "සත්‌ත බොජ්‌ඣඞ්‌ගා",
                    "sinh": "(සති, ධම්මවිචය, පීති, විරිය, පස්සද්ධි, සමාධි, උපෙක්ඛා යන) බොජ්ඣඞ්ග සත ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අට්ඨ නාම කිං?",
                    "sinh": "අට නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "අරියො අට්ඞ්ගිකො මග්ගො",
                    "sinh": "(සම්මාදිට්ඨි, සම්මාසඬ්කප්ප, සම්මාවාචා, සම්මාකම්මන්ත, සම්මාආජීව, සම්මාවායාම, සම්මාසති, සම්මාසාමාධි යන) අරි අටඟි මග ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නව නාම කිං?",
                    "sinh": "නවය නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "නව සත්‌තාවාසා",
                    "sinh": "(නානත්තකාය නානත්තසඤ්ඤි ය, නානත්තකාය එකත්තසඤ්ඤි ය, එකත්තකාය නානත්තසඤ්ඤි ය, එකත්තකාය එකත්තසඤ්ඤි ය, අසඤ්ඤි ය, අකාසානඤ්චායතනූපග ය, විඤ්ඤාණඤ්චායතනූපග ය, ආකිඤ්චඤ්ඤායතනූපග ය, නෙවසඤ්ඤානාසඤ්ඤායතනූපග ය යන) සත්තාවාස නවය ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දස නාම කිං?",
                    "sinh": "දස නම් කිම?",
                    "span": 1
                },
                {
                    "pali": "දසහඞ්ගෙහි",
                    "sinh": "(අසෙඛ සම්මාදිට්ඨි ය, අසෙඛ සම්මාසඬ්කප්ප ය, අසෙඛ සම්මාවාචා, අසෙඛ සම්මාකම්මන්ත ය, අසෙඛ සම්මාආජීව ය, අසෙඛ සම්මාවායාම ය, අසෙඛ සම්මාසති ය, අසෙඛ සම්මාසාමාධි ය, අසෙඛ සම්මාඤාණ ය, අසෙඛ සම්මාවිමුත්තිය යන) දසඟින්",
                    "span": 1
                },
                {
                    "pali": "සමන්නාගතො",
                    "sinh": "යුක්ත වූයේ",
                    "span": 1
                },
                {
                    "pali": "අරහාති",
                    "sinh": "අරහත්ය යි",
                    "span": 1
                },
                {
                    "pali": "වුච්චතීති",
                    "sinh": "කියනු ලැබේ.",
                    "span": 1
                }
            ]
        ]
    },
    "05-dvattimsakaraya": {
        "labels": [
            [
                0.69428,
                13.759374
            ],
            [
                14.138072,
                24.646952
            ],
            [
                24.930976,
                35.313623
            ],
            [
                35.818554,
                44.591733
            ],
            [
                44.970431,
                55.289961
            ],
            [
                55.66866,
                67.692333
            ]
        ],
        "text": [
            [
                {
                    "pali": "අත‍්ථි",
                    "sinh": "ඇත.",
                    "span": 1
                },
                {
                    "pali": "ඉමස්මිං කායෙ",
                    "sinh": "මේ සිරුරෙහි",
                    "span": 1
                },
                {
                    "pali": "කෙසා",
                    "sinh": "කේසයෝ ය",
                    "span": 1
                },
                {
                    "pali": "ලොමා",
                    "sinh": "ලෝම‍යෝ ය",
                    "span": 1
                },
                {
                    "pali": "නඛා",
                    "sinh": "නිය ය",
                    "span": 1
                },
                {
                    "pali": "දන්තා",
                    "sinh": "දත් ය",
                    "span": 1
                },
                {
                    "pali": "තචො",
                    "sinh": "සම ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මංසං",
                    "sinh": "මස් ය",
                    "span": 1
                },
                {
                    "pali": "නහාරු",
                    "sinh": "නහර ය",
                    "span": 1
                },
                {
                    "pali": "අට්ඨි",
                    "sinh": "ඇට ය",
                    "span": 1
                },
                {
                    "pali": "අට්ඨිමිඤ්ජා",
                    "sinh": "ඇටමිදුලු ය",
                    "span": 1
                },
                {
                    "pali": "වක්කං",
                    "sinh": "වකුගඩුව ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "හදයං",
                    "sinh": "හෘදය මාංස ය",
                    "span": 1
                },
                {
                    "pali": "යකනං",
                    "sinh": "අක්මාව ය",
                    "span": 1
                },
                {
                    "pali": "කිලොමකං",
                    "sinh": "දලබුව ය",
                    "span": 1
                },
                {
                    "pali": "පිහකං",
                    "sinh": "බඩදිව ය",
                    "span": 1
                },
                {
                    "pali": "පප්ඵාසං",
                    "sinh": "පපුව (පපුමස) ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අන්තං",
                    "sinh": "බඩවැල ය",
                    "span": 1
                },
                {
                    "pali": "අන්තගුණං",
                    "sinh": "අතුණු බහන් ය",
                    "span": 1
                },
                {
                    "pali": "උදරියං",
                    "sinh": "(නොපැසුණු අහරය) උදරිය ය",
                    "span": 1
                },
                {
                    "pali": "කරිසං",
                    "sinh": "අහර මල ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පිත්තං",
                    "sinh": "පිත ය",
                    "span": 1
                },
                {
                    "pali": "සෙම්හං",
                    "sinh": "සෙම ය",
                    "span": 1
                },
                {
                    "pali": "පුබ්බො",
                    "sinh": "(සැරවය) පූයා ය",
                    "span": 1
                },
                {
                    "pali": "ලොහිතං",
                    "sinh": "ලෙහෙ ය",
                    "span": 1
                },
                {
                    "pali": "සොද‍ො",
                    "sinh": "සෝදිය ය",
                    "span": 1
                },
                {
                    "pali": "මෙද‍ො",
                    "sinh": "මේද ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අස්සු",
                    "sinh": "කඳුලු ය",
                    "span": 1
                },
                {
                    "pali": "වසා",
                    "sinh": "වුරුණු ය",
                    "span": 1
                },
                {
                    "pali": "ඛෙලො",
                    "sinh": "කෙළ ය",
                    "span": 1
                },
                {
                    "pali": "සිංඝානිකා",
                    "sinh": "මුකුණු ය (සොටු ය)",
                    "span": 1
                },
                {
                    "pali": "ලසිකා",
                    "sinh": "සඳමිදුලු ය",
                    "span": 1
                },
                {
                    "pali": "මුත්තං",
                    "sinh": "මූත්‍ර ය",
                    "span": 1
                },
                {
                    "pali": "මත්ථකෙ",
                    "sinh": "හිස මුදුනෙහි",
                    "span": 1
                },
                {
                    "pali": "මත්ථලුඞ්ගන්ති",
                    "sinh": "හිස් මොලය යි යන මේ දෙතිස් කුණපයෝ",
                    "span": 1
                }
            ]
        ]
    },
    "06-paccavekkhana": {
        "labels": [
            [
                0,
                46.414089,
                1
            ],
            [
                46.414089,
                116.626903,
                2
            ],
            [
                116.626903,
                166.459593,
                3
            ],
            [
                166.459593,
                202.486393,
                4
            ]
        ],
        "text": [
            [
                {
                    "pali": "පටිසංඛායොනිසො",
                    "sinh": "නුවණින් මෙනෙහි කොට",
                    "span": 1
                },
                {
                    "pali": "චීවරං පටිසේවාමි",
                    "sinh": "සිවුරු පරිභෝග කරමි.",
                    "span": 1
                },
                {
                    "pali": "යාවදෙව",
                    "sinh": "යම්තාක්",
                    "span": 1
                },
                {
                    "pali": "සීතස්ස පටිඝාතාය",
                    "sinh": "සීත නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "උණ්හසස පටිඝාතාය",
                    "sinh": "උෂ්ණ නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "ඩංස",
                    "sinh": "ඩැහ ලේ බොන මැසි ය (ඇටමැසිය)",
                    "span": 1
                },
                {
                    "pali": "මකස",
                    "sinh": "මදුරු ය",
                    "span": 1
                },
                {
                    "pali": "වාතා’තප",
                    "sinh": "වාතය, අවුව ය",
                    "span": 1
                },
                {
                    "pali": "සිරිංසප",
                    "sinh": "සිරිංසප ය (සර්පයෝ ය) යන මොවුන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සම්ඵස්සානං",
                    "sinh": "ස්පර්ශය",
                    "span": 1
                },
                {
                    "pali": "පටිඝාතාය",
                    "sinh": "නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "යාවදෙව",
                    "sinh": "යම්තාක්",
                    "span": 1
                },
                {
                    "pali": "හිරිකොපීන",
                    "sinh": "ලජ්ජා කෝපන ස‍්ථානය (ලැජ්ජා නසන තැන)",
                    "span": 1
                },
                {
                    "pali": "පටිච්ඡාදනත්ථං",
                    "sinh": "වැසීම පිණිස",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පටිසංඛායොනිසො",
                    "sinh": "නුවණින් මෙනෙහි කොට",
                    "span": 1
                },
                {
                    "pali": "පිණ්ඩපාතං",
                    "sinh": "පිණ්ඩපාතය",
                    "span": 1
                },
                {
                    "pali": "පටිසේවාමි",
                    "sinh": "වළඳමි",
                    "span": 1
                },
                {
                    "pali": "නෙවදවාය",
                    "sinh": "ක්‍රීඩා පිණිස නොවේ",
                    "span": 1
                },
                {
                    "pali": "න මද‍ාය",
                    "sinh": "මදය පිණිස නොවේ (පුරුෂ මද, බලමද ආදිය පිණිස)",
                    "span": 1
                },
                {
                    "pali": "න මණ්ඩනාය",
                    "sinh": "අලංකාර පිණිස නොවේ",
                    "span": 1
                },
                {
                    "pali": "න විභුසනාය",
                    "sinh": "සැරසීම පිණිස නොවේ",
                    "span": 1
                },
                {
                    "pali": "යාවදෙව",
                    "sinh": "යම්තාක්",
                    "span": 1
                },
                {
                    "pali": "ඉමස්ස කායස්ස",
                    "sinh": "මේ ශරීරයා ගේ",
                    "span": 1
                },
                {
                    "pali": "ඨිතියා",
                    "sinh": "පැවැත්ම පිණිස",
                    "span": 1
                },
                {
                    "pali": "යාපනාය",
                    "sinh": "යැපීම පිණිස",
                    "span": 1
                },
                {
                    "pali": "විහිං සුපරතියා",
                    "sinh": "විහීංසාහරණ පිණිස (බඩගිනි නැසීමට)",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මචරියානුග්ගහාය",
                    "sinh": "බඹසර සපයනු පිණිස (බඹසර රැකීමට අනුග්‍රහ පිණිස) අහර වළඳිමි",
                    "span": 1
                },
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "පුරාණඤ්ච වෙදනං",
                    "sinh": "පුරාණ දුක් වේදනාව.",
                    "span": 1
                },
                {
                    "pali": "පටිහංඛාමි",
                    "sinh": "නසන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "නවං ච වෙදනං",
                    "sinh": "අලුත් දුක් වේදනාව",
                    "span": 1
                },
                {
                    "pali": "න උප්පාදෙස්සාමි",
                    "sinh": "නො උපදවමි",
                    "span": 1
                },
                {
                    "pali": "යාත්‍රා ච",
                    "sinh": "ඉරියව් පැවැත්ම ද",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මට",
                    "span": 1
                },
                {
                    "pali": "භවිස්සති",
                    "sinh": "වන්නේය යි (සළකා අහර වළඳමි.)",
                    "span": 1
                },
                {
                    "pali": "අනවජ්ජතා ච",
                    "sinh": "නිවරද බව ද",
                    "span": 1
                },
                {
                    "pali": "ඵසුවිහාරොචාති",
                    "sinh": "පහසු විහරණය ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පටිසංඛායොනිසො",
                    "sinh": "නුවණින් මෙනෙහි කොට",
                    "span": 1
                },
                {
                    "pali": "සෙනාසනං",
                    "sinh": "සෙනසුන්",
                    "span": 1
                },
                {
                    "pali": "පටිසේවාමි",
                    "sinh": "වැළඳ ගනිමි (පරිභෝග කරමි.)",
                    "span": 1
                },
                {
                    "pali": "යාවදෙව",
                    "sinh": "යම්තාක්",
                    "span": 1
                },
                {
                    "pali": "සීතස්ස පටිඝාතාය",
                    "sinh": "සීත පීඩා නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "උණ්හස්ස පටිඝාතාය",
                    "sinh": "උෂ්ණ පීඩා නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "ඩංස",
                    "sinh": "ඩැහැ ලේ බොන මැසි ය",
                    "span": 1
                },
                {
                    "pali": "මකස",
                    "sinh": "විද ලේබොන මදුරු ය",
                    "span": 1
                },
                {
                    "pali": "වාතා’තප",
                    "sinh": "වාතය, අවුව ය",
                    "span": 1
                },
                {
                    "pali": "සිරිංසප",
                    "sinh": "සිරිංසප ය (සර්පයෝ ය) යන මොවුන්ගේ",
                    "span": 1
                },
                {
                    "pali": "සම්ඵස්සානං පටිඝාතාය",
                    "sinh": "ස්පර්ශ නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "යාවදෙව",
                    "sinh": "යම්තාක්",
                    "span": 1
                },
                {
                    "pali": "උතුපරිස්සය",
                    "sinh": "සෘතු උපද්‍රව",
                    "span": 1
                },
                {
                    "pali": "විනොදනං",
                    "sinh": "දුරු කිරීම පිණිස",
                    "span": 1
                },
                {
                    "pali": "පටිසල්ලානාරාමත්ථං",
                    "sinh": "සිත එකඟ කිරීමෙහි ඇලෙනු පිණිස",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පටිසංඛායොනිසො",
                    "sinh": "නුවණින් මෙනෙහි කොට",
                    "span": 1
                },
                {
                    "pali": "ගිලානපච්චය භෙසජ්ජ පරික්ඛාරං",
                    "sinh": "ගිලන්පස බෙහෙත් පිරිකර",
                    "span": 1
                },
                {
                    "pali": "පටිසේවාමි",
                    "sinh": "වළඳමි.",
                    "span": 1
                },
                {
                    "pali": "යාවදෙව",
                    "sinh": "යම්තාක්",
                    "span": 1
                },
                {
                    "pali": "උප්පන්නානං",
                    "sinh": "උපන්",
                    "span": 1
                },
                {
                    "pali": "වෙය්‍යාබාධිකානං",
                    "sinh": "සිරුර පෙළන",
                    "span": 1
                },
                {
                    "pali": "වෙදනානං",
                    "sinh": "වේදනාවන්",
                    "span": 1
                },
                {
                    "pali": "පටිඝාතාය",
                    "sinh": "නසනු පිණිස",
                    "span": 1
                },
                {
                    "pali": "අඛ්‍යාපජ්ඣ",
                    "sinh": "නිරෝගිබව",
                    "span": 1
                },
                {
                    "pali": "පරමතායාති",
                    "sinh": "උතුම් බැවින්",
                    "span": 1
                }
            ]
        ]
    },
    "07-dasadhamma": {
        "labels": [
            [
                0.921807,
                2.654805
            ],
            [
                2.654805,
                23.966991
            ],
            [
                24.280405,
                47.731184
            ],
            [
                48.081471,
                62.830388
            ],
            [
                63.346601,
                79.164815
            ],
            [
                79.533537,
                94.577433
            ],
            [
                94.983028,
                111.169965
            ],
            [
                111.538688,
                129.790474
            ],
            [
                130.232941,
                154.16306
            ],
            [
                154.458038,
                175.622735
            ],
            [
                176.286436,
                218.652701
            ],
            [
                219.021424,
                237.789422
            ],
            [
                238.231889,
                255.561867
            ],
            [
                255.967463,
                293.245352
            ],
            [
                294.277776,
                307.920524
            ],
            [
                308.215503,
                322.337591
            ]
        ],
        "text": [
            [
                {
                    "pali": "දසධම්ම සුතං",
                    "sinh": "දස ධම්ම සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං මෙ සුතං",
                    "sinh": "මා විසින් මෙසේ අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත් නුවරැ",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමේ",
                    "sinh": "ආරාමයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තත්‍ර ඛො",
                    "sinh": "එකල්හි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු ආමන්තෙසි",
                    "sinh": "භික්ෂූන් ඇමතූසේක",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවොති",
                    "sinh": "මහණෙනි කියා",
                    "span": 1
                },
                {
                    "pali": "භදන්තෙති",
                    "sinh": "ස්වාමීන් වහන්සැ’යි කියා",
                    "span": 1
                },
                {
                    "pali": "තෙ භික්ඛු",
                    "sinh": "ඒ හික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "පච්චස්සොසුං",
                    "sinh": "පිළිවදන් දුන්හු ය",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "බුදුරජාණන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දස ඉමෙ",
                    "sinh": "මේ දස",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "ධම්මා",
                    "sinh": "ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බා",
                    "sinh": "ප්‍රත්‍යවෙක්ෂා කටයුත්තාහු ය",
                    "span": 1
                },
                {
                    "pali": "කතමෙ දස?",
                    "sinh": "කවර දස ධර්මයෝ ද යත්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වෙවණ්ණියම්හි",
                    "sinh": "විවණ බවට (වෙනස් වර්‍ණයකට)",
                    "span": 1
                },
                {
                    "pali": "අජ්ඣූපගතොති",
                    "sinh": "පැමිණියේ වෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිරතුරුව",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවෙක්ෂා කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පරපටිබද්ධා",
                    "sinh": "පරා (අනුන්) පිළිබඳය යි",
                    "span": 1
                },
                {
                    "pali": "මෙ ජීවිකාති",
                    "sinh": "මාගේ දිවි පැවත්ම",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "මෙනෙහි කටයුතු යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අඤ්ඤ‍ො",
                    "sinh": "අන්‍ය වූ (ගිහියන්ගෙන් වෙනස්වූ)",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "ආකප්පො",
                    "sinh": "ආකල්පයෙක් (හැසිරීමක්)",
                    "span": 1
                },
                {
                    "pali": "කරණීයොති",
                    "sinh": "කටයුතුය යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවේක්ෂා කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කච්චිනු ඛො",
                    "sinh": "කිම හෝ",
                    "span": 1
                },
                {
                    "pali": "මෙ අත්තා",
                    "sinh": "මාගේ ආත්මය (සිත)",
                    "span": 1
                },
                {
                    "pali": "සීලතො",
                    "sinh": "සීලයෙන්",
                    "span": 1
                },
                {
                    "pali": "න උපවදතිති",
                    "sinh": "උපවාද නො කෙරේ හෝයි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "මෙනෙහි කටයුතු ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කච්චිනු ඛො",
                    "sinh": "කිම හෝ",
                    "span": 1
                },
                {
                    "pali": "මං",
                    "sinh": "මා",
                    "span": 1
                },
                {
                    "pali": "අනුවිච්ච",
                    "sinh": "විචාර",
                    "span": 1
                },
                {
                    "pali": "විඤ්ඤු සබ්‍රහ්මචාරී",
                    "sinh": "නුවණැති සබ්‍රම්සරහු",
                    "span": 1
                },
                {
                    "pali": "සීලතො",
                    "sinh": "සීලයෙන්",
                    "span": 1
                },
                {
                    "pali": "න උපවදන්ති’ ති",
                    "sinh": "පරිභව නො බෙණෙද්දෝ හෝ යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවේක්ෂා කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බෙහි",
                    "sinh": "සියලුදෙනා ගෙන්",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "පියෙහි",
                    "sinh": "ප්‍රිය වූ",
                    "span": 1
                },
                {
                    "pali": "මනාපෙහි",
                    "sinh": "මනාප වූ",
                    "span": 1
                },
                {
                    "pali": "නානාභාවො",
                    "sinh": "නානාභාවය",
                    "span": 1
                },
                {
                    "pali": "විනාභාවොති",
                    "sinh": "විනාශ භාවය වේයයි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙත",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවෙක්ෂා කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කම්මස්සකොම්හි",
                    "sinh": "කර්මය තමා අයත් කොට ඇත්තේ වෙමි",
                    "span": 1
                },
                {
                    "pali": "කම්ම ද‍ායාද‍ො‍‍‍",
                    "sinh": "කර්මය ද‍ායාද කොට ඇත්තෙමි",
                    "span": 1
                },
                {
                    "pali": "කම්ම යොනි",
                    "sinh": "කර්මය යෝනි කොට ඇත්තෙමි",
                    "span": 1
                },
                {
                    "pali": "කම්ම බන්ධු",
                    "sinh": "කර්මය නෑ කොට ඇත්තෙමි",
                    "span": 1
                },
                {
                    "pali": "කම්ම පටිසරණො",
                    "sinh": "කර්මය පිළිසරණ කොට ඇත්තෙමි",
                    "span": 1
                },
                {
                    "pali": "යං කම්මං",
                    "sinh": "යම් කර්මයක්",
                    "span": 1
                },
                {
                    "pali": "කරිස්සාමි",
                    "sinh": "කෙරෙම් ද",
                    "span": 1
                },
                {
                    "pali": "කල්‍යාණං වා",
                    "sinh": "යහපත් වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "පාපකං වා",
                    "sinh": "පවිටු වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "තස්ස ද‍ායාද‍ො භවිස්සාමීති",
                    "sinh": "ඒ කර්මය විසින් දෙන ලද්ද අයත් වෙමි යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවේක්ෂා කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කථංභූතස්ස මෙ",
                    "sinh": "කෙසේ වූ මට",
                    "span": 1
                },
                {
                    "pali": "රත්තිං දිවා",
                    "sinh": "රෑ දවල්හු",
                    "span": 1
                },
                {
                    "pali": "වීතිපතන්තීති",
                    "sinh": "ඉක්මෙත් දෝහෝ යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිත්තෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවේක්ෂා කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කච්චනුඛොහං",
                    "sinh": "කිමැ හෝ මම",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාරෙ",
                    "sinh": "ශුන්‍යාගාරයෙහි (හිස් පෙදෙසෙහි)",
                    "span": 1
                },
                {
                    "pali": "අභිරමාමීති",
                    "sinh": "ඇලෙම්දෝ හෝ යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙත",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "ප්‍රත්‍යවේක්ෂා කටයුතු යි(මෙනෙහි කටයුතු යි)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අත්ථිනු ඛො",
                    "sinh": "ඇද්දෝ හෝ යි",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා වෙත",
                    "span": 1
                },
                {
                    "pali": "උත්තරිමනුස්ස ධම්මා",
                    "sinh": "උතුරු මිනිස් දම්",
                    "span": 1
                },
                {
                    "pali": "අලමරියඤාණදස්සන විසෙසො අධිගතො",
                    "sinh": "පොහොසත් ආර්යඤාණදර්ශන විශේෂයෙක් ලබන ලද්දේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සොහං",
                    "sinh": "ඒ මම",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමෙ කාලෙ",
                    "sinh": "පශ්චිම කාලයෙහි (මරණ කාලයෙහි)",
                    "span": 1
                },
                {
                    "pali": "සබ්‍රහ්මචාරිහි",
                    "sinh": "සබ්‍රම්සරුන් විසින්",
                    "span": 1
                },
                {
                    "pali": "පුට්ඨො",
                    "sinh": "විචාරණ ලද්දෙම්",
                    "span": 1
                },
                {
                    "pali": "න මංකුභවිස්සාමීති",
                    "sinh": "තේජස් රහිත නො වෙම් දෝ හෝ යි",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බං",
                    "sinh": "මෙනෙහි කටයුතු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමෙ ඛො",
                    "sinh": "මේ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "දස ධම්මා",
                    "sinh": "දස ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දහු විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිණ්හං",
                    "sinh": "නිතොර",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛිතබ්බාති",
                    "sinh": "මෙනෙහි කළ යුත්තාහු ය’යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච",
                    "sinh": "මේ දේශනාව වදාළ සේක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "බුදුරදුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අත්තමානා",
                    "sinh": "සතුටු සිත් ඇති",
                    "span": 1
                },
                {
                    "pali": "තෙ භික්ඛු",
                    "sinh": "ඒ භික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ",
                    "span": 1
                },
                {
                    "pali": "භාසිතං",
                    "sinh": "දේශනාවට",
                    "span": 1
                },
                {
                    "pali": "අභිනන්දුන්ති",
                    "sinh": "විශේෂයෙන් සතුටු වූවාහු ය.",
                    "span": 1
                }
            ]
        ]
    },
    "08-mahamangala": {
        "labels": [
            [
                0,
                2,
                0
            ],
            [
                3.277322,
                11.346696,
                1
            ],
            [
                11.814885,
                23.712392,
                2
            ],
            [
                24.235662,
                34.315494,
                3
            ],
            [
                34.701061,
                46.598568,
                4
            ],
            [
                47.121838,
                52.712564,
                5
            ],
            [
                52.850267,
                67.474286,
                6
            ],
            [
                67.970015,
                81.795359,
                7
            ],
            [
                83.199925,
                93.555163,
                8
            ],
            [
                93.94073,
                104.709075,
                9
            ],
            [
                105.342507,
                115.532501,
                10
            ],
            [
                116.028231,
                126.796576,
                11
            ],
            [
                127.264765,
                137.922948,
                12
            ],
            [
                138.308515,
                148.746374,
                13
            ],
            [
                149.242104,
                159.266855,
                14
            ],
            [
                159.679963,
                170.255524,
                15
            ],
            [
                170.833875,
                181.409437,
                16
            ],
            [
                181.877626,
                191.984998,
                17
            ],
            [
                192.508268,
                202.973668,
                18
            ],
            [
                203.386776,
                213.301364,
                19
            ],
            [
                214.320364,
                224.124791,
                20
            ],
            [
                224.537899,
                235.141001,
                21
            ],
            [
                235.664271,
                245.936886,
                22
            ],
            [
                246.377535,
                256.237043,
                23
            ],
            [
                256.898015,
                266.59228,
                24
            ],
            [
                267.088009,
                277.856355,
                25
            ],
            [
                278.462246,
                288.349294,
                26
            ],
            [
                288.707321,
                299.393045,
                27
            ],
            [
                299.943855,
                309.748282,
                28
            ],
            [
                310.188931,
                320.434006,
                29
            ],
            [
                321.039897,
                331.229892,
                30
            ],
            [
                331.642999,
                344.889992,
                31
            ]
        ],
        "text": [
            [
                {
                    "pali": "මහා මංගල සුත්තං",
                    "sinh": "මහා මංගල සූත්‍රය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත් නුවරැ",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු මහ සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "අරමෙ හි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "එකල්හි",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤතරා දෙවතා",
                    "sinh": "එක්තරා දෙවියෙක්",
                    "span": 1
                },
                {
                    "pali": "අභික්කන්තාය රත්තියා",
                    "sinh": "රෑ ඉක්ම ගිය කල්හි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අභික්කන්ත වණ්ණා",
                    "sinh": "විශිෂ්ඨ ශෝභා ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "කෙවලකපං ජෙතවනං",
                    "sinh": "සියලු දෙව්රම් වෙහෙර",
                    "span": 1
                },
                {
                    "pali": "ඔභාසෙත්වා",
                    "sinh": "ස්වකීය ශරීර ශොභාවෙන් බබුලුවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙන භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ යම් තැනෙක ද",
                    "span": 1
                },
                {
                    "pali": "තෙනුපසංකමි",
                    "sinh": "එතැනට එළඹියේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අභිවාදෙත්වා",
                    "sinh": "වැඳ",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත් පසෙක",
                    "span": 1
                },
                {
                    "pali": "අට්ඨාසි",
                    "sinh": "සිටියේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත් පසෙක",
                    "span": 1
                },
                {
                    "pali": "ඨිතා ඛො සා දෙවතා",
                    "sinh": "සිටි ඒ දෙවිතෙම",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේස්ට",
                    "span": 1
                },
                {
                    "pali": "ගාථාය",
                    "sinh": "ගාථායෙන්",
                    "span": 1
                },
                {
                    "pali": "අජ්ඣහාසි",
                    "sinh": "(මෙසේ) කීයේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බහුදෙවා",
                    "sinh": "බොහෝ දෙවියෝ ද",
                    "span": 1
                },
                {
                    "pali": "මනුස්සා ච",
                    "sinh": "මනුෂ්‍යයෝ ද",
                    "span": 1
                },
                {
                    "pali": "මංගලානි",
                    "sinh": "මංගල කරුණු",
                    "span": 1
                },
                {
                    "pali": "අචින්තයුං",
                    "sinh": "සිතූහ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආකංඛමානා",
                    "sinh": "කැමැති වන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "සොත්ථානං",
                    "sinh": "මෙලොව පරලොව සැප",
                    "span": 1
                },
                {
                    "pali": "බ්‍රූහි",
                    "sinh": "වදාළ මැනැවි",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "වැඩ සලසන උතුම් මංගල කරුණු.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අසෙවනා ච",
                    "sinh": "සේවනය නො කිරීම ද",
                    "span": 1
                },
                {
                    "pali": "බාලානං",
                    "sinh": "බාලයන් ගේ නොහොත් අසත් පුරුෂයන් ගේ",
                    "span": 1
                },
                {
                    "pali": "පණ්ඩිතානං ච සෙවනා",
                    "sinh": "පණ්ඩිතයන් නොහොත් සත්පුරුෂයන් සේවනය කිරීම ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පූජා ච පූජනීයානං",
                    "sinh": "පිදිය යුත්තන් පිදීම ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පතිරූප දෙස වාසො ච",
                    "sinh": "සුදුසු පෙදෙස්හි විසීම ද",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ ච කතපුඤ්ඤතා",
                    "sinh": "පෙරකළ පින් ඇති බව ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අත්තසම්මා පණිධි ච",
                    "sinh": "සිය අත් බව මනා දහම්හි පිහිටුවීම ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බාහුසච්චඤ් ච",
                    "sinh": "බොහෝ ඇසූපිරූ තැන් ඇති බව ද",
                    "span": 1
                },
                {
                    "pali": "සිප්පඤ් ච",
                    "sinh": "ශිල්ප දැනීම ද",
                    "span": 1
                },
                {
                    "pali": "විනයො ච සුසික්ඛිතො",
                    "sinh": "මනාව හික්මුණු විනය ඇති බව ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුභාසිතා ච යා වාචා",
                    "sinh": "යම් වචනයක් මොනවට කියන ලද ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මාතා පිතු උපට්ඨානං",
                    "sinh": "මවුට උපස්ථාන කිරීමද, පියාට උපස්ථාන කිරීම ද",
                    "span": 1
                },
                {
                    "pali": "පුත්තදාරස්ස සංගහො",
                    "sinh": "අඹුදරුවන්ට සංග්‍රහ කිරීම ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනාකුලා ච කම්මන්තා",
                    "sinh": "නිරවුල් කර්මාන්ත ඇති බව ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දානං ච",
                    "sinh": "දන්දීම ද",
                    "span": 1
                },
                {
                    "pali": "ධම්ම චරියා ච",
                    "sinh": "දශ කුශලයෙහි හැසිරීම ද",
                    "span": 1
                },
                {
                    "pali": "ඤාතකානං",
                    "sinh": "ඤාතීන්ට",
                    "span": 1
                },
                {
                    "pali": "සංගහො ච",
                    "sinh": "සංග්‍රහ කිරීම ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනවජ්ජානි කම්මානි",
                    "sinh": "නිවැරැදි ක්‍රියා ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආරති විරති පාපා",
                    "sinh": "පාපයෙහි නො ඇලීම ද, පවින් වැළකීම ද",
                    "span": 1
                },
                {
                    "pali": "මජ්ජපානා ච සඤ්ඤමො",
                    "sinh": "මත්පැනෙන් වැළකීම ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අප්පමාදො ච",
                    "sinh": "නොපමා බව",
                    "span": 1
                },
                {
                    "pali": "ධම්මෙසු",
                    "sinh": "කුශල ධර්මයෙහි (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මගුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගාරාවො ච",
                    "sinh": "ගරු කටයුත්තන්ට ගරු කිරීම ද",
                    "span": 1
                },
                {
                    "pali": "නිවාතො ච",
                    "sinh": "නිහතමාන බව ද",
                    "span": 1
                },
                {
                    "pali": "සන්තුට්ඨි ච",
                    "sinh": "ලද දෙයින් සතුටුවන බව ද",
                    "span": 1
                },
                {
                    "pali": "කතඤ්ඤුතා",
                    "sinh": "කෙළෙහිගුණ දන්නා බව ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කාලෙන ධම්ම සවණං",
                    "sinh": "සුදුසු කල්හි බණ ඇසීම ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛන්තී ච",
                    "sinh": "ඉවසීම ද",
                    "span": 1
                },
                {
                    "pali": "සොවචස්සතා",
                    "sinh": "සුවච බවද (කීකරු බවද)",
                    "span": 1
                },
                {
                    "pali": "සමණානඤ් ච දස්සනං",
                    "sinh": "ශ්‍රමණයන් දැකීම ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කාලෙන ධම්ම සාකච්ඡා",
                    "sinh": "සුදුසු කල්හි ධර්ම සාකච්ඡාව ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තපො ච",
                    "sinh": "තපස ද",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මචරියඤ් ච",
                    "sinh": "බඹසර ද (යහපත් හැසිරීම ද)",
                    "span": 1
                },
                {
                    "pali": "අරිය සච්චාන දස්සනං",
                    "sinh": "චතුරාර්යය සත්‍යයන් දැකීම ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නිබ්බාණ සච්ජිකිරියා ච",
                    "sinh": "නිවන් පසක් කිරීම ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඵුට්ඨස්ස",
                    "sinh": "ස්පර්ශ කරන ලද",
                    "span": 1
                },
                {
                    "pali": "ලොක ධම්මෙහි",
                    "sinh": "අටලෝ දහමින්",
                    "span": 1
                },
                {
                    "pali": "චිත්තං",
                    "sinh": "සිත",
                    "span": 1
                },
                {
                    "pali": "යස්ස",
                    "sinh": "යමෙකුගේ",
                    "span": 1
                },
                {
                    "pali": "න කම්පති",
                    "sinh": "නො සැලේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අසොකං",
                    "sinh": "ශෝක රහිත ද",
                    "span": 1
                },
                {
                    "pali": "විරජං",
                    "sinh": "රාගාදි රජස් (කෙලෙස්) රහිත ද",
                    "span": 1
                },
                {
                    "pali": "බේමං",
                    "sinh": "නිර්භය ද (යන)",
                    "span": 1
                },
                {
                    "pali": "එතං",
                    "sinh": "මෙය",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතාදිසානි",
                    "sinh": "(අසත් පුරුෂයන් සේවනය නො කිරීම ආදි) මෙබඳු මංගලයත්",
                    "span": 1
                },
                {
                    "pali": "කත්වාන",
                    "sinh": "කොට",
                    "span": 1
                },
                {
                    "pali": "සබ්බත්ථමපරාජිතා",
                    "sinh": "හැම තන්හි නොපැරැදුනෝව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බත්ථ",
                    "sinh": "සියලු තැන",
                    "span": 1
                },
                {
                    "pali": "සොත්ථිං ගච්ඡන්ති",
                    "sinh": "සැපයට යෙත් ද",
                    "span": 1
                },
                {
                    "pali": "තං",
                    "sinh": "එය",
                    "span": 1
                },
                {
                    "pali": "තෙසං",
                    "sinh": "ඔවුනට",
                    "span": 1
                },
                {
                    "pali": "මඞ්‌ගලමුත්‌තමං",
                    "sinh": "උතුම් මඟුලෙකි.",
                    "span": 1
                }
            ]
        ]
    },
    "09-rathana": {
        "labels": [
            [
                0.233795,
                1.870362
            ],
            [
                3.390031,
                16.950157
            ],
            [
                17.339815,
                30.783043
            ],
            [
                31.211668,
                45.08352
            ],
            [
                45.590076,
                58.604679
            ],
            [
                59.111236,
                72.3986
            ],
            [
                72.86619,
                85.452169
            ],
            [
                85.919759,
                93.128447
            ],
            [
                93.557071,
                106.961333
            ],
            [
                107.428924,
                120.365595
            ],
            [
                120.755254,
                127.963941
            ],
            [
                128.743258,
                141.952691
            ],
            [
                142.264418,
                155.123157
            ],
            [
                155.512816,
                162.682537
            ],
            [
                163.03323,
                176.281629
            ],
            [
                176.710253,
                190.426242
            ],
            [
                190.971764,
                204.298094
            ],
            [
                204.921548,
                218.715469
            ],
            [
                219.144094,
                232.743185
            ],
            [
                233.210775,
                246.615037
            ],
            [
                247.472286,
                261.42207
            ],
            [
                261.811729,
                275.371854
            ],
            [
                275.761513,
                289.165775
            ],
            [
                289.789229,
                302.92073
            ],
            [
                303.349354,
                316.363957
            ],
            [
                316.792582,
                329.885117
            ],
            [
                330.547536,
                343.055583
            ],
            [
                343.484208,
                355.953288
            ],
            [
                356.381913,
                369.396516
            ],
            [
                369.786175,
                382.87871
            ],
            [
                383.813891,
                397.958504
            ],
            [
                398.192299,
                411.090005
            ],
            [
                411.557595,
                424.611164
            ],
            [
                425.273584,
                438.677846
            ],
            [
                439.028539,
                451.731415
            ],
            [
                452.237971,
                465.447403
            ],
            [
                465.95396,
                478.890631
            ],
            [
                479.397187,
                492.60662
            ],
            [
                493.152142,
                507.296756
            ],
            [
                507.72538,
                521.519301
            ],
            [
                522.025857,
                535.118392
            ],
            [
                536.248402,
                549.574732
            ],
            [
                550.003357,
                563.602448
            ],
            [
                564.186936,
                577.513266
            ],
            [
                577.941891,
                591.190289
            ],
            [
                591.813743,
                604.98421
            ],
            [
                605.490766,
                619.089857
            ]
        ],
        "text": [
            [
                {
                    "pali": "රතන සුත්තං",
                    "sinh": "රතන සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යානීධ භූතානි",
                    "sinh": "යම් මෙතැන්හි අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "සමාගතානි",
                    "sinh": "රැස්වූ",
                    "span": 1
                },
                {
                    "pali": "භුම්මානි වා",
                    "sinh": "පොළොවෙහි වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "යානි ව",
                    "sinh": "යම් අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "අන්තලික්ඛෙ",
                    "sinh": "අහසෙහි වූ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බෙව භූතා",
                    "sinh": "ඒ සියලු අමනුෂ්‍යයෝ ම",
                    "span": 1
                },
                {
                    "pali": "සුමනා භවන්තු",
                    "sinh": "සතුටු සිතැත්තෝ වෙත්වා",
                    "span": 1
                },
                {
                    "pali": "අථොපි",
                    "sinh": "තවද",
                    "span": 1
                },
                {
                    "pali": "සක්කච්ච",
                    "sinh": "සකසා",
                    "span": 1
                },
                {
                    "pali": "සුණන්තු",
                    "sinh": "අසත්වා",
                    "span": 1
                },
                {
                    "pali": "භාසිතං",
                    "sinh": "මගේ වචනය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තස්මාහි",
                    "sinh": "එබැවින්",
                    "span": 1
                },
                {
                    "pali": "භූතා",
                    "sinh": "භූතයිනි",
                    "span": 1
                },
                {
                    "pali": "නිසාමෙථ",
                    "sinh": "(මගේ වචනය) අසවු",
                    "span": 1
                },
                {
                    "pali": "සබ්බෙ",
                    "sinh": "සියලු තොපි",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං කරොථ",
                    "sinh": "මෛත්‍රිය කරවු",
                    "span": 1
                },
                {
                    "pali": "මානුසියා පජාය",
                    "sinh": "මිනිස් ප්‍රජාවට",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දිවා ච රත්තො ච",
                    "sinh": "දහවල් ද රෑ ද",
                    "span": 1
                },
                {
                    "pali": "හරන්ති",
                    "sinh": "එළවත් ද",
                    "span": 1
                },
                {
                    "pali": "යෙ",
                    "sinh": "යම් කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "බලිං",
                    "sinh": "පුද පඬුරු",
                    "span": 1
                },
                {
                    "pali": "තස්මාහි",
                    "sinh": "එහෙයින්",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "ඔවුන්",
                    "span": 1
                },
                {
                    "pali": "රක්ඛථ",
                    "sinh": "රකිවු",
                    "span": 1
                },
                {
                    "pali": "අප්පමත්තා",
                    "sinh": "නොපමාවම",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං කිඤ්චි විත්තං",
                    "sinh": "යම් ධනයෙක් වේ ද",
                    "span": 1
                },
                {
                    "pali": "ඉධ වා",
                    "sinh": "මේ මිනිස් ලොව හෝ",
                    "span": 1
                },
                {
                    "pali": "හුරං වා",
                    "sinh": "නාග ලෝක ආදී අන් ලොවෙක හෝ",
                    "span": 1
                },
                {
                    "pali": "සග්ගෙසු වා",
                    "sinh": "ස්වර්ගයෙහි හෝ",
                    "span": 1
                },
                {
                    "pali": "යං රතනං පණීතං",
                    "sinh": "යම්කිසි උතුම් රත්නයක් වේ ද (ඔවුන් අතුරෙහි)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න නො සමං අත්ථි",
                    "sinh": "සදෘශයෙක් (සමානයෙක්) නොම ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "තථාගතෙන",
                    "sinh": "තථාගතයන් හා",
                    "span": 1
                },
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "බුද්ධෙ",
                    "sinh": "බුදුරදුන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛයං",
                    "sinh": "(කෙලෙසුන් දුරුකරන හෙයින්) ක්ෂය නම් වූ",
                    "span": 1
                },
                {
                    "pali": "විරාගං",
                    "sinh": "(රාගයෙන් වෙන්වීමට නිමිති වූ) විරාග නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අමතං",
                    "sinh": "(මරණයක් නැති හෙයින්) අමත නම් වූ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "උතුම් වූ (මහත් වූ)",
                    "span": 1
                },
                {
                    "pali": "යදජ්ඣගා",
                    "sinh": "යම් නිවනක් අවබෝධ කළේ ද?",
                    "span": 1
                },
                {
                    "pali": "සක්‍යමුනී",
                    "sinh": "ශාක්‍යමුනි තෙම",
                    "span": 1
                },
                {
                    "pali": "සමාහිතො",
                    "sinh": "එකඟ වූ සිත් ඇති",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න තෙන ධම්‌මෙන සමත්ථි කිඤ්චි",
                    "sinh": "ඒ ධර්මය හා සම වූ කිසිවක් නොමැත",
                    "span": 1
                },
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "ධම්මෙ",
                    "sinh": "ධර්මයෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං",
                    "sinh": "යම් ආර්යමාර්ගයක්",
                    "span": 1
                },
                {
                    "pali": "බුද්ධ සෙට්ඨො",
                    "sinh": "බුද්ධ ශ්‍රේෂ්ඨතෙමේ",
                    "span": 1
                },
                {
                    "pali": "පරිවණ්ණයී",
                    "sinh": "වර්ණනා කෙළේ ද",
                    "span": 1
                },
                {
                    "pali": "සුචිං",
                    "sinh": "පිරිසුදු වූ",
                    "span": 1
                },
                {
                    "pali": "සමාධිමානන්තරිකඤ්ඤමාහු",
                    "sinh": "ආනන්තරික සමාධිය යි (බුද්ධාදී ආර්යයෝ) කියද්ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමාධිනා තෙන",
                    "sinh": "ඒ සමාධිය හා",
                    "span": 1
                },
                {
                    "pali": "සමො",
                    "sinh": "සම වූ සමාධියෙක්",
                    "span": 1
                },
                {
                    "pali": "න විජ්ජති",
                    "sinh": "නැත",
                    "span": 1
                },
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "ධම්මෙ",
                    "sinh": "ධර්මයෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙ පුග්ගලා",
                    "sinh": "යම් ආර්ය පුද්ගලයෝ",
                    "span": 1
                },
                {
                    "pali": "අට්ඨ",
                    "sinh": "අටදෙනෙක් වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "සතං පසත්ථා",
                    "sinh": "සත්පුරුෂයන් විසින් පසස්නා ලද",
                    "span": 1
                },
                {
                    "pali": "චත්තාරි එතානි යුගානි",
                    "sinh": "මොහු හැම දෙන යුග සතරක්",
                    "span": 1
                },
                {
                    "pali": "හොන්‌ති",
                    "sinh": "වෙති",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙ",
                    "sinh": "ඒ ආර්ය පුද්ගලයෝ",
                    "span": 1
                },
                {
                    "pali": "දක්ඛිණෙය්‍යා",
                    "sinh": "දක්ෂිණාවට සුදුස්සෝ වෙති",
                    "span": 1
                },
                {
                    "pali": "සුගතස්ස",
                    "sinh": "සුගත් බුදුරජුගේ",
                    "span": 1
                },
                {
                    "pali": "සාවකා",
                    "sinh": "ශ්‍රාවක වූ",
                    "span": 1
                },
                {
                    "pali": "එතෙසු",
                    "sinh": "මේ බුදු සව්වන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "දින්නානි",
                    "sinh": "දෙන ලද ද‍ානයෝ",
                    "span": 1
                },
                {
                    "pali": "මහප්ඵලානී",
                    "sinh": "මහත් පල ඇත්තෝ වෙත්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙ",
                    "sinh": "යම් කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "සුප්පයුත්තා",
                    "sinh": "මනාකොට යෙදුණාහු ද",
                    "span": 1
                },
                {
                    "pali": "මනසා දළ්හෙන",
                    "sinh": "ස්ථිරවූ සිතින්",
                    "span": 1
                },
                {
                    "pali": "නික්කාමිනො",
                    "sinh": "සියලු කෙළෙසුන් කෙරෙන් මිදුණාහු ද",
                    "span": 1
                },
                {
                    "pali": "ගොතම සාසනම්හි",
                    "sinh": "ගෞතම නම් වූ තථාගත ශාසනයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙ",
                    "sinh": "ඔවුහු",
                    "span": 1
                },
                {
                    "pali": "පත්තිපත්තා",
                    "sinh": "රහත් ඵලයට පැමිණියාහු නම් වෙත්",
                    "span": 1
                },
                {
                    "pali": "අමතං",
                    "sinh": "නිවණට",
                    "span": 1
                },
                {
                    "pali": "විගය්හ",
                    "sinh": "බැස",
                    "span": 1
                },
                {
                    "pali": "ලද්ධා මුධා",
                    "sinh": "නොමිලයේ ලත්",
                    "span": 1
                },
                {
                    "pali": "නිබ්බුතිං",
                    "sinh": "තිවන්සුව",
                    "span": 1
                },
                {
                    "pali": "භුඤ්ජමානා",
                    "sinh": "වළඳන්නාහු",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යථා",
                    "sinh": "යම්සේ",
                    "span": 1
                },
                {
                    "pali": "ඉන්දඛීලො පඨවිංසිතො",
                    "sinh": "පොළොවෙහි යටට බැසගත් ඉන්ද්‍රඛීලයක්",
                    "span": 1
                },
                {
                    "pali": "සියා",
                    "sinh": "වන්නේ ද",
                    "span": 1
                },
                {
                    "pali": "චතුබ්හි වාතෙහි",
                    "sinh": "සිවු දිගින් හමන සුළගින්",
                    "span": 1
                },
                {
                    "pali": "අසම්ප කම්පියො",
                    "sinh": "සෙළවිය නොහැකි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථුපමං",
                    "sinh": "ඒ ඉන්ද්‍ර ඛීලය බඳු ය යි",
                    "span": 1
                },
                {
                    "pali": "සප්පුරිසං",
                    "sinh": "ඒ සත්පුරුෂයා",
                    "span": 1
                },
                {
                    "pali": "වද‍ාමි",
                    "sinh": "කියමි",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යම් ආර්ය පුද්ගලයෙක්",
                    "span": 1
                },
                {
                    "pali": "අරිය සච්චානි",
                    "sinh": "චතුරාර්ය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "අවෙච්ච පස්සති",
                    "sinh": "නුවණින් අවබෝධ කෙළේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙ",
                    "sinh": "යම් සෝවාන් පුද්ගල කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "අරිය සච්චානි",
                    "sinh": "චතුරාර්ය සත්‍යයත්",
                    "span": 1
                },
                {
                    "pali": "විභාවයන්ති",
                    "sinh": "තමා අවබෝධ කෙරෙත් ද",
                    "span": 1
                },
                {
                    "pali": "ගම්භීරපඤ්ඤෙන",
                    "sinh": "ගැඹුරු නුවණැති බුදුරදුන් විසින්",
                    "span": 1
                },
                {
                    "pali": "සුදෙසිතානි",
                    "sinh": "මනාකොට දෙසන ලද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කිඤ්චාපි තෙ හොන්ති භුසප්පමත්තා",
                    "sinh": "කිසිසේත් ඔවුහු බෙහෙවින් පමාවූවාහු නමුදු",
                    "span": 1
                },
                {
                    "pali": "න තෙ භවං අට්ඨමං ආදියන්ති",
                    "sinh": "ඔවුහු අටවන භවයක් නො ගනිති",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සහාවස්‌ස දස්සන සම්පද‍ාය",
                    "sinh": "දර්ශන සම්පත්තිය හා සමගම (සෝවාන් මග නුවණ පහළවීම සමග)",
                    "span": 1
                },
                {
                    "pali": "තයස්‌සු ධම්මා",
                    "sinh": "මේ සෝවාන් පුද්ගලයා ගේ කියන ලද සංයෝජන ධර්මයෝ තිදෙන",
                    "span": 1
                },
                {
                    "pali": "ජහිතා භවන්ති",
                    "sinh": "දුරුකරන ලද්ද‍ා‍‍‍‍‍‍හු වෙත් ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සක්කාය දිට්ඨි",
                    "sinh": "සක්කායදෘෂ්ටිය ද",
                    "span": 1
                },
                {
                    "pali": "විචිකිච්ඡතං ච",
                    "sinh": "විචිකිත්සාව ද (සැකය ද)",
                    "span": 1
                },
                {
                    "pali": "සිලබ්බතං වාපි",
                    "sinh": "ශීලව්‍රතාදියක් හෝ",
                    "span": 1
                },
                {
                    "pali": "යදත්‍ථි කිඤ්චි",
                    "sinh": "ඇද්ද යම්කිසි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චතුහි අපායෙහි ච",
                    "sinh": "සිවු අපායෙන් ද",
                    "span": 1
                },
                {
                    "pali": "විප්පමුත්තො",
                    "sinh": "මිදුණේ වේ",
                    "span": 1
                },
                {
                    "pali": "ඡචාභිඨානානි",
                    "sinh": "සවැදෑරුම් බරපතල පාපයන් (ආනන්තර්ය කර්ම පසත් මිථ්‍යාදෘෂ්ටියත්)",
                    "span": 1
                },
                {
                    "pali": "අභබ්බෝ",
                    "sinh": "නුසුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "කාතුං",
                    "sinh": "කරන්නට",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කිඤ්චාපි",
                    "sinh": "කිසියම්",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "ඒ සෝවාන් පුද්ගල තෙමේ",
                    "span": 1
                },
                {
                    "pali": "කම්මං කරොති පාපකං",
                    "sinh": "පාප කර්මයක් කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "කායෙන",
                    "sinh": "කයින් හෝ",
                    "span": 1
                },
                {
                    "pali": "වාචා",
                    "sinh": "වචනයෙන් හෝ",
                    "span": 1
                },
                {
                    "pali": "උද",
                    "sinh": "නොහොත්",
                    "span": 1
                },
                {
                    "pali": "චෙතසා වා",
                    "sinh": "සිතින් හෝ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අභබ්බො",
                    "sinh": "අභව්‍ය ය",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හෙතෙම",
                    "span": 1
                },
                {
                    "pali": "තස්ස",
                    "sinh": "ඒ පාපකර්මයා ගේ",
                    "span": 1
                },
                {
                    "pali": "පටිච්ඡාදාය",
                    "sinh": "සැඟවීමට",
                    "span": 1
                },
                {
                    "pali": "අභබ්බතා",
                    "sinh": "වරද සැඟවීමෙහි අභව්‍ය බව",
                    "span": 1
                },
                {
                    "pali": "දිට්ඨපදස්ස",
                    "sinh": "දක්නා ලද නිවන් පද ඇති සෝවාන් පුද්ගලයා ගේ",
                    "span": 1
                },
                {
                    "pali": "වුත්තා",
                    "sinh": "බුදුරදුන් වද‍ාරණ ලදී",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වනප්පගුම්බෙ",
                    "sinh": "වනලැහැබක්",
                    "span": 1
                },
                {
                    "pali": "යථා ඵුස්සිතග්ගෙ",
                    "sinh": "මනාව මල් පිපුණු අක් (අග්ගිසි) ඇත්තේ යම්සේ ද",
                    "span": 1
                },
                {
                    "pali": "ගිම්හාන මාසෙ පඨමස්‌මිං",
                    "sinh": "පළමු ශ්‍රීෂ්ම මාසයෙහි",
                    "span": 1
                },
                {
                    "pali": "ගිම්හෙ",
                    "sinh": "ශ්‍රීෂ්ම සෘතුවෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථොපමං",
                    "sinh": "එබඳු වූ",
                    "span": 1
                },
                {
                    "pali": "ධම්‌මවරං",
                    "sinh": "උතුම් වූ ධර්මය",
                    "span": 1
                },
                {
                    "pali": "අදෙසයි",
                    "sinh": "(බුදුරජාණන්වහන්සේ) දෙසූ සේක.",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණගාමිං",
                    "sinh": "නිවනට පමුණුවන",
                    "span": 1
                },
                {
                    "pali": "පරමං හිතාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "බුද්ධෙ",
                    "sinh": "බුදුරදුන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වරො",
                    "sinh": "උතුම් වූ",
                    "span": 1
                },
                {
                    "pali": "වරඤ්ඤු",
                    "sinh": "නිවන්දන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "වරද‍ො",
                    "sinh": "උතුම් නිවන් දෙන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "වරාහරො",
                    "sinh": "උතුම් නිවන් මග ගෙනහැර පාන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "අනුන්තරො",
                    "sinh": "නිරුත්තර වූ බුදුරජතෙම",
                    "span": 1
                },
                {
                    "pali": "ධම්මවරං",
                    "sinh": "උතුම් දහමක්",
                    "span": 1
                },
                {
                    "pali": "අදෙසයි",
                    "sinh": "දෙසී ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "බුද්ධෙ",
                    "sinh": "බුදුරදුන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "(ප්‍රණීත) උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛීණං",
                    "sinh": "ක්ෂණවූයේ ද",
                    "span": 1
                },
                {
                    "pali": "පුරාණං",
                    "sinh": "පුරාතන කර්ම (යම් රහත් කෙනකුගේ)",
                    "span": 1
                },
                {
                    "pali": "නවං නත්ථි සම්භවං",
                    "sinh": "අලුත් භවයක් නැත්තේ ද",
                    "span": 1
                },
                {
                    "pali": "විරත්ත චිත්තා",
                    "sinh": "නොඇලුණු සිත් ඇති",
                    "span": 1
                },
                {
                    "pali": "ආයතිකෙභවස්මිං",
                    "sinh": "මතුභවයක් කෙරෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙ",
                    "sinh": "ඒ රහත්හු",
                    "span": 1
                },
                {
                    "pali": "ඛීණ බීජා",
                    "sinh": "ක්ෂීණ වූ ප්‍රතිසන්ධී විඥ‍ාන සංඛ්‍යාත බීජ ඇති",
                    "span": 1
                },
                {
                    "pali": "අවිරූළ්භිච්ඡන්ද‍ා",
                    "sinh": "පුනරුත්පත්තියෙහි ආශාවක් නැති",
                    "span": 1
                },
                {
                    "pali": "නිබ්බන්ති",
                    "sinh": "(නිවෙත්) පිරිනිවෙත්",
                    "span": 1
                },
                {
                    "pali": "ධීරා",
                    "sinh": "ධෛර්යසම්පන්න වූ",
                    "span": 1
                },
                {
                    "pali": "යථායම්පදීපො",
                    "sinh": "මේ පහන මෙන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදම්පි",
                    "sinh": "මේ කරුණින් ද",
                    "span": 1
                },
                {
                    "pali": "සංඝෙ",
                    "sinh": "සංඝයා කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "රතනං",
                    "sinh": "රත්න භාවය වේ",
                    "span": 1
                },
                {
                    "pali": "පණීතං",
                    "sinh": "උතුම්.",
                    "span": 1
                },
                {
                    "pali": "එතෙන සච්චෙන",
                    "sinh": "මේ සත්‍ය බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යානීධ භූතානි",
                    "sinh": "යම් මෙතැන්හි අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "සමාගතානි",
                    "sinh": "රැස්වූ",
                    "span": 1
                },
                {
                    "pali": "භුම්මානි වා",
                    "sinh": "පොළොවෙහි වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "යානි ව",
                    "sinh": "යම් අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "අන්තලික්ඛෙ",
                    "sinh": "අහසෙහි වූ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථාගතං",
                    "sinh": "තථාගත නම් වූ",
                    "span": 1
                },
                {
                    "pali": "දෙවමනුස්ස පූජිතං",
                    "sinh": "දෙව්මිනිසුන් විසින් පුදනලද",
                    "span": 1
                },
                {
                    "pali": "බුද්ධං",
                    "sinh": "බුදුරදුන්",
                    "span": 1
                },
                {
                    "pali": "නමස්සාම",
                    "sinh": "(අපි හැම දෙනා ම) නමදිමු",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "(සත්හට) සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යානීධ භූතානි",
                    "sinh": "යම් මෙතැන්හි අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "සමාගතානි",
                    "sinh": "රැස්වූ",
                    "span": 1
                },
                {
                    "pali": "භුම්මානි වා",
                    "sinh": "පොළොවෙහි වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "යානි ව",
                    "sinh": "යම් අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "අන්තලික්ඛෙ",
                    "sinh": "අහසෙහි වූ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථාගතං",
                    "sinh": "තථාගත නම් වූ",
                    "span": 1
                },
                {
                    "pali": "දෙවමනුස්ස පූජිතං",
                    "sinh": "දෙව්මිනිසුන් විසින් පුදනලද",
                    "span": 1
                },
                {
                    "pali": "ධම්මං",
                    "sinh": "ධර්මය",
                    "span": 1
                },
                {
                    "pali": "නමස්සාම",
                    "sinh": "(අපි හැම දෙනා ම) නමදිමු",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "(සත්හට) සෙත් වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යානීධ භූතානි",
                    "sinh": "යම් මෙතැන්හි අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "සමාගතානි",
                    "sinh": "රැස්වූ",
                    "span": 1
                },
                {
                    "pali": "භුම්මානි වා",
                    "sinh": "පොළොවෙහි වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "යානි ව",
                    "sinh": "යම් අමනුෂ්‍ය කෙනෙක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "අන්තලික්ඛෙ",
                    "sinh": "අහසෙහි වූ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථාගතං",
                    "sinh": "තථාගත නම් වූ",
                    "span": 1
                },
                {
                    "pali": "දෙවමනුස්ස පූජිතං",
                    "sinh": "දෙව්මිනිසුන් විසින් පුදනලද",
                    "span": 1
                },
                {
                    "pali": "සංඝං",
                    "sinh": "සංඝයා",
                    "span": 1
                },
                {
                    "pali": "නමස්සාම",
                    "sinh": "(අපි හැම දෙනා ම) නමදිමු",
                    "span": 1
                },
                {
                    "pali": "සුවත්ථි හොතු",
                    "sinh": "(සත්හට) සෙත් වේවා.",
                    "span": 1
                }
            ]
        ]
    },
    "10-karaniya": {
        "labels": [
            [
                0,
                2.5,
                0
            ],
            [
                3.113279,
                13.740708,
                2
            ],
            [
                14.221152,
                25.040758,
                4
            ],
            [
                25.694163,
                36.340809,
                6
            ],
            [
                36.93656,
                48.255828,
                8
            ],
            [
                48.890015,
                60.074759,
                10
            ],
            [
                60.612857,
                72.508658,
                12
            ],
            [
                73.162063,
                85.326913,
                14
            ],
            [
                85.865011,
                96.953666,
                16
            ],
            [
                97.510981,
                108.868685,
                18
            ],
            [
                109.406783,
                121.398673,
                20
            ],
            [
                121.955989,
                133.313693,
                22
            ],
            [
                133.736484,
                145.190276,
                24
            ],
            [
                145.786027,
                157.182167,
                26
            ],
            [
                157.681829,
                168.80892,
                28
            ],
            [
                169.270146,
                180.070535,
                30
            ],
            [
                180.570197,
                191.697288,
                32
            ],
            [
                192.754265,
                204.861462,
                34
            ],
            [
                205.39956,
                216.565086,
                36
            ],
            [
                217.122401,
                226.981119,
                38
            ],
            [
                227.519217,
                240.625738,
                40
            ]
        ],
        "text": [
            [
                {
                    "pali": "කරණීය මෙත්ත සුත්තං",
                    "sinh": "කරණීය මෙත්ත සූත්‍රය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කරණීයමත්ථකුසලෙන",
                    "sinh": "අභිවෘද්ධියෙහි දක්ෂයා විසින් යමක් කටයුතු ද",
                    "span": 1
                },
                {
                    "pali": "යං තං",
                    "sinh": "එය කටයුතු යි",
                    "span": 1
                },
                {
                    "pali": "සන්තං පදං",
                    "sinh": "ශාන්ත පදය යි කියනු ලබන නිවනට",
                    "span": 1
                },
                {
                    "pali": "අභිසමෙච්ච",
                    "sinh": "පැමිණ වසන්නහු විසින්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සක්කො",
                    "sinh": "දක්ෂයෙක් ද",
                    "span": 1
                },
                {
                    "pali": "උජු ච",
                    "sinh": "ඍජු ද",
                    "span": 1
                },
                {
                    "pali": "සූජූ ච",
                    "sinh": "මනාකොට සෘජු ද",
                    "span": 1
                },
                {
                    "pali": "සුවචොචස්ස",
                    "sinh": "(ඔහු) කීකරු වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "මුදු",
                    "sinh": "මෘදු වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "අනතිමානි",
                    "sinh": "නිහතමානී වන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සන්තුස්සකො ච",
                    "sinh": "ලද දෙයින් සතුටු වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "සුභරො ච",
                    "sinh": "පහසුවෙන් පෝෂණය කළ හැක්කේ ය",
                    "span": 1
                },
                {
                    "pali": "අප්ප කිච්චො ච",
                    "sinh": "ස්වල්ප කටයුතු ඇත්තෙක් වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "සල්ලහුක වුත්ති",
                    "sinh": "සැහැල්ලු පැවතුම් ඇත්තෙක් වන්නේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සන්තින්ද්‍රියො ච",
                    "sinh": "සන්සුන් ඉඳුරන් ඇත්තෙක් වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "නිපකො ච",
                    "sinh": "නුවණ ඇත්තෙක් වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "අප්ප ගබ්භො",
                    "sinh": "ප්‍රගල්භය (හැඩි දැඩි අසංවර ගති) නැති වන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "කුලෙසූ අනනුගිද්ධෝ",
                    "sinh": "කුලයන් කෙරෙහි නො ඇලුනෙක් වන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නච ඛුද්දං සමාචරෙ",
                    "sinh": "ස්වල්ප වූ වරදකුදු නො කරන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "කිඤ්චි යෙන",
                    "sinh": "යම් බඳු ක්‍රියාවකින්",
                    "span": 1
                },
                {
                    "pali": "විඤ්ඤුපරෙ",
                    "sinh": "නුවණැති අන් කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "උපවදෙය්‍යුං",
                    "sinh": "නින්ද‍ා කෙරෙත් ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුඛිනො වා",
                    "sinh": "සැප ඇත්තෝ වෙත්වා",
                    "span": 1
                },
                {
                    "pali": "ඛෙමිනො හොන්තු",
                    "sinh": "භය තැත්තෝ වෙත්වා",
                    "span": 1
                },
                {
                    "pali": "සබ්බෙ සත්තා",
                    "sinh": "සියලු සත්වයෝ",
                    "span": 1
                },
                {
                    "pali": "භවන්තු සුඛිතත්තා",
                    "sinh": "සුඛිත සිත් ඇත්තෝ වෙත්වා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙ කෙචි",
                    "sinh": "යම්කිසි",
                    "span": 1
                },
                {
                    "pali": "පාණභූතත්ථි",
                    "sinh": "සත්ව කෙනෙක් වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "තසා වා",
                    "sinh": "(කෙලෙස් සහිත බැවින්) භයින් ත්‍රස්ත වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "ථාවරා වා",
                    "sinh": "නිර්භය හෙයින් ස්ථාවර වූ",
                    "span": 1
                },
                {
                    "pali": "අනවසෙසා",
                    "sinh": "සියලු (ඉතිරිනොවූ)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දීඝා වා",
                    "sinh": "දීර්ඝ ජාති ඇත්තාහු ද",
                    "span": 1
                },
                {
                    "pali": "යෙ",
                    "sinh": "යම් සත්ව කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "මහන්තා වා",
                    "sinh": "මහත් සිරුරු ඇත්තාහු ද",
                    "span": 1
                },
                {
                    "pali": "මජ්ඣිමා",
                    "sinh": "මධ්‍යම ප්‍රමාණ සිරුරු ඇත්තෝ ද",
                    "span": 1
                },
                {
                    "pali": "රස්සකාණුකථූලා",
                    "sinh": "මිටි සිරුරු ඇත්තෝ ද, ඉතා සියුම් සිරුරු ඇත්තෝ ද, ස්ථූල සිරුරු ඇත්තෝ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දිට්ඨා වා",
                    "sinh": "ඇසට පෙනෙන්නා වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "යෙව අද්දිට්ඨා",
                    "sinh": "නොපෙනෙන්නා වූ යම් සත්ව කෙනෙක් වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "යෙච දූරෙ වසන්ති",
                    "sinh": "යම් සත්ව කෙනෙක් දුර වෙසෙත් ද",
                    "span": 1
                },
                {
                    "pali": "අවිදූරෙ",
                    "sinh": "නුදුරෙහි වෙසෙත් ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "භූතා වා",
                    "sinh": "ඉපදීම අවසන් කළ සත්වයෝ වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "සම්භවෙසී වා",
                    "sinh": "ඉපදීම සොයන සත්වයෝ ද (යන)",
                    "span": 1
                },
                {
                    "pali": "සබ්බෙ සත්තා",
                    "sinh": "සියලු සත්වයෝ",
                    "span": 1
                },
                {
                    "pali": "භවන්තු",
                    "sinh": "වෙත්වා",
                    "span": 1
                },
                {
                    "pali": "සුඛිතත්තා",
                    "sinh": "සුඛිත සිත් ඇත්තෝ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න",
                    "sinh": "නොම",
                    "span": 1
                },
                {
                    "pali": "පරො",
                    "sinh": "අනිකෙක්",
                    "span": 1
                },
                {
                    "pali": "පරං",
                    "sinh": "අනිකකු",
                    "span": 1
                },
                {
                    "pali": "නිකුබ්බේථ",
                    "sinh": "රවටන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "නාතිමඤ්ඤෙථ",
                    "sinh": "අවමන් නො කරන්නේ ය ‍",
                    "span": 1
                },
                {
                    "pali": "කත්ථචි",
                    "sinh": "කිසි තැනෙක්හි",
                    "span": 1
                },
                {
                    "pali": "නං කඤ්‌චි",
                    "sinh": "ඒ කිසිවක් හට.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛ්‍යාරොසනා",
                    "sinh": "කාය වාක් විකාරයෙන් වූ කෝපයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "පටිඝසඤඤ‍ා",
                    "sinh": "(මනෝ විකාරයෙන් වූ) පටිඝ සංඥ‍ායෙන් ද",
                    "span": 1
                },
                {
                    "pali": "නාඤ්ඤමඤ්ඤස්ස",
                    "sinh": "එකෙක් අනෙකකුට (නොම)",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛමිච්ඡෙය්‍ය",
                    "sinh": "දුකක් කැමති නො වන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මාතා",
                    "sinh": "මවක්",
                    "span": 1
                },
                {
                    "pali": "යථා",
                    "sinh": "යම්සේ",
                    "span": 1
                },
                {
                    "pali": "නියං පුත්තං",
                    "sinh": "තමාගෙන් ඇති වූ",
                    "span": 1
                },
                {
                    "pali": "ආයුසා",
                    "sinh": "දිවි පිදීමෙන් හෝ",
                    "span": 1
                },
                {
                    "pali": "එක පුත්තමනුරක්ඛෙ",
                    "sinh": "එකම පුතු රකී ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවම්පි",
                    "sinh": "මෙසේ ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බ භුතෙසු",
                    "sinh": "හැම සතුන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "මානසං",
                    "sinh": "මෛත්‍රී සිත",
                    "span": 1
                },
                {
                    "pali": "භාවයෙ",
                    "sinh": "වඩන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "අපරිමාණං",
                    "sinh": "අප්‍රමාණ වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මෙත්තං ච",
                    "sinh": "මෛත්‍රී සහගත ව",
                    "span": 1
                },
                {
                    "pali": "සබ්බ ලොකස්මිං",
                    "sinh": "සියලු සත්වයන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "මානසං භාවයෙ",
                    "sinh": "සිත වඩන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "අපරිමාණං",
                    "sinh": "අප්‍රමාණ වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උද්ධං ච",
                    "sinh": "උඩ ද",
                    "span": 1
                },
                {
                    "pali": "අධො ච",
                    "sinh": "යට ද",
                    "span": 1
                },
                {
                    "pali": "තිරියඤ් ච",
                    "sinh": "සරස (හරස්ව) ද",
                    "span": 1
                },
                {
                    "pali": "අසම්බාධං",
                    "sinh": "සම්බාධ නැතිව",
                    "span": 1
                },
                {
                    "pali": "අවෙරං",
                    "sinh": "වෛර නැතිව",
                    "span": 1
                },
                {
                    "pali": "අසපත්තං",
                    "sinh": "සතුරන් නැති",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තිට්ඨං",
                    "sinh": "සිටින්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "චරං",
                    "sinh": "ඇවිදින්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "නිසින්නො වා",
                    "sinh": "උන්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සයානො වා",
                    "sinh": "නිදන්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "යාවතස්ස විගතමිධො",
                    "sinh": "යම්තාක් කල් නොනිද‍ා ද (ඒතාක්)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතං සතිං",
                    "sinh": "මේ මෛත්‍රී සහගත සිහිය",
                    "span": 1
                },
                {
                    "pali": "අධිට්ඨෙය්‍ය",
                    "sinh": "ඉටන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මමේතං විහාරං",
                    "sinh": "මෙය බ්‍රහ්ම විහාරය (ශ්‍රේෂ්ඨ වාසය කිරීම) යි",
                    "span": 1
                },
                {
                    "pali": "ඉධමාහු",
                    "sinh": "මේ ශාසනයෙහි (බුද්ධාදී උතුමෝ) කීහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දිට්ඨිඤ් ච",
                    "sinh": "මීත්‍යාදෘෂ්ටියට",
                    "span": 1
                },
                {
                    "pali": "අනුපගම්ම",
                    "sinh": "නො පැමිණ",
                    "span": 1
                },
                {
                    "pali": "සීලවා",
                    "sinh": "සිල්වත් වූයේ",
                    "span": 1
                },
                {
                    "pali": "දස්සනෙන සම්පන්නෝ",
                    "sinh": "දර්ශනයෙන් යුක්ත වූයේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කාමෙසූ",
                    "sinh": "වස්තුකාමයන්හි",
                    "span": 1
                },
                {
                    "pali": "විනෙය්‍ය ගෙධං",
                    "sinh": "ගිජු බව දුරු කොට",
                    "span": 1
                },
                {
                    "pali": "නහි ජාතු",
                    "sinh": "ඒකාන්තයෙන් නො එන්නේ යි",
                    "span": 1
                },
                {
                    "pali": "ගබ්භසෙය්‍යං",
                    "sinh": "මවු කුස පිළිසිඳ ගැනීමට",
                    "span": 1
                },
                {
                    "pali": "පුනරෙති ති",
                    "sinh": "නැවත",
                    "span": 1
                }
            ]
        ]
    },
    "11-khandha-parittam": {
        "labels": [
            [
                0,
                2.428625
            ],
            [
                2.428625,
                23.908465
            ],
            [
                23.908465,
                42.312046
            ],
            [
                42.312046,
                67.515778
            ],
            [
                67.515778,
                81.493865
            ],
            [
                81.493865,
                95.63386
            ],
            [
                95.63386,
                112.094541
            ],
            [
                112.094541,
                140.212623
            ],
            [
                140.212623,
                175.022916
            ],
            [
                175.022916,
                194.451917
            ],
            [
                194.451917,
                224.728776
            ],
            [
                224.728776,
                252.361133
            ],
            [
                252.361133,
                266.663037
            ],
            [
                266.663037,
                289.76196
            ],
            [
                289.76196,
                310.000502
            ],
            [
                310.000502,
                331.102556
            ],
            [
                331.102556,
                353.337968
            ],
            [
                353.337968,
                365.157277
            ],
            [
                365.157277,
                407.685201
            ]
        ],
        "text": [
            [
                {
                    "pali": "ඛන්ධ පරිත්තං",
                    "sinh": "කඳ පිරිත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී.",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක්හි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවතෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "ආරාමෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන ඛො පන සමයෙන",
                    "sinh": "එසමයෙහි",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත් නුවර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤතරො භික්ඛු",
                    "sinh": "එක්තරා භික්ෂූ නමෙක්",
                    "span": 1
                },
                {
                    "pali": "අහිනා දට්ඨො",
                    "sinh": "සර්පයකු විසින් දෂ්ට කරන ලදුව",
                    "span": 1
                },
                {
                    "pali": "කාලකතො හොති",
                    "sinh": "කලුරිය කෙළේය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "එකල්හි",
                    "span": 1
                },
                {
                    "pali": "සම්බහුලා භික්ඛු",
                    "sinh": "බොහෝ භික්ෂූන් වහන්සේලා",
                    "span": 1
                },
                {
                    "pali": "යෙන භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ යම් තැනක ද",
                    "span": 1
                },
                {
                    "pali": "තෙනුපසංකමිංසු",
                    "sinh": "එතනට එළඹුනාහු ය",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "අභිවාදෙත්වා",
                    "sinh": "වැඳ",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත් පසෙක",
                    "span": 1
                },
                {
                    "pali": "නිසීදිංසු",
                    "sinh": "හුන්නාහු ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත් පසෙක",
                    "span": 1
                },
                {
                    "pali": "නිසින්නො ඛො",
                    "sinh": "හුන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "තෙ භික්ඛු",
                    "sinh": "ඒ භික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "එතදවොචුං",
                    "sinh": "මේ පුවත ද‍ැන්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ භන්තෙ සාවත්ථියං",
                    "sinh": "ස්වාමීන් වහන්ස, මෙම සැවැත්නුවර සමීපයෙහි",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤතරො භික්ඛු",
                    "sinh": "එක්තරා භික්ෂු නමෙක්",
                    "span": 1
                },
                {
                    "pali": "අහිනා දට්ඨො",
                    "sinh": "සර්පයකු විසින් දෂ්ට කරන ලද්දේ",
                    "span": 1
                },
                {
                    "pali": "කාල කතො’ ති",
                    "sinh": "කළුරිය කෙළේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නහ නූන සො භික්ඛවෙ භික්ඛු",
                    "sinh": "මහණෙනි, ඒකාන්තයෙන් ඒ භික්ෂු තෙම (නොම)",
                    "span": 1
                },
                {
                    "pali": "චත්තාරි අහිරාජ කුලානි",
                    "sinh": "සතර අභිරාජකුලය",
                    "span": 1
                },
                {
                    "pali": "මෙත්තෙන චිත්තෙන",
                    "sinh": "මෙත් සිතින්",
                    "span": 1
                },
                {
                    "pali": "ඵරි",
                    "sinh": "පැතිර නො වී ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සචෙහි",
                    "sinh": "ඉදින් වනාහි",
                    "span": 1
                },
                {
                    "pali": "සො භික්ඛවෙ භික්ඛු",
                    "sinh": "මහණෙනි, ඒ භික්ෂු තෙම",
                    "span": 1
                },
                {
                    "pali": "චත්තාරි අහිරාජ කුලානි",
                    "sinh": "සතර අහිරාජකුලයන්",
                    "span": 1
                },
                {
                    "pali": "මෙත්තෙන චිත්තෙන",
                    "sinh": "මෙත් සිතින්",
                    "span": 1
                },
                {
                    "pali": "එරෙය්‍ය",
                    "sinh": "පැතිරවී නම්",
                    "span": 1
                },
                {
                    "pali": "නහි",
                    "sinh": "(නොම)",
                    "span": 1
                },
                {
                    "pali": "සො භික්ඛවෙ භික්ඛු",
                    "sinh": "මහණෙනි, ඒ භික්ෂු තෙම",
                    "span": 1
                },
                {
                    "pali": "අභිනා දට්ඨො",
                    "sinh": "සර්පයා විසින් දෂ්ට කරන ලද්දේ",
                    "span": 1
                },
                {
                    "pali": "කාලංකරෙය්‍ය",
                    "sinh": "කලුරිය නො කරන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමානි",
                    "sinh": "කවරහුද යත්?",
                    "span": 1
                },
                {
                    "pali": "චත්තාරි අහිරාජකුලානි",
                    "sinh": "සතර අභිරාජකුලයෝ.",
                    "span": 1
                },
                {
                    "pali": "විරූපක්ඛං අහිරාජකුලං",
                    "sinh": "විරූපාක්ෂ නම් සර්ප රාජකුලය",
                    "span": 1
                },
                {
                    "pali": "එරාපථං අහිරාජකුලං",
                    "sinh": "ඒරාපථ නම් සර්ප රාජකුලය",
                    "span": 1
                },
                {
                    "pali": "ඡඛ්‍යාපුත්තං අහිරාජකුලං",
                    "sinh": "ඡඛ්‍යාපුත්ත නම් සර්ප රාජකුලය",
                    "span": 1
                },
                {
                    "pali": "කණ්හා ගොතමකං අහිරාජකුලං",
                    "sinh": "කණ්හා ගොතමක නම් සර්ප රාජකුලය (යන මේ සතරයි.)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නහ නූන සො භික්ඛවෙ භික්ඛු",
                    "sinh": "මහණෙනි, ඒකාන්තයෙන් ඒ භික්ෂු තෙම (නොම)",
                    "span": 1
                },
                {
                    "pali": "ඉමානි චත්තාරි අහිරාජ කුලානි",
                    "sinh": "මේ සතර අභිරාජකුලය",
                    "span": 1
                },
                {
                    "pali": "මෙත්තෙන චිත්තෙන",
                    "sinh": "මෙත් සිතින්",
                    "span": 1
                },
                {
                    "pali": "ඵරි",
                    "sinh": "පැතිර නො වී ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සචෙහි",
                    "sinh": "ඉදින් වනාහි",
                    "span": 1
                },
                {
                    "pali": "සො භික්ඛවෙ භික්ඛු",
                    "sinh": "මහණෙනි, ඒ භික්ෂු තෙම",
                    "span": 1
                },
                {
                    "pali": "ඉමානි චත්තාරි අහිරාජ කුලානි",
                    "sinh": "මේ සතර අහිරාජකුලයන්",
                    "span": 1
                },
                {
                    "pali": "මෙත්තෙන චිත්තෙන",
                    "sinh": "මෙත් සිතින්",
                    "span": 1
                },
                {
                    "pali": "එරෙය්‍ය",
                    "sinh": "පැතිරවී නම්",
                    "span": 1
                },
                {
                    "pali": "නහි",
                    "sinh": "(නොම)",
                    "span": 1
                },
                {
                    "pali": "සො භික්ඛවෙ භික්ඛු",
                    "sinh": "මහණෙනි, ඒ භික්ෂු තෙම",
                    "span": 1
                },
                {
                    "pali": "අභිනා දට්ඨො",
                    "sinh": "සර්පයා විසින් දෂ්ට කරන ලද්දේ",
                    "span": 1
                },
                {
                    "pali": "කාලංකරෙය්‍ය",
                    "sinh": "කලුරිය නො කරන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනුජානාමි",
                    "sinh": "(අවසර දෙමි) අනුදනිමි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "ඉමානි චත්තාරි අහිරාජකුලානි",
                    "sinh": "මේ සතර සර්ප රාජකුලයන්",
                    "span": 1
                },
                {
                    "pali": "මෙත්තේන චිත්තෙන",
                    "sinh": "මෙත් සිතින්",
                    "span": 1
                },
                {
                    "pali": "එරිතුං",
                    "sinh": "පතුරු වන්නට (කුමක් හෙයින්ද යත්?)",
                    "span": 1
                },
                {
                    "pali": "අත්ත ගුත්තියා",
                    "sinh": "තමාගේ සංවරණය පිණිස",
                    "span": 1
                },
                {
                    "pali": "අත්තරක්ඛාය",
                    "sinh": "තමහට ආරක්ෂාව පිණිස",
                    "span": 1
                },
                {
                    "pali": "අත්තපරිත්තායාති",
                    "sinh": "තමාහට පිරිත් පිණිස පවත්නා හෙයිනි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ මෙසේ වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "ඉදං වත්වා",
                    "sinh": "මෙසේ වද‍ාරා",
                    "span": 1
                },
                {
                    "pali": "සුගතො",
                    "sinh": "සුගත නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අථාපරං",
                    "sinh": "නැවත ද මත්තෙහි",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "සත්ථා",
                    "sinh": "ශාස්තෘෘන් වහන්සේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරූපක්ඛෙහි",
                    "sinh": "විරූපාක්ෂ නම් සර්ප කුලයන් සමග ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රීය",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රිය",
                    "span": 1
                },
                {
                    "pali": "ඵරාපථෙහි",
                    "sinh": "ඒරාපථ නම් සර්ප රාජකුලයන් සමඟ ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "ඡඛ්‍යාපුත්තෙහි",
                    "sinh": "ඡඛ්‍යාපුත්ත නම් නාග කුලයන් සමඟ ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ.",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රිය",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රීය",
                    "span": 1
                },
                {
                    "pali": "කණ්භගොතමකෙහි ව",
                    "sinh": "කණ්භාගොතමක නම් සර්ප කුලයන් සමඟ ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අපාදකෙහි",
                    "sinh": "පා නැති දීර්ඝ ජාතීන් සමග ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රීය",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රිය",
                    "span": 1
                },
                {
                    "pali": "දීපාදකෙහි",
                    "sinh": "(දෙපා ඇති මිනිස් ආදී) දීපාදකයන් සමඟ ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "චතුප්පදෙහි",
                    "sinh": "සිවුපා සතුන් සමඟ ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ.",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රිය",
                    "span": 1
                },
                {
                    "pali": "මෙත්තං",
                    "sinh": "මෛත්‍රීය",
                    "span": 1
                },
                {
                    "pali": "බහුප්පදෙහි",
                    "sinh": "(පත්තෑ ආදී) බොහෝ පා ඇත්තවුන් සමඟ ය",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මා මං හිංසි අපාදකො",
                    "sinh": "මා පා නැති සත්වයෙක් නො පෙළාවා",
                    "span": 1
                },
                {
                    "pali": "මා මං හිංසි දිපාදකො",
                    "sinh": "මා දීපාදක සත්වයෙක් නො පෙළාවා",
                    "span": 1
                },
                {
                    "pali": "මා මං හිංසි චතුස්පද‍ො",
                    "sinh": "මා සිවුපා සත්වයෙක් නො පෙළාවා",
                    "span": 1
                },
                {
                    "pali": "මා මං හිංසි බහුප්පද‍ො",
                    "sinh": "මා බොහෝ පා ඇති සත්වයෙක් නො පෙළාවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබෙ සත්තා",
                    "sinh": "සියලු සත්හු ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බ පාණා",
                    "sinh": "සියලු ප්‍රාණීහුද",
                    "span": 1
                },
                {
                    "pali": "සබ්බෙ භුතා ච කෙවලා",
                    "sinh": "හුදෙක් සියලු භූතයෝ ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බෙ",
                    "sinh": "හැමදෙන",
                    "span": 1
                },
                {
                    "pali": "භද්‍රානි",
                    "sinh": "යහපතක්ම",
                    "span": 1
                },
                {
                    "pali": "පස්සන්තු",
                    "sinh": "දකිත්වා.",
                    "span": 1
                },
                {
                    "pali": "මා කඤ්චි පාපමාගමා",
                    "sinh": "කිසිවකුත් කරා දුකෙක් නො පැමිණේවා!",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අප්පමාණො බුද්ධො",
                    "sinh": "බුද්ධ ගුණය අපමණය",
                    "span": 1
                },
                {
                    "pali": "අප්පමාණො ධම්මො",
                    "sinh": "දහම් ගුණය අපමණය",
                    "span": 1
                },
                {
                    "pali": "අප්පමාණො සංඝො",
                    "sinh": "සංඝ ගුණය අපමණය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පමාණවන්තානි",
                    "sinh": "ප්‍රමාණ කළ හැක",
                    "span": 1
                },
                {
                    "pali": "සිරිංසපානි",
                    "sinh": "සිරිංසපයෝ හෙවත් දීර්ඝ ජාතීහු (එනම්)",
                    "span": 1
                },
                {
                    "pali": "අභි",
                    "sinh": "සර්පයෝ ය",
                    "span": 1
                },
                {
                    "pali": "විච්ඡිකා",
                    "sinh": "ගෝනුස්සෝ ය",
                    "span": 1
                },
                {
                    "pali": "සතපදී",
                    "sinh": "සතපදීහු ය (පත්තෑ ආදීහු)",
                    "span": 1
                },
                {
                    "pali": "උණ්ණානාභි",
                    "sinh": "මකුළුවෝ ය",
                    "span": 1
                },
                {
                    "pali": "සරබු",
                    "sinh": "සිකනල්ලු ය",
                    "span": 1
                },
                {
                    "pali": "මූසිකා",
                    "sinh": "මූසිකය හ (යන මේ වශයෙනි)",
                    "span": 1
                },
                {
                    "pali": "කතා මෙ රක්ඛා",
                    "sinh": "මා විසින් ආරක්ෂා කරන ලද්ද‍ාහ",
                    "span": 1
                },
                {
                    "pali": "කතා මෙ පරිත්තා",
                    "sinh": "මා විසින් පිරිත් කරන ලද්ද‍ාහ",
                    "span": 1
                },
                {
                    "pali": "පටික්කමන්තු",
                    "sinh": "පහවෙත්වා",
                    "span": 1
                },
                {
                    "pali": "භූතානි",
                    "sinh": "භූතයෝ",
                    "span": 1
                },
                {
                    "pali": "සො අහං",
                    "sinh": "ඒ මම",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර කරමි",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර කරමි",
                    "span": 1
                },
                {
                    "pali": "සත්තන්නං සම්මා සම්බුද්ධානං",
                    "sinh": "සත් සම්බුදුවරයන්ට වහන්සේ ලාට",
                    "span": 1
                }
            ]
        ]
    },
    "12-mettanisamsa": {
        "labels": [
            [
                0.686303,
                3.088365
            ],
            [
                3.088365,
                23.986303
            ],
            [
                23.986303,
                47.801031
            ],
            [
                47.66377,
                91.278351
            ],
            [
                91.278351,
                115.745066
            ],
            [
                115.745066,
                155.859499
            ],
            [
                155.859499,
                195.596465
            ],
            [
                195.596465,
                210.798085
            ]
        ],
        "text": [
            [
                {
                    "pali": "මෙත්තානිසංස සුත්තං",
                    "sinh": "මෙත්තානිසංස සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී.",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත් නුවරැ",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "ආරාමයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තත්‍ර ඛො",
                    "sinh": "එකල්හි වනාහි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවත්හු",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "භික්‍ෂූන්",
                    "span": 1
                },
                {
                    "pali": "ආමන්තෙසි",
                    "sinh": "ඇමතූහ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවො’ති",
                    "sinh": "මහණෙනි කියා",
                    "span": 1
                },
                {
                    "pali": "භදන්තෙති",
                    "sinh": "වහන්සැ’යි",
                    "span": 1
                },
                {
                    "pali": "තෙ භික්ඛු",
                    "sinh": "ඒ භික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "පච්චස්සොසුං",
                    "sinh": "පිළිවදන් දුන්හ.",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මෙත්තාය",
                    "sinh": "මෛත්‍රී",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "චෙතොවිමුත්තියා",
                    "sinh": "චේතෝ විමුක්තිය ගේ",
                    "span": 1
                },
                {
                    "pali": "ආසෙවිතාය",
                    "sinh": "ආදරයෙන් සෙවුනා ලද",
                    "span": 1
                },
                {
                    "pali": "භාවිතාය",
                    "sinh": "භාවිතා කරන ලද",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතාය",
                    "sinh": "බහුල වශයෙන් වඩනා ලද",
                    "span": 1
                },
                {
                    "pali": "යානීකතාය",
                    "sinh": "යානාවක් මෙන් කරන ලද",
                    "span": 1
                },
                {
                    "pali": "වත්ථුකතාය",
                    "sinh": "වස්තුවක් මෙන් කරන ලද",
                    "span": 1
                },
                {
                    "pali": "අනුට්ඨිතාය",
                    "sinh": "එළඹ සිටියා වූ",
                    "span": 1
                },
                {
                    "pali": "පරිචිතාය",
                    "sinh": "පුරුදු කරන ලද",
                    "span": 1
                },
                {
                    "pali": "සුසමාරද්ධාය",
                    "sinh": "මොනවට පටන් ගන්නා ලද",
                    "span": 1
                },
                {
                    "pali": "එකාදසානිසංසා",
                    "sinh": "එකොළොස් අනුසස්හු",
                    "span": 1
                },
                {
                    "pali": "පාටි කංඛා’ති",
                    "sinh": "කැමැති විය යුත්තාහ.",
                    "span": 1
                },
                {
                    "pali": "කතමෙ එකාදස?",
                    "sinh": "කවර එකොළොසෙක් ද යත්.-",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "1. සුඛංසුපති",
                    "sinh": "සැපසේ නිදි යි",
                    "span": 1
                },
                {
                    "pali": "2. සුඛං පටිබුජ්ඣති",
                    "sinh": "සැපසේ පුබුදි යි",
                    "span": 1
                },
                {
                    "pali": "3. පාපකං සුපිනං න පස්සති",
                    "sinh": "නපුරු සීන නොදකි යි",
                    "span": 1
                },
                {
                    "pali": "4. මනුස්සානං පියො හොති",
                    "sinh": "මිනිසුන්ට ප්‍රිය වෙයි",
                    "span": 1
                },
                {
                    "pali": "5. අමනුස්සානං පියො හොති",
                    "sinh": "නොමිනිසුන්ට ද ප්‍රිය වෙ යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "6. දෙවතා රක්ඛන්ති",
                    "sinh": "දෙවියෝ රකිති",
                    "span": 1
                },
                {
                    "pali": "7. නාස්ස",
                    "sinh": "නොම ඔහුගේ ගේ සිරුරෙහි",
                    "span": 1
                },
                {
                    "pali": "අග්ගි වා",
                    "sinh": "ගිනි හෝ",
                    "span": 1
                },
                {
                    "pali": "විසං වා",
                    "sinh": "විස හෝ",
                    "span": 1
                },
                {
                    "pali": "සත්ථං වා",
                    "sinh": "සැත් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඛමති",
                    "sinh": "වදි යි",
                    "span": 1
                },
                {
                    "pali": "8. තුවටං",
                    "sinh": "වහා",
                    "span": 1
                },
                {
                    "pali": "චිත්තං",
                    "sinh": "සිත",
                    "span": 1
                },
                {
                    "pali": "සමාධියති",
                    "sinh": "සමාහිත වෙයි",
                    "span": 1
                },
                {
                    "pali": "9. මුඛවණ්ණො විප්පසීදති",
                    "sinh": "මුහුණ පැහැපත් වෙයි",
                    "span": 1
                },
                {
                    "pali": "10. අසම්මූල්හො",
                    "sinh": "නො මුළාව",
                    "span": 1
                },
                {
                    "pali": "කාළංකරොති",
                    "sinh": "කලුරිය කෙරෙයි",
                    "span": 1
                },
                {
                    "pali": "11. උත්තරිං අප්පටිවිජ්ඣන්තො",
                    "sinh": "මතුයෙහි රහත් වීමට නො හැකි වී නම්",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මලොකුපගොහොති",
                    "sinh": "බඹ ලොව උපදී.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මෙත්තාය",
                    "sinh": "මෛත්‍රී",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "චෙතොවිමුත්තියා",
                    "sinh": "චේතෝ විමුක්තිය ගේ",
                    "span": 1
                },
                {
                    "pali": "ආසෙවිතාය",
                    "sinh": "ආදරයෙන් සෙවුනා ලද",
                    "span": 1
                },
                {
                    "pali": "භාවිතාය",
                    "sinh": "භාවිතා කරන ලද",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතාය",
                    "sinh": "බහුල වශයෙන් වඩනා ලද",
                    "span": 1
                },
                {
                    "pali": "යානීකතාය",
                    "sinh": "යානාවක් මෙන් කරන ලද",
                    "span": 1
                },
                {
                    "pali": "වත්ථුකතාය",
                    "sinh": "වස්තුවක් මෙන් කරන ලද",
                    "span": 1
                },
                {
                    "pali": "අනුට්ඨිතාය",
                    "sinh": "එළඹ සිටියා වූ",
                    "span": 1
                },
                {
                    "pali": "පරිචිතාය",
                    "sinh": "පුරුදු කරන ලද",
                    "span": 1
                },
                {
                    "pali": "සුසමාරද්ධාය",
                    "sinh": "මොනවට පටන් ගන්නා ලද",
                    "span": 1
                },
                {
                    "pali": "ඉමෙ එකාදසානිසංසා",
                    "sinh": "මේ එකොළොස් අනුසස්හු",
                    "span": 1
                },
                {
                    "pali": "පාටිකංඛා’ති",
                    "sinh": "කැමැති විය යුත්තාහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච",
                    "sinh": "මෙම සූත්‍රය වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අත්ත මනා",
                    "sinh": "සතුටු සිත් ඇති",
                    "span": 1
                },
                {
                    "pali": "තෙ භික්ඛු",
                    "sinh": "ඒ භික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවත්හු ගේ",
                    "span": 1
                },
                {
                    "pali": "භාසිතං",
                    "sinh": "භාෂිතයට (දේශනාවට)",
                    "span": 1
                },
                {
                    "pali": "අභිනන්දුංති",
                    "sinh": "සතුටු වූහ.",
                    "span": 1
                }
            ]
        ]
    },
    "13-mittanisamsa": {
        "labels": [
            [
                0.167284,
                2.776911
            ],
            [
                2.776911,
                23.386278
            ],
            [
                23.386278,
                43.560707
            ],
            [
                43.560707,
                64.772295
            ],
            [
                64.772295,
                85.314749
            ],
            [
                85.314749,
                105.288437
            ],
            [
                105.288437,
                125.295582
            ],
            [
                125.295582,
                144.432851
            ],
            [
                144.432851,
                165.309872
            ],
            [
                165.309872,
                184.614425
            ],
            [
                184.614425,
                205.190335
            ]
        ],
        "text": [
            [
                {
                    "pali": "මිත්තානිසංස සුත්තං",
                    "sinh": "මිත්තානිසංසය සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පහූතභක්ඛො",
                    "sinh": "බොහෝ කනු, බොනු ලැබීම",
                    "span": 1
                },
                {
                    "pali": "භවති",
                    "sinh": "වෙයි, සිදුවෙයි",
                    "span": 1
                },
                {
                    "pali": "විප්පවුත්ථො",
                    "sinh": "බැහැර තැනක ගියේ",
                    "span": 1
                },
                {
                    "pali": "සකාඝරා",
                    "sinh": "ස්වකීය ගෙයින්",
                    "span": 1
                },
                {
                    "pali": "බහු",
                    "sinh": "බොහෝ දෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "නං",
                    "sinh": "ඒ මිතුරා ඇසුරු කොට",
                    "span": 1
                },
                {
                    "pali": "උපජීවන්ති",
                    "sinh": "ජීවත්වෙති.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යම්පුද්ගලයෙක් තෙම",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන්ට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නො කෙරේ ද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං යං ජනපදං යාතී",
                    "sinh": "යම් යම් ජනපදයකට ගියේ ද",
                    "span": 1
                },
                {
                    "pali": "නිගමෙ",
                    "sinh": "නියම් ගමකට",
                    "span": 1
                },
                {
                    "pali": "රාජධානියො",
                    "sinh": "රාජධානියකට ගියේ ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බත්ථ",
                    "sinh": "ඒ හැම තන්හි ම",
                    "span": 1
                },
                {
                    "pali": "පූජිතො හොති",
                    "sinh": "පුදනු ලැබෙයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නො කෙරේ ද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නාස්ස",
                    "sinh": "ඔහුට (නොම)",
                    "span": 1
                },
                {
                    "pali": "චොරා",
                    "sinh": "සොරු",
                    "span": 1
                },
                {
                    "pali": "පසහන්ති",
                    "sinh": "ළං නො වෙත්",
                    "span": 1
                },
                {
                    "pali": "නාතිමඤ්ඤෙති",
                    "sinh": "අවමන් නො කෙරෙයි",
                    "span": 1
                },
                {
                    "pali": "ඛත්තියො",
                    "sinh": "රජතෙම",
                    "span": 1
                },
                {
                    "pali": "සබ්බෙ අමිත්තෙ",
                    "sinh": "හැම සතුරන්",
                    "span": 1
                },
                {
                    "pali": "තරති",
                    "sinh": "දුරු කෙරෙයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නොවේ ද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අක්කුද්ධො",
                    "sinh": "නොද‍ැහැවියේ (කෝප නොවී)",
                    "span": 1
                },
                {
                    "pali": "සඝරං",
                    "sinh": "සියගෙට",
                    "span": 1
                },
                {
                    "pali": "එති",
                    "sinh": "එයි",
                    "span": 1
                },
                {
                    "pali": "සභාය",
                    "sinh": "සභාවෙහි",
                    "span": 1
                },
                {
                    "pali": "පටිනන්දිතො",
                    "sinh": "සතුටු වූයේ",
                    "span": 1
                },
                {
                    "pali": "ඤ‍ාතීනං",
                    "sinh": "ඤ‍ාතීන් හට",
                    "span": 1
                },
                {
                    "pali": "උත්තමො හොති",
                    "sinh": "උතුම් වෙයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නො වේද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සක්කත්වා",
                    "sinh": "අනුන්ට සත්කාර කොට",
                    "span": 1
                },
                {
                    "pali": "සක්කතො හොති",
                    "sinh": "සත්කාර ලබන්නෙක් වෙයි",
                    "span": 1
                },
                {
                    "pali": "ගරු හොති",
                    "sinh": "තෙමේ ද ගරු කටයුතු වෙයි",
                    "span": 1
                },
                {
                    "pali": "සගාරවො",
                    "sinh": "අනුන් කෙරෙහි ගෞරව සහිත වූයේ",
                    "span": 1
                },
                {
                    "pali": "වණ්ණ කිත්ති භතො හොති",
                    "sinh": "වර්ණකීර්ති දෙක උසුලන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තාන",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නො වේද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පූජකො",
                    "sinh": "මිත්‍රයන් පුදන තැනැත්තේ",
                    "span": 1
                },
                {
                    "pali": "ලභතෙ පූජං",
                    "sinh": "තෙමේ ද පුද ලබයි",
                    "span": 1
                },
                {
                    "pali": "වන්දකො",
                    "sinh": "බුද්ධාදි කලණ මිතුරන් වැන්දේ",
                    "span": 1
                },
                {
                    "pali": "පටිවන්දනං",
                    "sinh": "තෙමේ ද පෙරළා වැඳුම් ලබයි",
                    "span": 1
                },
                {
                    "pali": "යසො",
                    "sinh": "යසසට ද",
                    "span": 1
                },
                {
                    "pali": "කිත්තිං ච",
                    "sinh": "කීර්තියට ද",
                    "span": 1
                },
                {
                    "pali": "පප්පොති",
                    "sinh": "පැමිණෙයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නොවේද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අග්ගි යථා",
                    "sinh": "දිලිසෙන ගිනි සෙයින්",
                    "span": 1
                },
                {
                    "pali": "පජ්ජලති",
                    "sinh": "ඉසුරෙන් දිලිසෙයි",
                    "span": 1
                },
                {
                    "pali": "දෙවතා ව",
                    "sinh": "දෙවියකු මෙන්",
                    "span": 1
                },
                {
                    "pali": "විරොචති",
                    "sinh": "බබලයි",
                    "span": 1
                },
                {
                    "pali": "සිරියා",
                    "sinh": "ශ්‍රීය විසින්",
                    "span": 1
                },
                {
                    "pali": "අජහිතො",
                    "sinh": "හොති අත් නොහරන ලද්දේ වෙයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහි නොවේ ද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගාවො",
                    "sinh": "ගෙරිහූ",
                    "span": 1
                },
                {
                    "pali": "තස්ස",
                    "sinh": "ඕහට",
                    "span": 1
                },
                {
                    "pali": "පජායන්ති",
                    "sinh": "පලදෙති",
                    "span": 1
                },
                {
                    "pali": "ඛෙත්තෙ",
                    "sinh": "ක්ෂේත්‍රයෙහි",
                    "span": 1
                },
                {
                    "pali": "වුත්තං",
                    "sinh": "වපුළතාක්",
                    "span": 1
                },
                {
                    "pali": "විරූහති",
                    "sinh": "පැල හටගනී",
                    "span": 1
                },
                {
                    "pali": "පුත්තානං ඵලමස්නාති",
                    "sinh": "දරු සැප වළඳයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහි නොවේ ද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දරිතො",
                    "sinh": "ද‍ැදුරෙන් (පර්වත විවරයෙන්) හෝ",
                    "span": 1
                },
                {
                    "pali": "පබ්බතො වා",
                    "sinh": "පර්වතයෙන් හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛාතො",
                    "sinh": "රුකින් (ගසකින්) හෝ",
                    "span": 1
                },
                {
                    "pali": "පතිතො",
                    "sinh": "වැටුණා වූ",
                    "span": 1
                },
                {
                    "pali": "නරො",
                    "sinh": "සත්වතෙම",
                    "span": 1
                },
                {
                    "pali": "චුතො",
                    "sinh": "යමකින් ගිලිහුණා වූ",
                    "span": 1
                },
                {
                    "pali": "පතිට්ඨං ලභති",
                    "sinh": "පිහිට ලබයි.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නො කෙරේද (හෙතෙම)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරුළ්හමූල සන්තානාං",
                    "sinh": "වැඩුණු මුල් හා නුග අරළු ඇති",
                    "span": 1
                },
                {
                    "pali": "නිග්‍රොධමිව මාලුතො",
                    "sinh": "නුගරුකක් (සොලවා එලන්ට නො හැකි) සුළඟ සෙයින්",
                    "span": 1
                },
                {
                    "pali": "අමිත්තා",
                    "sinh": "සතුරෝ",
                    "span": 1
                },
                {
                    "pali": "නප්පසහන්ති",
                    "sinh": "ඔහු මැඩපවත්වන්නට නො හැකි වෙත්.",
                    "span": 1
                },
                {
                    "pali": "යො",
                    "sinh": "යමෙක්",
                    "span": 1
                },
                {
                    "pali": "මිත්තානං",
                    "sinh": "මිතුරන් හට",
                    "span": 1
                },
                {
                    "pali": "න දූභති",
                    "sinh": "ද්‍රෝහ නො වේද (හෙතෙම)",
                    "span": 1
                }
            ]
        ]
    },
    "14-mora-parittam": {
        "labels": [
            [
                0.281506,
                2.627393
            ],
            [
                2.627393,
                33.405428
            ],
            [
                33.405428,
                48.278351
            ],
            [
                48.278351,
                72.206396
            ],
            [
                72.206396,
                102.280665
            ],
            [
                102.280665,
                116.872081
            ],
            [
                116.872081,
                143.474437
            ]
        ],
        "text": [
            [
                {
                    "pali": "මොරපරිත්තං",
                    "sinh": "මෝර පිරිත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උදෙතයං",
                    "sinh": "මේ හිරු තෙම නැගෙයි",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුමා",
                    "sinh": "ඇස් ඇති",
                    "span": 1
                },
                {
                    "pali": "එකරාජා",
                    "sinh": "ඒකරාජ වූ",
                    "span": 1
                },
                {
                    "pali": "හරිස්සවණ්ණො",
                    "sinh": "රන්වන් වූ",
                    "span": 1
                },
                {
                    "pali": "පඨවිප්පභාසො",
                    "sinh": "පොළොව බබුළුවන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "තං",
                    "sinh": "එහෙයින්",
                    "span": 1
                },
                {
                    "pali": "තං",
                    "sinh": "තා",
                    "span": 1
                },
                {
                    "pali": "නමස්සාමි",
                    "sinh": "වඳිමි",
                    "span": 1
                },
                {
                    "pali": "හරිස්සවණ්ණං",
                    "sinh": "රන්වන් වූ",
                    "span": 1
                },
                {
                    "pali": "පඨවිප්පභාසං",
                    "sinh": "පොළොව බබුළුවන",
                    "span": 1
                },
                {
                    "pali": "තයා",
                    "sinh": "තා විසින්",
                    "span": 1
                },
                {
                    "pali": "අජ්ජ",
                    "sinh": "අද",
                    "span": 1
                },
                {
                    "pali": "ගුත්තා",
                    "sinh": "රක්නා ලද",
                    "span": 1
                },
                {
                    "pali": "විහරෙමු",
                    "sinh": "අපි (සුවසේ) වසමු",
                    "span": 1
                },
                {
                    "pali": "දිවසං",
                    "sinh": "මේ දවස",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙ බ්‍රහ්මණා",
                    "sinh": "යම් ක්ෂීණාශ්‍රව බ්‍රාහ්මණ කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "වෙදගු",
                    "sinh": "සම්‍යක්සම්බෝධියට පැමිණියෝ ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බ ධම්මෙ",
                    "sinh": "සියළු ඤෙය ධර්මයන් ද‍ැන",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "ඔවුන්ට",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාරය වේවා",
                    "span": 1
                },
                {
                    "pali": "තෙ ච",
                    "sinh": "ඒ භාග්‍යවත්හුදු",
                    "span": 1
                },
                {
                    "pali": "මං",
                    "sinh": "මා",
                    "span": 1
                },
                {
                    "pali": "පාලයන්තු",
                    "sinh": "රකිත්වා, පාලනය කරත්වා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නමත්ථු",
                    "sinh": "නමස්කාරය වේවා",
                    "span": 1
                },
                {
                    "pali": "බුද්ධානං",
                    "sinh": "පෙර බුදුවරුනට",
                    "span": 1
                },
                {
                    "pali": "නමත්ථු",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "බොධියා",
                    "sinh": "(සතර මග සතර ඵලයයි කියන ලද) බොධියට",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "විමුත්තානං",
                    "sinh": "කෙලෙසුන් කෙරෙන් මිදුනා වූ ඒ බුදුවරයන්ට",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "විමුක්තියා",
                    "sinh": "(තදංගවිමුක්ති ආදී) පඤ්ච විමුක්තියට",
                    "span": 1
                },
                {
                    "pali": "ඉමං",
                    "sinh": "මේ (පිරිත)",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "ඒ තෙම (මොනරා)",
                    "span": 1
                },
                {
                    "pali": "පරිත්තං කත්වා",
                    "sinh": "පිරිත (ආරක්ෂා) කොටගෙන",
                    "span": 1
                },
                {
                    "pali": "මොරො",
                    "sinh": "මයුරා (මොනරා)",
                    "span": 1
                },
                {
                    "pali": "චරති",
                    "sinh": "හැසිරෙයි.",
                    "span": 1
                },
                {
                    "pali": "එසනා",
                    "sinh": "අහර සෙවීමෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අපෙතයං",
                    "sinh": "මේ හිරු තෙම පහවෙයි",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුමා",
                    "sinh": "ඇස් ඇති",
                    "span": 1
                },
                {
                    "pali": "එකරාජා",
                    "sinh": "ඒකරාජ වූ",
                    "span": 1
                },
                {
                    "pali": "හරිස්සවණ්ණො",
                    "sinh": "රන්වන් වූ",
                    "span": 1
                },
                {
                    "pali": "පඨවිප්පභාසො",
                    "sinh": "පොළොව බබුළුවන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "තං",
                    "sinh": "එහෙයින්",
                    "span": 1
                },
                {
                    "pali": "තං",
                    "sinh": "තා",
                    "span": 1
                },
                {
                    "pali": "නමස්සාමි",
                    "sinh": "වඳිමි",
                    "span": 1
                },
                {
                    "pali": "හරිස්සවණ්ණං",
                    "sinh": "රන්වන් වූ",
                    "span": 1
                },
                {
                    "pali": "පඨවිප්පභාසං",
                    "sinh": "පොළොව බබුළුවන",
                    "span": 1
                },
                {
                    "pali": "තයා",
                    "sinh": "තා විසින්",
                    "span": 1
                },
                {
                    "pali": "අජ්ජ",
                    "sinh": "අද",
                    "span": 1
                },
                {
                    "pali": "ගුත්තා",
                    "sinh": "රක්නා ලද",
                    "span": 1
                },
                {
                    "pali": "විහරෙමු",
                    "sinh": "අපි (සුවසේ) වසමු",
                    "span": 1
                },
                {
                    "pali": "රත්තිං",
                    "sinh": "රැයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙ බ්‍රහ්මණා",
                    "sinh": "යම් ක්ෂීණාශ්‍රව බ්‍රාහ්මණ කෙනෙක්",
                    "span": 1
                },
                {
                    "pali": "වෙදගු",
                    "sinh": "සම්‍යක්සම්බෝධියට පැමිණියෝ ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බ ධම්මෙ",
                    "sinh": "සියළු ඤෙය ධර්මයන් ද‍ැන",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "ඔවුන්ට",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මාගේ",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාරය වේවා",
                    "span": 1
                },
                {
                    "pali": "තෙ ච",
                    "sinh": "ඒ භාග්‍යවත්හුදු",
                    "span": 1
                },
                {
                    "pali": "මං",
                    "sinh": "මා",
                    "span": 1
                },
                {
                    "pali": "පාලයන්තු",
                    "sinh": "රක්ෂා කෙරෙත්වා, පාලනය කරත්වා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නමත්ථු",
                    "sinh": "නමස්කාරය වේවා",
                    "span": 1
                },
                {
                    "pali": "බුද්ධානං",
                    "sinh": "පෙර බුදුවරුනට",
                    "span": 1
                },
                {
                    "pali": "නමත්ථු",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "බොධියා",
                    "sinh": "(සතර මග සතර ඵලයයි කියන ලද) බොධියට",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "විමුත්තානං",
                    "sinh": "කෙලෙසුන් කෙරෙන් මිදුනා වූ ඒ බුදුවරයන්ට",
                    "span": 1
                },
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "විමුක්තියා",
                    "sinh": "(තදංගවිමුක්ති ආදී) පඤ්ච විමුක්තියට",
                    "span": 1
                },
                {
                    "pali": "ඉමං",
                    "sinh": "මේ (පිරිත)",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "ඒ තෙම (මොනරා)",
                    "span": 1
                },
                {
                    "pali": "පරිත්තං කත්වා",
                    "sinh": "පිරිත (ආරක්ෂා) කොටගෙන",
                    "span": 1
                },
                {
                    "pali": "මොරො",
                    "sinh": "මයුරා (මොනරා)",
                    "span": 1
                },
                {
                    "pali": "වාසං අකප්පයි",
                    "sinh": "වාසය කෙළේ යි.",
                    "span": 1
                }
            ]
        ]
    },
    "15-canda-parittam": {
        "labels": [
            [
                0.465508,
                2.493793
            ],
            [
                2.493793,
                23.042651
            ],
            [
                23.042651,
                38.437669
            ],
            [
                38.437669,
                58.587519
            ],
            [
                58.587519,
                81.763173
            ],
            [
                81.763173,
                95.362659
            ],
            [
                95.362659,
                117.308041
            ],
            [
                117.308041,
                148.164578
            ],
            [
                148.164578,
                162.030069
            ],
            [
                162.030069,
                182.645428
            ],
            [
                182.645428,
                204.258304
            ]
        ],
        "text": [
            [
                {
                    "pali": "චන්දපරිත්තං",
                    "sinh": "චන්ද පිරිත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත්නුවර සමීපයෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු මහ සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "ආරාමයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙත ඛො පන සමයෙන",
                    "sinh": "එ සමයෙහි වනාහි",
                    "span": 1
                },
                {
                    "pali": "චන්දිමා දෙවපුත්තො",
                    "sinh": "සඳ දෙව්පුත් තෙමේ",
                    "span": 1
                },
                {
                    "pali": "රාහුනා අසුරින්දෙන",
                    "sinh": "රාහු අසුරේන්ද්‍රයා විසින්",
                    "span": 1
                },
                {
                    "pali": "ගහිතො හොති",
                    "sinh": "ගන්නා ලද්දේ වෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "චන්දිමා දෙවපුත්තො",
                    "sinh": "සඳ දෙව්පුත් තෙමේ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "බුදුරදුත්",
                    "span": 1
                },
                {
                    "pali": "අනුස්සරමානො",
                    "sinh": "සිහි කරමින්",
                    "span": 1
                },
                {
                    "pali": "තායං වේලායං",
                    "sinh": "එ වේලෙහි",
                    "span": 1
                },
                {
                    "pali": "ඉමං ගාථං",
                    "sinh": "මේ ගාථාව",
                    "span": 1
                },
                {
                    "pali": "අභාසි",
                    "sinh": "කීය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "නුඹ වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "බුද්ධවීරත්ථු",
                    "sinh": "බුද්ධවීරයන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "විප්පමුත්තොසි",
                    "sinh": "කෙලෙසුන් කෙරෙන් විශේෂයෙන් මිදුණු",
                    "span": 1
                },
                {
                    "pali": "සබ්බධි",
                    "sinh": "සියලු කල්හි.",
                    "span": 1
                },
                {
                    "pali": "සම්බාධ පටිපන්නෝස්මි",
                    "sinh": "(මම) සම්බාධයකට පැමිණියෙමි",
                    "span": 1
                },
                {
                    "pali": "තස්ස මෙ",
                    "sinh": "ඒ මට",
                    "span": 1
                },
                {
                    "pali": "සරණං භව",
                    "sinh": "පිළිසරණ වුව මැනව.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "එකල්හි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "චන්දිමං දෙවපුත්තං",
                    "sinh": "සඳ දෙව් පුතුන්",
                    "span": 1
                },
                {
                    "pali": "ආරබ්හ",
                    "sinh": "අරභයා",
                    "span": 1
                },
                {
                    "pali": "රාහුං අසුරින්දං",
                    "sinh": "රාහු අසුරිඳු හට",
                    "span": 1
                },
                {
                    "pali": "ගාථාය",
                    "sinh": "ගාථාවකින්",
                    "span": 1
                },
                {
                    "pali": "අජ්ඣභාසි",
                    "sinh": "මෙසේ වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථාගතං",
                    "sinh": "තථාගතයන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අරහන්තං",
                    "sinh": "අරහත් වූ",
                    "span": 1
                },
                {
                    "pali": "චන්දිමා",
                    "sinh": "සඳදෙව් පුත් තෙමේ",
                    "span": 1
                },
                {
                    "pali": "සරණගතො",
                    "sinh": "සරණ ගියේ ය",
                    "span": 1
                },
                {
                    "pali": "රාහු",
                    "sinh": "රාහු අසුරේන්ද්‍රය",
                    "span": 1
                },
                {
                    "pali": "චන්දං පමුඤ්චස්සු",
                    "sinh": "සඳු අතහැරව",
                    "span": 1
                },
                {
                    "pali": "බුද්ධා",
                    "sinh": "බුදුවරයෝ",
                    "span": 1
                },
                {
                    "pali": "ලොකානුකම්පකා",
                    "sinh": "ලොවට අනුකම්පා කරන්නෝ ය. (එහෙයින්)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "රාහු අසුරින්දෝ",
                    "sinh": "රාහු අසුරේන්ද්‍ර තෙම",
                    "span": 1
                },
                {
                    "pali": "චන්දිමං දෙවපුත්තං",
                    "sinh": "සඳු දෙව්පුතු",
                    "span": 1
                },
                {
                    "pali": "මුඤ්චිත්වා",
                    "sinh": "හැර",
                    "span": 1
                },
                {
                    "pali": "තරමාණ රූපො",
                    "sinh": "වෙළෙවි වූයේ",
                    "span": 1
                },
                {
                    "pali": "යෙන",
                    "sinh": "යම් තැනක් හි වීද",
                    "span": 1
                },
                {
                    "pali": "වෙපචිත්ති අසුරේන්ද‍ො",
                    "sinh": "වේපචිත්ති අසුරේන්ද්‍රයා",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැන්හි",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "සංවිග්ගො",
                    "sinh": "සංවේග ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "ලොමහට්ඨජාතො",
                    "sinh": "ලොමුද‍ැහැගත් සිරුරු ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත් පසෙක",
                    "span": 1
                },
                {
                    "pali": "අට්ඨාසි",
                    "sinh": "සිටියේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එකමන්තං ඨිතං ඛො රාහුං අසුරින්දං",
                    "sinh": "එකත් පස්ව සිටියා වූ රාහු අසුරිඳු හට",
                    "span": 1
                },
                {
                    "pali": "වෙපචිත්ති අසුරින්ද‍ො",
                    "sinh": "වේපචිත්ති නම් අසුරේන්ද්‍ර තෙම",
                    "span": 1
                },
                {
                    "pali": "ගාථාය",
                    "sinh": "ගාථාවකින්",
                    "span": 1
                },
                {
                    "pali": "අජ්ඣභාසි",
                    "sinh": "මෙසේ කීයේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කින්නු",
                    "sinh": "කුමක් හෙයින්",
                    "span": 1
                },
                {
                    "pali": "සන්තරමානොව",
                    "sinh": "වෙලෙව් වූවකු මෙන්",
                    "span": 1
                },
                {
                    "pali": "රාහු",
                    "sinh": "රාහු අසුරේන්ද්‍රය",
                    "span": 1
                },
                {
                    "pali": "චන්දං",
                    "sinh": "සඳු",
                    "span": 1
                },
                {
                    "pali": "පමුඤචසි",
                    "sinh": "අත්හැරියෙහි ද?",
                    "span": 1
                },
                {
                    "pali": "සංවිග්ගරූපො ආගම්ම",
                    "sinh": "කලකිරුණු, සංවේගයට පත් සිත් ඇත්තෙක් වැ අවුත්",
                    "span": 1
                },
                {
                    "pali": "කින්නු",
                    "sinh": "කුමක් හෙයින්",
                    "span": 1
                },
                {
                    "pali": "භීතොව",
                    "sinh": "බියවූවකු මෙන්",
                    "span": 1
                },
                {
                    "pali": "තිට්ඨසී’ති",
                    "sinh": "සිටිනෙහි ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සත්තධා",
                    "sinh": "සත්කඩක් ව",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මගේ",
                    "span": 1
                },
                {
                    "pali": "ඵලෙ",
                    "sinh": "පැළෙයි",
                    "span": 1
                },
                {
                    "pali": "මුද්ධා",
                    "sinh": "හිස",
                    "span": 1
                },
                {
                    "pali": "ජීවන්තො",
                    "sinh": "ජීවත්වන්නේ ද",
                    "span": 1
                },
                {
                    "pali": "න සුඛං ලභෙ",
                    "sinh": "සැපයක් නො ලබයි.",
                    "span": 1
                },
                {
                    "pali": "බුද්ධගාථාහි",
                    "sinh": "බුදුන් විසින් (සඳු හරුව යි) ගාථා දෙකකින්",
                    "span": 1
                },
                {
                    "pali": "ගීතොම්හි",
                    "sinh": "ගයන ලද්දක් ඇසුවෙමි",
                    "span": 1
                },
                {
                    "pali": "නො චෙ මුඤ්චෙය්‍ය චන්දිමං",
                    "sinh": "ඉදින් සඳු අත නොහැරියේ නම්.",
                    "span": 1
                }
            ]
        ]
    },
    "16-suriya-parittam": {
        "labels": [
            [
                0,
                2.056175
            ],
            [
                2.552493,
                21.696192
            ],
            [
                21.696192,
                35.486745
            ],
            [
                35.486745,
                53.247843
            ],
            [
                53.247843,
                73.738691
            ],
            [
                73.738691,
                86.891121
            ],
            [
                86.891121,
                105.325794
            ],
            [
                106.389333,
                134.963076
            ],
            [
                134.963076,
                164.67126
            ],
            [
                164.67126,
                177.965495
            ],
            [
                177.965495,
                196.648327
            ],
            [
                197.392805,
                217.600042
            ]
        ],
        "text": [
            [
                {
                    "pali": "සුරියපරිත්තං",
                    "sinh": "සූරිය පිරිත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත්නුවර සමීපයෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු මහ සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "ආරාමයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙත ඛො පන සමයෙන",
                    "sinh": "එ සමයෙහි වනාහි",
                    "span": 1
                },
                {
                    "pali": "සුරියො දෙවපුත්තො",
                    "sinh": "හිරු දෙව්පුත් තෙමේ",
                    "span": 1
                },
                {
                    "pali": "රාහුනා අසුරින්දෙන",
                    "sinh": "රාහු අසුරේන්ද්‍රයා විසින්",
                    "span": 1
                },
                {
                    "pali": "ගහිතො හොති",
                    "sinh": "ගන්නා ලද්දේ වෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "සුරියො දෙව පුත්තො",
                    "sinh": "හිරු දෙව්පුත් තෙමේ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "බුදුරදුත්",
                    "span": 1
                },
                {
                    "pali": "අනුස්සරමානො",
                    "sinh": "සිහි කරමින්",
                    "span": 1
                },
                {
                    "pali": "තායං වේලායං",
                    "sinh": "එ වේලෙහි",
                    "span": 1
                },
                {
                    "pali": "ඉමං ගාථං",
                    "sinh": "මේ ගාථාව",
                    "span": 1
                },
                {
                    "pali": "අභාසි",
                    "sinh": "කීය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නමො",
                    "sinh": "නමස්කාර වේවා",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "නුඹ වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "බුද්ධවීරත්ථු",
                    "sinh": "බුද්ධවීරයන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "විප්පමුත්තොසි",
                    "sinh": "කෙලෙසුන් කෙරෙන් විශේෂයෙන් මිදුණු",
                    "span": 1
                },
                {
                    "pali": "සබ්බධි",
                    "sinh": "සියලු කල්හි.",
                    "span": 1
                },
                {
                    "pali": "සම්බාධ පටිපන්නෝස්මි",
                    "sinh": "(මම) සම්බාධයකට පැමිණියෙමි",
                    "span": 1
                },
                {
                    "pali": "තස්ස මෙ",
                    "sinh": "ඒ මට",
                    "span": 1
                },
                {
                    "pali": "සරණං භව",
                    "sinh": "පිළිසරණ වුව මැනව.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "එකල්හි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සුරියං දෙවපුත්තං",
                    "sinh": "හිරු දෙව් පුතුන්",
                    "span": 1
                },
                {
                    "pali": "ආරබ්හ",
                    "sinh": "අරභයා",
                    "span": 1
                },
                {
                    "pali": "රාහුං අසුරින්දං",
                    "sinh": "රාහු අසුරිඳු හට",
                    "span": 1
                },
                {
                    "pali": "ගාථාය",
                    "sinh": "ගාථාවකින්",
                    "span": 1
                },
                {
                    "pali": "අජ්ඣභාසි",
                    "sinh": "මෙසේ වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථාගතං",
                    "sinh": "තථාගතයන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අරහන්තං",
                    "sinh": "අරහත් වූ",
                    "span": 1
                },
                {
                    "pali": "චන්දිමා",
                    "sinh": "සඳදෙව් පුත් තෙමේ",
                    "span": 1
                },
                {
                    "pali": "සරණගතො",
                    "sinh": "සරණ ගියේ ය",
                    "span": 1
                },
                {
                    "pali": "රාහු",
                    "sinh": "රාහු අසුරේන්ද්‍රය",
                    "span": 1
                },
                {
                    "pali": "සුරියං පමුඤ්චස්සු",
                    "sinh": "හිරු අතහැරව",
                    "span": 1
                },
                {
                    "pali": "බුද්ධා",
                    "sinh": "බුදුවරයෝ",
                    "span": 1
                },
                {
                    "pali": "ලොකානුකම්පකා",
                    "sinh": "ලොවට අනුකම්පා කරන්නෝ ය. (එහෙයින්)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යො",
                    "sinh": "යම් සූර්යයෙක්",
                    "span": 1
                },
                {
                    "pali": "අන්ධකාරෙ තමසි",
                    "sinh": "ගන අඳුරු දුරහැර",
                    "span": 1
                },
                {
                    "pali": "පහංකරො",
                    "sinh": "පහන් කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "වෙරොචනො මණ්ඩලී",
                    "sinh": "බබලන මඬුලු ඇත්තේ ද",
                    "span": 1
                },
                {
                    "pali": "උග්ගතෙජො",
                    "sinh": "මහතෙද ඇත්තේ ද",
                    "span": 1
                },
                {
                    "pali": "මා",
                    "sinh": "නොම",
                    "span": 1
                },
                {
                    "pali": "රාහු",
                    "sinh": "එම්බල රාහු",
                    "span": 1
                },
                {
                    "pali": "ගිලී",
                    "sinh": "ගිලව",
                    "span": 1
                },
                {
                    "pali": "චරං",
                    "sinh": "හැසිරෙන හිරු",
                    "span": 1
                },
                {
                    "pali": "අන්තලික්ඛෙ",
                    "sinh": "අහසෙහි",
                    "span": 1
                },
                {
                    "pali": "පජං මම",
                    "sinh": "මගේ පූත්‍ර වූ",
                    "span": 1
                },
                {
                    "pali": "රාහු",
                    "sinh": "එබල රාහු",
                    "span": 1
                },
                {
                    "pali": "පමුඤ්ච",
                    "sinh": "මුදවයි",
                    "span": 1
                },
                {
                    "pali": "සූරියන්ති",
                    "sinh": "හිරුව.’ යි වද‍ාළ සේක",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "රාහු අසුරින්දෝ",
                    "sinh": "රාහු අසුරේන්ද්‍ර තෙම",
                    "span": 1
                },
                {
                    "pali": "සූරියං දෙවපුත්තං",
                    "sinh": "හිරු දෙව්පුතු",
                    "span": 1
                },
                {
                    "pali": "මුඤ්චිත්වා",
                    "sinh": "හැර",
                    "span": 1
                },
                {
                    "pali": "තරමාණ රූපො",
                    "sinh": "වෙළෙවි වූයේ",
                    "span": 1
                },
                {
                    "pali": "යෙන",
                    "sinh": "යම් තැනක් හි වීද",
                    "span": 1
                },
                {
                    "pali": "වෙපචිත්ති අසුරේන්ද‍ො",
                    "sinh": "වේපචිත්ති අසුරේන්ද්‍රයා",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැන්හි",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "සංවිග්ගො",
                    "sinh": "සංවේග ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "ලොමහට්ඨජාතො",
                    "sinh": "ලොමුද‍ැහැගත් සිරුරු ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත් පසෙක",
                    "span": 1
                },
                {
                    "pali": "අට්ඨාසි",
                    "sinh": "සිටියේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එකමන්තං ඨිතං ඛො රාහුං අසුරින්දං",
                    "sinh": "එකත් පස්ව සිටියා වූ රාහු අසුරිඳු හට",
                    "span": 1
                },
                {
                    "pali": "වෙපචිත්ති අසුරින්ද‍ො",
                    "sinh": "වේපචිත්ති නම් අසුරේන්ද්‍ර තෙම",
                    "span": 1
                },
                {
                    "pali": "ගාථාය",
                    "sinh": "ගාථාවකින්",
                    "span": 1
                },
                {
                    "pali": "අජ්ඣභාසි",
                    "sinh": "මෙසේ කීයේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කින්නු",
                    "sinh": "කුමක් හෙයින්",
                    "span": 1
                },
                {
                    "pali": "සන්තරමානොව",
                    "sinh": "වෙලෙව් වූවකු මෙන්",
                    "span": 1
                },
                {
                    "pali": "රාහු",
                    "sinh": "රාහු අසුරේන්ද්‍රය",
                    "span": 1
                },
                {
                    "pali": "සූරියං",
                    "sinh": "හිරු",
                    "span": 1
                },
                {
                    "pali": "පමුඤචසි",
                    "sinh": "අත්හැරියෙහි ද?",
                    "span": 1
                },
                {
                    "pali": "සංවිග්ගරූපො ආගම්ම",
                    "sinh": "කලකිරුණු, සංවේගයට පත් සිත් ඇත්තෙක් වැ අවුත්",
                    "span": 1
                },
                {
                    "pali": "කින්නු",
                    "sinh": "කුමක් හෙයින්",
                    "span": 1
                },
                {
                    "pali": "භීතොව",
                    "sinh": "බියවූවකු මෙන්",
                    "span": 1
                },
                {
                    "pali": "තිට්ඨසී’ති",
                    "sinh": "සිටිනෙහි ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සත්තධා",
                    "sinh": "සත්කඩක් ව",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මගේ",
                    "span": 1
                },
                {
                    "pali": "ඵලෙ",
                    "sinh": "පැළෙයි",
                    "span": 1
                },
                {
                    "pali": "මුද්ධා",
                    "sinh": "හිස",
                    "span": 1
                },
                {
                    "pali": "ජීවන්තො",
                    "sinh": "ජීවත්වන්නේ ද",
                    "span": 1
                },
                {
                    "pali": "න සුඛං ලභෙ",
                    "sinh": "සැපයක් නො ලබයි.",
                    "span": 1
                },
                {
                    "pali": "බුද්ධගාථාහි",
                    "sinh": "බුදුන් විසින් (හිරු හරුව යි) ගාථා දෙකකින්",
                    "span": 1
                },
                {
                    "pali": "ගීතොම්හි",
                    "sinh": "ගයන ලද්දක් ඇසුවෙමි",
                    "span": 1
                },
                {
                    "pali": "නො චෙ මුඤ්චෙය්‍ය සූරියං",
                    "sinh": "ඉදින් හිරු නොඅතහැරියේ නම්.",
                    "span": 1
                }
            ]
        ]
    },
    "17-dhajagga-parittam": {
        "labels": [
            [
                0,
                3.25323
            ],
            [
                3.25323,
                22.06774
            ],
            [
                22.06774,
                43.267953
            ],
            [
                43.267953,
                68.046718
            ],
            [
                68.046718,
                92.933924
            ],
            [
                92.933924,
                112.670183
            ],
            [
                112.670183,
                130.074961
            ],
            [
                130.074961,
                154.14886
            ],
            [
                154.14886,
                174.589985
            ],
            [
                174.589985,
                197.525254
            ],
            [
                197.525254,
                217.966379
            ],
            [
                217.966379,
                242.202939
            ],
            [
                242.202939,
                301.249055
            ],
            [
                301.249055,
                320.280448
            ],
            [
                320.280448,
                358.614336
            ],
            [
                359.210762,
                387.459638
            ],
            [
                387.459638,
                405.894606
            ],
            [
                406.599472,
                416.847145
            ],
            [
                416.847145,
                437.667814
            ],
            [
                437.667814,
                456.482325
            ],
            [
                456.482325,
                467.543305
            ],
            [
                467.543305,
                498.394765
            ],
            [
                499.262293,
                532.011471
            ],
            [
                532.011471,
                553.91655
            ],
            [
                553.91655,
                578.15311
            ],
            [
                578.912197,
                591.003366
            ],
            [
                591.003366,
                610.793846
            ],
            [
                610.793846,
                630.692767
            ],
            [
                630.692767,
                650.591687
            ],
            [
                650.591687,
                672.659428
            ]
        ],
        "text": [
            [
                {
                    "pali": "ධජග්ග පරිත්තං",
                    "sinh": "ධජග්ග පිරිත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවැත්නුවර සමීපයෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවන නම් වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථ පිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු මහ සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "ආරාමයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තත්‍ර ඛො",
                    "sinh": "එකල්හි වනාහි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "භික්‍ෂූන්",
                    "span": 1
                },
                {
                    "pali": "ආමන්තෙසි",
                    "sinh": "ඇමතූහ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවො’ති",
                    "sinh": "මහණෙනි කියා",
                    "span": 1
                },
                {
                    "pali": "භදන්තෙති",
                    "sinh": "වහන්සැ’යි",
                    "span": 1
                },
                {
                    "pali": "තෙ භික්ඛු",
                    "sinh": "ඒ භික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "පච්චස්සොසුං",
                    "sinh": "පිළිවදන් දුන්හ.",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "භූතපුබ්බං",
                    "sinh": "පෙර වූ දෙයක් කියමි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවේ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "දෙවාසුරසංගාමො",
                    "sinh": "දෙවියන් හා අසුරයන් අතර සංග්‍රාමයක්",
                    "span": 1
                },
                {
                    "pali": "සමූපබ්බුළ්හො අහොසි",
                    "sinh": "එළඹුනේ විය",
                    "span": 1
                },
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "සක්කො දෙවානමින්ද‍ො",
                    "sinh": "සක්දෙව් රජතෙම",
                    "span": 1
                },
                {
                    "pali": "දෙවෙ තාවතිංසෙ",
                    "sinh": "තව්තිසා වැසි දෙවියන්",
                    "span": 1
                },
                {
                    "pali": "ආමන්තෙසි",
                    "sinh": "ඇමතුවේය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සචෙ",
                    "sinh": "ඉදින්",
                    "span": 1
                },
                {
                    "pali": "මාරිසා",
                    "sinh": "නිදුකාණෙනි",
                    "span": 1
                },
                {
                    "pali": "දෙවානං",
                    "sinh": "දෙවියන්ට",
                    "span": 1
                },
                {
                    "pali": "සංගාමගතානං",
                    "sinh": "යුද්ධයට ගිය",
                    "span": 1
                },
                {
                    "pali": "උප්පජ්ජෙය්‍ය",
                    "sinh": "උපන්නේ නම්",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැතිගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "මම එව තස්මිං සමයෙ",
                    "sinh": "එ සමයෙහි මගේ ම",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකෙය්‍යාථ",
                    "sinh": "බලව්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මමංහි වො",
                    "sinh": "තොපට මගේ වනාහි",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකයතං",
                    "sinh": "බලන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති",
                    "sinh": "යම් වේ ද",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැතිගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරු වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ මෙ ධජග්ගං උල්ලොකෙය්‍යාථ",
                    "sinh": "ඉදින් මාගේ ධ්වජාග්‍රය නොබලා නම්",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "පජාපතිස්ස දේවරාජස්ස",
                    "sinh": "ප්‍රජාපති දෙව්රජහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකෙය්‍යාථ",
                    "sinh": "බලව්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පජාපතිස්සහි වො දෙවරාජස්ස",
                    "sinh": "තොපට ප්‍රජාපති නම් දෙව්රජහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකයතං",
                    "sinh": "බලන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති",
                    "sinh": "යම් වේ ද",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "යම් බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරුවෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ පජාපතිස්ස දෙවරාජස්ස ධජග්ගං උල්ලොකෙය්‍යාථ",
                    "sinh": "ඉදින් ප්‍රජාපතී දෙව් රජහු ගේ ධ්වජාග්‍රය නොබලා නම්",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "වරුණස්ස දේවරාජස්ස",
                    "sinh": "වරුණ දෙව්රජහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකෙය්‍යාථ",
                    "sinh": "බලව්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වරුණස්සහි වො දෙවරාජස්ස",
                    "sinh": "තොපට වරුණ නම් දෙව්රජහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකයතං",
                    "sinh": "බලන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති",
                    "sinh": "යම් වේ ද",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "යම් බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරුවෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ වරුණස්ස දෙවරාජස්ස ධජග්ගං උල්ලොකෙය්‍යාථ",
                    "sinh": "ඉදින් වරුණ දෙව් රජහු ගේ ධ්වජාග්‍රය නොබලා නම්",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ඊසානස්ස දේවරාජස්ස",
                    "sinh": "ඊසාන දෙව්රජහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකෙය්‍යාථ",
                    "sinh": "බලව්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඊසානස්සහි වො දෙවරාජස්ස",
                    "sinh": "තොපට ඊසාන නම් දෙව්රජහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලොකයතං",
                    "sinh": "බලන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති",
                    "sinh": "යම් වේ ද",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "යම් බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරුවෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන",
                    "sinh": "ඒ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "සක්කස්ස වා දෙවානමින්දස්ස",
                    "sinh": "සක්දෙව් රජුහු ගේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලෙකයතං",
                    "sinh": "බලන්නහුට",
                    "span": 1
                },
                {
                    "pali": "පජාපතිස්සවා දෙවරාජස්ස",
                    "sinh": "ප්‍රජාපති දෙව්රජු ගේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලෙකයතං",
                    "sinh": "බලන්නහුට",
                    "span": 1
                },
                {
                    "pali": "වරුණස්ස වා දෙවරාජස්ස",
                    "sinh": "වරුණ නම් දෙව්රජහු ගේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලෙකයතං",
                    "sinh": "බලන්නහුට",
                    "span": 1
                },
                {
                    "pali": "ඊසානස්ස වා දෙවරාජස්ස",
                    "sinh": "ඊසාන නම් දෙව්රජහු ගේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ධජග්ගං",
                    "sinh": "ධ්වජාග්‍රය",
                    "span": 1
                },
                {
                    "pali": "උල්ලෙකයතං",
                    "sinh": "බලන්නහුට",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති භයං වා",
                    "sinh": "යම් වේ ද බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැනීමක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැනීමක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයෙථාපි",
                    "sinh": "දුරු වන්නේ හෝ ද වේ",
                    "span": 1
                },
                {
                    "pali": "නො පි පහියෙථ",
                    "sinh": "දුරු නො වන්නේ හෝ ද වෙයි",
                    "span": 1
                },
                {
                    "pali": "තංකිස්සහෙතු?",
                    "sinh": "එයට හේතු කවරේ ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සක්කොහි භික්ඛවෙ දෙවානමින්දෝ",
                    "sinh": "මහණෙනි සක්දෙව් රජතෙම වනාහි",
                    "span": 1
                },
                {
                    "pali": "අවිතරාගො",
                    "sinh": "දුරු නො කළ රාග ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "අවිතද‍ොසො",
                    "sinh": "දුරු නොකළ ද්වේෂ ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "අවිතමොහො",
                    "sinh": "දුරු නො කළ මෝහ ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "භීරු",
                    "sinh": "බියවන සුලු ය",
                    "span": 1
                },
                {
                    "pali": "ඡම්භි",
                    "sinh": "තැති ගන්නා සුලුය",
                    "span": 1
                },
                {
                    "pali": "උත්‍රාසි",
                    "sinh": "අතිශයින් ම බියවන සුලුය",
                    "span": 1
                },
                {
                    "pali": "පලායීති",
                    "sinh": "පලා යන සුලුය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අහඤ්ව ඛො",
                    "sinh": "මම ද",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "තුම්හාකං",
                    "sinh": "නුඹලාට",
                    "span": 1
                },
                {
                    "pali": "එවං වද‍ාමි",
                    "sinh": "මෙසේ කියමි",
                    "span": 1
                },
                {
                    "pali": "සවෙ",
                    "sinh": "ඉදින්",
                    "span": 1
                },
                {
                    "pali": "තුම්හාකං",
                    "sinh": "නුඹලාට",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතානං වා",
                    "sinh": "වනයට ගියා වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලගතානං වා",
                    "sinh": "රුක්මුලට ගියා වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාරගතානං වා",
                    "sinh": "ගෙවලින් හිස් තැනකට ගියා වූ හෝ",
                    "span": 1
                },
                {
                    "pali": "උප්පජ්ජෙය්‍ය",
                    "sinh": "උපදනේ වී නම්",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්හිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැමෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "මමේව",
                    "sinh": "මා ම",
                    "span": 1
                },
                {
                    "pali": "තස්මිං සමයෙ",
                    "sinh": "ඒ සමයෙහි",
                    "span": 1
                },
                {
                    "pali": "අනුස්සරෙය්‍යාථ",
                    "sinh": "සිහි කරව් (කෙසේ ද?)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉතිපි",
                    "sinh": "මේ කරුණෙනුදු",
                    "span": 1
                },
                {
                    "pali": "සො භගවා",
                    "sinh": "ඒ භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අරහං",
                    "sinh": "අර්හත් ය",
                    "span": 1
                },
                {
                    "pali": "සම්මා සම්බුද්ධෝ",
                    "sinh": "සම්‍යක් සම්බුද්ධ ය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා චරණ සම්පන්නො",
                    "sinh": "විද්‍යාචරණ ධර්මයන් ගෙන් යුක්ත ය",
                    "span": 1
                },
                {
                    "pali": "සුගතො",
                    "sinh": "සුගත ය",
                    "span": 1
                },
                {
                    "pali": "ලොකවිදු",
                    "sinh": "ලෝකවිදු ය",
                    "span": 1
                },
                {
                    "pali": "අනුන්තරො",
                    "sinh": "අනුත්තර ය",
                    "span": 1
                },
                {
                    "pali": "පුරිස දම්ම සාරථි",
                    "sinh": "පුරිස දම්මසාරථි ය",
                    "span": 1
                },
                {
                    "pali": "සත්ථා දේවමනුස්සානං",
                    "sinh": "දෙව් මිනිසුනට අනුශාසක ය",
                    "span": 1
                },
                {
                    "pali": "බුද්ධො",
                    "sinh": "බුද්ධ ය",
                    "span": 1
                },
                {
                    "pali": "භගවා’ති",
                    "sinh": "භාග්‍යවත් ය (කියායි).",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මමංහි වො භික්ඛවෙ අනුස්සරතං",
                    "sinh": "මහණෙනි මා සිහි කරන්නා වූ තොපට",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති භයං වා",
                    "sinh": "වේ ද, යම් බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැමෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරුවේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ මං අනුස්සරෙය්‍යාථ",
                    "sinh": "ඉදින් මා සිහි නො කරව් නම්",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ධම්මං",
                    "sinh": "ධර්මය",
                    "span": 1
                },
                {
                    "pali": "අනුස්සරෙය්‍යාථ",
                    "sinh": "සිහි කරව්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ස්වාක්ඛාතො",
                    "sinh": "මොනවට දෙසන ලද",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "බුදුරදුන් විසින්",
                    "span": 1
                },
                {
                    "pali": "ධම්මො",
                    "sinh": "ධර්මය තෙම",
                    "span": 1
                },
                {
                    "pali": "සන්දිට්ඨිකො",
                    "sinh": "සාන්දෘෂ්ටික ය",
                    "span": 1
                },
                {
                    "pali": "අකාලිකො",
                    "sinh": "කල් නො යවා විපාක දෙන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "එහිපස්සිකො",
                    "sinh": "එව බලව යන විදියට සුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "ඔපනයිකො",
                    "sinh": "එළඹීමට සුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "පච්චත්තං",
                    "sinh": "තම තමන් කෙරෙහි ලා",
                    "span": 1
                },
                {
                    "pali": "වෙදිතබ්බො",
                    "sinh": "දතයුත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "විඤ්ඤූහී’ති",
                    "sinh": "නුවණැත්තන් විසින් (යනුයි).",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ධම්මංහි වො භික්ඛවෙ අනුස්සරතං",
                    "sinh": "මහණෙනි ධර්මය සිහි කරන්නා වූ තොපට",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති භයං වා",
                    "sinh": "වේ ද, යම් බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැමෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරුවේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ ධම්මං අනුස්සරෙය්‍යාථ",
                    "sinh": "ඉදින් ධර්මය සිහි නො කරව් නම්",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "සංඝං",
                    "sinh": "සඟුන්",
                    "span": 1
                },
                {
                    "pali": "අනුස්සරෙය්‍යාථ",
                    "sinh": "සිහි කරව් (කෙසේ ද?)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුපටිපන්නො භගවතො සාවක සංඝො",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ ශ්‍රාවක සංඝ තෙමේ මනාව පිළිපන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "උජුපටිපන්නො භගවතො සාවක සංඝො",
                    "sinh": "භාග්‍යවතුන් වහන්සේගේ ශ්‍රාවක සංඝ තෙමේ ඍජු වූ පිළිවෙතින් යුක්ත ය",
                    "span": 1
                },
                {
                    "pali": "ඤ‍ායපටිපන්නො භගවතො සාවක සංඝො",
                    "sinh": "භාග්‍යවතුන් වහන්සේගේ ශ්‍රාවක සංඝ තෙමේ නිවන් සඳහා පිළිපන්නේ ය",
                    "span": 1
                },
                {
                    "pali": "සාමීචිපටිපන්නො භගවතො සාවක සංඝො",
                    "sinh": "භාග්‍යවතුන් වහන්සේගේ ශ්‍රාවක සංඝ තෙමේ ත්‍රිශික්ෂාවෙහි ගරු කිරීමට සුදුසු පිළිවෙත්හි පිළිපන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යදිදං",
                    "sinh": "යම් මේ",
                    "span": 1
                },
                {
                    "pali": "චත්තාරි පුරිස යුගානි",
                    "sinh": "පුරුෂ යුගල වශයෙන් සතර කොටසක් වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "අට්ඨපුරිස පුග්ගලා",
                    "sinh": "පුරුෂ පුද්ගල වශයෙන් අට දෙනෙක් වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "එස භගවතො සාවක සංඝො",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ මේ ශ්‍රාවක සංඝ තෙමේ",
                    "span": 1
                },
                {
                    "pali": "ආහුනෙය්‍යො",
                    "sinh": "දුරිනිදු ගෙන හැර දිය යුතු ප්‍රත්‍යයට සුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "පාහුනෙය්‍යො",
                    "sinh": "අමුතු ප්‍රත්‍යයන් පිළි ගැනීමට සුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "දක්ඛිණෙ‍ය්‍යො",
                    "sinh": "දක්ෂිණාවට සුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "අඤ්ජලිකරණීයො",
                    "sinh": "ද‍ොහොත් මුදුන් දී වැඳීමට සුදුසු ය",
                    "span": 1
                },
                {
                    "pali": "අනුත්තරං",
                    "sinh": "උතුම් වූ",
                    "span": 1
                },
                {
                    "pali": "පුඤ්ඤක්ඛෙත්තං",
                    "sinh": "පින් කෙතකැයි",
                    "span": 1
                },
                {
                    "pali": "ලොකස්සාති",
                    "sinh": "සියලු ලෝකයාට කියායි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සංඝංහි වො භික්ඛවෙ අනුස්සරතං",
                    "sinh": "මහණෙනි සංඝයා සිහි කරන්නා වූ තොපට",
                    "span": 1
                },
                {
                    "pali": "යං භවිස්සති භයං වා",
                    "sinh": "වේ ද, යම් බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැන්මෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො වා",
                    "sinh": "ලොමුද‍ැහැගැමෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "සො",
                    "sinh": "හේ",
                    "span": 1
                },
                {
                    "pali": "පහීයිස්සති",
                    "sinh": "දුරුවේ",
                    "span": 1
                },
                {
                    "pali": "තංකිස්ස හෙතු?",
                    "sinh": "එයට කාරණා කිම යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථාගතො",
                    "sinh": "තථාගත තෙම",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "අරහං",
                    "sinh": "අරහත් වූ",
                    "span": 1
                },
                {
                    "pali": "සම්මා සම්බුද්ධෝ",
                    "sinh": "සම්‍යක් සම්බුද්ධ වූ",
                    "span": 1
                },
                {
                    "pali": "වීතරාගො",
                    "sinh": "නසන ලද රාග ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "වීතද‍ොසො",
                    "sinh": "නසන ලද ද්වේෂ ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "වීතමොහො",
                    "sinh": "නසන ලද මෝහ ඇත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "අභීරු",
                    "sinh": "බිය නොවන සුලුය",
                    "span": 1
                },
                {
                    "pali": "අච්ඡම්හි",
                    "sinh": "තැති නො ගන්නා සුලුය",
                    "span": 1
                },
                {
                    "pali": "අනුත්‍රාසි",
                    "sinh": "ත්‍රාස නො වන සුලුය",
                    "span": 1
                },
                {
                    "pali": "අපලායීති",
                    "sinh": "බියෙන් පලා නො යන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච",
                    "sinh": "මේ ධජග්ග පරිත්තය වද‍ාළේ ය",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවත් තෙම",
                    "span": 1
                },
                {
                    "pali": "ඉදං වත්වා",
                    "sinh": "මේ වද‍ාරා",
                    "span": 1
                },
                {
                    "pali": "සුගතො",
                    "sinh": "සුගත වූ",
                    "span": 1
                },
                {
                    "pali": "අථාපරං",
                    "sinh": "නැවත අන්‍ය වූ",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මේ කාරණය වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "සත්ථා",
                    "sinh": "ශාස්තෘෘන්වහන්සේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අරඤ්ඤෙ",
                    "sinh": "ආරණ්‍යයෙහි හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලෙ වා",
                    "sinh": "රුක් මුල්හි හෝ",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාරෙව",
                    "sinh": "ජන ශුන්‍ය ස්ථානයක හෝ",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවො",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "අනුස්සරෙථ",
                    "sinh": "සිහි කරව්",
                    "span": 1
                },
                {
                    "pali": "සම්බුද්ධං",
                    "sinh": "සම්බුදුන්",
                    "span": 1
                },
                {
                    "pali": "භයං",
                    "sinh": "බියෙක්",
                    "span": 1
                },
                {
                    "pali": "තුම්හාකං",
                    "sinh": "තොපට",
                    "span": 1
                },
                {
                    "pali": "නො සියා",
                    "sinh": "නො වන්නේ යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ බුද්ධං සරෙය්‍යාථ",
                    "sinh": "බුදුරදුන් ඉදින් සිහි නො කරව් නම්",
                    "span": 1
                },
                {
                    "pali": "ලොකජෙට්ඨං",
                    "sinh": "ලොවට ජ්‍යෙෂ්ඨ වූ",
                    "span": 1
                },
                {
                    "pali": "නරාසභං",
                    "sinh": "නරෝත්තම වූ",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ධමමං",
                    "sinh": "ධර්මය",
                    "span": 1
                },
                {
                    "pali": "සරෙය්‍යාථ",
                    "sinh": "සිහි කරව්",
                    "span": 1
                },
                {
                    "pali": "නිය්‍යාණිකං",
                    "sinh": "නෛර්යානික වූ",
                    "span": 1
                },
                {
                    "pali": "සුදෙසිතං",
                    "sinh": "මනාකොට දෙසන ලද.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නො චෙ ධම්මං සරෙය්‍යාථ",
                    "sinh": "සද්ධර්මය ඉදින් සිහි නො කරව් නම්",
                    "span": 1
                },
                {
                    "pali": "නිය්‍යාණිකං",
                    "sinh": "නෛර්යානික වූ",
                    "span": 1
                },
                {
                    "pali": "සුදෙසිතං",
                    "sinh": "මොනවට දෙසන ලද",
                    "span": 1
                },
                {
                    "pali": "අථ",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "සංඝං",
                    "sinh": "සංඝයා",
                    "span": 1
                },
                {
                    "pali": "සරෙය්‍යාථ",
                    "sinh": "සිහි කරව්",
                    "span": 1
                },
                {
                    "pali": "පුඤ්ඤඛෙත්තං",
                    "sinh": "පින් කෙතක් වූ",
                    "span": 1
                },
                {
                    "pali": "අනුත්තරං",
                    "sinh": "අනුත්තර වූ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "බුද්ධං",
                    "sinh": "බුදුන් ද",
                    "span": 1
                },
                {
                    "pali": "සරන්තානං",
                    "sinh": "සිහි කරන්නවුනට",
                    "span": 1
                },
                {
                    "pali": "ධම්මං",
                    "sinh": "ධර්මය ද",
                    "span": 1
                },
                {
                    "pali": "සංඝං ච",
                    "sinh": "සංඝයා ද",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවො",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "භයං වා",
                    "sinh": "බියෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ඡම්භිතත්තං වා",
                    "sinh": "තැති ගැමෙක් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොමහංසො",
                    "sinh": "ලොමු ද‍ැහැගැන්මෙක්",
                    "span": 1
                },
                {
                    "pali": "න හෙස්සතීති",
                    "sinh": "නොවේ.",
                    "span": 1
                }
            ]
        ]
    },
    "18-kassapa-bojjhanga": {
        "labels": [
            [
                0,
                4.727073
            ],
            [
                4.727073,
                43.023219
            ],
            [
                43.023219,
                82.346989
            ],
            [
                82.346989,
                108.380147
            ],
            [
                108.380147,
                134.413305
            ],
            [
                134.413305,
                161.679613
            ],
            [
                161.679613,
                187.027688
            ],
            [
                187.027688,
                213.814437
            ],
            [
                213.814437,
                239.916104
            ],
            [
                239.916104,
                265.949262
            ],
            [
                265.949262,
                292.393469
            ],
            [
                292.393469,
                318.974694
            ],
            [
                318.974694,
                345.281885
            ],
            [
                345.281885,
                371.315043
            ],
            [
                371.315043,
                381.043223
            ],
            [
                381.043223,
                398.170301
            ],
            [
                398.170301,
                423.792409
            ]
        ],
        "text": [
            [
                {
                    "pali": "මහාකස්සප බොජ්ඣංග සුත්තං",
                    "sinh": "මහාකස්සප බොජ්ඣංග සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී.",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "රාජගහෙ",
                    "sinh": "රජගහ නුවර",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "වෙළුවනෙ",
                    "sinh": "වේළුවන නම් වූ මහා විහාරයෙහි",
                    "span": 1
                },
                {
                    "pali": "කලන්දක නිවාපෙ",
                    "sinh": "ලෙහෙනුන්ට දෙන ලද නිවාප ඇති හෙයින් කලන්දක නිවාප නම් වූ",
                    "span": 1
                },
                {
                    "pali": "තෙන ඛො පන සමයෙන",
                    "sinh": "එ සමයෙහි වනාහි",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහාකස්සපො",
                    "sinh": "ආයුෂ්මත් මහා කාශ්‍යප ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "පිප්ඵලි ගුහායං",
                    "sinh": "පිප්ඵලි ගුහාවෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වෙසෙයි",
                    "span": 1
                },
                {
                    "pali": "ආබාධිකො",
                    "sinh": "පීඩිත වූයේ",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛිතො",
                    "sinh": "දුකට පත් වූයේ",
                    "span": 1
                },
                {
                    "pali": "බාළ්හගිලානො",
                    "sinh": "ද‍ැඩි ගිලන්වූයේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සායණ්හසමයං",
                    "sinh": "සවස් වේලෙහි",
                    "span": 1
                },
                {
                    "pali": "පතිසල්ලානා",
                    "sinh": "ඵල සමවතින්",
                    "span": 1
                },
                {
                    "pali": "වුට්ඨිතො",
                    "sinh": "නැගිටියේ",
                    "span": 1
                },
                {
                    "pali": "යෙන",
                    "sinh": "යම් තැනක වෙසෙත් ද",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහාකස්සපො",
                    "sinh": "ආයුෂ්මත් මහා කාශ්‍යප ස්ථවිරයන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැනට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹි සේක",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤත්තෙ ආසනෙ",
                    "sinh": "පැණ වූ අස්නෙක",
                    "span": 1
                },
                {
                    "pali": "නිසීදි",
                    "sinh": "වැඩහුන් සේක",
                    "span": 1
                },
                {
                    "pali": "නිසජ්ජ ඛො",
                    "sinh": "වැඩහිඳ ම",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "ආයස්මන්තං මහා කස්සපං",
                    "sinh": "ආයුෂ්මත් මහා කාශ්‍යපයන් වහන්සේ හට",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කච්චි?",
                    "sinh": "කිමෙක් ද?",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "තොපට",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යප,",
                    "span": 1
                },
                {
                    "pali": "ඛමනීයං",
                    "sinh": "ඉවසිය හැකි ද?",
                    "span": 1
                },
                {
                    "pali": "කච්චි?",
                    "sinh": "කිම?",
                    "span": 1
                },
                {
                    "pali": "යාපනීයං",
                    "sinh": "යැපිය හැකිද ?",
                    "span": 1
                },
                {
                    "pali": "කච්චි?",
                    "sinh": "කිම?",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛා වේදනා",
                    "sinh": "දුක්ඛ වේදනාවෝ",
                    "span": 1
                },
                {
                    "pali": "පටික්කමන්ති",
                    "sinh": "පිරිහෙත් ද?",
                    "span": 1
                },
                {
                    "pali": "නො අභික්කමන්ති",
                    "sinh": "කිම දියුණු නොවෙත් ද?",
                    "span": 1
                },
                {
                    "pali": "පටික්කමොසානං පඤ්ඤ‍ායති",
                    "sinh": "ප්‍රතික්‍රමණාවසානය පෙනේ ද? (ඒ දුක්ඛ වේදනාවන් ගේ කෙළවරක් පැනේ ද?)",
                    "span": 1
                },
                {
                    "pali": "නො අභික්කමෙති",
                    "sinh": "වැඩීමක් නොපෙනේ ද‍ැ’යි වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න මෙ භන්තෙ ඛමනීයං",
                    "sinh": "ස්වාමින් වහන්ස මට ඉවසීමට නො හැකි ය",
                    "span": 1
                },
                {
                    "pali": "න යාපනීයං",
                    "sinh": "ඉරියව් පවත්වන්නට නො හැකි ය",
                    "span": 1
                },
                {
                    "pali": "බාළ්හා මෙ දුක්ඛ වෙදනා",
                    "sinh": "මගේ දුක්ඛ වේදනාවෝ බලවත් හ",
                    "span": 1
                },
                {
                    "pali": "අභික්කමන්ති",
                    "sinh": "දියුණු වෙත්",
                    "span": 1
                },
                {
                    "pali": "නො පටික්කමන්ති",
                    "sinh": "ප්‍රතික්‍රමණය නොවෙත් (අඩු නොවෙත්)",
                    "span": 1
                },
                {
                    "pali": "අභික්කමොසානං",
                    "sinh": "දුක්ඛ වේදනාවන් ගේ වැඩීම",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ායති",
                    "sinh": "පෙනෙයි",
                    "span": 1
                },
                {
                    "pali": "නො පටික්කමොති",
                    "sinh": "අඩුවක් නො පෙනෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සත්තිමෙ කස්සප බොජ්ඣංගා",
                    "sinh": "කාශ්‍යප මේ සප්ත බොජ්ඣංගයෝ",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතා",
                    "sinh": "මොනවට ප්‍රකාශ කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "භාවිතා",
                    "sinh": "භාවිතා කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතා",
                    "sinh": "නැවත නැවත පුරුදු කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තන්ති",
                    "sinh": "පවතිත්",
                    "span": 1
                },
                {
                    "pali": "කතමෙ සත්ත?",
                    "sinh": "කවර සප්ත බෝධ්‍යංගයෝ ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සතිසම්බොජ්ඣංගො ඛො",
                    "sinh": "සතිසම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ධම්ම විචය සම්බොජ්ඣංගො ඛො",
                    "sinh": "ධම්ම විචය සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරිය සම්බොජ්ඣංගො ඛො",
                    "sinh": "විරිය සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පීති සම්බොජ්ඣංගො ඛො",
                    "sinh": "ප්‍රීති සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සද්ධි සම්බොජ්ඣංගො ඛො",
                    "sinh": "පස්සද්ධි සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමාධි සම්බොජ්ඣංගො ඛො",
                    "sinh": "සමාධි සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උපෙක්ඛා සම්බොජ්ඣංගො ඛො",
                    "sinh": "උපෙක්ෂා සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "කස්සප",
                    "sinh": "කාශ්‍යපය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමෙ ඛො කස්සප සත්තබොජ්ඣංගා",
                    "sinh": "කාශ්‍යපය මේ සප්ත බොධ්‍යංගයෝ වනාහි",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතා",
                    "sinh": "මොනවට කියන ලදහ",
                    "span": 1
                },
                {
                    "pali": "භාවිතා",
                    "sinh": "භාවිතය හ",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතා",
                    "sinh": "බහුලීකෘතය හ",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍ය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "ඔවුන්ගේ මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තන්ති",
                    "sinh": "පවතිත්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තග්ඝ",
                    "sinh": "මැනව",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගා",
                    "sinh": "බොධ්‍යංග ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "තග්ඝ",
                    "sinh": "මැනව",
                    "span": 1
                },
                {
                    "pali": "සුගත",
                    "sinh": "සුගතයන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගොති",
                    "sinh": "බොධ්‍යංගයෝ’යි කසුප් තෙරහු ද‍ැන්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච",
                    "sinh": "මේ ධර්මය වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "භගව",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අත්තමනො",
                    "sinh": "එයට සතුටු වූ",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහා කස්සපො",
                    "sinh": "ආයුෂ්මත් මහා කාශ්‍යප ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ",
                    "span": 1
                },
                {
                    "pali": "භාසිතං",
                    "sinh": "දේශනාවට",
                    "span": 1
                },
                {
                    "pali": "අභිනන්දි",
                    "sinh": "කැමති විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උට්ඨාහි ච",
                    "sinh": "නැගී සිටියේ ම ය",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහා කස්සපො",
                    "sinh": "ආයුෂ්මත් මහා කාශ්‍යප ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "තම්හා ආබාධා",
                    "sinh": "ඒ ආබාධයෙන්:",
                    "span": 1
                },
                {
                    "pali": "තථා",
                    "sinh": "එසේ ම",
                    "span": 1
                },
                {
                    "pali": "පහීනො ච",
                    "sinh": "පහවී (ප්‍රහීණ වී)",
                    "span": 1
                },
                {
                    "pali": "ආයස්මතො මහා කස්සපස්ස",
                    "sinh": "ආයුෂ්මත් මහා කාශ්‍යප ස්ථවිරයන් වහන්සේ ගේ",
                    "span": 1
                },
                {
                    "pali": "සො ආබාධො",
                    "sinh": "ඒ ආබාධය",
                    "span": 1
                },
                {
                    "pali": "අහොසීති",
                    "sinh": "අහෝසි වී ගියේ ම ය.",
                    "span": 1
                }
            ]
        ]
    },
    "19-moggallana-bojjhanga": {
        "labels": [
            [
                0,
                5.273815
            ],
            [
                5.273815,
                46.273477
            ],
            [
                46.273477,
                87.307164
            ],
            [
                87.307164,
                114.662955
            ],
            [
                114.662955,
                141.474352
            ],
            [
                141.474352,
                169.54466
            ],
            [
                169.54466,
                195.165195
            ],
            [
                195.165195,
                221.023903
            ],
            [
                221.023903,
                245.997971
            ],
            [
                245.997971,
                270.699842
            ],
            [
                270.699842,
                295.878057
            ],
            [
                295.878057,
                320.852125
            ],
            [
                320.852125,
                346.09839
            ],
            [
                346.09839,
                371.548803
            ],
            [
                371.548803,
                380.123006
            ],
            [
                380.123006,
                396.250674
            ],
            [
                396.250674,
                421.769135
            ]
        ],
        "text": [
            [
                {
                    "pali": "මහාමොග්ගල්ලාන බොජ්ඣංග පරිත්තං",
                    "sinh": "මහාමොග්ගල්ලාන බොජ්ඣංග පිරිත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී.",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "රාජගහෙ",
                    "sinh": "රජගහ නුවර",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "වෙළුවනෙ",
                    "sinh": "වේළුවන නම් වූ මහා විහාරයෙහි",
                    "span": 1
                },
                {
                    "pali": "කලන්දක නිවාපෙ",
                    "sinh": "ලෙහෙනුන්ට දෙන ලද නිවාප ඇති හෙයින් කලන්දක නිවාප නම් වූ",
                    "span": 1
                },
                {
                    "pali": "තෙන ඛො පන සමයෙන",
                    "sinh": "එ සමයෙහි වනාහි",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහාමොග්ගල්ලානො",
                    "sinh": "ආයුෂ්මත් මහා මෞද්ගල්‍යායන (මුගලන්) ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "ගිජ්ඣකූට පබ්බතෙ",
                    "sinh": "ගිජුකුළු පව්වෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වෙසෙයි",
                    "span": 1
                },
                {
                    "pali": "ආබාධිකො",
                    "sinh": "පීඩිත වූයේ",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛිතො",
                    "sinh": "දුකට පත් වූයේ",
                    "span": 1
                },
                {
                    "pali": "බාළ්හගිලානො",
                    "sinh": "ද‍ැඩි ගිලන්වූයේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "සායණ්හසමයං",
                    "sinh": "සවස් වේලෙහි",
                    "span": 1
                },
                {
                    "pali": "පතිසල්ලානා",
                    "sinh": "ඵල සමවතින්",
                    "span": 1
                },
                {
                    "pali": "වුට්ඨිතො",
                    "sinh": "නැගිටියේ",
                    "span": 1
                },
                {
                    "pali": "යෙන",
                    "sinh": "යම් තැනක වෙසෙත් ද",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහාමොග්ගල්ලානො",
                    "sinh": "ආයුෂ්මත් මහා මෞද්ගල්‍යායන ස්ථවිරයන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැනට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹි සේක",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤත්තෙ ආසනෙ",
                    "sinh": "පැණ වූ අස්නෙක",
                    "span": 1
                },
                {
                    "pali": "නිසීදි",
                    "sinh": "වැඩහුන් සේක",
                    "span": 1
                },
                {
                    "pali": "නිසජ්ජ ඛො",
                    "sinh": "වැඩහිඳ ම",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "ආයස්මන්තං මහා මොග්ගල්ලානං",
                    "sinh": "ආයුෂ්මත් මහා මෞද්ගල්‍යායනයන් වහන්සේ හට",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කච්චි?",
                    "sinh": "කිමෙක් ද?",
                    "span": 1
                },
                {
                    "pali": "තෙ",
                    "sinh": "තොපට",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායන,",
                    "span": 1
                },
                {
                    "pali": "ඛමනීයං",
                    "sinh": "ඉවසිය හැකි ද?",
                    "span": 1
                },
                {
                    "pali": "කච්චි?",
                    "sinh": "කිම?",
                    "span": 1
                },
                {
                    "pali": "යාපනීයං",
                    "sinh": "යැපිය හැකිද ?",
                    "span": 1
                },
                {
                    "pali": "කච්චි?",
                    "sinh": "කිම?",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛා වේදනා",
                    "sinh": "දුක්ඛ වේදනාවෝ",
                    "span": 1
                },
                {
                    "pali": "පටික්කමන්ති",
                    "sinh": "පිරිහෙත් ද?",
                    "span": 1
                },
                {
                    "pali": "නො අභික්කමන්ති",
                    "sinh": "කිම දියුණු නොවෙත් ද?",
                    "span": 1
                },
                {
                    "pali": "පටික්කමොසානං පඤ්ඤ‍ායති",
                    "sinh": "ප්‍රතික්‍රමණාවසානය පෙනේ ද? (ඒ දුක්ඛ වේදනාවන් ගේ කෙළවරක් පැනේ ද?)",
                    "span": 1
                },
                {
                    "pali": "නො අභික්කමෙති",
                    "sinh": "වැඩීමක් නොපෙනේ ද‍ැ’යි වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න මෙ භන්තෙ ඛමනීයං",
                    "sinh": "ස්වාමින් වහන්ස මට ඉවසීමට නො හැකි ය",
                    "span": 1
                },
                {
                    "pali": "න යාපනීයං",
                    "sinh": "ඉරියව් පවත්වන්නට නො හැකි ය",
                    "span": 1
                },
                {
                    "pali": "බාළ්හා මෙ දුක්ඛ වෙදනා",
                    "sinh": "මගේ දුක්ඛ වේදනාවෝ බලවත් හ",
                    "span": 1
                },
                {
                    "pali": "අභික්කමන්ති",
                    "sinh": "දියුණු වෙත්",
                    "span": 1
                },
                {
                    "pali": "නො පටික්කමන්ති",
                    "sinh": "ප්‍රතික්‍රමණය නොවෙත් (අඩු නොවෙත්)",
                    "span": 1
                },
                {
                    "pali": "අභික්කමොසානං",
                    "sinh": "දුක්ඛ වේදනාවන් ගේ වැඩීම",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ායති",
                    "sinh": "පෙනෙයි",
                    "span": 1
                },
                {
                    "pali": "නො පටික්කමොති",
                    "sinh": "අඩුවක් නො පෙනෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සත්තිමෙ මොග්ගල්ලාන බොජ්ඣංගා",
                    "sinh": "මෞද්ගල්‍යායන මේ සප්ත බොජ්ඣංගයෝ",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතා",
                    "sinh": "මොනවට ප්‍රකාශ කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "භාවිතා",
                    "sinh": "භාවිතා කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතා",
                    "sinh": "නැවත නැවත පුරුදු කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තන්ති",
                    "sinh": "පවතිත්",
                    "span": 1
                },
                {
                    "pali": "කතමෙ සත්ත?",
                    "sinh": "කවර සප්ත බෝධ්‍යංගයෝ ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සතිසම්බොජ්ඣංගො ඛො",
                    "sinh": "සතිසම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ධම්ම විචය සම්බොජ්ඣංගො ඛො",
                    "sinh": "ධම්ම විචය සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරිය සම්බොජ්ඣංගො ඛො",
                    "sinh": "විරිය සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පීති සම්බොජ්ඣංගො ඛො",
                    "sinh": "ප්‍රීති සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සද්ධි සම්බොජ්ඣංගො ඛො",
                    "sinh": "පස්සද්ධි සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමාධි සම්බොජ්ඣංගො ඛො",
                    "sinh": "සමාධි සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උපෙක්ඛා සම්බොජ්ඣංගො ඛො",
                    "sinh": "උපෙක්ෂා සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "මොග්ගල්ලාන",
                    "sinh": "මෞද්ගල්‍යායනය",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමෙ ඛො මොග්ගල්ලාන සත්තබොජ්ඣංගා",
                    "sinh": "මෞද්ගල්‍යායනය මේ සප්ත බොධ්‍යංගයෝ වනාහි",
                    "span": 1
                },
                {
                    "pali": "මයා",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතා",
                    "sinh": "මොනවට කියන ලදහ",
                    "span": 1
                },
                {
                    "pali": "භාවිතා",
                    "sinh": "භාවිතය හ",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතා",
                    "sinh": "බහුලීකෘතය හ",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍ය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "ඔවුන්ගේ මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තන්ති",
                    "sinh": "පවතිත්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තග්ඝ",
                    "sinh": "මැනව",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගා",
                    "sinh": "බොධ්‍යංග ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "තග්ඝ",
                    "sinh": "මැනව",
                    "span": 1
                },
                {
                    "pali": "සුගත",
                    "sinh": "සුගතයන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගොති",
                    "sinh": "බොධ්‍යංගයෝ’යි මුගලන් තෙරහු ද‍ැන්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච",
                    "sinh": "මේ ධර්මය වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "භගව",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "අත්තමනො",
                    "sinh": "එයට සතුටු වූ",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහා මොග්ගල්ලානො",
                    "sinh": "ආයුෂ්මත් මහා මෞද්ගල්‍යායන ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ",
                    "span": 1
                },
                {
                    "pali": "භාසිතං",
                    "sinh": "දේශනාවට",
                    "span": 1
                },
                {
                    "pali": "අභිනන්දි",
                    "sinh": "කැමති විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උට්ඨාහි ච",
                    "sinh": "නැගී සිටියේ ම ය",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහා මොග්ගල්ලානො",
                    "sinh": "ආයුෂ්මත් මහා මෞද්ගල්‍යායන ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "තම්හා ආබාධා",
                    "sinh": "ඒ ආබාධයෙන්:",
                    "span": 1
                },
                {
                    "pali": "තථා",
                    "sinh": "එසේ ම",
                    "span": 1
                },
                {
                    "pali": "පහීනො ච",
                    "sinh": "පහවී (ප්‍රහීණ වී)",
                    "span": 1
                },
                {
                    "pali": "ආයස්මතො මහා මොග්ගල්ලානස්ස",
                    "sinh": "ආයුෂ්මත් මහා මුගලන් ස්ථවිරයන් වහන්සේ ගේ",
                    "span": 1
                },
                {
                    "pali": "සො ආබාධො",
                    "sinh": "ඒ ආබාධය",
                    "span": 1
                },
                {
                    "pali": "අහොසීති",
                    "sinh": "අහෝසි වී ගියේ ම ය.",
                    "span": 1
                }
            ]
        ]
    },
    "20-chunda-bojjhanga": {
        "labels": [
            [
                0,
                4.325857
            ],
            [
                4.325857,
                38.333751
            ],
            [
                38.333751,
                73.73923
            ],
            [
                73.73923,
                96.233688
            ],
            [
                96.233688,
                127.646068
            ],
            [
                127.646068,
                156.462933
            ],
            [
                156.462933,
                186.544279
            ],
            [
                186.544279,
                216.093213
            ],
            [
                216.093213,
                245.575594
            ],
            [
                245.575594,
                275.191079
            ],
            [
                275.191079,
                305.405529
            ],
            [
                305.405529,
                335.753082
            ],
            [
                335.753082,
                367.032359
            ],
            [
                367.764427,
                378.612346
            ],
            [
                378.612346,
                391.65647
            ],
            [
                391.65647,
                411.621965
            ]
        ],
        "text": [
            [
                {
                    "pali": "මහාචුන්ද බොජ්ඣඞ්ග සුත්තං",
                    "sinh": "මහාචුන්දත්ථෙර බොජ්ඣඞ්ග සූත්‍රය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී.",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "රාජගහෙ",
                    "sinh": "රජගහ නුවර",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "වෙළුවනෙ",
                    "sinh": "වේළුවන නම් වූ මහා විහාරයෙහි",
                    "span": 1
                },
                {
                    "pali": "කලන්දක නිවාපෙ",
                    "sinh": "ලෙහෙනුන්ට දෙන ලද නිවාප ඇති හෙයින් කලන්දක නිවාප නම් වූ",
                    "span": 1
                },
                {
                    "pali": "තෙන ඛො පන සමයෙන",
                    "sinh": "එ සමයෙහි වනාහි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවත් තෙම",
                    "span": 1
                },
                {
                    "pali": "ආබාධිකො හොති",
                    "sinh": "හටගත් ආබාධ ඇත්තේ වෙයි",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛිතො",
                    "sinh": "දුක්ඛිත වූයේ",
                    "span": 1
                },
                {
                    "pali": "බාළ්හගිලානො",
                    "sinh": "ද‍ැඩි ගිලන් වූයේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ආයෂ්මා මහා චුන්ද‍ො",
                    "sinh": "ආයුෂ්මත් මහා චුන්ද තෙම",
                    "span": 1
                },
                {
                    "pali": "සායණ්හසමයං",
                    "sinh": "සවස් කාලයෙහි",
                    "span": 1
                },
                {
                    "pali": "පතිසල්ලානා",
                    "sinh": "ඵල සමවතින්",
                    "span": 1
                },
                {
                    "pali": "වුට්ඨිතො",
                    "sinh": "නැගී සිටියේ",
                    "span": 1
                },
                {
                    "pali": "යෙන",
                    "sinh": "යම් තැනෙක ද",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැනට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "අභිවාදෙත්වා",
                    "sinh": "වැඳ",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත්පසෙක",
                    "span": 1
                },
                {
                    "pali": "නිසීදි",
                    "sinh": "හුන්නේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එකමන්තං නිසින්නං ඛො",
                    "sinh": "එකත් පසෙක හුන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "ආයස්මන්තං මහා චුන්දං",
                    "sinh": "ආයුෂ්මත් මහා චුන්ද ස්ථවිරයන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය වද‍ාළ සේක",
                    "span": 1
                },
                {
                    "pali": "පටිහන්තු",
                    "sinh": "වැටහෙත්වා",
                    "span": 1
                },
                {
                    "pali": "තං",
                    "sinh": "තොපට",
                    "span": 1
                },
                {
                    "pali": "චුන්ද",
                    "sinh": "චුන්දය",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගා",
                    "sinh": "බොජ්ඣංග ධර්මයෝ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සත්තිමෙ භන්තෙ බොජ්ඣංගා",
                    "sinh": "වහන්ස මේ සප්ත බොජ්ඣංගයෝ",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතා",
                    "sinh": "මොනවට ප්‍රකාශ කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "භාවිතා",
                    "sinh": "භාවිතා කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතා",
                    "sinh": "නැවත නැවත පුරුදු කරන ලදහ",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තන්ති",
                    "sinh": "පවතිත්",
                    "span": 1
                },
                {
                    "pali": "කතමෙ සත්ත?",
                    "sinh": "කවර සප්ත බෝධ්‍යංගයෝ ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සතිසම්බොජ්ඣංගො ඛො",
                    "sinh": "සතිසම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ධම්ම විචය සම්බොජ්ඣංගො ඛො",
                    "sinh": "ධම්ම විචය සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරිය සම්බොජ්ඣංගො ඛො",
                    "sinh": "විරිය සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පීති සම්බොජ්ඣංගො ඛො",
                    "sinh": "ප්‍රීති සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සද්ධි සම්බොජ්ඣංගො ඛො",
                    "sinh": "පස්සද්ධි සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමාධි සම්බොජ්ඣංගො ඛො",
                    "sinh": "සමාධි සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උපෙක්ඛා සම්බොජ්ඣංගො ඛො",
                    "sinh": "උපෙක්ෂා සම්බොධ්‍යංගය වනාහි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතො",
                    "sinh": "මොනවට කියන ලදි",
                    "span": 1
                },
                {
                    "pali": "භාවිතො",
                    "sinh": "වඩනා ලදි",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතො",
                    "sinh": "බහුල වශයෙන් කරන ලදී",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතියි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමෙ ඛො භන්තෙ සත්තබොජ්ඣංගා",
                    "sinh": "ස්වාමීන් වහන්ස, මේ සප්ත බොධ්‍යංගයෝ වනාහි",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "සම්ම දක්ඛාතා",
                    "sinh": "මොනවට කියන ලදහ",
                    "span": 1
                },
                {
                    "pali": "භාවිතා",
                    "sinh": "භාවිතය හ",
                    "span": 1
                },
                {
                    "pali": "බහුලීකතා",
                    "sinh": "බහුලීකෘතය හ",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "සත්‍ය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "ඔවුන්ගේ මනා අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තන්ති",
                    "sinh": "පවතිත්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තග්ඝ",
                    "sinh": "මැනව",
                    "span": 1
                },
                {
                    "pali": "චුන්ද",
                    "sinh": "චුන්දය",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගා",
                    "sinh": "බොධ්‍යංග ධර්මයෝ,",
                    "span": 1
                },
                {
                    "pali": "තග්ඝ",
                    "sinh": "මැනව",
                    "span": 1
                },
                {
                    "pali": "චුන්ද",
                    "sinh": "චුන්දය",
                    "span": 1
                },
                {
                    "pali": "බොජ්ඣංගොති",
                    "sinh": "බොධ්‍යංගයෝ’යි භාග්‍යවතුන් වහන්සේ වද‍ාළ සේක",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච",
                    "sinh": "මෙය වද‍ාළේ ය",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා මහා චුන්ද‍ො",
                    "sinh": "ආයුෂ්මත් මහා චුන්ද ස්ථවිර තෙම.",
                    "span": 1
                },
                {
                    "pali": "සමනුඤ්ඤ‍ො සත්ථා අහොසි",
                    "sinh": "ශාස්තෘෘන්වහන්සේ මනාකොට අනුද‍ැන වද‍ාළ හ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උට්ඨාහි ච",
                    "sinh": "නැගී සිටියේ ම ය",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන්වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "තම්හා ආබාධා",
                    "sinh": "ඒ ආබාධයෙන්",
                    "span": 1
                },
                {
                    "pali": "තථා",
                    "sinh": "එසේ ම",
                    "span": 1
                },
                {
                    "pali": "පහීනො ච",
                    "sinh": "පහවී (ප්‍රහීණ වී)",
                    "span": 1
                },
                {
                    "pali": "භගවතො",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ",
                    "span": 1
                },
                {
                    "pali": "සො ආබාධො",
                    "sinh": "ඒ ආබාධය",
                    "span": 1
                },
                {
                    "pali": "අහොසීති",
                    "sinh": "අහෝසි වී ගියේ ම ය.",
                    "span": 1
                }
            ]
        ]
    },
    "21-girimananda-suttam": {
        "labels": [
            [
                0,
                2.793054
            ],
            [
                2.793054,
                12.795775
            ],
            [
                12.795775,
                25.887429
            ],
            [
                25.887429,
                45.459669
            ],
            [
                45.459669,
                61.291436
            ],
            [
                61.291436,
                71.860446
            ],
            [
                71.860446,
                87.866189
            ],
            [
                87.866189,
                104.176389
            ],
            [
                104.176389,
                124.966457
            ],
            [
                124.966457,
                145.356503
            ],
            [
                145.356503,
                156.664909
            ],
            [
                156.664909,
                172.583664
            ],
            [
                172.583664,
                185.414355
            ],
            [
                185.414355,
                200.550221
            ],
            [
                200.550221,
                211.90212
            ],
            [
                211.90212,
                219.035114
            ],
            [
                219.035114,
                238.215909
            ],
            [
                238.215909,
                258.049113
            ],
            [
                258.049113,
                278.273761
            ],
            [
                278.273761,
                285.01531
            ],
            [
                285.01531,
                304.674538
            ],
            [
                304.674538,
                318.027155
            ],
            [
                318.027155,
                331.858205
            ],
            [
                331.858205,
                346.080699
            ],
            [
                346.080699,
                367.740645
            ],
            [
                367.740645,
                374.482195
            ],
            [
                374.482195,
                384.355302
            ],
            [
                384.355302,
                400.100082
            ],
            [
                400.100082,
                412.147883
            ],
            [
                412.147883,
                428.936516
            ],
            [
                428.936516,
                444.898765
            ],
            [
                444.898765,
                455.119824
            ],
            [
                455.119824,
                471.038579
            ],
            [
                471.038579,
                478.215067
            ],
            [
                478.215067,
                496.91743
            ],
            [
                496.91743,
                506.181624
            ],
            [
                506.181624,
                518.229425
            ],
            [
                518.229425,
                532.756376
            ],
            [
                532.756376,
                540.498285
            ],
            [
                540.498285,
                549.762478
            ],
            [
                549.762478,
                566.899062
            ],
            [
                566.899062,
                578.468431
            ],
            [
                578.468431,
                589.341897
            ],
            [
                589.341897,
                600.911266
            ],
            [
                600.911266,
                612.393647
            ],
            [
                612.393647,
                629.443243
            ],
            [
                629.443243,
                640.838636
            ],
            [
                640.838636,
                658.845097
            ],
            [
                658.845097,
                665.847609
            ],
            [
                665.847609,
                679.809141
            ],
            [
                679.809141,
                687.203098
            ],
            [
                687.203098,
                699.207405
            ],
            [
                699.207405,
                706.775338
            ],
            [
                706.775338,
                725.825652
            ],
            [
                725.825652,
                748.52945
            ],
            [
                748.52945,
                755.705939
            ],
            [
                755.705939,
                761.925561
            ],
            [
                761.925561,
                780.497443
            ],
            [
                780.497443,
                792.936689
            ],
            [
                792.936689,
                805.462922
            ],
            [
                805.462922,
                812.682904
            ],
            [
                812.682904,
                819.467947
            ],
            [
                819.467947,
                838.648743
            ],
            [
                838.648743,
                851.392446
            ],
            [
                851.392446,
                863.91868
            ],
            [
                863.91868,
                871.182155
            ],
            [
                871.182155,
                880.315867
            ],
            [
                880.315867,
                889.319098
            ],
            [
                889.319098,
                905.281347
            ],
            [
                905.281347,
                914.806504
            ],
            [
                914.806504,
                924.418648
            ],
            [
                924.418648,
                937.075364
            ],
            [
                937.075364,
                947.426904
            ],
            [
                947.426904,
                954.907849
            ],
            [
                954.907849,
                976.567795
            ],
            [
                976.567795,
                986.74536
            ],
            [
                986.74536,
                995.96606
            ],
            [
                995.96606,
                1007.752898
            ],
            [
                1007.752898,
                1019.93118
            ],
            [
                1019.93118,
                1031.761512
            ],
            [
                1031.761512,
                1043.852807
            ],
            [
                1043.852807,
                1054.769768
            ],
            [
                1054.769768,
                1066.252149
            ],
            [
                1066.252149,
                1077.647542
            ],
            [
                1077.647542,
                1089.086429
            ],
            [
                1089.086429,
                1098.916043
            ],
            [
                1098.916043,
                1108.919632
            ],
            [
                1108.919632,
                1118.662258
            ],
            [
                1118.662258,
                1128.404885
            ],
            [
                1128.404885,
                1139.843772
            ],
            [
                1139.843772,
                1150.630251
            ],
            [
                1150.630251,
                1161.547211
            ],
            [
                1161.547211,
                1172.551159
            ],
            [
                1172.551159,
                1181.858847
            ],
            [
                1181.858847,
                1191.384004
            ],
            [
                1191.384004,
                1201.561569
            ],
            [
                1201.561569,
                1211.826121
            ],
            [
                1211.826121,
                1221.220797
            ],
            [
                1221.220797,
                1230.48499
            ],
            [
                1230.48499,
                1239.444727
            ],
            [
                1239.444727,
                1248.578439
            ],
            [
                1248.578439,
                1257.625163
            ],
            [
                1257.625163,
                1266.149961
            ],
            [
                1266.149961,
                1274.935722
            ],
            [
                1274.935722,
                1283.938953
            ],
            [
                1283.938953,
                1292.768208
            ],
            [
                1292.768208,
                1301.771438
            ],
            [
                1301.771438,
                1311.949003
            ],
            [
                1311.949003,
                1322.03958
            ],
            [
                1322.03958,
                1329.259562
            ],
            [
                1329.259562,
                1346.787591
            ],
            [
                1346.787591,
                1355.660339
            ],
            [
                1355.660339,
                1368.360549
            ],
            [
                1368.360549,
                1382.757019
            ],
            [
                1382.757019,
                1393.978436
            ],
            [
                1393.978436,
                1404.329977
            ],
            [
                1404.329977,
                1423.336796
            ],
            [
                1423.336796,
                1433.427374
            ],
            [
                1433.427374,
                1450.302994
            ]
        ],
        "text": [
            [
                {
                    "pali": "ගිරිමානන්ද සුත්තං",
                    "sinh": "ගිරිමානන්ද සූත්‍රය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සාවත්ථියං",
                    "sinh": "සැවත් නුවර",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක",
                    "span": 1
                },
                {
                    "pali": "ජෙතවනෙ",
                    "sinh": "ජේතවනයෙහි වූ",
                    "span": 1
                },
                {
                    "pali": "අනාථපිණ්ඩිකස්ස",
                    "sinh": "අනේපිඬු මහ සිටුහු ගේ",
                    "span": 1
                },
                {
                    "pali": "ආරාමෙ",
                    "sinh": "ආරාමයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන ඛො පන සමයෙන",
                    "sinh": "එ සමයෙහි වනාහි",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා ගිරිමානන්දො",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "ආබාධිකො හොති",
                    "sinh": "ආබාධ ඇති වූයේ වෙයි",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛිතො",
                    "sinh": "දුඃඛිත වූයේ",
                    "span": 1
                },
                {
                    "pali": "බාළ්හගිලානො",
                    "sinh": "දැඩි ගිලන් වූයේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා ආනන්දො",
                    "sinh": "ආයුෂ්මත් ආනන්ද ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "යෙන",
                    "sinh": "යම් තැනෙක ද",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැනට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එසේ එළඹ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "භගවන්තං",
                    "sinh": "බුදුරදුන්",
                    "span": 1
                },
                {
                    "pali": "අභිවාදෙත්වා",
                    "sinh": "වැඳ",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත්පසෙක",
                    "span": 1
                },
                {
                    "pali": "නිසීදී",
                    "sinh": "හුන්නේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එකමන්තං",
                    "sinh": "එකත්පසෙක",
                    "span": 1
                },
                {
                    "pali": "නිසින්නො ඛො",
                    "sinh": "හුන්නාවු ම",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා ආනන්දො",
                    "sinh": "ආයුෂ්මත් ආනන්ද ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "එතදවොච",
                    "sinh": "මෙය කීයේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආයස්මා",
                    "sinh": "ආයුෂ්මත්",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "වහන්ස",
                    "span": 1
                },
                {
                    "pali": "ගිරිමානන්දො",
                    "sinh": "ගිරිමානන්ද ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "ආබාධිකො හොති",
                    "sinh": "ආබාධයෙන් යුක්ත ය",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛිතො",
                    "sinh": "දුඃඛිත ය",
                    "span": 1
                },
                {
                    "pali": "බාළ්හගිලානො",
                    "sinh": "ද‍ැඩි සේ ගිලන් ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සාධු",
                    "sinh": "මැනවි",
                    "span": 1
                },
                {
                    "pali": "භන්තෙ",
                    "sinh": "ස්වාමීනි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්ස",
                    "span": 1
                },
                {
                    "pali": "යෙන ආයස්මා ගිරිමානන්දො",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද ස්ථවිර තෙම යම් තැනෙක වෙසේද",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එතැනට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමතු",
                    "sinh": "එළඹෙන සේක් නම්",
                    "span": 1
                },
                {
                    "pali": "අනුකම්පං උපාද‍ායාති",
                    "sinh": "අනුකම්පා පිණිස.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සචෙ ඛො",
                    "sinh": "ඉදින් වනාහි",
                    "span": 1
                },
                {
                    "pali": "ත්වං ආනන්ද",
                    "sinh": "ආනන්දය ඔබ",
                    "span": 1
                },
                {
                    "pali": "ගිරිමානන්දස්ස භික්ඛුනො",
                    "sinh": "ගිරිමානන්ද භික්ෂුහු ගේ සමීපයට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "දස සංඤ්ඤ‍ා",
                    "sinh": "දශ සංඥ‍ාවන්",
                    "span": 1
                },
                {
                    "pali": "භාසෙය්‍යාසි",
                    "sinh": "කියන්නෙහි නම්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඨානං ඛො පනෙතං",
                    "sinh": "මේ කාරණය වනාහි",
                    "span": 1
                },
                {
                    "pali": "විජ්ජති",
                    "sinh": "විද්‍යමාන වෙයි.",
                    "span": 1
                },
                {
                    "pali": "යං",
                    "sinh": "යමක් වේද (කුමක්ද?)",
                    "span": 1
                },
                {
                    "pali": "ගිරිමානන්දස්ස භික්ඛුනො",
                    "sinh": "ගිරිමානන්ද භික්ෂු නම",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දස සඤ්ඤා සුත්වා",
                    "sinh": "දශ සංඥ‍ාවන් අසා",
                    "span": 1
                },
                {
                    "pali": "සො ආබාධො",
                    "sinh": "ඒ ආබාධය තෙම",
                    "span": 1
                },
                {
                    "pali": "ඨානසො",
                    "sinh": "වහා",
                    "span": 1
                },
                {
                    "pali": "පටිප්පස්සම්භෙය්‍යය",
                    "sinh": "සංසිඳෙන්නේ ය යන මෙය.",
                    "span": 1
                },
                {
                    "pali": "කතමෙ දශ?",
                    "sinh": "කවර දසසංඥ‍ාවක් ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනිච්ච සඤ්ඤා",
                    "sinh": "අනිත්‍ය සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "අනත්ත සඤ්ඤා",
                    "sinh": "අනාත්ම සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "අසුබ සඤ්ඤා",
                    "sinh": "අසුබ සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "ආදීනව සඤ්ඤා",
                    "sinh": "ආදීනව සංඥ‍ා ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පහාණ සඤඤ‍ා",
                    "sinh": "ප්‍රහාණ සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "විරාග සඤ්ඤා",
                    "sinh": "විරාග සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "නිරොධ සංඤ්ඤ‍ා",
                    "sinh": "නිරෝධ සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "සබ්බලෝකෙ අනභිරත සඤ්ඤා",
                    "sinh": "සියලු ලෝකයෙහි අනභිරත සංඥ‍ා ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බ සංඛාරෙසු අනිච්ච සඤ්ඤා",
                    "sinh": "සියලු සංස්කාරයන් කෙරෙහි අනිත්‍ය සංඥ‍ා ය",
                    "span": 1
                },
                {
                    "pali": "ආනාපාන සති",
                    "sinh": "ආනාපාන සතිය යනු යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "අනිච්ච සඤ්ඤා",
                    "sinh": "අනිත්‍ය සංඥ‍ාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතොවා",
                    "sinh": "ආරණ්‍යගත වූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූල ගතො වා",
                    "sinh": "රුක්මුලකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාර ගතො වා",
                    "sinh": "ශූන්‍යාගාරයකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ඉති පටිසංචික්ඛති",
                    "sinh": "මෙසේ නුවණින් සලකයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපං අනිච්චං",
                    "sinh": "රූපස්කන්ධය අනිත්‍ය ය",
                    "span": 1
                },
                {
                    "pali": "වෙදනා අනිච්චා",
                    "sinh": "වේදනාස්කන්ධය අනිත්‍ය ය",
                    "span": 1
                },
                {
                    "pali": "සඤ්ඤා අනිච්චා",
                    "sinh": "සංඥ‍ාස්කන්ධය අනිත්‍ය ය",
                    "span": 1
                },
                {
                    "pali": "සංඛාරා අනිච්චා",
                    "sinh": "සංස්කාරස්කන්ධය අනිත්‍ය ය",
                    "span": 1
                },
                {
                    "pali": "විඤ්ඤ‍ාණං අනිච්චං ඉති",
                    "sinh": "විඤ්ඤ‍ාණස්කන්ධය අනිත්‍යය කියායි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "ඉමෙසු පඤ්චසු උපාධානක්ඛන්ධෙසු",
                    "sinh": "මේ උපාද‍ානස්කන්ධ පඤ්චකයෙහි",
                    "span": 1
                },
                {
                    "pali": "අනිච්චානුපස්සි විහරති",
                    "sinh": "අනිත්‍ය ලක්ෂණය නැවත නැවත බලමින් වෙසෙයි",
                    "span": 1
                },
                {
                    "pali": "අයං වුච්චති ආනන්ද අනිච්චසඤ්ඤා",
                    "sinh": "ආනන්දය, මේ අනිත්‍ය සංඥ‍ාය’යි කියනු ලැබේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරේ ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "අනත්තසඤ්ඤා",
                    "sinh": "අනාත්ම සංඥ‍ාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතො වා",
                    "sinh": "අරණ්‍යගත වූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලගතො වා",
                    "sinh": "රුක්මුලකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාර ගතො වා",
                    "sinh": "ශුන්‍යාගාර ගත වූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "පටිසංභික්ඛති",
                    "sinh": "නුවණින් සිතයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං අනත්තා",
                    "sinh": "ඇස අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "රූපං අනත්තා",
                    "sinh": "රූපය අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "සොතං අනත්තා",
                    "sinh": "කන අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "සද්දා අනත්තා",
                    "sinh": "ශබ්දයෝ අනාත්ම ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝාණං අනත්තා",
                    "sinh": "නාසය අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "ගන්ධා අනත්තා",
                    "sinh": "ගන්ධයෝ අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හා අනත්තා",
                    "sinh": "දිව අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "රසා අනත්තා",
                    "sinh": "රසයෝ අනාත්ම ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායෝ අනත්තා",
                    "sinh": "කය අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "පොට්ඨබ්බා අනත්තා",
                    "sinh": "ස්පර්ශයෝ අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "මනො අනත්තා",
                    "sinh": "මනස අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "ධම්මා අනත්තා",
                    "sinh": "ධර්මයෝ අනාත්ම ය",
                    "span": 1
                },
                {
                    "pali": "ඉති",
                    "sinh": "යනුයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "ඉමෙසු ඡසු අජ්ඣත්තික බාහිරෙසු ආයතනෙසු",
                    "sinh": "මේ ආධ්‍යාත්මික වූ ද බාහිර වූ ද ෂඩායතනයන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "අනත්තානු පස්සි විහරති",
                    "sinh": "අනාත්ම ලක්ෂණ අනුව බලමින් වාසය කෙරෙයි",
                    "span": 1
                },
                {
                    "pali": "අයං වුච්චති ආනන්ද අනත්ත සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ අනාත්ම සංඥ‍ාය යි කියනු ලැබේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "අසුභ සඤ්ඤා",
                    "sinh": "අශුභ සංඥ‍ාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "ඉමමෙවකායං",
                    "sinh": "මේ ශරීරය ම,",
                    "span": 1
                },
                {
                    "pali": "උද්ධං පාදතලා",
                    "sinh": "පල්ලෙන් උඩ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අධො කෙසමත්ථකා",
                    "sinh": "කෙස් මතුයෙන් යට",
                    "span": 1
                },
                {
                    "pali": "තචපරියන්තං",
                    "sinh": "සම කෙළවර කොට ඇති,",
                    "span": 1
                },
                {
                    "pali": "පූරං නානප්පකාරස්ස අසුචිනො",
                    "sinh": "නානාප්‍රකාර වූ අසූචියෙන් පිරුණේය යි",
                    "span": 1
                },
                {
                    "pali": "පච්චවෙක්ඛති",
                    "sinh": "ප්‍රත්‍යවේක්ෂා කෙරේද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අත්ථි",
                    "sinh": "ඇත්තාහු",
                    "span": 1
                },
                {
                    "pali": "ඉමස්මිං කායෙ",
                    "sinh": "මේ ශරීරයෙහි",
                    "span": 1
                },
                {
                    "pali": "කෙසා",
                    "sinh": "කේසයෝ ය",
                    "span": 1
                },
                {
                    "pali": "ලොමා",
                    "sinh": "ලෝමයෝ ය",
                    "span": 1
                },
                {
                    "pali": "නඛා",
                    "sinh": "නිය ය",
                    "span": 1
                },
                {
                    "pali": "දන්තා",
                    "sinh": "දත් ය",
                    "span": 1
                },
                {
                    "pali": "තචෝ",
                    "sinh": "සම ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මංසං",
                    "sinh": "මස් ය",
                    "span": 1
                },
                {
                    "pali": "නහාරු",
                    "sinh": "නහර ය",
                    "span": 1
                },
                {
                    "pali": "අට්ඨි",
                    "sinh": "ඇට ය",
                    "span": 1
                },
                {
                    "pali": "අට්ඨිමිඤ්ජා",
                    "sinh": "ඇට මිදුලු ය",
                    "span": 1
                },
                {
                    "pali": "වක්කං",
                    "sinh": "වකුගඩු ය",
                    "span": 1
                },
                {
                    "pali": "හදයං",
                    "sinh": "හෘදය මාංශ ය",
                    "span": 1
                },
                {
                    "pali": "යකනං",
                    "sinh": "අක්මාව ය",
                    "span": 1
                },
                {
                    "pali": "කිලොමකං",
                    "sinh": "දලබුව ය",
                    "span": 1
                },
                {
                    "pali": "පිහකං",
                    "sinh": "බඩදිව ය",
                    "span": 1
                },
                {
                    "pali": "පස්ඵාසං",
                    "sinh": "පපුව ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අන්තං",
                    "sinh": "බඩවැල ය",
                    "span": 1
                },
                {
                    "pali": "අන්තගුණං",
                    "sinh": "අතුනුබහන ය",
                    "span": 1
                },
                {
                    "pali": "උදරියං",
                    "sinh": "අමු අහර ය",
                    "span": 1
                },
                {
                    "pali": "කරිසං",
                    "sinh": "මල ය",
                    "span": 1
                },
                {
                    "pali": "පිත්තං",
                    "sinh": "පිත ය",
                    "span": 1
                },
                {
                    "pali": "සෙම්හං",
                    "sinh": "සෙම ය",
                    "span": 1
                },
                {
                    "pali": "පුබ්බො",
                    "sinh": "පූයා ය",
                    "span": 1
                },
                {
                    "pali": "ලොහිතං",
                    "sinh": "ලේ ය",
                    "span": 1
                },
                {
                    "pali": "සෙදො",
                    "sinh": "ඩහදිය ය",
                    "span": 1
                },
                {
                    "pali": "මෙදො",
                    "sinh": "මේද තෙල ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අස්සු",
                    "sinh": "කඳුළු ය",
                    "span": 1
                },
                {
                    "pali": "වසා",
                    "sinh": "වුරුණු තෙල ය",
                    "span": 1
                },
                {
                    "pali": "ඛෙලො",
                    "sinh": "කෙළ ය",
                    "span": 1
                },
                {
                    "pali": "සිංඝාණිකා",
                    "sinh": "මුකුණු ය (සොටු ය)",
                    "span": 1
                },
                {
                    "pali": "ලසිකා",
                    "sinh": "සඳමිදුලු ය",
                    "span": 1
                },
                {
                    "pali": "මුත්තං ඉති",
                    "sinh": "මුත්‍ර ය යන මොහු.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "ඉමස්මිං කායෙ",
                    "sinh": "මේ ශරීරයෙහි",
                    "span": 1
                },
                {
                    "pali": "අසුභානුපස්සී",
                    "sinh": "අසුභය අනුව බලමින්",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වාසය කෙරෙයි.",
                    "span": 1
                },
                {
                    "pali": "අයං වුච්චති ආනන්ද අසුභ සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ අසුභ සංඥ‍ාය යි කියනු ලැබේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "ආදීනව සඤ්ඤා",
                    "sinh": "ආදීනව සඤ්ඤාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතො වා",
                    "sinh": "අරණ්‍ය ගතවූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලගතො වා",
                    "sinh": "රුක්මුලකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සුද්ඤ‍ාගාරගතො වා",
                    "sinh": "ශුන්‍යගාර ගතවූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "පටිසංභික්ඛති",
                    "sinh": "නුවණින් සිතයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බහුදුක්ඛො අයං කායො",
                    "sinh": "මේ ශරීරය තෙම, බොහෝ දුක් ඇත්තේ වෙයි",
                    "span": 1
                },
                {
                    "pali": "බහු ආදීනවො",
                    "sinh": "බොහෝ ආදීනව ඇත්තේ වෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "ඉමස්මිං කායෙ",
                    "sinh": "මේ ශරීරයෙහි",
                    "span": 1
                },
                {
                    "pali": "විවිධා ආබාධා",
                    "sinh": "බොහෝ ආබාධයෝ",
                    "span": 1
                },
                {
                    "pali": "උප්පජ්ජන්ති",
                    "sinh": "උපදිති",
                    "span": 1
                },
                {
                    "pali": "සෙය්‍යථිදං?",
                    "sinh": "ඒ කවරහුද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛු රොගො",
                    "sinh": "ඇස් රෝගය ද",
                    "span": 1
                },
                {
                    "pali": "සොත රොගො",
                    "sinh": "කර්ණ රෝගය ද",
                    "span": 1
                },
                {
                    "pali": "ඝාණ රොගො",
                    "sinh": "නාසිකා රෝගය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හා රොගො",
                    "sinh": "දිවේ ඇතිවන රෝගය",
                    "span": 1
                },
                {
                    "pali": "කාය රොගො",
                    "sinh": "කයෙහි ඇතිවන රෝග ය",
                    "span": 1
                },
                {
                    "pali": "සීස රොගො",
                    "sinh": "හිසෙහි ඇතිවන රෝගය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කණ්ණ රොගො",
                    "sinh": "කර්ණ මූලයෙහි ඇතිවන රෝග ය",
                    "span": 1
                },
                {
                    "pali": "මුඛ රොගො",
                    "sinh": "මුඛයෙහි ඇතිවන රෝගය",
                    "span": 1
                },
                {
                    "pali": "දන්ත රොගො",
                    "sinh": "දන්ත රෝගය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කාසො",
                    "sinh": "කාස ය",
                    "span": 1
                },
                {
                    "pali": "සාසො",
                    "sinh": "ස්වාස ය",
                    "span": 1
                },
                {
                    "pali": "පිනාසො",
                    "sinh": "පීනස ය",
                    "span": 1
                },
                {
                    "pali": "ඩහො",
                    "sinh": "ද‍ැවිල්ල ය",
                    "span": 1
                },
                {
                    "pali": "ජරො",
                    "sinh": "උණ ය",
                    "span": 1
                },
                {
                    "pali": "කුච්ජි රොගො",
                    "sinh": "උදර රෝගය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මූච්ජා",
                    "sinh": "මුර්ජාව",
                    "span": 1
                },
                {
                    "pali": "පක්ඛන්දිතා",
                    "sinh": "අතීසාරය",
                    "span": 1
                },
                {
                    "pali": "සූලා",
                    "sinh": "ඉදිමීම ය",
                    "span": 1
                },
                {
                    "pali": "විසූචිකා",
                    "sinh": "විසූචිකා ය",
                    "span": 1
                },
                {
                    "pali": "කුට්ඨං",
                    "sinh": "කුෂ්ඨ ය",
                    "span": 1
                },
                {
                    "pali": "ගණ්ඩො",
                    "sinh": "ගඩු ය",
                    "span": 1
                },
                {
                    "pali": "කිලාසො",
                    "sinh": "කිලාස ය",
                    "span": 1
                },
                {
                    "pali": "සොසො",
                    "sinh": "සෝස ය",
                    "span": 1
                },
                {
                    "pali": "අපමාරො",
                    "sinh": "අපස්මාරය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දද්දු",
                    "sinh": "දද ය",
                    "span": 1
                },
                {
                    "pali": "කණ්ඩු",
                    "sinh": "කන්ඩිති ය",
                    "span": 1
                },
                {
                    "pali": "කච්ඡු",
                    "sinh": "කච්ඡු නම් කුෂ්ඨ රෝග ය",
                    "span": 1
                },
                {
                    "pali": "රඛසා",
                    "sinh": "නියෙන් කැසූ තැන වන රෝග ය",
                    "span": 1
                },
                {
                    "pali": "විතච්ඡිකා",
                    "sinh": "විචර්චිකා නම් වූ කුෂ්ඨ රෝග ය",
                    "span": 1
                },
                {
                    "pali": "ලොහිත පිත්තං",
                    "sinh": "රත් පිත ය",
                    "span": 1
                },
                {
                    "pali": "මධුමෙහො",
                    "sinh": "මධුමෙහ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අංසා",
                    "sinh": "අංශ රෝග ය",
                    "span": 1
                },
                {
                    "pali": "පිළිකා",
                    "sinh": "පිළිකා ය",
                    "span": 1
                },
                {
                    "pali": "භගන්දලා",
                    "sinh": "භගන්දලා ය",
                    "span": 1
                },
                {
                    "pali": "පිත්ත සමුට්ඨානා ආබාධා",
                    "sinh": "පිත්තෙන් ඇතිවන රෝග ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සෙම්හ සමුට්ඨානා ආබාධා",
                    "sinh": "සෙමෙන් හට ගන්නා රෝග ය",
                    "span": 1
                },
                {
                    "pali": "වාත සමුට්ඨානා ආබාධා",
                    "sinh": "වාතයෙන් හට ගන්නා රෝග ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සන්නිපාතිකා ආබාධා",
                    "sinh": "තුන් දොසින් වන රෝග ය",
                    "span": 1
                },
                {
                    "pali": "උතුපරිණාමජා ආබාධා",
                    "sinh": "ඍතු පෙරළියෙන් ඇතිවන රෝග ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විසමපරිහාරජා ආබාධා",
                    "sinh": "විෂම පරිහාරයෙන් ඇතිවන රෝග ය",
                    "span": 1
                },
                {
                    "pali": "ඔපක්කමිකා ආබාධා",
                    "sinh": "උපක්‍රමයෙන් වන රෝග ය",
                    "span": 1
                },
                {
                    "pali": "කම්මවිපාකජා ආබාධා",
                    "sinh": "කර්ම විපාකයෙන් වන රෝග ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සීතං",
                    "sinh": "සීත ය",
                    "span": 1
                },
                {
                    "pali": "උණහං",
                    "sinh": "උෂ්ණය",
                    "span": 1
                },
                {
                    "pali": "ජීඝච්ඡා",
                    "sinh": "ක්ෂුධා ය",
                    "span": 1
                },
                {
                    "pali": "පිපාසා",
                    "sinh": "පිපාස ය",
                    "span": 1
                },
                {
                    "pali": "උච්චාරො",
                    "sinh": "අහර මල ය",
                    "span": 1
                },
                {
                    "pali": "පස්සාවො’ති",
                    "sinh": "පස්සාව ය යි (මූත්‍රය)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉති",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "ඉමස්මිං කායෙ",
                    "sinh": "මේ සිරුරෙහි",
                    "span": 1
                },
                {
                    "pali": "ආදීනවානුපස්සී",
                    "sinh": "ආදීනව අනුව බලමින්",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වෙසෙයි",
                    "span": 1
                },
                {
                    "pali": "අයං වුච්චති ආනන්ද ආදීනව සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ ආදීනව සංඥ‍ාය යි කියනු ලැබේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "පහාන සඤ්ඤා",
                    "sinh": "ප්‍රහාණ සංඥාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "උප්පන්නං කාම විතක්කං",
                    "sinh": "උපන් කාම විතර්කය",
                    "span": 1
                },
                {
                    "pali": "නාධි වාසෙති",
                    "sinh": "නො ඉවසා ද",
                    "span": 1
                },
                {
                    "pali": "පජහති",
                    "sinh": "අත්හරී ද",
                    "span": 1
                },
                {
                    "pali": "විනොදෙති",
                    "sinh": "දුරු කෙරේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛ්‍යන්ති කරොති",
                    "sinh": "නැති කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "අනභාවං ගමෙති",
                    "sinh": "අභාවයට පමුණුවා ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උප්පන්නං ව්‍යාපාද විතක්කං",
                    "sinh": "උපන් ව්‍යාපාද විතර්කය",
                    "span": 1
                },
                {
                    "pali": "නාධි වාසෙති",
                    "sinh": "නො ඉවසා ද",
                    "span": 1
                },
                {
                    "pali": "පජහති",
                    "sinh": "අත්හරි ද",
                    "span": 1
                },
                {
                    "pali": "විනොදෙති",
                    "sinh": "දුරු කෙරේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛ්‍යන්ති කරොති",
                    "sinh": "නැති කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "අනභාවං ගමෙති",
                    "sinh": "අභාවයට පමුණුවා ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උප්පන්නං විහිංසා විතක්කං",
                    "sinh": "උපන්නා වූ විහිංසා විතර්කය",
                    "span": 1
                },
                {
                    "pali": "නාධි වාසෙති",
                    "sinh": "නො ඉවසා ද",
                    "span": 1
                },
                {
                    "pali": "පජහති",
                    "sinh": "අත්හරී ද",
                    "span": 1
                },
                {
                    "pali": "විනොදෙති",
                    "sinh": "දුරු කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "ඛ්‍යන්ති කරොති",
                    "sinh": "නැති කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "අනභාවං ගමෙති",
                    "sinh": "අභාවයට පමුණුවා ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උප්පන්නුප්පන්නෙ",
                    "sinh": "උපනුපන්",
                    "span": 1
                },
                {
                    "pali": "පාපකෙ අකුසලෙ ධම්මෙ",
                    "sinh": "පවිටු අකුසල ධර්මයන්",
                    "span": 1
                },
                {
                    "pali": "නාධි වාසෙති",
                    "sinh": "නො ඉවසා ද",
                    "span": 1
                },
                {
                    "pali": "පජහති",
                    "sinh": "අත්හරි ද",
                    "span": 1
                },
                {
                    "pali": "විනොදෙති",
                    "sinh": "දුරු කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "ඛ්‍යන්ති කරොති",
                    "sinh": "නැති කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "අනභාවං ගමෙති",
                    "sinh": "අභාවයට පමුණුවා ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං වුච්චති ආනන්ද පහාණ සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ පහාණ සංඥ‍ාය යි කියනු ලැබේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "විරාග සඤ්ඤා",
                    "sinh": "විරාග සංඥාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතො වා",
                    "sinh": "අරණ්‍ය ගතවූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලගතො වා",
                    "sinh": "වෘක්ෂ මූලයකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සුද්ඤ‍ාගාරගතො වා",
                    "sinh": "ශුන්‍යගාර ගතවූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ඉති පටිසංවික්ඛති",
                    "sinh": "මෙසේ සිතයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතං සන්තං",
                    "sinh": "මේ ශාන්ත ය",
                    "span": 1
                },
                {
                    "pali": "එතං පණීතං",
                    "sinh": "මේ ප්‍රණීත ය",
                    "span": 1
                },
                {
                    "pali": "යදිදං",
                    "sinh": "යම් මේ",
                    "span": 1
                },
                {
                    "pali": "සබ්බ සංඛාර සමථො",
                    "sinh": "සියලු සංස්කාරයන්ගේ සංසිඳී ම ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බුපධිපටිනිස්සගො",
                    "sinh": "සියලු කෙලෙසුන් දුරලීම ය",
                    "span": 1
                },
                {
                    "pali": "තණ්හක්ඛයො",
                    "sinh": "තෘෂ්ණාව ක්ෂය කිරීම ය",
                    "span": 1
                },
                {
                    "pali": "විරාගො",
                    "sinh": "නො ඇලීම ය",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාත්ති",
                    "sinh": "නිර්වාණය යනු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං වුච්චති ආනන්ද විරාග සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ විරාග සංඥ‍ාය යි කියනු ලැබේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "නිරොධ සඤ්ඤා",
                    "sinh": "නිරොධ සංඥාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතො වා",
                    "sinh": "අරණ්‍යගත වූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලගතො වා",
                    "sinh": "වෘක්ෂ මූලයකට ගියේ හෝ,",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාරගතො වා",
                    "sinh": "ශුන්‍යාගාරයකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "ඉති පටිසංචික්ඛති",
                    "sinh": "මෙසේ සිතයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතං සන්තං",
                    "sinh": "මේ ශාන්ත ය",
                    "span": 1
                },
                {
                    "pali": "එතං පණීතං",
                    "sinh": "මේ ප්‍රණීත ය",
                    "span": 1
                },
                {
                    "pali": "යද්දිං",
                    "sinh": "යම් මේ",
                    "span": 1
                },
                {
                    "pali": "සබ්බ සංඛාර සමථො",
                    "sinh": "සියලු සංස්කාරයන්ගේ සංසිඳී ම ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බුපධිපටිනිස්සග්ගො",
                    "sinh": "සියලු කෙලෙසුන් දුරලීම ය",
                    "span": 1
                },
                {
                    "pali": "තණ්හක්ඛයො",
                    "sinh": "තෘෂණාව ක්ෂය කිරීම ය",
                    "span": 1
                },
                {
                    "pali": "නිරොධො",
                    "sinh": "නිරෝධ ය",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණන්ති",
                    "sinh": "නිර්වානය යනුයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං වුච්චති ආනන්ද නිරොධ සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ නිරොධ සංඥ‍ාය යි කියනු ලැබේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "සබ්බ ලොකෙ අනභිරත සඤ්ඤා",
                    "sinh": "මුලුලොව නො ඇලීමේ සංඥ‍ාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "යෙ ලොකෙ උපායූපාදානා",
                    "sinh": "ලෝකයෙහි තෘෂ්ණා දෘෂ්ටි යයි කියන ලද යම් උපායයෝ වෙත් ද, යම් උපාද‍ාන කෙනෙක් වෙත් ද.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චෙතසො",
                    "sinh": "සිත පිළිබඳ",
                    "span": 1
                },
                {
                    "pali": "අධිට්ඨානාභිනිවෙසා",
                    "sinh": "පිහිටියා වූ ශාස්වත නම් ලද අභිනිවෙසයෝ වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "අනුසයො",
                    "sinh": "අනුසය නම් ලද යම් වැදහෙව පැවැති කෙලෙස් වෙත් ද",
                    "span": 1
                },
                {
                    "pali": "තෙ පජහන්තො",
                    "sinh": "ඔවුන් පහකරමින්",
                    "span": 1
                },
                {
                    "pali": "විරමති න උපාදින්තො",
                    "sinh": "නො ගනිමින්, නො ඇලේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං වුච්චති ආනන්ද සබ්බ ලොකෙ අනභිරත සඤ්ඤා",
                    "sinh": "ආනන්දය, මේ මුලුලොව නො ඇලීමේ සංඥ‍ාය යි කියනු ලැබේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "සබ්බ සංඛාරෙසු",
                    "sinh": "සියලු සංස්කාර ධර්මයන්හි",
                    "span": 1
                },
                {
                    "pali": "අනිච්ච සඤ්ඤා",
                    "sinh": "අනිත්‍ය සංඥ‍ාව",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "සබ්බ සංඛාරෙහි",
                    "sinh": "සියලු සංස්කාර ධර්මයන් කෙරෙන්",
                    "span": 1
                },
                {
                    "pali": "අට්ටියති",
                    "sinh": "පීඩාවට පත් වේ ද",
                    "span": 1
                },
                {
                    "pali": "හරායති",
                    "sinh": "ලජ්ජාවේ ද?",
                    "span": 1
                },
                {
                    "pali": "ජිගුච්ඡති",
                    "sinh": "පිළිකුල් කෙරේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං වුච්චති ආනන්ද සබ්බ සංඛාරෙසු අනිච්ච සඤ්ඤා",
                    "sinh": "ආනන්දය, සියලු සංස්කාර ධර්මයන්හි අනිත්‍ය සංඥ‍ාය යි කියනු ලැබේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච",
                    "sinh": "කවරී ද",
                    "span": 1
                },
                {
                    "pali": "ආනන්ද",
                    "sinh": "ආනන්දය",
                    "span": 1
                },
                {
                    "pali": "ආනාපාන සති",
                    "sinh": "ආනාපාන සතිය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉධ ආනන්ද",
                    "sinh": "ආනන්දය, මේ සස්නෙහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු",
                    "sinh": "මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "අරඤ්ඤගතො වා",
                    "sinh": "අරණ්‍යගත වූයේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රුක්ඛමූලගතො වා",
                    "sinh": "වෘක්ෂ මූලයකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "සුඤ්ඤ‍ාගාරගතො වා",
                    "sinh": "ශුන්‍යගාරයකට ගියේ හෝ",
                    "span": 1
                },
                {
                    "pali": "නිසිදති",
                    "sinh": "හිඳියි",
                    "span": 1
                },
                {
                    "pali": "පල්ලකං ආභුජිත්වා",
                    "sinh": "පලක් බැඳ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උජුං කායං පණීධාය",
                    "sinh": "උඩුකය ඇද නැතිව මනාව පිහිටුවා ගෙන",
                    "span": 1
                },
                {
                    "pali": "පරිමුඛං සතිං උපට්ඨපෙත්වා",
                    "sinh": "අරමුණෙහි සිහිය එළවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සො",
                    "sinh": "ඒ මහණතෙම",
                    "span": 1
                },
                {
                    "pali": "සතොව",
                    "sinh": "සිහි ඇත්තේ ම",
                    "span": 1
                },
                {
                    "pali": "අස්ස සති",
                    "sinh": "ආශ්වාස කෙරේ ද?",
                    "span": 1
                },
                {
                    "pali": "සතො",
                    "sinh": "සිහි ඇත්තේ ම",
                    "span": 1
                },
                {
                    "pali": "පස්ස සති",
                    "sinh": "ප්‍රාශ්වාස කෙරේ ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දීඝං වා",
                    "sinh": "දීර්ඝ කොට",
                    "span": 1
                },
                {
                    "pali": "අස්ස සන්තො",
                    "sinh": "ආශ්වාස කරන්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "දීඝං අස්ස සාමීති පජනාති",
                    "sinh": "දීර්ඝ කොට ආශ්වාස කෙරෙමි’යි දන්නේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දීඝං වා පස්ස සන්තො",
                    "sinh": "දීර්ඝ කොට ප්‍රශ්වාස කරන්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "දීඝං පස්ස සාමිති පජනාති",
                    "sinh": "දීර්ඝ කොට ප්‍රශ්වාස කෙරෙමි’යි දනියි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රස්සං වා අස්ස සන්තො",
                    "sinh": "කෙටිව ආශ්වාස කරන්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රස්සං අස්ස සාමීති පජනාති",
                    "sinh": "ලුහුඬු කොට ආශ්වාස කෙරෙමි’යි දනියි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රස්සං වා පස්ස සන්තො",
                    "sinh": "කෙටිව ප්‍රශ්වාස කරන්නේ හෝ",
                    "span": 1
                },
                {
                    "pali": "රස්සං පස්සසාමී’ති පජනාති",
                    "sinh": "ලුහුඬු කොට ප්‍රශ්වාස කෙරෙමි’යි දනියි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බකාය පටිසංවේදී",
                    "sinh": "සියලු ආශ්වාසකය දන්නේ",
                    "span": 1
                },
                {
                    "pali": "අස්ස සිස්සාමීති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බකාය පටිසංවේදී",
                    "sinh": "සියලු ප්‍රශ්වාස කය දන්නේ",
                    "span": 1
                },
                {
                    "pali": "පස්ස සිස්සාමීති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සංභයං කාය සංඛාරං",
                    "sinh": "කාය සංස්කාරය හෙවත් ආශ්වාසය සංසිඳුවන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "අස්සසාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’ යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සංභයං කාය සංඛාරං",
                    "sinh": "කාය සංස්කාරය හෙවත් ආශ්වාසය සංසිඳුවන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පීතිපටිසංවේදී",
                    "sinh": "ප්‍රීතිය විඳිමින්",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි ති",
                    "sinh": "ආවාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පීතිපටිසංවේදී",
                    "sinh": "ප්‍රීතිය විඳිමින්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රාශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුඛපටිසංවේදී",
                    "sinh": "සුව විඳිමින්",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුඛපටිසංවේදී",
                    "sinh": "සුව විදිමින්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තසංඛාර පටිසංවේදී",
                    "sinh": "චිත්ත සංස්කාරය විඳිමින්",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්ත සංඛාර පටිසංවේදී",
                    "sinh": "චිත්ත සංස්කාරය විඳිමින්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සම්භයං චිත්ත සංඛාරං",
                    "sinh": "චිත්ත සංස්කාරය සංසිඳු වන්නෙම්",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පස්සම්භයං චිත්ත සංඛාරං",
                    "sinh": "චිත්ත සංස්කාරය සංසිඳු වන්නෙම්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’ යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තපටිසංවේදී",
                    "sinh": "සිත් පහළ කෙරෙමින්",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’යි",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තපටිසංවේදී",
                    "sinh": "සිත් පහළ කෙරෙමින්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’ යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අධිප්පමොදයං චිත්තං",
                    "sinh": "සමථ විදර්ශනා දෙකින් සිත ඉතා සතුටු කෙරෙමින්",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අභිප්පමොදයං චිත්තං",
                    "sinh": "සමථ විදර්ශනා දෙකින් සිත ඉතා සතුටු කෙරෙමින්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමාදහං චිත්තං",
                    "sinh": "ආශ්වාසයෙහි(අරමුණක්) සිත පිහිටු වන්නේමි’යි",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමාදහං චිත්තං",
                    "sinh": "ආශ්වාසයෙහි(අරමුණක්) සිත පිහිටු වන්නේමි’යි",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විමොචයං චිත්තං",
                    "sinh": "නීවරණයන් ගෙන් සිත මුදන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විමොචයං චිත්තං",
                    "sinh": "නීවරණයන් ගෙන් සිත මුදන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’ යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනිච්චානුපස්සි",
                    "sinh": "අනිත්‍ය ලක්ෂණ නැවත නැවත දකින්නේ",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’ යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අතිච්චානුපස්සි",
                    "sinh": "අනිත්‍ය ලක්ෂණ නැවත නැවත දකින්නේ",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරාගානුපස්සි",
                    "sinh": "විරාගය නැවත නැවත දකින්නේ",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරාගානුපස්සි",
                    "sinh": "විරාගය නැවත නැවත දකින්නේ",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නිරෝධානුපස්සි",
                    "sinh": "නිරෝධය නැවත නැවත දකිනේ",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නිරෝධානුපස්සී",
                    "sinh": "නිරෝධය නැවත නැවත දකිනේ",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පටිනිස්සග්ගානුපස්සි",
                    "sinh": "කෙලෙසුන්ගෙන් මිදීම නැවත නැවත දකින්නේ",
                    "span": 1
                },
                {
                    "pali": "අස්සසිස්සාමි’ති",
                    "sinh": "ආශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පටිනිස්සග්ගානුපස්සි",
                    "sinh": "කෙලෙසුන්ගෙන් මිදීම නැවත නැවත දකින්නෙම්",
                    "span": 1
                },
                {
                    "pali": "පස්සසිස්සාමි’ති",
                    "sinh": "ප්‍රාශ්වාස කෙරෙමි’යි",
                    "span": 1
                },
                {
                    "pali": "සික්ඛති",
                    "sinh": "හික්මෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං වුච්චති ආනන්ද ආනාපානසති",
                    "sinh": "ආනන්දය, මේ ආනාපානසති යි කියනු ලැබේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සචෙ ඛො",
                    "sinh": "ඉදින් වනාහි",
                    "span": 1
                },
                {
                    "pali": "ත්වං ආනන්ද",
                    "sinh": "ආනන්දය ඔබ",
                    "span": 1
                },
                {
                    "pali": "ගිරිමානන්දස්ස භික්ඛුනො",
                    "sinh": "ගිරිමානන්ද භික්ෂුහු ගේ සමීපයට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                },
                {
                    "pali": "ඉමා දස සංඤ්ඤ‍ා",
                    "sinh": "මේ දශ සංඥ‍ාවන්",
                    "span": 1
                },
                {
                    "pali": "භාසෙය්‍යාසි",
                    "sinh": "කියන්නෙහි නම්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඨානං ඛො පනෙතං",
                    "sinh": "මේ කාරණය වනාහි",
                    "span": 1
                },
                {
                    "pali": "විජ්ජති",
                    "sinh": "විද්‍යමාන වෙයි.",
                    "span": 1
                },
                {
                    "pali": "යං",
                    "sinh": "යමක් වේද (කුමක්ද?)",
                    "span": 1
                },
                {
                    "pali": "ගිරිමානන්දස්ස භික්ඛුනො",
                    "sinh": "ගිරිමානන්ද භික්ෂු නම",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමා දස සඤ්ඤා සුත්වා",
                    "sinh": "මේ දශ සංඥ‍ාවන් අසා",
                    "span": 1
                },
                {
                    "pali": "සො ආබාධො",
                    "sinh": "ඒ ආබාධය තෙම",
                    "span": 1
                },
                {
                    "pali": "ඨානසො",
                    "sinh": "වහා",
                    "span": 1
                },
                {
                    "pali": "පටිප්පස්සම්භෙය්‍ය ඉති",
                    "sinh": "සංසිඳෙන්නේ ය යන මෙය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා ආනන්දො",
                    "sinh": "ආයුෂ්මත් ආනන්ද ස්ථවිර තෙම",
                    "span": 1
                },
                {
                    "pali": "භගවතො සන්තිකෙ",
                    "sinh": "භාග්‍යවතුන් වහන්සේ ගේ සමීපයෙහි",
                    "span": 1
                },
                {
                    "pali": "ඉමා දස සඤ්ඤා",
                    "sinh": "මේ දශ සංඥ‍ාවන්",
                    "span": 1
                },
                {
                    "pali": "උග්ගහෙත්වා",
                    "sinh": "උගෙන",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙන ආයස්මා ගිරිමානන්දො",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද භික්ෂුනම යම් තැනෙක ද",
                    "span": 1
                },
                {
                    "pali": "තෙන",
                    "sinh": "එ තැනට",
                    "span": 1
                },
                {
                    "pali": "උපසංකමි",
                    "sinh": "එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "උපසංකමිත්වා",
                    "sinh": "එළඹ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආයස්මතො ගිරිමානන්දස්ස",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද භික්ෂු නමට",
                    "span": 1
                },
                {
                    "pali": "ඉමා දස සඤ්ඤා",
                    "sinh": "මේ දස සංඥ‍ාවන්",
                    "span": 1
                },
                {
                    "pali": "අභාසි",
                    "sinh": "වද‍ාළහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "ආයස්මතො ගිරිමානන්දස්ස",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද භික්ෂු නමගේ",
                    "span": 1
                },
                {
                    "pali": "ඉමා දස සඤ්ඤා සුත්වා",
                    "sinh": "මේ දස සංඥ‍ාවන් අසා",
                    "span": 1
                },
                {
                    "pali": "සො ආබාධො",
                    "sinh": "ඒ ආබාධය",
                    "span": 1
                },
                {
                    "pali": "ඨානසො",
                    "sinh": "වහා",
                    "span": 1
                },
                {
                    "pali": "පටිප්පස්සම්හි",
                    "sinh": "සංසිඳුනේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වුට්ඨාහි",
                    "sinh": "නැගී සිටියේ ය",
                    "span": 1
                },
                {
                    "pali": "ආයස්මා ගිරිමානන්දො ච",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද ස්ථවිර තෙමේ ද",
                    "span": 1
                },
                {
                    "pali": "තම්හි ආබාධා",
                    "sinh": "ඒ ආබාධයෙන්.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තථා පහීනො ච පනායස්මතො ගිරිමානන්‍දස්ස සො ආබාධො අහොසීති",
                    "sinh": "ආයුෂ්මත් ගිරිමානන්ද භික්ෂු නමගේ වනාහි, ඒ ආබාධය එසේ ම ප්‍රහීණ වීය යනුයි.",
                    "span": 1
                }
            ]
        ]
    },
    "23-dhammacakkappavattana": {
        "labels": [
            [
                0,
                3.396545
            ],
            [
                3.396545,
                13.169059
            ],
            [
                13.169059,
                21.868981
            ],
            [
                21.868981,
                32.475734
            ],
            [
                32.475734,
                43.082488
            ],
            [
                43.082488,
                62.150809
            ],
            [
                62.150809,
                75.617811
            ],
            [
                75.617811,
                92.898477
            ],
            [
                92.898477,
                111.072971
            ],
            [
                111.072971,
                124.420795
            ],
            [
                124.420795,
                142.237758
            ],
            [
                142.237758,
                152.367804
            ],
            [
                152.367804,
                165.536863
            ],
            [
                165.536863,
                178.884688
            ],
            [
                178.884688,
                192.053747
            ],
            [
                192.053747,
                211.122068
            ],
            [
                211.122068,
                220.59664
            ],
            [
                220.59664,
                232.871872
            ],
            [
                232.871872,
                244.432042
            ],
            [
                244.432042,
                258.673694
            ],
            [
                258.673694,
                268.38662
            ],
            [
                268.38662,
                284.71387
            ],
            [
                284.71387,
                292.758318
            ],
            [
                292.758318,
                301.637005
            ],
            [
                301.637005,
                310.813634
            ],
            [
                310.813634,
                318.798494
            ],
            [
                318.798494,
                331.133314
            ],
            [
                331.133314,
                340.786652
            ],
            [
                340.786652,
                353.240649
            ],
            [
                353.240649,
                365.813823
            ],
            [
                365.813823,
                379.459591
            ],
            [
                379.459591,
                398.527912
            ],
            [
                398.527912,
                417.417467
            ],
            [
                417.417467,
                436.783731
            ],
            [
                436.783731,
                454.600693
            ],
            [
                454.600693,
                473.371072
            ],
            [
                473.371072,
                488.149021
            ],
            [
                488.149021,
                506.621457
            ],
            [
                506.621457,
                526.524017
            ],
            [
                526.524017,
                545.175219
            ],
            [
                545.175219,
                563.230535
            ],
            [
                563.230535,
                581.881737
            ],
            [
                581.881737,
                596.361743
            ],
            [
                596.361743,
                615.489653
            ],
            [
                615.489653,
                635.273036
            ],
            [
                635.273036,
                654.22218
            ],
            [
                654.22218,
                673.528855
            ],
            [
                673.528855,
                692.537588
            ],
            [
                692.537588,
                709.937431
            ],
            [
                709.937431,
                728.648221
            ],
            [
                728.648221,
                750.159671
            ],
            [
                750.159671,
                768.51293
            ],
            [
                768.51293,
                789.666849
            ],
            [
                789.666849,
                808.079696
            ],
            [
                808.079696,
                819.580278
            ],
            [
                819.580278,
                834.715758
            ],
            [
                834.715758,
                847.169755
            ],
            [
                847.169755,
                857.001858
            ],
            [
                857.001858,
                868.144908
            ],
            [
                868.144908,
                878.453719
            ],
            [
                878.453719,
                893.410434
            ],
            [
                893.410434,
                904.672661
            ],
            [
                904.672661,
                914.802706
            ],
            [
                914.802706,
                926.779996
            ],
            [
                926.779996,
                947.635972
            ],
            [
                947.635972,
                963.367337
            ],
            [
                963.367337,
                975.940511
            ],
            [
                975.940511,
                983.746605
            ],
            [
                983.746605,
                992.982823
            ],
            [
                992.982823,
                1006.569002
            ],
            [
                1006.569002,
                1015.864808
            ],
            [
                1015.864808,
                1024.624318
            ],
            [
                1024.624318,
                1042.322104
            ],
            [
                1042.322104,
                1058.351411
            ],
            [
                1058.351411,
                1074.857427
            ],
            [
                1074.857427,
                1089.87373
            ],
            [
                1089.87373,
                1103.638674
            ],
            [
                1103.638674,
                1118.059092
            ],
            [
                1118.059092,
                1135.578112
            ],
            [
                1135.578112,
                1152.680012
            ],
            [
                1152.680012,
                1168.828497
            ],
            [
                1168.828497,
                1184.679039
            ],
            [
                1184.679039,
                1199.397399
            ],
            [
                1199.397399,
                1214.89041
            ],
            [
                1214.89041,
                1230.264244
            ],
            [
                1230.264244,
                1244.863427
            ],
            [
                1244.863427,
                1259.760553
            ],
            [
                1259.760553,
                1275.074799
            ],
            [
                1275.074799,
                1289.554805
            ],
            [
                1289.554805,
                1304.392342
            ],
            [
                1304.392342,
                1317.680579
            ],
            [
                1317.680579,
                1331.147581
            ],
            [
                1331.147581,
                1344.733759
            ],
            [
                1344.733759,
                1359.035
            ],
            [
                1359.035,
                1376.792374
            ],
            [
                1376.792374,
                1393.536744
            ],
            [
                1393.536744,
                1406.467449
            ],
            [
                1406.467449,
                1417.96803
            ],
            [
                1417.96803,
                1434.593223
            ],
            [
                1434.593223,
                1441.267135
            ],
            [
                1441.267135,
                1451.397181
            ],
            [
                1451.397181,
                1466.592249
            ]
        ],
        "text": [
            [
                {
                    "pali": "ධම්මචක්කපවත්තන සුත්තං",
                    "sinh": "දම්සක් පැවතුම් සුත්‍රය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "මෙ",
                    "sinh": "මා විසින්",
                    "span": 1
                },
                {
                    "pali": "සුතං",
                    "sinh": "අසන ලදී",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං",
                    "sinh": "එක් සමයෙක",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බාරාණසියං",
                    "sinh": "බරණැස් නුවරෙහි",
                    "span": 1
                },
                {
                    "pali": "විහරති",
                    "sinh": "වැඩ වසන සේක.",
                    "span": 1
                },
                {
                    "pali": "ඉසිපතනෙ",
                    "sinh": "ඉසිපතනාරාමයෙහි",
                    "span": 1
                },
                {
                    "pali": "මිගද‍ායෙ",
                    "sinh": "මුවන්ට අභය ද‍ානය කළ හෙයින් මිගද‍ාය නම් වූ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තත්‍ර ඛො",
                    "sinh": "එකල්හි වනාහි",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "පඤ්ච වග්ගියෙ භික්ඛු",
                    "sinh": "පස්වග මහණුන්",
                    "span": 1
                },
                {
                    "pali": "ආමන්තෙසි",
                    "sinh": "ඇමතු සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ද්වෙ මෙ භික්ඛවෙ අන්තා",
                    "sinh": "මහණෙනි, මේ අන්තයෝ දෙකෙකි: (එනම්)",
                    "span": 1
                },
                {
                    "pali": "පබ්බජිතෙන",
                    "sinh": "පැවිද්දෙකු විසින්",
                    "span": 1
                },
                {
                    "pali": "න සෙවිතබ්බා",
                    "sinh": "නො සෙවිය යුතු.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යොචායං",
                    "sinh": "යම් මේ",
                    "span": 1
                },
                {
                    "pali": "කාමෙසු",
                    "sinh": "වස්තු කාමයන් කෙරෙහි",
                    "span": 1
                },
                {
                    "pali": "කාමසුඛල්ලිකානුයොගො",
                    "sinh": "කාමසුඛල්ලිකානුයෝගයක් ඇද්ද,",
                    "span": 1
                },
                {
                    "pali": "හීනො",
                    "sinh": "ලාමක වූ",
                    "span": 1
                },
                {
                    "pali": "ගම්මො",
                    "sinh": "ග්‍රාම්‍ය වූ",
                    "span": 1
                },
                {
                    "pali": "පොථුජ්ජනිකො",
                    "sinh": "පෘථග්ජනයන් විසින් පුරුදු කරන ලද",
                    "span": 1
                },
                {
                    "pali": "අනරියො",
                    "sinh": "අනාර්යය වූ",
                    "span": 1
                },
                {
                    "pali": "අනත්ථසංහිතො",
                    "sinh": "අනර්ථයක් ම සිදු කරන්නා වූ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යොචායං",
                    "sinh": "යම් මේ",
                    "span": 1
                },
                {
                    "pali": "අත්තකිලමථානුයොගො",
                    "sinh": "අත්තකිලමථානුයෝගයක් ඇද්ද",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛො",
                    "sinh": "දුක් උපදවන්නා වූ",
                    "span": 1
                },
                {
                    "pali": "අනරියො",
                    "sinh": "අනාර්යය වූ",
                    "span": 1
                },
                {
                    "pali": "අනත්ථසංහිතො",
                    "sinh": "අනර්ථයක් ම ඇසුරු කරන්නා වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතෙ තෙ භික්ඛවෙ උභො අන්තෙ",
                    "sinh": "මහණෙනි, ඒ මේ අන්ත දෙකට",
                    "span": 1
                },
                {
                    "pali": "අනුපගම්ම",
                    "sinh": "නො පැමිණ",
                    "span": 1
                },
                {
                    "pali": "මජ්ඣිමා පටිපද‍ා",
                    "sinh": "මධ්‍යම ප්‍රතිපද‍ා තොමෝ",
                    "span": 1
                },
                {
                    "pali": "තථාගතෙන",
                    "sinh": "තථාගතයන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිසම්බුද්ධා",
                    "sinh": "අවබෝධ කරන ලදු; (ඕතොමෝ)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුකරණි",
                    "sinh": "ප්‍රඥ‍ා‍‍‍‍චක්ෂුස පිරිසිදු කරන්නී ය",
                    "span": 1
                },
                {
                    "pali": "ඤ‍ාණකරණී",
                    "sinh": "නුවණැස ඇති කරන්නී ය",
                    "span": 1
                },
                {
                    "pali": "උපසමාය",
                    "sinh": "කෙලෙසුන් සංසිඳීම පිණිස",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "චතුරාර්ය සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "ඔවුන්ගේ ම අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවන්නී ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කතමා ච සා භික්ඛවෙ මජ්ඣිමා පටිපද‍ා",
                    "sinh": "මහණෙනි, ඒ කවර මධ්‍යම ප්‍රතිපද‍ාව තොමෝ",
                    "span": 1
                },
                {
                    "pali": "තථාගතෙන",
                    "sinh": "තථාගතයන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිසම්බුද්ධා",
                    "sinh": "මනාකොට අවබෝධ කරන ලද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුකරණි",
                    "sinh": "ප්‍රඥ‍ා‍‍‍‍චක්ෂුස පිරිසිදු කරන්නී",
                    "span": 1
                },
                {
                    "pali": "ඤ‍ාණකරණී",
                    "sinh": "නුවණැස ඇති කරන්නී",
                    "span": 1
                },
                {
                    "pali": "උපසමාය",
                    "sinh": "කෙලෙසුන් සංසිඳීම පිණිස",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "චතුරාර්ය සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "ඔවුන්ගේ ම අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතී ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං එව අරියො අට්ඨංගිකො මග්ගෝ",
                    "sinh": "මේ ආර්ය අෂ්ඨාංගික මාර්ගය මැ යි",
                    "span": 1
                },
                {
                    "pali": "සෙය්‍යථිදං?",
                    "sinh": "ඒ කවරේ ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සම්මාදිට්ඨි",
                    "sinh": "සම්‍යක්දෘෂ්ටි ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාසංකප්පො",
                    "sinh": "සම්‍යක්සංකල්පනාව ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාවාචා",
                    "sinh": "සම්‍යක්වචන ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාකම්මන්තො",
                    "sinh": "සම්‍යක්කර්මාන්ත ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සම්මාආජීවො",
                    "sinh": "සම්‍යක්ආජීව ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාවායාමො",
                    "sinh": "සම්‍යක්ව්‍යායාම ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාසති",
                    "sinh": "සම්‍යක්සමෘති ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාසමාධි",
                    "sinh": "සම්‍යක්සමාධි ය යනු මොහු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයං ඛො සා භික්ඛවේ මජ්ඣිමා පටිපද‍ා",
                    "sinh": "මහණෙනි, මේ ඒ මධ්‍යම ප්‍රතිපද‍ාතොමෝ",
                    "span": 1
                },
                {
                    "pali": "තථාගතෙන",
                    "sinh": "තථාගතයන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "අභිසම්බුද්ධා",
                    "sinh": "අවබෝධ කරන ලද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුකරණි",
                    "sinh": "ප්‍රඥ‍ා‍‍‍‍චක්ෂුස පිරිසිදු කරන්නී ය",
                    "span": 1
                },
                {
                    "pali": "ඤ‍ාණකරණී",
                    "sinh": "නුවණැස ඇති කරන්නී ය",
                    "span": 1
                },
                {
                    "pali": "උපසමාය",
                    "sinh": "කෙලෙසුන් සංසිඳීම පිණිස",
                    "span": 1
                },
                {
                    "pali": "අභිඤ්ඤ‍ාය",
                    "sinh": "චතුරාර්ය සත්‍යය ප්‍රතිවේධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "සම්බොධාය",
                    "sinh": "ඔවුන්ගේ ම අවබෝධය පිණිස",
                    "span": 1
                },
                {
                    "pali": "නිබ්බාණාය",
                    "sinh": "නිවන් පිණිස",
                    "span": 1
                },
                {
                    "pali": "සංවත්තති",
                    "sinh": "පවතී.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං ඛො පන",
                    "sinh": "මේ වනාහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛං අරියසච්චං",
                    "sinh": "දුක්ඛ ආර්ය සත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජාතිපි දුක්ඛා",
                    "sinh": "ඉපදීම දුක ය",
                    "span": 1
                },
                {
                    "pali": "ජරාපි දුක්ඛා",
                    "sinh": "ජරාව ද දුක ය",
                    "span": 1
                },
                {
                    "pali": "ව්‍යාධිපි දුක්ඛො",
                    "sinh": "රෝගීවීම දුක ය",
                    "span": 1
                },
                {
                    "pali": "මරණම්පි දුක්ඛං",
                    "sinh": "මරණය ද දුක ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අප්පියෙහි සම්පයොගො දුක්ඛො",
                    "sinh": "අප්‍රියයන් හා එක්වීම දුක ය",
                    "span": 1
                },
                {
                    "pali": "පියෙහි විප්පයොගො දුක්ඛො",
                    "sinh": "ප්‍රියයන් ගෙන් වෙන්වීම දුක ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යම්පිච්ඡං න ලභති",
                    "sinh": "කැමති යමක් නො ලැබේ ද",
                    "span": 1
                },
                {
                    "pali": "තම්පි දුක්ඛං",
                    "sinh": "එද දුක ය",
                    "span": 1
                },
                {
                    "pali": "සංඛිත්තෙන",
                    "sinh": "සැකෙවින්",
                    "span": 1
                },
                {
                    "pali": "පඤ්ච උපාද‍ානක්ඛන්ධා",
                    "sinh": "පඤ්ච උපද‍ානස්කන්ධයෝ",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛා",
                    "sinh": "දුක් වන්නාහු ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං ඛො පන",
                    "sinh": "මේ වනාහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛ සමුදයං අරිය සච්චං",
                    "sinh": "දුක්ඛ සමුදය ආර්ය සත්‍යය නම් වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යායං තණ්හා",
                    "sinh": "යම් මේ තෘෂ්ණාවක්",
                    "span": 1
                },
                {
                    "pali": "පොනොභවිකා",
                    "sinh": "පුනරුප්පත්තිය ඇති කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "නන්දිරාග සහගතා",
                    "sinh": "නන්දිරාග සම්ප්‍රයුක්ත වන්නී ද",
                    "span": 1
                },
                {
                    "pali": "තත්‍රතත්‍රාභි නන්දිනී",
                    "sinh": "ඒ ඒ භවයෙහි විශේෂයෙන් සතුට ඇති කරන්නී ද",
                    "span": 1
                },
                {
                    "pali": "සෙය්‍යථිදං?",
                    "sinh": "ඕ තෘෂ්ණාව කවරීද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කාම තණ්හා",
                    "sinh": "කාම තෘෂ්ණාව ය",
                    "span": 1
                },
                {
                    "pali": "භව තණ්හා",
                    "sinh": "භව තෘෂ්ණාව ය හෙවත් ශාස්වත දෘෂ්ටිය හා යෙදෙන තෘෂ්ණාව ය",
                    "span": 1
                },
                {
                    "pali": "විභව තණ්හා",
                    "sinh": "විභව තෘෂ්ණාව ය හෙවත් උච්ඡේද දෘෂ්ටිය හා යෙදෙන තෘෂ්ණාව ය යන මොහු යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං ඛො පන",
                    "sinh": "මේ වනාහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛ නිරෝධං අරියසච්චං",
                    "sinh": "දුක්ඛ නිරෝධ ආර්යය සත්‍යය යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යො තස්සාය එව තණ්හාය",
                    "sinh": "ඒ තෘෂ්ණාවගේ ම යම්",
                    "span": 1
                },
                {
                    "pali": "අසෙස විරාග නිරොධො",
                    "sinh": "යම් සම්පූර්ණ නො ඇලීමක් නැති කිරීමක් වේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චාගො",
                    "sinh": "අත්හැරීමක් වේ ද",
                    "span": 1
                },
                {
                    "pali": "පටිනිස්සගො",
                    "sinh": "දුරලීමක් වේ ද",
                    "span": 1
                },
                {
                    "pali": "මුත්තී",
                    "sinh": "මිදීමක් වේ ද",
                    "span": 1
                },
                {
                    "pali": "අනාලයො",
                    "sinh": "නො ඇලීමක් වේ ද (එයයි)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං ඛො පන",
                    "sinh": "මේ වනාහි",
                    "span": 1
                },
                {
                    "pali": "භික්ඛවෙ",
                    "sinh": "මහණෙනි",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛනිරොධ ගාමිනිපටිපද‍ා අරියසච්චං",
                    "sinh": "දුක්ඛ නිරෝධ ගාමිනී ප්‍රතිපද‍ාර්යය සත්‍යය වේ, එනම්;",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයමෙව අරියො අට්ඨංගිකො මග්ගො",
                    "sinh": "මේ ආර්යය අෂ්ටාංගික මාර්ගය ම ය.",
                    "span": 1
                },
                {
                    "pali": "සෙය්‍යථිදං?",
                    "sinh": "ඒ කවරේ ද යත්?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සම්මාදිට්ඨි",
                    "sinh": "සම්‍යක්දෘෂ්ටි ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාසංකප්පො",
                    "sinh": "සම්‍යක්සංකල්පනාව ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාවාචා",
                    "sinh": "සම්‍යක්වචන ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාකම්මන්තො",
                    "sinh": "සම්‍යක්කර්මාන්ත ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සම්මාආජීවො",
                    "sinh": "සම්‍යක්ආජීව ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාවායාමො",
                    "sinh": "සම්‍යක්ව්‍යායාම ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාසති",
                    "sinh": "සම්‍යක්සමෘති ය",
                    "span": 1
                },
                {
                    "pali": "සම්මාසමාධි",
                    "sinh": "සම්‍යක්සමාධි ය යනු මොහු යි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං දුක්ඛං අරියසච්චන්ති",
                    "sinh": "මේ දුක්ඛ ආර්යය සත්‍යය යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛං අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "පරිඤ්ඤෙය්‍යංති",
                    "sinh": "පිරිසිඳ දත යුතුය යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බෙ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛං අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "පරිඤ්ඤාතන්ති",
                    "sinh": "පිරිසිඳ දක්නා ලද‍ැ’යි,",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බෙ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං දුක්ඛ සමුදයං අරියසච්චන්ති",
                    "sinh": "මේ දුක්ඛ සමුද‍ායාර්යය සත්‍යය යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛං සමුදයං අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛ සමුද‍ායාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "පහාතබ්බන්ති",
                    "sinh": "ප්‍රහාණය කළ යුතුය’යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛං සමුදයං අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛ සමුද‍ායාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "පහීනන්ති",
                    "sinh": "ප්‍රහාණය වීය යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං දුක්ඛ නිරොධො අරියසච්චන්ති",
                    "sinh": "මේ දුක්ඛ නිරෝධ ආර්යය සත්‍යය’යි කියා",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛ නිරොධො අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛ නිරොධාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "සච්ඡිකාතබ්බන්ති",
                    "sinh": "සාක්ෂාත් කටයුතු ය’යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛ නිරොධො අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛ නිරොධාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "සච්ඡිකාතන්ති",
                    "sinh": "සාක්ෂාත් කරන ලද‍ැ’යි කියා",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදං දුක්ඛ නිරොධ ගාමිනි පටිපද‍ා අරියසච්චන්ති",
                    "sinh": "මේ දුක්ඛනිරොධ ගාමිනි පටිපද‍ා ආර්යය සත්‍යය’යි කියා",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛ නිරොධ ගාමිනි පටිපද‍ා අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛ නිරොධ ගාමිනි පටිපද‍ාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "භාවෙතබ්බන්ති",
                    "sinh": "භාවිතා කටයුතු’යි",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තං ඛො පන ඉදං දුක්ඛ නිරොධො අරියසච්චං",
                    "sinh": "ඒ මේ දුක්ඛ නිරොධාර්යය සත්‍යය",
                    "span": 1
                },
                {
                    "pali": "භාවිතන්ති",
                    "sinh": "භාවිතා කරන ලද‍ැ’යි කියා",
                    "span": 1
                },
                {
                    "pali": "මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට",
                    "span": 1
                },
                {
                    "pali": "පුබ්බේ",
                    "sinh": "පෙර",
                    "span": 1
                },
                {
                    "pali": "අනනුස්සුතෙසු ධම්මෙසු",
                    "sinh": "නො ඇසූ විරූ ධර්මයන්හි,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛුං උදපාදි",
                    "sinh": "සත්‍යඥ‍ාන චක්ෂුස පහළ විය",
                    "span": 1
                },
                {
                    "pali": "ඤාණං උදපාදි",
                    "sinh": "එහි දැනීම ඇති ඥ‍ානය පහළ විය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤ‍ා උදපාදි",
                    "sinh": "ප්‍රඥ‍ාව පහළ විය",
                    "span": 1
                },
                {
                    "pali": "විජ්ජා උදපාදි",
                    "sinh": "විද්‍යාව හෙවත් කෙලෙසුන් දුරුකිරීමෙහි නුවණ ඇති විය",
                    "span": 1
                },
                {
                    "pali": "ආලොකො උදපාදි",
                    "sinh": "අවිද්‍යාන්ධකාරය දුරු කරන ඥ‍ා‍‍නාලෝකය පහළ විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යාවකීවඤ්ච මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට යම්තාක් කල්",
                    "span": 1
                },
                {
                    "pali": "ඉමෙසු චතුසු අරියසච්චෙසු",
                    "sinh": "මේ චතුරාර්යසත්‍යයන් කෙරෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "තිපරිවට්ටං",
                    "sinh": "සත්‍යඥ‍ාන,කෘත්‍යඥ‍ාන, කෘතඥ‍ාන සංඛ්‍යාත වූ ත්‍රිපරිවෘත්තයක් ඇති",
                    "span": 1
                },
                {
                    "pali": "ද්වාදසාකාරං",
                    "sinh": "(එකි එකී සත්‍යය තුන් ආකාරයන් ගේ වශයෙන්) ද‍ොළොස් ආකාරයක් ඇති",
                    "span": 1
                },
                {
                    "pali": "යථා භූතං ඤ‍ාණදස්සනං",
                    "sinh": "යථාභූත ඥ‍ානදර්ශනය",
                    "span": 1
                },
                {
                    "pali": "න සුවිසුද්ධං අහොසි",
                    "sinh": "අතිපරිශුද්ධ නො වී ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නෙව තාවාහං භික්ඛවෙ",
                    "sinh": "මහණෙනි, ඒ තාක් කල් මම නොකළෙමි (කුමක්ද?)",
                    "span": 1
                },
                {
                    "pali": "සදෙවකෙ",
                    "sinh": "දෙවියන් සහිත වූ",
                    "span": 1
                },
                {
                    "pali": "ලොකෙ",
                    "sinh": "ලෝකයෙහි",
                    "span": 1
                },
                {
                    "pali": "සමාරකෙ",
                    "sinh": "මරුන් සහිත වූ",
                    "span": 1
                },
                {
                    "pali": "සබ්‍රහ්මකෙ",
                    "sinh": "බඹුන් සහිත වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සස්සමණබ්‍රාහ්මණියා",
                    "sinh": "මහණ බමුණන් සහිත වූ",
                    "span": 1
                },
                {
                    "pali": "පජාය",
                    "sinh": "ප්‍රජාවෙහි",
                    "span": 1
                },
                {
                    "pali": "සදෙවමනුස්සාය",
                    "sinh": "දෙවි මිනිසුන් සහිත වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනුත්තරං සම්මාසම්බොධිං අභිසම්බුද්ධො පච්චඤ්ඤ‍ාසිං",
                    "sinh": "අනුත්තර වූ සම්‍යක් සම්බෝධිය ප්‍රත්‍යක්ෂ කෙළෙමි’යි ප්‍රතිඥ‍ා කිරීම",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යතොච ඛො මෙ භික්ඛවෙ",
                    "sinh": "මහණෙනි, මට යම් තැනෙක පටන්",
                    "span": 1
                },
                {
                    "pali": "ඉමෙසු චතුසු අරියසච්චෙසු",
                    "sinh": "මේ චතුරාර්යසත්‍යයන් කෙරෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං",
                    "sinh": "මෙසේ",
                    "span": 1
                },
                {
                    "pali": "තිපරිවට්ටං",
                    "sinh": "සත්‍යඥ‍ාන,කෘත්‍යඥ‍ාන, කෘතඥ‍ාන සංඛ්‍යාත වූ ත්‍රිපරිවෘත්තයක් ඇති",
                    "span": 1
                },
                {
                    "pali": "ද්වාදසාකාරං",
                    "sinh": "(එකි එකී සත්‍යය තුන් ආකාරයන් ගේ වශයෙන්) ද‍ොළොස් ආකාරයක් ඇති",
                    "span": 1
                },
                {
                    "pali": "යථා භූතං ඤ‍ාණදස්සනං",
                    "sinh": "යථාභූත ඥ‍ානදර්ශනය",
                    "span": 1
                },
                {
                    "pali": "සුවිසුද්ධං අහොසි",
                    "sinh": "අතිපරිශුද්ධ වී ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථාහං භික්ඛවෙ",
                    "sinh": "මහණෙනි, එකල්හි මම",
                    "span": 1
                },
                {
                    "pali": "සදෙවකෙ",
                    "sinh": "දෙවියන් සහිත වූ",
                    "span": 1
                },
                {
                    "pali": "ලොකෙ",
                    "sinh": "ලෝකයෙහි",
                    "span": 1
                },
                {
                    "pali": "සමාරකෙ",
                    "sinh": "මරුන් සහිත වූ",
                    "span": 1
                },
                {
                    "pali": "සබ්‍රහ්මකෙ",
                    "sinh": "බඹුන් සහිත වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සස්සමණබ්‍රාහ්මණියා",
                    "sinh": "මහණ බමුණන් සහිත වූ",
                    "span": 1
                },
                {
                    "pali": "පජාය",
                    "sinh": "ප්‍රජාවෙහි",
                    "span": 1
                },
                {
                    "pali": "සදෙවමනුස්සාය",
                    "sinh": "දෙවි මිනිසුන් සහිත වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනුත්තරං සම්මාසම්බොධිං අභිසම්බුද්ධො පච්චඤ්ඤ‍ාසිං",
                    "sinh": "අනුත්තර වූ සම්‍යක් සම්බෝධිය ප්‍රත්‍යක්ෂ කෙළෙමි’යි ප්‍රතිඥ‍ා කළෙමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඤාණඤ්ච පන මෙ දස්සනං",
                    "sinh": "මට ප්‍රත්‍යවෙක්ෂාඥ‍ානය වනාහි",
                    "span": 1
                },
                {
                    "pali": "උදපාදි",
                    "sinh": "පහළ විය",
                    "span": 1
                },
                {
                    "pali": "අකුප්පා මෙ චෙතොවිමුත්ති",
                    "sinh": "මාගේ චෙතොවිමුක්තිය (අරහත්ඵලය) අකෝප්‍ය ය",
                    "span": 1
                },
                {
                    "pali": "අයමන්තිමා ජාති",
                    "sinh": "මෝතොමෝ පශ්චිම ජාතිය වන්නී ය",
                    "span": 1
                },
                {
                    "pali": "නත්‍ථිදානි පුනබ්භවොති",
                    "sinh": "ද‍ැන් පුනර්භවයෙක් නැත්තේ ය’යි වද‍ාළ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉදමවොච භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ මේ සූත්‍ර ධර්මය වද‍ාළ සේක.",
                    "span": 1
                },
                {
                    "pali": "අත්තමනා",
                    "sinh": "සතුටු සිත් ඇති",
                    "span": 1
                },
                {
                    "pali": "පඤ්චවග්ගියා භික්ඛූ",
                    "sinh": "පඤ්ච වග්ගීය භික්ෂූහු",
                    "span": 1
                },
                {
                    "pali": "භගවතො භාසිතං",
                    "sinh": "භාග්‍යවතුන් වහන්සේගේ දේශනාවට",
                    "span": 1
                },
                {
                    "pali": "අභිනන්‍දුන්ති",
                    "sinh": "ප්‍රීතිය ප්‍රකාශ කළහ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමස්මිඤ්ච පන වෙය්‍යාකරණස්මිං",
                    "sinh": "මේ වෙය්‍යාකරණ ධර්මය",
                    "span": 1
                },
                {
                    "pali": "භඤ්ඤමානෙ",
                    "sinh": "වද‍ාළ කල්හි",
                    "span": 1
                },
                {
                    "pali": "ආයස්මතො කොණ්ඩඤ්ඤස්ස",
                    "sinh": "ආයුෂ්මත් කොණ්ඩඤ්ඤ ස්ථවිරයන් වහන්සේට",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරජං",
                    "sinh": "රජස් රහිත වූ",
                    "span": 1
                },
                {
                    "pali": "වීතමලං",
                    "sinh": "පහ වූ කෙලෙස් මල ඇති",
                    "span": 1
                },
                {
                    "pali": "ධම්ම චක්ඛුං",
                    "sinh": "දහම් ඇස (සෝවාන් මාර්ග ඤ‍ාණය)",
                    "span": 1
                },
                {
                    "pali": "උදපාදි",
                    "sinh": "පහළ විය (කෙසේ ද?)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යංකිඤ්චි",
                    "sinh": "යම් කිසිවක්",
                    "span": 1
                },
                {
                    "pali": "සමුදය ධම්මං",
                    "sinh": "හටගන්නා ස්වභාවය ඇත්තේ ද",
                    "span": 1
                },
                {
                    "pali": "සබ්බං තං",
                    "sinh": "ඒ සියල්ල",
                    "span": 1
                },
                {
                    "pali": "නිරොධ ධම්මං ඉති",
                    "sinh": "නිරුද්ධවන ස්වභාවය ඇත්තේ ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පවත්තිතෙ ච පන භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්, පවත්වන ලද කල්හි",
                    "span": 1
                },
                {
                    "pali": "ධම්ම චක්කෙ",
                    "sinh": "මේ ධර්ම චක්‍රය",
                    "span": 1
                },
                {
                    "pali": "භුම්මා දෙවා",
                    "sinh": "බූමාටු දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ (කෙසේ ද?)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතං",
                    "sinh": "මේ",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "බාරාණසියං",
                    "sinh": "බාරාණසි පුරයෙහි",
                    "span": 1
                },
                {
                    "pali": "ඉසිපතනෙ මිගද‍ායෙ",
                    "sinh": "මිගද‍ාය නම් වූ ඉසිපතනාරාමයෙහි දී",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනුත්තරං ධම්ම චක්කං",
                    "sinh": "අනුත්තර වූ ධර්ම චක්‍රය",
                    "span": 1
                },
                {
                    "pali": "පවත්තිතං",
                    "sinh": "පවත්වන ලද්දේ ය කියා යි",
                    "span": 1
                },
                {
                    "pali": "අප්පතිවත්තියං",
                    "sinh": "නොපැවැත්විය හැකි වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමණෙන වා",
                    "sinh": "ශ්‍රමණයෙකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "බ්‍රාහ්මණෙන වා",
                    "sinh": "බමුණෙකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "දෙවෙන වා",
                    "sinh": "දෙවියකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "මාරෙන වා",
                    "sinh": "මාරයකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මුණා වා",
                    "sinh": "බ්‍රහ්මයකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "කෙනචි වා",
                    "sinh": "අන් කිසිවකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොකස්මින්ති",
                    "sinh": "ලෝකයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "භුම්මානං දෙවානං",
                    "sinh": "භූමි නිශ්‍රිත දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධු නාදය අසා",
                    "span": 1
                },
                {
                    "pali": "චාතුම්මහාරාජිකා දෙවා",
                    "sinh": "චතුර්මහාරාජික දෙවියෝ ද",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චාතුම්මහාරාජිකානං",
                    "sinh": "චාතුර්මහාරාජික දිව්‍යලෝක වාසී වූ",
                    "span": 1
                },
                {
                    "pali": "දෙවානං",
                    "sinh": "දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "තාවතිංසා දෙවා",
                    "sinh": "තව්තිසා වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තාවතිංසානං දෙවානං",
                    "sinh": "තව්තිසා වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "යාමා දෙවා",
                    "sinh": "යාම දෙව්ලොව දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යාමානං දෙවානං",
                    "sinh": "යාම දෙව් ලොව වැසි දෙවියන්ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "තුසිතා දෙවා",
                    "sinh": "තුසිත දෙව් ලොව වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තුසිතානං දෙවානං",
                    "sinh": "තුසිත දෙව් ලොව වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "නිම්මාණරති දෙවා",
                    "sinh": "නිර්මාණරති දෙව් ලොව වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නිම්මාණරතිනං දෙවානං",
                    "sinh": "නිර්මාණරති දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "පරනිම්මිත වසවන්තිනො දෙවා",
                    "sinh": "පරනිම්මිත වසවර්ති දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පරනිම්මිත වසවත්තිනොදෙවානං",
                    "sinh": "පරනිර්මිත වසවර්ති දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මපාරිසජ්ජා දෙවා",
                    "sinh": "බ්‍රහ්මපාරිසජ්ජ නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බ්‍රහ්මපාරිසජ්ජානං දෙවානං",
                    "sinh": "බ්‍රහ්මපාරිසජ්ජ නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මපුරොහිතා දෙවා",
                    "sinh": "බ්‍රහ්මපුරෝහිත නම් බඹලොව වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බ්‍රහ්මපුරොහිතානං දෙවානං",
                    "sinh": "බ්‍රහ්මපුරෝහිත නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "මහාබ්‍රහ්මා දෙවා",
                    "sinh": "මහා බ්‍රහ්ම වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මහාබ්‍රහ්මාණං දෙවානං",
                    "sinh": "මහාබ්‍රහ්ම දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "පරිත්තාභා දෙවා",
                    "sinh": "පරිත්තාභ නම් දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පරිත්තාභානං දෙවානං",
                    "sinh": "පරිත්තාභ නම් දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "අප්පමාණාහා දෙවා",
                    "sinh": "අප්පමාණහා නම් බඹලොව වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අප්පමාණභානං දෙවානං",
                    "sinh": "අප්පමාණාභා නම් බඹලෝ වැසි දෙවියන්ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "ආභස්සරා දෙවා",
                    "sinh": "ආභස්සර නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආභස්සරානං දෙවානං",
                    "sinh": "ආභස්සර නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "පරිත්තසුභා දෙවා",
                    "sinh": "පරිත්තසුභ නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පරිත්තසුභානං දෙවානං",
                    "sinh": "පරිත්තසුභා නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "අප්පමාණසුභා දෙවා",
                    "sinh": "අප්පමාණසුභ නම් බඹලො වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අප්පමාණසුභානං දෙවානං",
                    "sinh": "අප්පමාණසුභ නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "සුභකිණ්හකා දෙවා",
                    "sinh": "සුභකිණ්හක නම් බඹලෝ වැසියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුභකිණ්හකානං දෙවානං",
                    "sinh": "සුභකිණ්හක නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "වෙහප්ඵලා දෙවා",
                    "sinh": "වෙහප්ඵල නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වෙහප්ඵලානං දෙවානං",
                    "sinh": "වෙහප්ඵල නම් බඹලෝ වැසි දෙවියන්ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "අවිහා දෙවා",
                    "sinh": "අවිහ නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අවිහානං දෙවානං",
                    "sinh": "අවිහ නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "අතප්පා දෙවා",
                    "sinh": "අතප්ප නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අතප්පානං දෙවානං",
                    "sinh": "අතප්ප නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "සුදස්සා දෙවා",
                    "sinh": "සුදස්ස නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුදස්සානං දෙවානං",
                    "sinh": "සුදස්ස නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "සුදස්සී දෙවා",
                    "sinh": "සුදස්සී නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුදස්සීනං දෙවානං",
                    "sinh": "සුදස්සී නම් බඹලෝ වැසි දෙවියන් ගේ",
                    "span": 1
                },
                {
                    "pali": "සද්දං සුත්වා",
                    "sinh": "සාධුකාර ශබ්දය අසා",
                    "span": 1
                },
                {
                    "pali": "අකනිට්ඨකා දෙවා",
                    "sinh": "අකනිට්ඨක නම් බඹලෝ වැසි දෙවියෝ",
                    "span": 1
                },
                {
                    "pali": "සද්දමනුස්සාවෙසුං",
                    "sinh": "සාධු නාදය පැවැත්වූහ (කෙසේ ද?)",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එතං",
                    "sinh": "මේ",
                    "span": 1
                },
                {
                    "pali": "භගවතා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "බාරාණසියං",
                    "sinh": "බාරාණසි පුරයෙහි",
                    "span": 1
                },
                {
                    "pali": "ඉසිපතනෙ මිගද‍ායෙ",
                    "sinh": "මිගද‍ාය නම් වූ ඉසිපතනාරාමයෙහි දී",
                    "span": 1
                },
                {
                    "pali": "අනුත්තරං ධම්ම චක්කං",
                    "sinh": "අනුත්තර වූ ධර්ම චක්‍රය",
                    "span": 1
                },
                {
                    "pali": "පවත්තිතං",
                    "sinh": "පවත්වන ලද්දේ ය කියා යි",
                    "span": 1
                },
                {
                    "pali": "අප්පතිවත්තියං",
                    "sinh": "නොපැවැත්විය හැකි වූ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සමණෙන වා",
                    "sinh": "ශ්‍රමණයෙකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "බ්‍රාහ්මණෙන වා",
                    "sinh": "බමුණෙකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "දෙවෙන වා",
                    "sinh": "දෙවියකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "මාරෙන වා",
                    "sinh": "මාරයකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මුණා වා",
                    "sinh": "බ්‍රහ්මයකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "කෙනචි වා",
                    "sinh": "අන් කිසිවකු විසින් හෝ",
                    "span": 1
                },
                {
                    "pali": "ලොකස්මින්ති",
                    "sinh": "ලෝකයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉතීහ",
                    "sinh": "මේ ආකාරයෙන්",
                    "span": 1
                },
                {
                    "pali": "තෙන ඛනෙන",
                    "sinh": "එකෙණෙහි",
                    "span": 1
                },
                {
                    "pali": "තෙන මුහුත්තෙන",
                    "sinh": "ඒ මොහොතෙහි",
                    "span": 1
                },
                {
                    "pali": "යාව බ්‍රහ්මලොකො",
                    "sinh": "බඹලොව දක්වා",
                    "span": 1
                },
                {
                    "pali": "සද්දො",
                    "sinh": "සාධුකාර ශබ්දය",
                    "span": 1
                },
                {
                    "pali": "අබ්භුග්ගඤ්ජි",
                    "sinh": "ඉතා උස්ව පැන නැංගේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අයඤ්ච දස සහස්ස ලොකධාතු",
                    "sinh": "මේ දශ සහශ්‍රී ලෝක ධාතුව ද",
                    "span": 1
                },
                {
                    "pali": "සංකම්පි",
                    "sinh": "බොහෝ සෙයින් කම්පා විය",
                    "span": 1
                },
                {
                    "pali": "සම්පකම්පි",
                    "sinh": "අතිශයින් ම කම්පා විය",
                    "span": 1
                },
                {
                    "pali": "සමිපවෙධි",
                    "sinh": "විශේෂයෙන් ම කම්පිත විය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අප්පමාණො ච",
                    "sinh": "අප්‍රමාණ වූ",
                    "span": 1
                },
                {
                    "pali": "උළාරො",
                    "sinh": "මහත් වූ",
                    "span": 1
                },
                {
                    "pali": "ඔභාසො",
                    "sinh": "ආලෝකය",
                    "span": 1
                },
                {
                    "pali": "ලොකෙ",
                    "sinh": "ලෝකයෙහි",
                    "span": 1
                },
                {
                    "pali": "පාතුරහොසි",
                    "sinh": "පහළ විය,",
                    "span": 1
                },
                {
                    "pali": "අතික්කම්ම",
                    "sinh": "ඉක්මවා,",
                    "span": 1
                },
                {
                    "pali": "දෙවානං දෙවානුභාවන්ති",
                    "sinh": "දෙවියන් ගේ දෙවානුභාවය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො",
                    "sinh": "ඉක්බිති",
                    "span": 1
                },
                {
                    "pali": "භගවා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "උද‍ානං",
                    "sinh": "ප්‍රීති වාක්‍යයක්",
                    "span": 1
                },
                {
                    "pali": "උද‍ානෙසි",
                    "sinh": "පැවැත් වූ සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අඤ්ඤාසි වත භො, කොණ්ඩඤ්ඤො",
                    "sinh": "භවත් කොණ්ඩඤ්ඤ තෙමේ, ඒකාන්තයෙන් චතුස්සත්‍යය දත්තේ ය",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤාසි වත භො කොණ්ඩඤ්ඤොති",
                    "sinh": "භවත් කොණ්ඩඤ්ඤ තෙමේ, ඒකාන්තයෙන් චතුස්සත්‍යය දත්තේ ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉතිහිදං",
                    "sinh": "මෙසේ මේ කාරණයෙහි දි",
                    "span": 1
                },
                {
                    "pali": "ආයස්මතො කොණ්ඩඤ්ඤස්ස",
                    "sinh": "කොණ්ඩඤ්ඤ ආයුෂ්මතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤාකොණ්ඩඤ්ඤොත්වෙව",
                    "sinh": "අඤ්ඤ‍ාකොණ්ඩඤ්ඤ්ය යන",
                    "span": 1
                },
                {
                    "pali": "නාමං",
                    "sinh": "නාමය",
                    "span": 1
                },
                {
                    "pali": "අහොසීති",
                    "sinh": "වූයේ ය",
                    "span": 1
                }
            ]
        ]
    },
    "25-alavaka-suttam": {
        "labels": [
            [
                0,
                3.015199,
                1
            ],
            [
                3.015199,
                11.59983,
                2
            ],
            [
                11.59983,
                20.055128,
                3
            ],
            [
                20.055128,
                38.468111,
                4
            ],
            [
                38.468111,
                57.475062,
                5
            ],
            [
                57.475062,
                67.956836,
                6
            ],
            [
                67.956836,
                86.684272,
                7
            ],
            [
                86.684272,
                97.235925,
                8
            ],
            [
                97.235925,
                115.369394,
                9
            ],
            [
                115.369394,
                125.990925,
                10
            ],
            [
                125.990925,
                141.608769,
                11
            ],
            [
                141.608769,
                169.769802,
                12
            ],
            [
                169.769802,
                207.119857,
                13
            ],
            [
                207.119857,
                254.637233,
                14
            ],
            [
                254.637233,
                284.9645,
                15
            ],
            [
                284.9645,
                305.299142,
                16
            ],
            [
                305.299142,
                325.598845,
                17
            ],
            [
                325.598845,
                354.528541,
                18
            ],
            [
                354.528541,
                373.675249,
                19
            ],
            [
                373.675249,
                393.171349,
                20
            ],
            [
                393.171349,
                421.856471,
                21
            ],
            [
                421.856471,
                440.234515,
                22
            ],
            [
                440.234515,
                458.647498,
                23
            ],
            [
                458.647498,
                475.907486,
                24
            ],
            [
                475.907486,
                495.508404,
                25
            ],
            [
                495.508404,
                513.012966,
                26
            ],
            [
                513.012966,
                531.076557,
                27
            ],
            [
                531.076557,
                553.018404,
                28
            ],
            [
                553.018404,
                580.101224,
                29
            ],
            [
                0
            ]
        ],
        "text": [
            [
                {
                    "pali": "ආළවක සුත‍්තං",
                    "sinh": "ආළවක සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං සුතං",
                    "sinh": "මා විසින් මෙසේ අසන ලදි",
                    "span": 1
                },
                {
                    "pali": "එකං සමයං භගවා",
                    "sinh": "එක් සමයෙක්හි භාග්‍යවතුන් වහන්සේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආළවියං විහරති",
                    "sinh": "අලව් නුවර සමීපයෙහි වූ වැඩ වාසය කරන",
                    "span": 1
                },
                {
                    "pali": "ආළවකස‍්ස යක‍්ඛස‍්ස භවනෙ",
                    "sinh": "ආලවක නම් යක්ෂයා ගේ භවනයෙහි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො ආළවකො යක‍්ඛො",
                    "sinh": "ඉක්බිති ආලවක යක්ෂ තෙමේ",
                    "span": 1
                },
                {
                    "pali": "යෙන භගවා තෙන උපසංකමි උපසංකමිත්වා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ යම් තැනෙක්හි ද එතැනට එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං භගවන‍්තං එතදවොච",
                    "sinh": "එළඹ භාග්‍යවතුන් වහන්සේට මෙය කී ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නික‍්ඛම සමණාති",
                    "sinh": "මහණ, නික්මෙව යි",
                    "span": 1
                },
                {
                    "pali": "සාධාවුසොති භගවා නික‍්ඛමි",
                    "sinh": "ඇවැත්නි මැනවැ යි භාග්‍යවතුන් වහන්සේ නික්මුනු සේක",
                    "span": 1
                },
                {
                    "pali": "පවිස සමණාති",
                    "sinh": "මහණ, පිවිසෙව යි.",
                    "span": 1
                },
                {
                    "pali": "සාධාවුසොති භගවා පාවිසි",
                    "sinh": "ඇවැත්නි මැනවැ යි භාග්‍යවතුන් වහන්සේ පිවිසි සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දුතියම්පි ඛො ආළවකො යක්ඛො",
                    "sinh": "දෙවන වට දු ආළවක යක්ෂ තෙමේ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං එතදවොච",
                    "sinh": "භාග්‍යවතුන් වහන්සේට මෙය කී ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නික්ඛම සමණාති",
                    "sinh": "මහණ, නික්මෙව",
                    "span": 1
                },
                {
                    "pali": "සාධාවුසොති භගවා නික්ඛමි",
                    "sinh": "ඇවැත්නි, මැනවැ යි භාග්‍යවතුන් වහන්සේ නික්මුනු සේක",
                    "span": 1
                },
                {
                    "pali": "පවිස සමණාති",
                    "sinh": "මහණ, පිවිසෙව යි.",
                    "span": 1
                },
                {
                    "pali": "සාධාවුසොති භගවා පාවිසි",
                    "sinh": "ඇවැත්නි, මැනවැ යි භාග්‍යවතුන් වහන්සේ පිවිසි සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තතියම්පි ඛො ආළවකො යක්ඛො භගවන්තං එතදවොච",
                    "sinh": "තෙවන වටදු ආළවක යක්ෂ තෙමේ භාග්‍යවතුන් වහන්සේට මෙය කී ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නික්ඛම සමණාති",
                    "sinh": "මහණ, නික්මෙව",
                    "span": 1
                },
                {
                    "pali": "සාධාවුසොති භගවා නික්ඛමි",
                    "sinh": "ඇවැත්නි, මැනවැ යි භාග්‍යවතුන් වහන්සේ නික්මුනු සේක",
                    "span": 1
                },
                {
                    "pali": "පවිස සමණාති",
                    "sinh": "මහණ, පිවිසෙව යි.",
                    "span": 1
                },
                {
                    "pali": "සාධාවුසොති භගවා පාවිසි",
                    "sinh": "ඇවැත්නි, මැනවැ යි භාග්‍යවතුන් වහන්සේ පිවිසි සේක.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චතුත්‍ථම්පි ඛො ආළවකො යක්ඛො භගවන්තං එතදවොච",
                    "sinh": "සිවුවන වට දු ආළවක යක්ෂ තෙමේ භාග්‍යවතුන් වහන්සේට මෙය කී ය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නික්ඛම සමණාති",
                    "sinh": "මහණ, නික්මෙව",
                    "span": 1
                },
                {
                    "pali": "න ඛ්වාහං ආවුසො නික්ඛමිස්සාමි",
                    "sinh": "ඇවැත්නි, මම නො නික්මෙන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "යං තෙ කරණීයං",
                    "sinh": "තා විසින් යමක් කටයුතු නම්",
                    "span": 1
                },
                {
                    "pali": "තං කරොහීති",
                    "sinh": "තා විසින් යමක් කටයුතු නම්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පඤ්හං තං සමණ",
                    "sinh": "මහණ, තොපගෙන් පැණයක්",
                    "span": 1
                },
                {
                    "pali": "පුච්ඡිස්සාමි",
                    "sinh": "විචාරන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "සචෙ මෙ න බ්‍යාකරිස්සසි",
                    "sinh": "ඉදින් මට (එය) නො විසඳන්නෙහි නම්",
                    "span": 1
                },
                {
                    "pali": "චිත්තං වා තෙ ඛිපිස්සාමි",
                    "sinh": "තාගේ සිත හෝ වික්ෂේප කරන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "හදයං වා තෙ ඵාලෙස්සාමි",
                    "sinh": "තාගේ හෘදය හෝ පලන්නෙමි",
                    "span": 1
                },
                {
                    "pali": "පාදෙසු වා ගහෙත්‍වා පාරගඞ්ගාය ඛිපිස්සාමීති",
                    "sinh": "පා ගෙණ ගඟපරතෙර හෝ දමන්නෙමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න ඛ්වාහං තං ආවුසො පස්සාමි",
                    "sinh": "ඇවැත්නි, දෙවියන් සහිත මරුන් සහිත බඹුන් සහිත ලොව මහණබමුණන් සහිත දෙවිමිනිසුන් සහිත ප්‍රජාවෙහි යමෙක් මාගේ සිත හෝ වික්ෂේප කරන්නේ ද, හෘදය හෝ පලන්නේ ද, පා ගෙණ ගඟපරතෙර හෝ දමන්නේ ද, එබන්දකු මම නො දකිමි.",
                    "span": 7
                },
                {
                    "pali": "සදෙවකෙ ලොකෙ"
                },
                {
                    "pali": "සමාරකෙ සබ්‍රහ්මකෙ"
                },
                {
                    "pali": "සස්සමණබ්‍රාහ්මණියා පජාය සදෙවමනුස්සාය"
                },
                {
                    "pali": "යෙ මෙ චිත්තං වා ඛිපෙය්‍ය"
                },
                {
                    "pali": "හදයං වා ඵාලෙය්‍ය"
                },
                {
                    "pali": "පාදෙසු වා ගහෙත්‍වා පාරගඞ්ගාය ඛිපෙය්‍ය."
                }
            ],
            [
                {
                    "pali": "අපි ච ත්‍වං ආවුසො",
                    "sinh": "වැලි දු ඇවැත්නි",
                    "span": 1
                },
                {
                    "pali": "පුච්ඡ යදාකඞ්ඛසීති",
                    "sinh": "තෝ යමක් කැමැත්තෙහි ද (එය) විචාරව යි",
                    "span": 1
                },
                {
                    "pali": "අථ ඛො ආළවකො යක්ඛො",
                    "sinh": "ඉක්බිති ආළවක යක්ෂ තෙමේ",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං ගාථාය අජ්ඣභාසි",
                    "sinh": "භාග්‍යවතුන් වහන්සේට ගාථාවකින් කී ය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කිං සූධ විත්තං",
                    "sinh": "මෙ ලොව කිමෙක්",
                    "span": 1
                },
                {
                    "pali": "පුරිසස්ස සෙට්ඨං",
                    "sinh": "සත්වයාට ශ්‍රේෂ්ඨ ධනය වේ ද?",
                    "span": 1
                },
                {
                    "pali": "කිං සු සුචිණ්ණං",
                    "sinh": "කිමෙක් මැනවින් පුරුදු කරණ ලද්දේ",
                    "span": 1
                },
                {
                    "pali": "සුඛමාවහාති",
                    "sinh": "සුව එළවා ද?",
                    "span": 1
                },
                {
                    "pali": "කිං සු හවෙ",
                    "sinh": "රසයන් අතුරෙන් කුමක්",
                    "span": 1
                },
                {
                    "pali": "සාදුතරං රසානං",
                    "sinh": "ඉතා මිහිරි ද?",
                    "span": 1
                },
                {
                    "pali": "කථං ජීවී",
                    "sinh": "කෙසේ ජීවත්වන්නහුගේ",
                    "span": 1
                },
                {
                    "pali": "ජීවිතමාහු සෙට්ඨන්ති?",
                    "sinh": "ජීවිතය ශ්‍රේෂ්ඨ යයි කියද්ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්ධීධ විත්තං පුරිසස්ස සෙට්ඨං",
                    "sinh": "මෙලොව සත්වයාට ශ්‍රද්ධාව ශ්‍රේෂ්ඨ ධනය වේ",
                    "span": 1
                },
                {
                    "pali": "ධම්මො සුචිණ්ණො",
                    "sinh": "දහම මැනවින් පුරුදු කරණ ලද්දේ",
                    "span": 1
                },
                {
                    "pali": "සුඛමාවහාති",
                    "sinh": "සුව එළවයි.",
                    "span": 1
                },
                {
                    "pali": "සච්චං හවෙ සාදුතරං රසානං",
                    "sinh": "රසයන් අතුරෙන් සත්‍යය ඒකාන්තයෙන් ඉතා මිහිරි ය",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤාජීවිං",
                    "sinh": "නුවණින් ජිවත්වනහුගේ",
                    "span": 1
                },
                {
                    "pali": "ජීවිතමාහු සෙට්ඨන්ති",
                    "sinh": "ජීවිතය ශ්‍රේෂ්ඨ යයි කියත්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කථං සු තරති ඔඝං",
                    "sinh": "ඕඝය කෙසේ තරණය කෙරේ ද?",
                    "span": 1
                },
                {
                    "pali": "කථංසු තරති අණ්ණවං",
                    "sinh": "අණිවය කෙසේ තරණය කෙරේ ද?",
                    "span": 1
                },
                {
                    "pali": "කථං සු දුක්ඛං අච්චෙති",
                    "sinh": "දුක කෙසේ ඉක්මවා ද?",
                    "span": 1
                },
                {
                    "pali": "කථං සු පරිසුජ්ඣතීති",
                    "sinh": "කෙසේ පිරිසිදු වේ ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්ධාය තරති ඔඝං",
                    "sinh": "ශ්‍රද්ධාවෙන් ඕඝය තරණය කෙරේ",
                    "span": 1
                },
                {
                    "pali": "අප්පමාදෙන අණ්ණවං",
                    "sinh": "අප්‍රමාදයෙන් අණිවය තරණය කෙරේ",
                    "span": 1
                },
                {
                    "pali": "විරියෙන දුක්ඛං අච්චෙති",
                    "sinh": "වීර්ය්‍යයෙන් දුක ඉක්මවයි",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤාය පරිසුජ්ඣතීති",
                    "sinh": "ප්‍රඥාවෙන් පිරිසිදු වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කථං සු ලභතෙ පඤ්ඤං",
                    "sinh": "නුවණ කෙසේ ලබා ද?",
                    "span": 1
                },
                {
                    "pali": "කථංසු වින්‍දතෙ ධනං",
                    "sinh": "ධනය කෙසේ ලබා ද?",
                    "span": 1
                },
                {
                    "pali": "කථං සු කිත්තිං පප්පොති",
                    "sinh": "කෙසේ කීර්තියට පැමිණේ ද?",
                    "span": 1
                },
                {
                    "pali": "කථං මිත්තානි ගන්‍ථති",
                    "sinh": "කෙසේ මිත්‍රයන් සපයා ගණී ද?",
                    "span": 1
                },
                {
                    "pali": "අස්මා ලොකා පරං ලොකං",
                    "sinh": "මෙලොවින් පරලොවට පැමිණ",
                    "span": 1
                },
                {
                    "pali": "කථං පෙච්ච න සොචතීති?",
                    "sinh": "කෙසේ ශෝක නො කෙරේ ද?",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්දහානො අරහතං",
                    "sinh": "නො පමා වූ නුවණැත්තේ රහතුන්ගේ ධර්මය අදහන්නේ අසනු කැමැත්ත හේතු කොට ගෙණ නිවණට පැමිණීම පිණිස ප්‍රඥාව ලබයි",
                    "span": 4
                },
                {
                    "pali": "ධම්මං නිබ්බාණපත්තියා"
                },
                {
                    "pali": "සුස්සූසා ලභතෙ පඤ්ඤං"
                },
                {
                    "pali": "අප්පමත්තො විචක්ඛණො"
                }
            ],
            [
                {
                    "pali": "පතිරූපකාරී ධුරවා",
                    "sinh": "සුදුසු කටයුතු කරණ බහා නො තැබූ ධූර ඇති",
                    "span": 1
                },
                {
                    "pali": "උට්ඨාතා වින්‍දතෙ ධනං",
                    "sinh": "උත්ථානවීර්ය්‍ය ඇත්තේ ධනය ලබයි",
                    "span": 1
                },
                {
                    "pali": "සච්චෙන කිත්තිං පප්පොති",
                    "sinh": "සත්‍යවචනය කරණකොට ගෙණ කීර්තියට පැමිණේ",
                    "span": 1
                },
                {
                    "pali": "දදං මිත්තානි ගන්‍ථති",
                    "sinh": "දන් දෙන්නේ මිත්‍රයන් බැඳ ගණී.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යස්සෙතෙ චතුරො ධම්මා",
                    "sinh": "සිවු දහම්හු වෙත් නම්",
                    "span": 1
                },
                {
                    "pali": "සද්ධස්ස ඝරමෙසිනො",
                    "sinh": "ගිහිගෙයි වෙසෙන ශ්‍රද්ධා ඇති යමකුහට",
                    "span": 1
                },
                {
                    "pali": "සච්චං ධම්මො",
                    "sinh": "සත්‍යයත්, ධර්මයත්",
                    "span": 1
                },
                {
                    "pali": "ධිති චාගො",
                    "sinh": "ධෘතියත්, ත්‍යාගයත්",
                    "span": 1
                },
                {
                    "pali": "ස චෙ පෙච්ච න සොචති",
                    "sinh": "හෙ තෙමේ පරලොවට පැමිණ එක්කාන්තයෙන් ශෝක නො කෙරෙයි.",
                    "span": 1
                },
                {
                    "pali": "අස්මා ලොකා පරං ලොකං",
                    "sinh": "මෙලොවින් පරලොවට පැමිණ",
                    "span": 1
                },
                {
                    "pali": "එවං පෙච්ච න සොචතීති",
                    "sinh": "මෙසේ ශෝක නො කෙරෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉඞ්ඝ අඤ්ඤෙපි පුච්ඡස්සු",
                    "sinh": "සත්‍යයටත්, ඉන්ද්‍රියදමනයටත්, ත්‍යාගයටත්, ක්ෂාන්තියටත් අධික වූ යමක් මෙලොව ඉදින් ඇත් නම් (ඒ කුමැයි) බොහෝ වූ අනෙක් මහණබමුණන් ද විචාරව යි",
                    "span": 4
                },
                {
                    "pali": "පුථූ සමණබ්‍රාහ්මණෙ"
                },
                {
                    "pali": "යදි සච්චා දමා චාගා"
                },
                {
                    "pali": "ඛන්ත්‍යා භිය්‍යොධ විජ්ජතීති"
                }
            ],
            [
                {
                    "pali": "කථං නු දානි පුච්ඡෙය්‍යං",
                    "sinh": "සාම්පරායික වූ ද (දෘෂ්ටධාර්මිකවූ ද) යම් අර්ථයෙක් වේ නම් (එය) ඒ මම අද දනිමි. (එහෙයින්) දැන් බොහෝ වූ මහණබමුණන් කුමකට විචාරන්නෙම් ද",
                    "span": 4
                },
                {
                    "pali": "පුථූ සමණබ්‍රාහ්මණෙ"
                },
                {
                    "pali": "සො’හං අජ්ජ පජානාමි"
                },
                {
                    "pali": "යො අත්‍ථො සම්පරායිකො."
                }
            ],
            [
                {
                    "pali": "අත්‍ථාය වත මෙ බුද්ධො වාසායාළවිමාගමා",
                    "sinh": "ඒකාන්තයෙන් මට වැඩ පිණිස බුදුරජානන් වහන්සේ විසීම පිණිස අළව් නුවරට වැඩිසේක",
                    "span": 1
                },
                {
                    "pali": "සො’හං අජ්ජ පජානාමි යත්‍ථ දින්නං මහප්ඵලං",
                    "sinh": "යමකුට දෙන ලද්ද මහත්ඵල වේ නම් එය මම අද දනිමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සො අහං විචරිස්සාමි",
                    "sinh": "මම (බුද්ධසුබුද්ධතාව කියා) බුදුරජානන් වහන්සේ ද, (ධර්මසුධර්මතාව කියා) ධර්මය ද (සඞ්ඝසුසඞ්ඝතාව කියා) සඞ්ඝයා ද වඳිමින් ගමින් ගම නුවරින් නුවර හැසිරෙන්නෙමි",
                    "span": 4
                },
                {
                    "pali": "ගාමා ගාමං පුරා පුරං"
                },
                {
                    "pali": "නමස්සමානො සම්බුද්ධං"
                },
                {
                    "pali": "ධම්මස්ස ච සුධම්මතන්ති"
                }
            ],
            [
                {
                    "pali": "එවං වත්වා, මෙසේ කියා"
                },
                {
                    "pali": "ආලවකො යක්ඛො, ආලවක යක්ෂ තෙමේ"
                },
                {
                    "pali": "භගවන්තං",
                    "sinh": "භාග්‍යවතුන් වහන්සේට",
                    "span": 1
                },
                {
                    "pali": "එතද වොච",
                    "sinh": "මෙසේ කීය",
                    "span": 1
                },
                {
                    "pali": "අභික්කන්තං",
                    "sinh": "දහම් දෙසුම ඉතා යහපත;",
                    "span": 1
                },
                {
                    "pali": "භො ගොතම",
                    "sinh": "භවත් ගොතමයන් වහන්ස,",
                    "span": 1
                },
                {
                    "pali": "අභික්කන්තං හො ගොතම",
                    "sinh": "භවත් ගෞතමයන් වහන්ස දේශනාව ඉතා යහපතං",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සෙය්‍යථාපි",
                    "sinh": "යම් සේ වනාහි;",
                    "span": 1
                },
                {
                    "pali": "භො ගොතම",
                    "sinh": "භවත් ගෞතමයන් වහන්ස;",
                    "span": 1
                },
                {
                    "pali": "නික්කුජ්ජිතං වා",
                    "sinh": "මුනින් තබන ලද භාජනයක් යම් සේ;",
                    "span": 1
                },
                {
                    "pali": "උක්කුජ්ජ්‍යෙ",
                    "sinh": "උඩුකුරු කොට හෝ",
                    "span": 1
                },
                {
                    "pali": "පටිච්ඡන්නං",
                    "sinh": "වා, වැසී තිබුණු යමක්;",
                    "span": 1
                },
                {
                    "pali": "විවරෙය්‍ය වා",
                    "sinh": "විවෘත කොට තබන්නේ යම් සේ ද",
                    "span": 1
                },
                {
                    "pali": "මුළ්හස්ස",
                    "sinh": "මංමුළාවුවෙකුට;",
                    "span": 1
                },
                {
                    "pali": "මග්ගං වා",
                    "sinh": "මාර්ගය හෝ",
                    "span": 1
                },
                {
                    "pali": "ආවික්ඛෙය්‍ය",
                    "sinh": "කියන්නේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අන්ධකාරෙ",
                    "sinh": "අඳුරෙහි",
                    "span": 1
                },
                {
                    "pali": "තෙලපජ්ජොතං ධාරෙය්‍ය වා",
                    "sinh": "යම් සේ තෙල් පහනක් දරන්නේ ද",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුමතො රූපානිදක්ඛින්ති",
                    "sinh": "ඉති, ඇස් ඇත්තෝ රූපයන් දකිත්වා යි",
                    "span": 1
                },
                {
                    "pali": "එවං එව",
                    "sinh": "එපරිද්දෙන් ම",
                    "span": 1
                },
                {
                    "pali": "හොතා ගොතමෙන",
                    "sinh": "භවත් ගෞතමයන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "අනේක පරියායෙන",
                    "sinh": "නොයෙක් අයුරින්",
                    "span": 1
                },
                {
                    "pali": "ධම්මො පකාසිතො",
                    "sinh": "ධර්මය දෙසන ලදී.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එසා’හං",
                    "sinh": "මේ මම;",
                    "span": 1
                },
                {
                    "pali": "භවන්තං ගොතමං",
                    "sinh": "භවත් ගෞතමයන් වහන්සේ ද",
                    "span": 1
                },
                {
                    "pali": "සරණං ගච්ඡාමි",
                    "sinh": "පිහිට කොට යමි",
                    "span": 1
                },
                {
                    "pali": "ධම්මඤ්ච",
                    "sinh": "ධර්මය ද;",
                    "span": 1
                },
                {
                    "pali": "භික්ඛු සංඝඤ්ච",
                    "sinh": "හික්ඛු සංඝයා ද",
                    "span": 1
                },
                {
                    "pali": "උපාසිතං",
                    "sinh": "උපාසකයකු කොට",
                    "span": 1
                },
                {
                    "pali": "මං",
                    "sinh": "මා",
                    "span": 1
                },
                {
                    "pali": "හවං ගොතමො",
                    "sinh": "භවත් ගෞතමයන් වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "ධාරෙතු ඉති",
                    "sinh": "දරන සේක්වා.",
                    "span": 1
                },
                {
                    "pali": "අජ්ජතග්ගෙ",
                    "sinh": "අද පටන්",
                    "span": 1
                },
                {
                    "pali": "පාණුපෙතං",
                    "sinh": "දිවිහිමි කොට",
                    "span": 1
                },
                {
                    "pali": "සරණං ගතං",
                    "sinh": "සරණ ගියා වූ",
                    "span": 1
                }
            ]
        ]
    },
    "26-kasibharadvaja-suttam": {
        "labels": [
            [
                0,
                2.561086,
                1
            ],
            [
                2.561086,
                22.223005,
                2
            ],
            [
                22.223005,
                41.793264,
                3
            ],
            [
                41.793264,
                79.466512,
                4
            ],
            [
                79.466512,
                113.054761,
                5
            ],
            [
                113.054761,
                148.381281,
                6
            ],
            [
                148.381281,
                199.045647,
                7
            ],
            [
                199.045647,
                218.638507,
                8
            ],
            [
                218.638507,
                237.736598,
                9
            ],
            [
                237.736598,
                256.834688,
                10
            ],
            [
                256.834688,
                275.685395,
                11
            ],
            [
                275.685395,
                331.544837,
                12
            ],
            [
                331.544837,
                360.983604,
                13
            ],
            [
                360.983604,
                391.9057,
                14
            ],
            [
                391.9057,
                400.803176,
                15
            ],
            [
                400.803176,
                436.546432,
                16
            ],
            [
                436.546432,
                453.066476,
                17
            ],
            [
                453.066476,
                483.381609,
                18
            ],
            [
                483.381609,
                517.380365,
                19
            ],
            [
                517.380365,
                545.654662,
                20
            ],
            [
                545.654662,
                583.009308,
                21
            ],
            [
                583.009308,
                619.496402,
                22
            ],
            [
                619.496402,
                664.460506,
                23
            ],
            [
                664.460506,
                708.530207,
                24
            ]
        ],
        "text": [
            [
                {
                    "pali": "කසීභාරද්වාජසුත්තං",
                    "sinh": "කසීභාරද්වාජ සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවං මෙ සුතං එකං සමයං භගවා",
                    "sinh": "මා විසින් මෙසේ අසන ලද: එක් කලෙක්හි භාග්‍යවතුන්වහන්සේ",
                    "span": 1
                },
                {
                    "pali": "මගධෙසු විහරති දක්ඛිණාගිරිස්මිං එකනාළායං බ්‍රාහ්මණගාමෙ",
                    "sinh": "මගධදනවුයෙහි දක්ඛිණාගිරියෙහි ‘එකනාළා’ නම් බමුණුගම්හි වැඩ වසනසේක",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන ඛො පන සමයෙන කසීභාරද්වාජස්ස බ්‍රාහ්මණස්ස",
                    "sinh": "එකල්හි කසීභාරද්වාජ නම් බමුණු විසින්",
                    "span": 1
                },
                {
                    "pali": "පඤ්චමත්තානි නඞ්ගලසතානි පයුත්තානි හොන්ති වප්පකාලෙ",
                    "sinh": "වප්දවස්හි පන්සියයක් පමණ නගුල් යොදනලද වෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො භගවා පුබ්බන්හසමයං නිවාසෙත්‍වා පත්තචීවරමාදාය",
                    "sinh": "එකල්හි භාග්‍යවතුන් වහන්සේ පෙරවරුයෙහි හැඳ පෙරෙවැ පාසිවුරුගෙණ",
                    "span": 1
                },
                {
                    "pali": "යෙන කසීභාරද්වාජස්ස බ්‍රාහ්මණස්ස කම්මන්තො තෙනුපසංකමි",
                    "sinh": "කසීභාරද්වාජ බ්‍රාහ්මණයාගේ කර්මාන්තස්ථානය කරා වැඩිසේක.",
                    "span": 1
                },
                {
                    "pali": "තෙන ඛො පන සමයෙන කසීභාරද්වාජස්ස බ්‍රාහ්මණස්ස පරිවෙසනාවත්තති",
                    "sinh": "එසමයෙහි කසීභාරද්වාජ බ්‍රාහ්මණයාගේ බත්පිරිවිසීම ඇත",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො භගවා යෙන පරිවෙසනා තෙනුපසඞ්කමි උපසඞ්කමිත්‍වා",
                    "sinh": "ඉක්බිති භාග්‍යවතුන් වහන්සේ බිදැ හිඳුනාතැන් කරා වැඩිසේක.",
                    "span": 1
                },
                {
                    "pali": "එකමන්තං අට්ඨාසි",
                    "sinh": "වැඩැ එකත්පසෙක සිටිසේක.",
                    "span": 1
                },
                {
                    "pali": "අද්දසා ඛො කසීභාරද්වාජො බ්‍රාහ්මණො භගවන්තං පිණ්ඩාය ඨිතං. දිස්වාන භගවන්තං එතදවොච",
                    "sinh": "කසීභාරද්වාජ බමුණා පිඬු පිණිස වැඩසිටි භාග්‍යවතුන් වහන්සේ දිටී. දැකැ භාග්‍යවතුන් වහන්සේට තෙල බස් කීය:",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අහං ඛො සමණ කසාමි ච වපාමි ච කසිත්‍වා ච වපිත්‍වා ච භුඤ්ජාමි",
                    "sinh": "මහණ මම සී සාමි, වපුරමි. සී සා, වපුට වළද කෙරෙමි.",
                    "span": 1
                },
                {
                    "pali": "ත්‍වම්පි සමණ කසස්සු ච වපස්සු ච කසිත්‍වා ච වපිත්‍වා ච භුඤ්ජස්සූති.",
                    "sinh": "මහණ, තොයිත් සී සා, වපුර. සී සා වපුට වළඳව”යි",
                    "span": 1
                },
                {
                    "pali": "අහම්පි ඛො බ්‍රාහ්මණ කසාමි ච වපාමි ච කසිත්‍වා ච වපිත්‍වා ච භුඤ්ජාමීති.",
                    "sinh": "බමුණ, මමත් සී සාමි, බිජුවට වපුරමි. සී සා වපුට වළඳමි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න ඛො පන මයං පස්සාම ගොතමස්ස යුගං වා නඞ්ගලං වා ඵාලං වා පාචනං වා බලිවද්දෙ වා",
                    "sinh": "අපි භවත් ගෞතමයන්ගේ වියගස වේවයි, නගුල් වේවයි, හීවැල් වේවයි, කෙවිට වේවයි, ගෙරිසරක් වේවයි නොදක්මහ.",
                    "span": 1
                },
                {
                    "pali": "අථ ච පන භවං ගොතමො එවමාහ: අහම්පි ඛො බ්‍රාහ්මණ කසාමි ච වපාමි ච කසිත්‍වා ච වපිත්‍වා ච භුඤ්ජාමීති",
                    "sinh": "තෙකුදුවූවත් බවත් ගෞතම මෙසේ කියයි; මම ද බමුණ සී සාමි, වපුරමි, සී සා වපුට වළඳමි”",
                    "span": 1
                },
                {
                    "pali": "අථ ඛො කසීභාරද්වාජො බ්‍රාහ්මණො භගවන්තං ගාථාය අජ්ඣභාසි",
                    "sinh": "ඉක්බිති කසීභාරද්වාජ බමුණු භාග්‍යවතුන් වහන්සේට ගාථායෙන් මෙසේ කී",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කස්සකො පටිජානාසි න ච පස්සාම තෙ කසිං",
                    "sinh": "තෙපි ‘කර්‍ෂකයෙමි’යි ප්‍ර‍තිඥා කරව. තොපගේ කෘෂිභාණ්ඩ නො ද කුම්හ. යම් පරිද්දෙකින් තොපගේ කෘෂිභාණ්ඩ දනුමෝ නම්, එපරිද්දෙන් පුළුවුස්නාලද තෙපි අපට කෘෂිභාණ්ඩ කියව",
                    "span": 2
                },
                {
                    "pali": "කසිං නො පුච්ඡිතො බ්‍රූහි යථා ජානෙමු තෙ කසිං."
                }
            ],
            [
                {
                    "pali": "සද්ධා බීජං",
                    "sinh": "මාගේ ශ්‍ර‍ද්ධාව බිජුවට වෙයි",
                    "span": 1
                },
                {
                    "pali": "තපො වුට්ඨි",
                    "sinh": "තපස වැසිදහර වෙයි",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤා මෙ යුගනඞ්ගලං",
                    "sinh": "ප්‍ර‍ඥාව විය හා නගුල් වෙයි",
                    "span": 1
                },
                {
                    "pali": "හිරි ඊසා",
                    "sinh": "හිරිය නගුලිස් වෙයි",
                    "span": 1
                },
                {
                    "pali": "මනො යොත්තං",
                    "sinh": "චිත්තය වියරැහැන් වෙයි",
                    "span": 1
                },
                {
                    "pali": "සති මෙ ඵාලපාචනං",
                    "sinh": "ස්මෘතිය මාගේ හීවැල හා කෙවිට යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායගුත්තො",
                    "sinh": "(ත්‍රිවිධ) කායසුචරිතයෙන් ගුප්තයෙමි",
                    "span": 1
                },
                {
                    "pali": "වචීගුත්තො",
                    "sinh": "(චතුර්විධ) වාක්සුචරිතයෙන් ගුප්තයෙමි",
                    "span": 1
                },
                {
                    "pali": "ආහාරෙ උදරෙ යතො",
                    "sinh": "සිවුපසෙහි (භොජනයෙහි) දු (මාත්‍රඥතායෙන්) සංයතයෙමි",
                    "span": 1
                },
                {
                    "pali": "සච්චං කරොමි",
                    "sinh": "අවිසංවාදන සඞ්ඛ්‍යාත සත්‍යයෙන් කෑම්පීම් කෙරෙමි",
                    "span": 1
                },
                {
                    "pali": "නිද්දානං සොරච්චං මෙ පමොචනං",
                    "sinh": "(නිවනෙහි ඇලෙන හෙයින් අර්හත් ඵල සඞ්ඛ්‍යාත) සුරතභාවය මාගේ විය මිදීම වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරියං මෙ ධුරධොරය්හං යොගක්ඛෙමාධිවාහනං, ගච්ඡති අනිවත්තන්තං යත්‍ථ ගන්ත්‍වා න සොචති",
                    "sinh": "(නිර්‍වාණසඞ්ඛ්‍යාත) යම් ක්ෂේමයකට ගොස් ශෝක නොකෙරේ නම් ඒ යෝගක්ෂේම (නිර්‍වාණ) ය කරා නො නවත්වමින් යන සම්‍යක්ප්‍ර‍ධානවීර්‍ය්‍යය මාගේ ධුරවාහක වෙයි",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවමෙසා කසීකට්ඨා සා හොති අමතප්ඵලා එතං කසිං කයීත්‍වාන සබ්බදුක්ඛා පමුච්චතීති",
                    "sinh": "මෙසෙයින් (මා විසින් ) තෙල සීසෑම කරන ලදී. ඒ කෘෂිකර්මය අමා ඵල ඇති.",
                    "span": 1
                },
                {
                    "pali": "අථ ඛො කසීභාරද්වාජො බ්‍රාහ්මණො මහතියා කංසපාතියා පායාසං වඩ්ඪෙත්‍වා භගවතො උපනාමෙසි, භුඤ්ජතු භවං ගොතමො පායාසං කස්සකො භවං යං හි භවං ගොතමො අමතඵලං කසිං කසතීති",
                    "sinh": "තෙල ඇත. තෙල කෘෂිකර්මය කොට සී සා හැම දුකින් මිදේය”යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගාථාභිගීතං මෙ අභොජනෙය්‍යං",
                    "sinh": "බ්‍රාහ්මණය, ගාථාභිගීත වූ (ගී ගැයුමින් ලත්) පායාසය මා විසින් වළඳනට නො නිසි යැ.",
                    "span": 1
                },
                {
                    "pali": "සම්පස්සතං බ්‍රාහ්මණ නෙසධම්මො",
                    "sinh": "සම්‍යක්ආජීවපාරිශුද්ධිය දක්නා බුදුවරයනට තෙල (චාරිත්‍ර) ධර්ම නොවේ.",
                    "span": 1
                },
                {
                    "pali": "ගාථාභිගීතං පනුදන්ති බුද්ධා",
                    "sinh": "සර්‍වඥයෝ ගාථාභිගීත භෝජනය පිළිකෙවු කෙරෙති.",
                    "span": 1
                },
                {
                    "pali": "ධම්මෙ සතී බ්‍රාහ්මණ වුත්තිරෙසා",
                    "sinh": "බ්‍රාහ්මණය, චාරිත්‍ර‍ධර්මය (ලොව්හි) පවතිත් ම ඒකාන්තව්‍යවදාත වූ පය්‍යෙර්‍ෂණය (බුදුවරුන්ගේ) ජීවිතවෘත්තිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අඤ්ඤෙන ච කෙවලිනං මහෙසිං ඛීණාසවං කුක්කුච්ච වූපසන්තං",
                    "sinh": "(සර්‍වගුණයෙන් පිරිපුන් හෙයින්) කේවලි වූ මහර්ෂී වූ ක්ෂීණාස්‍ර‍ව වූ සන්සුන් කුකුස් ඇති බුදුනුට",
                    "span": 1
                },
                {
                    "pali": "අන්නෙන පානෙන උපට්ඨහස්සු",
                    "sinh": "අන්‍ය ආහාරපානයෙකින් ම උවටන් කරව.",
                    "span": 1
                },
                {
                    "pali": "ඛෙත්තං හි තං පුඤ්ඤපෙඛස්ස හොතීති.",
                    "sinh": "යම් හෙයෙකින් ඒ පින් කැමැතියහුට පින්කෙත් වේ ද, එහෙයිනි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ කස්ස චාහං භො ගොතම",
                    "sinh": "භවත් ගෞතමයන් වහන්ස, එසේ වත් ම",
                    "span": 1
                },
                {
                    "pali": "ඉමං පායාසං දම්මීති",
                    "sinh": "මෙ පායාසය මම් කවරකුහට දෙම් දැ? යි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "න ඛ්වාහං තං බ්‍රාහ්මණ පස්සාමි සදෙවකෙ ලොකෙ සමාරකෙ සබ්‍රහ්මකෙ සස්සමණබ්‍රාහ්මණීයා පජාය සදෙවමනුස්සාය යස්ස සො පායාසො භුත්තො සම්මා පරිණාමං ගච්ඡෙය්‍ය අඤ්ඤත්‍ර තථාගතස්ස වා තථාගතසාවකස්ස වා",
                    "sinh": "බමුණ, දෙවියන් සහිත වූ මරුන් සහිත වූ බඹුන් සහිත වූ ලොවැ දෙවිමිනිසුන් සහිත, මහණබමුණන් සහිත සත්ත්‍වාඛ්‍ය ප්‍ර‍ජායෙහි තථාගතයන් වහන්සේ හෝ තථාගත ශ්‍රාවකයෙකු හො විනා යමකු විසින් ඒ පායාසය වළදන ලද්දේ මොනොවට පරිණාමයට යේ නම්, එබන්දකු නො දක්මි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන හි ත්‍වං බ්‍රාහ්මමණ තං පායාසං අප්පහරිතෙ වා ජඩ්ඩෙහි, අප්පාණකෙ වා උදකෙ ඔපිලාපෙහීති",
                    "sinh": "බමුණ, එකරුණින් තෝ ඒ පායාසය නිල්තණ නැති බිමෙක් හෝ දමව. (එයින් නැසෙන) ප්‍රාණීන් රහිත දියෙහි හෝ උල්පවාලවයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො කසීභාරද්වාජො බ්‍රාහ්මණො",
                    "sinh": "ඉක්බිති කසීභාරද්වාජ බමුණු",
                    "span": 1
                },
                {
                    "pali": "තං පායාසං අප්පාණකෙ උදකෙ ඔපිලාපෙසී",
                    "sinh": "ඒ පායාසය ප්‍රාණීන් රහිත දියෙහි උල්පවාලීය",
                    "span": 1
                },
                {
                    "pali": "අථ ඛො සො පායාසො උදකෙ පක්ඛීත්තො චිච්චිටායති චිටිචිටායති",
                    "sinh": "එකල්හි ඒ පායාසය. දියෙහි බහාලන ලදුයේ, චිච්චිට යන අනුකරණ කෙරෙයි. චිටිචිටි යන අනුකරණ කෙරෙයි.",
                    "span": 1
                },
                {
                    "pali": "සන්‍ධූපායති සම්පධූපායති",
                    "sinh": "හාත්පසින් දුමයි. අධිමාත්‍ර‍ව හාත්පසින් දුමයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සෙය්‍යථාපි නාම ඵාලො දිවසසන්තත්තො උදකෙ පක්ඛිත්තො",
                    "sinh": "යම් සේ දවසක් තැවුනු සීවැලෙක් දියෙහි බහාලනුලදුයේ",
                    "span": 1
                },
                {
                    "pali": "චිච්චිටායති චිටිචිටායති",
                    "sinh": "චිව්චිට යන අනුකරණ කෙරේ ද",
                    "span": 1
                },
                {
                    "pali": "සන්‍ධූපායතී සම්පධූපායති",
                    "sinh": "හාත්පසින් දුමා ද. අධිමාත්‍ර‍ව හාත්පසින් දුමා ද",
                    "span": 1
                },
                {
                    "pali": "එවමෙව සො පායාසො උදකෙ පක්ඛීත්තො චිච්චිටායති චිටිචිටායති සන්‍ධූපායති සම්පධූපායති",
                    "sinh": "එසෙයින් මැ ඒ පායාසය දියෙහි බහාලන ලදුයේ චිව්චිට යන ශබ්ද කෙරෙයි. චිටිචිටි යන ශබ්ද කෙරෙයි. හාත්පසින් දුමයි. අධිමාත්‍ර‍ව හාත්පසින් දුමයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අථ ඛො කසීභාරද්වාජො බ්‍රාහ්මණො",
                    "sinh": "එකල්හි කසීභාරද්වාජ බ්‍රාහ්මණ",
                    "span": 1
                },
                {
                    "pali": "සංවිග්ගො ලොමහට්ඨජාතො",
                    "sinh": "සංවිග්න වූයේ හටගත් ලොමුදහ ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "යෙන භගවා තෙනුපසඞ්කමි උපසඞ්කමිත්‍වා",
                    "sinh": "භාග්‍යවතුන් වහන්සේ වෙත එළඹියේ ය",
                    "span": 1
                },
                {
                    "pali": "භගවතො පාදෙසු සිරසා නිපතිත්‍වා",
                    "sinh": "එළඹ භාග්‍යවතුන් වහන්සේ පාමුල්හි හිසින් වැඳ හෙව",
                    "span": 1
                },
                {
                    "pali": "භගවන්තං එතදවොච",
                    "sinh": "භාග්‍යවතුන් වහන්සේට තෙල සැලකෙළේය:",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අභික්කන්තං භො ගොතම අභික්කන්තං භො ගොතම",
                    "sinh": "භවත් ගෞතමයන් වහන්ස, ඉතා මැනැවැ, භවත් ගෞතමයන් වහන්ස ඉතා මැනැවැ",
                    "span": 1
                },
                {
                    "pali": "සෙය්‍යථාපි භො ගොතම නික්කුජ්ජිතං වා උක්කුජ්ජෙය්‍ය",
                    "sinh": "ගෞතමයන් වහන්ස, යම් සේ වනාහි යටිකුරු කොට තබනලද්දක් උඩුකුරු කොට තබන්නේ වේ ද",
                    "span": 1
                },
                {
                    "pali": "පටිච්ඡන්නං වා විවරෙය්‍ය",
                    "sinh": "පිළිසන් වූවක් වැසුම් හරණේ වේ ද",
                    "span": 1
                },
                {
                    "pali": "මූළ්හස්ස වා මග්ගං ආචික්ඛෙය්‍ය",
                    "sinh": "මංමුළා වූවකුට හෝ මග කියන්නේ වේද",
                    "span": 1
                },
                {
                    "pali": "අන්‍ධකාරෙ වා තෙලපජ්ජාතං ධාරෙය්‍ය චක්ඛුමන්තො රූපානි දක්ඛින්තීති",
                    "sinh": "ඇසි ඇත්තාහු රූ දක්නාහයි අඳුරෙහි හෝ තෙල් පහනක් දල්වන්නේ වේ ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "එවමෙවං භොතා ගොතමෙන",
                    "sinh": "එපරිදි ම භවත් ගෞතමයන් වහන්සේ විසින්",
                    "span": 1
                },
                {
                    "pali": "අනෙකපරියායෙන ධම්මො පකාසිතො",
                    "sinh": "නන්අයුරින් ධර්මය දෙසන ලද",
                    "span": 1
                },
                {
                    "pali": "එසාහං භවන්තං ගොතමං සරණං ගච්ඡාමි ධම්මඤ්ච භික්ඛුසඞ්ඝඤ්ච",
                    "sinh": "මම භවත් ගෞතමයන් වහන්සේ ද ධර්මයද භික්ෂුසඞ්ඝයා ද සරන කොට යෙමි",
                    "span": 1
                },
                {
                    "pali": "ලභෙය්‍යාහං භොතො ගොතමස්ස සන්තිකෙ පබ්බජ්ජං, ලභෙය්‍යං උපසම්පදන්ති",
                    "sinh": "මම භවත් ගෞතමයන් වහන්සේ සමීපයෙහි පැවැදි ලබම්වා උපසපුව ලබම්වයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අලත්‍ථ ඛො කසීභාරද්වාජො බ්‍රාහ්මණො භගවතො සන්තිකෙ",
                    "sinh": "කසීභාරද්වාජ බ්‍රාහ්මණ භාග්‍යවතුන් වහන්සේ සමීපයෙහි පැවිදි ලැබී ය",
                    "span": 1
                },
                {
                    "pali": "පබ්බජ්ජං අලත්‍ථ උපසම්පදං",
                    "sinh": "උපසපුව ලැබී ය",
                    "span": 1
                },
                {
                    "pali": "අචිරූපසම්පන්නො ඛො පනායස්මා භාරද්වාජො",
                    "sinh": "උපසපුව ලැබූ නොබෝ කල් ඇති ආයුෂ්මත් භාරද්වාජ",
                    "span": 1
                },
                {
                    "pali": "එකො වූපකට්ඨෙ",
                    "sinh": "එකලා වූයේ",
                    "span": 1
                },
                {
                    "pali": "අප්පමත්තො ආතාපී පහිතත්තො විහරන්තො",
                    "sinh": "කයින් සිතින් වෙන්වූයේ නොපමා වූයේ කෙලෙස් තවන වැර ඇතියේ නිවනට මෙහෙයූ සිත් ඇතිව වෙසෙනුයේ",
                    "span": 1
                },
                {
                    "pali": "න චිරස්සෙ ව යස්සත්‍ථාය කුලපුත්තා සම්මදෙව අගාරස්මා අනගාරියං පබ්බජන්ති",
                    "sinh": "යම් රහත් පලයක් පිණිස කුලපුත්‍රයෝ මනා කොට මැ ගිහිගෙන් නික්මැ පැවිද්දවට පැමිණෙත් ද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තදනුත්තරං බ්‍රහ්මචරියපරියොසානං",
                    "sinh": "මාර්‍ගබ්‍ර‍හ්මචර්‍ය්‍යය අවසන් කොට ඇති",
                    "span": 1
                },
                {
                    "pali": "දිට්ඨෙව ධම්මෙ සයං අභිඤ්ඤා සච්ඡිකත්‍වා උපසම්පජ්ජ විහාසි",
                    "sinh": "එ අර්හත් ඵලය ඉහාත්මයෙහි මැ තමා විසින් දැනැ පසක් කොට සපයා විසී",
                    "span": 1
                },
                {
                    "pali": "ඛීණා ජාති",
                    "sinh": "ජාතිය ක්ෂීණ වූ යැ",
                    "span": 1
                },
                {
                    "pali": "වුසිතං බ්‍රහ්මචරියං",
                    "sinh": "සසුන් බ්‍ර‍ම්සර මගබ්‍රම්සර වස් වැස නිමවන ලද",
                    "span": 1
                },
                {
                    "pali": "කතං කරණීයං",
                    "sinh": "සිවුමගින් කළ යුතු සොළොස් වැදෑරුම් කරණි කරණී කරණ ලද",
                    "span": 1
                },
                {
                    "pali": "නාපරං ඉත්‍ථත්තායාති අබ්භඤ්ඤාසි",
                    "sinh": "ළිමෙබවට නො එමි යි දැනගති.",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤතරොච ඛො පනායස්මා භාරද්වාජො අරහතං අහොසීති",
                    "sinh": "ආයුෂ්මත් භාරද්වාජ රහතුන් කෙරෙහි අන්‍යතරයෙක් වී යයි.",
                    "span": 1
                }
            ]
        ]
    },
    "50-angulimala": {
        "labels": [
            [
                0,
                7.126139,
                1
            ],
            [
                7.126139,
                13.468062,
                2
            ],
            [
                13.468062,
                20.491912,
                3
            ],
            [
                20.491912,
                27.686244,
                4
            ],
            [
                27.686244,
                35.187444,
                5
            ],
            [
                35.187444,
                41.49527,
                6
            ],
            [
                41.49527,
                49.780686,
                7
            ],
            [
                49.780686,
                57.588752,
                8
            ],
            [
                57.588752,
                63.998868,
                9
            ],
            [
                63.998868,
                72.284284,
                10
            ],
            [
                72.284284,
                79.683194,
                11
            ],
            [
                79.683194,
                85.888731,
                12
            ],
            [
                85.888731,
                94.310532,
                13
            ],
            [
                94.310532,
                101.709442,
                14
            ],
            [
                101.709442,
                108.801485,
                15
            ],
            [
                108.801485,
                116.06401,
                16
            ],
            [
                116.06401,
                123.650431,
                17
            ]
        ],
        "text": [
            [
                {
                    "pali": "පරිත්තං යං භණන්තස්ස නිසින්නට්ඨාන ධොවනං",
                    "sinh": "මේ අංගුලිමාල පිරිත දේශනා කිරීමට දේශකයා ඉඳගත් ආසනය සේදු xx",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උදකම්පි විනාසෙසි සබ්බ මෙව පරිස්සයං",
                    "sinh": "ජලය පවා සියලු උවදුරු විනාශ කරයි. xx",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොත්ථිනා ගබ්භවුට්ඨානං යඤ්ච සාදෙති තං ඛණෙ",
                    "sinh": "මේ පිරිත ප්‍රසූත නො කළ හැකිව පීඩා විඳිමින් සිටි මවකට සෙත් කරනු පිණිස xx",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ථේරස්සංගුලිමාලස්ස ලොකනාථෙන භාසිතං",
                    "sinh": "බුදුරජාණන් වහන්සේ විසින් අංගුලිමාල තෙරුන් වහන්සේට උගන්වන ලද්දකි xx",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කප්පට්ඨායිං මහාතෙජං පරිත්තං තං භණාමහෙ",
                    "sinh": "ඒ පිරිතේ ආනුභාවය තෙරුන් වහන්සේ පිරිත කී තැන ද පිහිටියේ ය. එහි ආනුභාවය එතැන මහපොළොව පවත්නා තුරුම පවතී. එය කල්පස්ථායි ප්‍රාතිහාර්යයක් බව කියා තිබේ. xx",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යතොහං භගිනි ආරියාය ජාතියා ජාතො",
                    "sinh": "සහෝදරිය, මම යම් අවස්ථාවක් ආර්ය ජාතියෙන් උපන්නෙම්ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නාභිජානාමි සංචිච්ච පාණං ජීවිතා වොරො පෙතා",
                    "sinh": "එතැන් සිට දැනුවත්ව ප්‍රාණියෙකුගෙ දිවි තොරකල බවක් නොදනිමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන සච්චෙන සොථිතෙ හොතු සොත්ථි ගබ්භස්සාති",
                    "sinh": "ඒ සත්‍යය බලයෙන් තොපට යහපතක්ම වේවා, දරුගැබටද යහපතක්ම වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යතොහං භගිනි ආරියාය ජාතියා ජාතො",
                    "sinh": "සහෝදරිය, මම යම් අවස්ථාවක් ආර්ය ජාතියෙන් උපන්නෙම්ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නාභිජානාමි සංචිච්ච පාණං ජීවිතා වොරො පෙතා",
                    "sinh": "එතැන් සිට දැනුවත්ව ප්‍රාණියෙකුගෙ දිවි තොරකල බවක් නොදනිමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන සච්චෙන සොථිතෙ හොතු සොත්ථි ගබ්භස්සාති",
                    "sinh": "ඒ සත්‍යය බලයෙන් තොපට යහපතක්ම වේවා, දරුගැබටද යහපතක්ම වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යතොහං භගිනි ආරියාය ජාතියා ජාතො",
                    "sinh": "සහෝදරිය, මම යම් අවස්ථාවක් ආර්ය ජාතියෙන් උපන්නෙම්ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නාභිජානාමි සංචිච්ච පාණං ජීවිතා වොරො පෙතා",
                    "sinh": "එතැන් සිට දැනුවත්ව ප්‍රාණියෙකුගෙ දිවි තොරකල බවක් නොදනිමි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තෙන සච්චෙන සොථිතෙ හොතු සොත්ථි ගබ්භස්සාති",
                    "sinh": "ඒ සත්‍යය බලයෙන් තොපට යහපතක්ම වේවා, දරුගැබටද යහපතක්ම වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඒතෙන සච්ච වජ්ජේන දුක්ඛා වූප සමෙන්තු (තෙ).",
                    "sinh": "මේ සත්‍ය බලයෙන් (ඔබගේ) දුක් සංසිඳේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඒතෙන සච්ච වජ්ජේන භයා වූප සමෙන්තු (තෙ).",
                    "sinh": "මේ සත්‍ය බලයෙන් (ඔබගේ) භය සංසිඳේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඒතෙන සච්ච වජ්ජේන රෝගා වූප සමෙන්තු (තෙ).",
                    "sinh": "මේ සත්‍ය බලයෙන් (ඔබගේ) රෝග සංසිඳේවා",
                    "span": 1
                }
            ]
        ]
    },
    "51-atavisi": {
        "labels": [
            [
                0,
                12.991988,
                1
            ],
            [
                12.991988,
                25.191782,
                2
            ],
            [
                25.191782,
                37.906502,
                3
            ],
            [
                37.906502,
                50.779661,
                4
            ],
            [
                50.779661,
                63.098284,
                5
            ],
            [
                63.098284,
                75.100029,
                6
            ],
            [
                75.100029,
                88.171237,
                7
            ],
            [
                88.171237,
                101.400884,
                8
            ],
            [
                101.400884,
                114.313652,
                9
            ],
            [
                114.313652,
                128.454331,
                10
            ]
        ],
        "text": [
            [
                {
                    "pali": "තණ්හංකරෝ මහාවීරෝ",
                    "sinh": "මහත්වූ වීර්‍ය ඇත්තා වූ තණ්හංකර බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "මේධංකරෝ මහායසෝ",
                    "sinh": "මහත්වූ කිර්තිය ඇත්තා වූ මේධංකර බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "සරණංකරෝ ලෝකහිතෝ",
                    "sinh": "ලොවට හිත අත්තා වූ සරණංකර බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "දීපංකරෝ ජුතින්ධරෝ",
                    "sinh": "බබලන්නාවූ දීපංකර බුදුරජුන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කොණ්ඩඤ්ඤෝ ජනපාමොක්ඛෝ",
                    "sinh": "ජනයාට නායක වූ කොණ්ඩඤ්ඤ බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "මංගලෝ පුරිසාසභෝ",
                    "sinh": "මහත් වූ පෞරෂය ඇත්තා වූ මංගල බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "සුමනෝ සුමනෝ ධීරෝ",
                    "sinh": "මනාවූ සිහිය ඇත්තාවූ ධෛර්‍යයෙන් යුතු සුමන බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "රේවතෝ රතිවද්ධනෝ",
                    "sinh": "නො ඇලීම වර්ධනය කරන්නාවූ රේවත බුදුරජුන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සෝභිතෝ ගුණසම්පන්නෝ",
                    "sinh": "ගුණවත් වූ සෝභිත බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "අනෝමදස්සී ජනුත්තමෝ",
                    "sinh": "ජනයින්ට උතුම් වූ අනෝමදස්සී බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "පදුමෝ ලෝක පජ්ජෝතෝ",
                    "sinh": "ලෝකය ආලොකමත් කළාවූ පදුම බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "නාරදෝ වර සාරථී",
                    "sinh": "උතුම් මග පෙන්වන්නා වූ නාරද බුදුරජුන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පදුමුත්තරෝ සත්තසාරෝ",
                    "sinh": "සත්තවයා හරයෙහි ඇලවූ පදුමුත්තර බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "සුමේධෝ අග්ගපුග්ගලෝ",
                    "sinh": "ශ්‍රේෂ්ඨ පුද්ඝලයා වූ සුමේධ බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "සුජාතෝ සබ්බලෝකග්ගෝ",
                    "sinh": "සියළු ලොවට අග්‍ර වූ සුජාත බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "පියදස්සී නරාසභෝ",
                    "sinh": "අති උත්තම මිනිසා වූ පියදස්සී බුදුරජුන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අත්ථදස්සී කාරුණිකෝ",
                    "sinh": "කාරුණික වූ අත්ථදස්සී බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "ධම්මදස්සී තමෝනුදෝ",
                    "sinh": "අඳුර දුරුකළා වූ ධම්මදස්සී බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "සිද්ධත්ථෝ අසමෝ ලෝකේ",
                    "sinh": "ලෝකයේ අසම වූ සිද්ධත්ථ බුදුරජුන්",
                    "span": 2
                },
                {
                    "pali": "තිස්සෝ වරදසංවරෝ",
                    "sinh": ""
                }
            ],
            [
                {
                    "pali": "ඵුස්සෝ වරද සම්බුද්ධෝ",
                    "sinh": "මනාකොට අවබෝධ කරවූ තැනැත්තා වූ ඵුස්ස බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "විපස්සීච අනූපමෝ",
                    "sinh": "උපමා නැති වූ විපස්සී බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "සිඛී සබ්බහිතො සත්තා",
                    "sinh": "සියළු සත්වයින්ගේ හිත පිණිස වූ සිඛී බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "වෙස්සභූ සුඛදායකෝ",
                    "sinh": "සැපය දෙන්නා වූ වෙස්සභූ බුදුරජුන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කකුසන්ධෝ සත්ථවාහෝ",
                    "sinh": "උතුම් ශ්‍රාස්තෘවරයානෝ වූ කකුසඳ බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "කෝණාගමනෝ රණඤ්ජහෝ",
                    "sinh": "කෙලෙස් දුරු කළා වූ කෝණාගමන බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "කස්සපෝ සිරිසම්පන්නෝ",
                    "sinh": "ශ්‍රීයෙන් යුක්ත වූ කස්සප බුදුරජුන්",
                    "span": 1
                },
                {
                    "pali": "ගෝතමෝ සක්‍යපුංගවෝ",
                    "sinh": "ශාක්‍ය කුලයේ උපන්නා වූ ගෝතම බුදුරජුන්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේසං සච්චේන සීලේන",
                    "sinh": "උන්වහන්සේලා ගේ සත්‍ය වු සීල බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "ඛන්තිමෙත්ත බලේන ච",
                    "sinh": "ඉවසීමේ සහ මෛත්‍රී බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "තේපි(ත්වං) අනුරක්ඛන්තු",
                    "sinh": "සියලු දුක් නසා ඔබ රැකේවා",
                    "span": 1
                },
                {
                    "pali": "ආරෝග්‍යේන සුඛේන ච",
                    "sinh": "නිරෝගීබව සහ සැපය ගෙන දෙමින්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේසං සච්චේන සීලේන",
                    "sinh": "උන්වහන්සේලා ගේ සත්‍ය වු සීල බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "ඛන්තිමෙත්ත බලේන ච",
                    "sinh": "ඉවසීමේ සහ මෛත්‍රී බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "තේපි(ත්වං) අනුරක්ඛන්තු",
                    "sinh": "සියලු දුක් නසා ඔබ රැකේවා",
                    "span": 1
                },
                {
                    "pali": "ආරෝග්‍යේන සුඛේන ච",
                    "sinh": "නිරෝගීබව සහ සැපය ගෙන දෙමින්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේසං සච්චේන සීලේන",
                    "sinh": "උන්වහන්සේලා ගේ සත්‍ය වු සීල බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "ඛන්තිමෙත්ත බලේන ච",
                    "sinh": "ඉවසීමේ සහ මෛත්‍රී බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "තේපි(ත්වං) අනුරක්ඛන්තු",
                    "sinh": "සියලු දුක් නසා ඔබ රැකේවා",
                    "span": 1
                },
                {
                    "pali": "ආරෝග්‍යේන සුඛේන ච",
                    "sinh": "නිරෝගීබව සහ සැපය ගෙන දෙමින්",
                    "span": 1
                }
            ]
        ]
    },
    "52-wattaka": {
        "labels": [
            [
                0,
                2.036103,
                1
            ],
            [
                2.036103,
                20.126099,
                2
            ],
            [
                20.126099,
                38.372718,
                3
            ],
            [
                38.372718,
                55.444662,
                4
            ],
            [
                55.444662,
                72.594918,
                5
            ],
            [
                72.594918,
                90.371667,
                6
            ],
            [
                90.371667,
                109.088156,
                7
            ],
            [
                109.088156,
                121.618023,
                8
            ]
        ],
        "text": [
            [
                {
                    "pali": "වට්ට සුත්ත",
                    "sinh": "වට්ටක සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පූරෙන්තං බෝධි සම්භාරේ",
                    "sinh": "බුදු බව පතා උන් බෝධිසත්වයන් වහන්සේ එක් භවයක වටු ජාතියේ ඉපිද තදින් පැතිරෙන ලැව් ගින්නක් වැලැක්වීය",
                    "span": 4
                },
                {
                    "pali": "නිබ්බත්තං වට්ටක ජාතියං"
                },
                {
                    "pali": "යස්ස තේජේන දාවග්ගි"
                },
                {
                    "pali": "මහාසත්තං විවජ්ජයි"
                }
            ],
            [
                {
                    "pali": "ථේරස්ස සාරිපුත්තස්ස",
                    "sinh": "බුදුන් වහන්සේ සැරියුත් හිමිට දෙසූ කපක් බල මේ පිරිත ඔබහට සෙත සුව පතා දෙසමු",
                    "span": 4
                },
                {
                    "pali": "ලෝකනාථේන භාසිතං"
                },
                {
                    "pali": "කප්පට්ඨායි මහාතේජං"
                },
                {
                    "pali": "පරිත්තං තං භණාමහේ"
                }
            ],
            [
                {
                    "pali": "අත්ථි ලෝකේ සීලගුණෝ",
                    "sinh": "ලොව ඇති සැබෑ පිවිතුරැ දයා සිල් ගුණ බලය මත උතුම් අදිටන් කරමි",
                    "span": 4
                },
                {
                    "pali": "සච්චං සෝචෙය්‍යනුද්දයා"
                },
                {
                    "pali": "තේන සච්චේන කාහාමි"
                },
                {
                    "pali": "සච්චකිරියමනුත්තරං"
                }
            ],
            [
                {
                    "pali": "ආවජ්ජිත්වා ධම්මබලං",
                    "sinh": "දම් ගුණද පෙර බුදු වරැන්ගේ සැබෑ බස ගැන මෙනෙහි කොට මෙලෙසින් අදිටන් කලෙමි",
                    "span": 4
                },
                {
                    "pali": "සරිත්වා පුබ්බකෙ ජිනෙ"
                },
                {
                    "pali": "සච්චබල’මපස්සාය"
                },
                {
                    "pali": "සච්චකිරිය’මකාස’හං"
                }
            ],
            [
                {
                    "pali": "සන්තිපක්ඛා අපතනා",
                    "sinh": "පියාපත් ඇතිමුත් පියෑඹීමට අසමත්",
                    "span": 1
                },
                {
                    "pali": "සන්තිපාදා අවඤ්චනා",
                    "sinh": "පා දෙකක් ඇතිමුත් යා නොහැකි",
                    "span": 1
                },
                {
                    "pali": "මාතා පිතා ච නික්ඛන්තා",
                    "sinh": "මව්පියන් මා වන මැද අතහැර ගොස් ඇතිවිට",
                    "span": 1
                },
                {
                    "pali": "ජාතවේද පටික්කම",
                    "sinh": "රුදුරැ ගිණිකද ආපසු යන ලෙස",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සහසච්චේ කතෙ මය්හං",
                    "sinh": "ඉතා තදින් පැතිරුනු ගිණිකද මේ අදිටන සමගින් ඒ දෙසට නොපැමිණ නැවතුනෝය",
                    "span": 4
                },
                {
                    "pali": "මහාපජ්ජලිතෝ සිඛී"
                },
                {
                    "pali": "වජ්ජේසි සෝළස කරීසානි"
                },
                {
                    "pali": "උදකං පත්වා යථා සිඛී"
                }
            ],
            [
                {
                    "pali": "සච්චේන මේ සමෝ නත්ථි",
                    "sinh": "මේ සැබෑ වදනින් ඔබට සුව සෙත වේවා!!",
                    "span": 2
                },
                {
                    "pali": "ඒසා මේ සච්ච පාරමී"
                },
                {
                    "pali": "වට්ට සුත්ත නිට්ඨිතං",
                    "sinh": "වට්ටක සූත්‍රය නිමි.",
                    "span": 1
                }
            ]
        ]
    },
    "53-jaya-mangala-attha-gatha": {
        "labels": [
            [
                0,
                4.60972,
                1
            ],
            [
                4.60972,
                37.06215,
                2
            ],
            [
                37.06215,
                69.422386,
                3
            ],
            [
                69.422386,
                100.676289,
                4
            ],
            [
                100.676289,
                132.206775,
                5
            ],
            [
                132.206775,
                162.907511,
                6
            ],
            [
                162.907511,
                193.423859,
                7
            ],
            [
                193.423859,
                223.940206,
                8
            ],
            [
                223.940206,
                255.101915,
                9
            ],
            [
                255.101915,
                286.171429,
                10
            ]
        ],
        "text": [
            [
                {
                    "pali": "ජය මංගල අට්ඨ ගාථා",
                    "sinh": "ජය මංගල අට්ඨ ගාථා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බාහුං සහස්ස මභිනිම් මිත සා යුධං තං",
                    "sinh": "දාසක්‌ මවාගෙන අතුත් අවියෙන් සමත් වූ",
                    "span": 1
                },
                {
                    "pali": "ගිරි මේඛලං උදිත ඝෝර සසේන මාරං",
                    "sinh": "ගිරි මේඛලා ඇතු නැගී සිටි මාර සේනා",
                    "span": 1
                },
                {
                    "pali": "දානාදි ධම්ම විධිනා ජිත වා මුනින්දෝ",
                    "sinh": "දානාදි දම් විදි බෙලෙන් දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මාරාතිරේක මභියුජ් ජිත සබ්බ රත්තිං",
                    "sinh": "ඒ මාරයා හට වඩා නපුරක්‌ බිරම් වූ",
                    "span": 1
                },
                {
                    "pali": "ඝෝරම්පනාලවක මක්ඛ මථද්ධ යක්ඛං",
                    "sinh": "බෝසත් අතින් හොර අලව් යකු කෝපවත් වූ",
                    "span": 1
                },
                {
                    "pali": "ඛන්තී සුදන්ත විධිනා ජිත වා මුනින්දෝ",
                    "sinh": "මෙත් සිත් වඩා යස ලෙසින් දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නාලාගිරිං ගජවරං අතිමත්ථ භූතං",
                    "sinh": "නාලාගිරි ඇත් රජා ඇතිතෙක්‌ම රා බී",
                    "span": 1
                },
                {
                    "pali": "දාවග්ගිචක්ක මසනීව සුදාරු නන්තං",
                    "sinh": "සෝකා දෙමින් හෙණ හඬක්‌ ලෙස බෝ බිරම් වූ",
                    "span": 1
                },
                {
                    "pali": "මෙත්තම්බුසේක විධිනා ජිත වා මුනින්දෝ",
                    "sinh": "මෙත්පැන් ඉසීමෙන් වහා දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උක්ඛිත්ත ඛග්ග මතිහත්ථ සුදාරුනංතං",
                    "sinh": "උස්‌සා සියුම් කගපතක්‌ සුරතින් රැගත් වූ",
                    "span": 1
                },
                {
                    "pali": "දාවන්තියෝ ජනපදංගුලිමාල වන්තං",
                    "sinh": "බෝසේ රකුස්‌යුරු අඟුල්මල් නම් සොරා ඒ",
                    "span": 1
                },
                {
                    "pali": "ඉද්ධීභිසංඛතමනෝ ජිත වා මුනින්දෝ",
                    "sinh": "පාලා යසේ ඒ ඉඳු බෙලෙන් දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කත්වාන කට්ඨමුදරං ඉවගබ්භිනීයා",
                    "sinh": "රාසේ බැඳන් බොරු බඩක්‌ ගැබිනි විලාසෙන්",
                    "span": 1
                },
                {
                    "pali": "චිඤ්චාය දුට්ඨ වචනං ජනකාය මජ්ඣේ",
                    "sinh": "ආවේ නිගාකර සභාවට චින්චිමානා",
                    "span": 1
                },
                {
                    "pali": "සන්තේන සෝම විධිනා ජිත වා මුනින්දෝ",
                    "sinh": "සන්සුන් ලෙසින් ගුණ වඩා දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සච්චං විහාය මති සච්චක වාදකේතුං",
                    "sinh": "වාදෙන් සමත්කම් නැගු කොඩියක්‌ විලාසෙන්",
                    "span": 1
                },
                {
                    "pali": "වාදාභිරෝපිතමනං අති අන්ධ භූතං",
                    "sinh": "ඇත්තෙත් වෙනස්‌ සිතැති සච්චකයා විවාදී",
                    "span": 1
                },
                {
                    "pali": "පඤ්ඤා පදීප-ජලිතෝ ජිත වා මුනින්දෝ",
                    "sinh": "දල්වා පහන් ගුණ නැණින් දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නන්දෝපනන්ද භුජගං විබුධං මහිද්ධිං",
                    "sinh": "නන්දොපනන්ද භුජගා ඉදුයෙන් සමත් වූ",
                    "span": 1
                },
                {
                    "pali": "පුත්තේන ථේර භුජගේන ධම්මාපයන්තෝ",
                    "sinh": "සෑසී මුණි පුතු ලවා දැහැමින් දැමීමෙන්",
                    "span": 1
                },
                {
                    "pali": "ඉද්ධූපදේස විධිනා ජිත වා මුනින්දෝ",
                    "sinh": "පාලා තෙදින් සිතු බෙලෙන් දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දුග්ගාහදිට්ථි භුජගේන සුදට්ඨ හත්ථං",
                    "sinh": "දාසක්‌ ලොවේ බබළනා එළියෙන් දිමුත් වූ",
                    "span": 1
                },
                {
                    "pali": "බ්‍රහ්මං විසුද්ධි ජුතිමිද්ධි බකාභිධානං",
                    "sinh": "බෝසේ පසන් මහබඹා වරදී වදාළා",
                    "span": 1
                },
                {
                    "pali": "ඤාණාගදේන විධිනා ජිත වා මුනින්දෝ",
                    "sinh": "යහපත් උතුම් නැණ බෙලෙන් දිනුවේ මුනින්දා",
                    "span": 1
                },
                {
                    "pali": "තං තේජසා භවතු (තේ) ජය මංගලානී",
                    "sinh": "ඒ තේජසින් ජය මඟුල් ඔබට ලැබේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඒතා පි බුද්ධ ජය මංගල අට්ඨ ගාථා",
                    "sinh": "මේ ලෙස බුදුන් ජය මඟුල් අට මගී මතාසේ",
                    "span": 1
                },
                {
                    "pali": "යෝ වාචකෝ දිනදිනේ සරතේ මතන්දී",
                    "sinh": "යම් ඒ කෙනෙක්‌ දින දිනේ සොඳසේ කියයි නම්",
                    "span": 1
                },
                {
                    "pali": "හිත්‍වාන නේක විවිධානි-ඡුපද්දවානි",
                    "sinh": "නානා උපද්දාව නසා සිත දුක නොවීමෙන්",
                    "span": 1
                },
                {
                    "pali": "මොක්ඛං සුඛං අධිගමෙය්‍ය නරෝ සපංඥෝ",
                    "sinh": "අක්‌වේ සැපත් අමපුරේ සව් දුක්‌ නසාලා",
                    "span": 1
                }
            ]
        ]
    },
    "54-narasiha-gatha": {
        "labels": [
            [
                0,
                22.691296
            ],
            [
                22.691296,
                44.829939,
                2
            ],
            [
                44.829939,
                66.70851,
                3
            ],
            [
                66.70851,
                89.30228,
                4
            ],
            [
                89.30228,
                111.440923,
                5
            ],
            [
                111.440923,
                133.937165,
                6
            ],
            [
                133.937165,
                156.173335,
                7
            ],
            [
                156.173335,
                178.311978,
                8
            ],
            [
                178.311978,
                201.816,
                9
            ]
        ],
        "text": [
            [
                {
                    "pali": "චක්ක වරංකිත රත්ත සුපාදෝ",
                    "sinh": "චක්‍ර ලකුණු යුතු රන්වන් පාදේ",
                    "span": 1
                },
                {
                    "pali": "ලක්ඛණ මණ්ඩිත ආයත පණ්හී",
                    "sinh": "ලක්ෂනයෙන් පිරි දිගැති විළුඹේ",
                    "span": 1
                },
                {
                    "pali": "චාමර ඡත්ත විභූසිත පාදෝ",
                    "sinh": "චාමර සත් බැබලෙන පා පතුලේ",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි..",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සක්‍ය කුමාරවරෝ සුඛුමාලෝ",
                    "sinh": "ශාක්‍ය කුලේ සිවුමැළි ඒ කුමරා",
                    "span": 1
                },
                {
                    "pali": "ලක්ඛණ විත්තිත පුණ්ණ සරීරෝ",
                    "sinh": "පින් ඇති පුන් සිරුරින් පිරිවරිනා",
                    "span": 1
                },
                {
                    "pali": "ලෝක හිතාය ගතෝ නරවීරෝ",
                    "sinh": "ලෝ යහපත වෙත ආ නරවීරා",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුණ්ණ සසංක නිභෝ මුඛ වණ්ණෝ",
                    "sinh": "පුන්සද මෙන් බැබලෙන පැහැ මුහුණයි",
                    "span": 1
                },
                {
                    "pali": "දේව නරාන පියෝ නරනාගෝ",
                    "sinh": "දෙව් මිනිසුන් හැමටම ප්‍රිය උපදයි",
                    "span": 1
                },
                {
                    "pali": "මත්ත ගජින්ද විලාසිත ගාමී",
                    "sinh": "මත් ඇතෙකුගෙ ගමනට සරි ගමණයි",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඛත්තිය සම්භව අග්ග කුලීනෝ",
                    "sinh": "අග්‍ර කුලය වූ කැත් කුල වංශේ",
                    "span": 1
                },
                {
                    "pali": "දේව මනුස්ස නමස්සිත පාදෝ",
                    "sinh": "දෙව් මිනිසුන් වැදි පා යුග ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "සීල සමාධි පතිට්ඨිත චිත්තෝ",
                    "sinh": "ශීල සමාධියෙ පිහිටි සිතැත්තේ",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආයත යුත්ත සුසන්ඨිත නාසෝ",
                    "sinh": "උසින් දිගින් සුපිහිටි සොද නාසේ",
                    "span": 1
                },
                {
                    "pali": "ගෝපබුමෝ අභිනීල සුනෙත්තෝ",
                    "sinh": "ගෝ නෙත වැනි වූ සුනිල සුනෙත්තේ",
                    "span": 1
                },
                {
                    "pali": "ඉන්දධනූ අභිනීල භමූකෝ",
                    "sinh": "දේදුනු මෙනි ප්‍රිය දෙබැමක් ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වට්ට සුමට්ට සුසණ්ඨිත ගීවෝ",
                    "sinh": "මනාව වටකොට සැදි ගෙල ඇත්තේ",
                    "span": 1
                },
                {
                    "pali": "සීහ හනූ මිග රාජ සරීරෝ",
                    "sinh": "සිංහ හනුද මුව රජ වැනි සිරුරේ",
                    "span": 1
                },
                {
                    "pali": "කඤ්චින සුච්ඡවි උත්තම වණ්ණෝ",
                    "sinh": "රන්පාටින් බැබලෙන ගත සිරියේ",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අඤ්ජන වණ්ණ සුනීල සුකේසෝ",
                    "sinh": "සුසිනිල කේශය අඤ්ජන වර්ණය",
                    "span": 1
                },
                {
                    "pali": "කංචන පට්ට විසුද්ධ ලළාටෝ",
                    "sinh": "රන්පටයක් බඳු නිමල ලලාටය",
                    "span": 1
                },
                {
                    "pali": "ඕසධි පණ්ඩරසුද්ධ සුඋණ්හෝ",
                    "sinh": "ඕසධි තරුවක් සේ පිරිසිදු විය",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සිනිද්ධ සුගම්භිර මන්ජු සුඝෝසෝ",
                    "sinh": "සුසිනිදු ගැඹුරැති මියුරු තෙපුල් දෙන",
                    "span": 1
                },
                {
                    "pali": "හිංගුල බද්ධ සුරත්ත සුජිව්හෝ",
                    "sinh": "හිංගුල කන්ද සෙ දිව යහපත් වේ",
                    "span": 1
                },
                {
                    "pali": "වීසති වීසති සේත සුදන්තෝ",
                    "sinh": "විස්ස බැගින් යුත් සමසතලිස් දත්",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගච්ඡති නීල පථේ විය චන්දෝ",
                    "sinh": "අහස් කුසේ සරණා පුන්සඳ සේ",
                    "span": 1
                },
                {
                    "pali": "තාර ගණා පරිවේඨිත රූපෝ",
                    "sinh": "තරු ගණනින් පිරිවරණ පරිද්දෙන්",
                    "span": 1
                },
                {
                    "pali": "සාවක මජ්ඣතෝ සමණින්දෝ",
                    "sinh": "ශ්‍රාවක සඟ මැද වඩින සමින්දා",
                    "span": 1
                },
                {
                    "pali": "ඒසහි තුය්හ පිතා නරසීහෝ",
                    "sinh": "මේ උත්තම මුණි පුත නුඹ පිය වෙයි.",
                    "span": 1
                }
            ]
        ]
    },
    "55-maha-jaya-mangala-gatha": {
        "labels": [
            [
                0,
                17.362571,
                1
            ],
            [
                17.362571,
                28.630069,
                2
            ],
            [
                28.630069,
                45.852846,
                3
            ],
            [
                45.852846,
                63.103581,
                4
            ],
            [
                63.103581,
                81.472678,
                5
            ],
            [
                81.472678,
                93.355275,
                6
            ],
            [
                93.355275,
                105.405627,
                7
            ],
            [
                105.405627,
                117.511896,
                8
            ],
            [
                117.511896,
                129.78592,
                9
            ],
            [
                129.78592,
                141.976067,
                10
            ],
            [
                141.976067,
                153.774787,
                11
            ],
            [
                153.774787,
                166.048811,
                12
            ],
            [
                166.048811,
                177.791613,
                13
            ],
            [
                177.791613,
                189.534415,
                14
            ],
            [
                189.534415,
                201.556807,
                15
            ],
            [
                201.556807,
                214.026544,
                16
            ],
            [
                214.026544,
                231.389116,
                17
            ],
            [
                231.389116,
                248.835564,
                18
            ],
            [
                248.835564,
                266.226095,
                19
            ],
            [
                266.226095,
                279.92603,
                20
            ],
            [
                279.92603,
                292.507604,
                21
            ],
            [
                292.507604,
                306.48713,
                22
            ],
            [
                306.48713,
                320.326861,
                23
            ],
            [
                320.326861,
                334.669841,
                24
            ]
        ],
        "text": [
            [
                {
                    "pali": "මහාකාරුණිකෝ නාථෝ",
                    "sinh": "මහා කාරුණික බුදුරජාණන් වහන්සේ සියලු සත්‍වයන්ට හිත සුව පිණිස පාරමිතා පුරා බුදූබවට පැමිණිහ. ඒ සත්‍යයේ බලයෙන් ඔබට ජය මංගල්‍යක් වේවා",
                    "span": 6
                },
                {
                    "pali": "හිතාය සබ්බපාණිනං"
                },
                {
                    "pali": "පූරෙත්වා පාරමී සබ්බා"
                },
                {
                    "pali": "පත්තෝ සම්බෝධිමුත්තමං"
                },
                {
                    "pali": "එතේන සච්චවජ්ජේන"
                },
                {
                    "pali": "හෝතු (තේ) ජයමංගලං"
                }
            ],
            [
                {
                    "pali": "ජයන්තෝ බෝධියා මූලේ",
                    "sinh": "ජය ශ්‍රී මහා බො මුලදී ශාක්‍ය තොමො මාර සෙනා පරදවා ජය ලැබූ ආකාරායෙන් ඔබට ද ජය ලැබේවා! ජය මංගල්‍යක් වේවා!",
                    "span": 4
                },
                {
                    "pali": "සක්‍යානං නන්දිවද්ධනෝ"
                },
                {
                    "pali": "ඒවං (තුය්හං) ජයෝ හෝතු"
                },
                {
                    "pali": "ජයස්සු ජයමංගලං"
                }
            ],
            [
                {
                    "pali": "සක්කත්වා බුද්ධරතනං",
                    "sinh": "දෙව් මිනිසුන්ට හිත සුව සලසන්නා වූ බුද්ධ රත්නය උතුම් බෙහෙතකි. ඒ තෙජසින් මගේ සියලු උවදුරු නැසේවා! සියලු දුක් දුරුවේවා!",
                    "span": 6
                },
                {
                    "pali": "ඕසධං උත්තමං වරං"
                },
                {
                    "pali": "හිතං දේවමනුස්සානං"
                },
                {
                    "pali": "බුද්ධ තේජේන සොත්ථිනා"
                },
                {
                    "pali": "නස්සන්තුපද්දවා සබ්බේ"
                },
                {
                    "pali": "දුක්ඛා වූපසමෙන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "සක්කත්වා ධම්මරතනං",
                    "sinh": "කෙළෙස් ගින්නෙන් ඇතිවන දැවිල්ල සංසිදුවන ධර්ම රත්නය උතුම් බෙහෙතකි. ඒ තේජසින් ඔබගේ සියලු උවදුරු නැසේවා! සියලු භය දූරු වේවා!",
                    "span": 6
                },
                {
                    "pali": "ඕසධං උත්තමං වරං"
                },
                {
                    "pali": "පරිළාවූපසමණං"
                },
                {
                    "pali": "ධම්මතේජේන සොත්ථිනා"
                },
                {
                    "pali": "නස්සන්තුපද්දවා සබ්බේ"
                },
                {
                    "pali": "භයා වූපසමෙන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "සක්කත්වා සංඝරතනං",
                    "sinh": "දුරසිට ගෙනවුත් පුදන සිව්පසය පිළිගැනීමට සුදුසු සංඝරත්නය උතුම් බෙහෙතකි, ඒ ‌තේජසින් ඔබගේ සියලු උවදුරු නැසේවා! සියලු රෝග දුරු වේවා!",
                    "span": 6
                },
                {
                    "pali": "ඕසධං උත්තමං වරං"
                },
                {
                    "pali": "ආහුනෙය්‍යං පාහුනෙය්‍යං"
                },
                {
                    "pali": "සංඝ තේජේන සොත්ථිනා"
                },
                {
                    "pali": "නස්සන්තු’පද්දවා සබ්බේ"
                },
                {
                    "pali": "රෝගා වූපසමෙන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "යං කිඤ්චි රතනං ලෝකේ",
                    "sinh": "මේ පෙළොතලෙහි ඇති කිසිම වස්තුවක් බුද්ධ රත්නයට සම කළ නොහැක. ඒ සත්‍යයෙන් ඔබට සියලු යහපත වේවා!",
                    "span": 4
                },
                {
                    "pali": "විජ්ජති විවිධා පුථු"
                },
                {
                    "pali": "රතනං බුද්ධසමං නත්ථි"
                },
                {
                    "pali": "තස්මා සොත්ථි භවන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "යං කිඤ්චි රතනං ලෝකේ",
                    "sinh": "මේ පෙළොතලෙහි ඇති කිසිම වස්තුවක් ධර්ම රත්නයට සම කළ නොහැක. ඒ සත්‍යයෙන් ඔබට සියලු යහපත වේවා!",
                    "span": 4
                },
                {
                    "pali": "විජ්ජති විවිධා පුථු"
                },
                {
                    "pali": "රතනං ධම්මසමං නත්ථි"
                },
                {
                    "pali": "තස්මා සොත්ථි භවන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "යං කිඤ්චි රතනං ලෝකේ",
                    "sinh": "මේ පෙළොතලෙහි ඇති කිසිම වස්තුවක් සංඝ රත්නයට සම කළ නොහැක. ඒ සත්‍යයෙන් ඔබට සියලු යහපත වේවා!",
                    "span": 4
                },
                {
                    "pali": "විජ්ජති විවිධා පුථු"
                },
                {
                    "pali": "රතනං සංඝසමං නත්ථි"
                },
                {
                    "pali": "තස්මා සොත්ථි භවන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "නත්ථි මේ සරණං අඤ්ඤං",
                    "sinh": "බුදුරජාණන් වහනසේ මට එකම සරණ වන සේක. අන් කිසිම සරණක් නැත. ඒ සත්‍යයේ බලයෙන් ඔබට ජය මංගල්‍යක් වේවා!",
                    "span": 4
                },
                {
                    "pali": "බුද්ධෝ මේ සරණං වරං"
                },
                {
                    "pali": "ඒතේන සච්චවජ්ජේන"
                },
                {
                    "pali": "හෝතු (තේ) ජයමංගලං"
                }
            ],
            [
                {
                    "pali": "නත්ථි මේ සරණං අඤ්ඤං",
                    "sinh": "ධර්ම රත්නය මට එකම සරණ වන සේක. අන් කිසිම සරණක් නැත. ඒ සත්‍යයේ බලයෙන් ඔබට ජය මංගල්‍යක් වේවා!",
                    "span": 4
                },
                {
                    "pali": "ධම්මෝ මේ සරණං වරං"
                },
                {
                    "pali": "ඒතේන සච්චවජ්ජේන"
                },
                {
                    "pali": "හෝතු (තේ) ජයමංගලං"
                }
            ],
            [
                {
                    "pali": "නත්ථි මේ සරණං අඤ්ඤං",
                    "sinh": "සංඝ රත්නය මට එකම සරණ වන සේක. අන් කිසිම සරණක් නැත. ඒ සත්‍යයේ බලයෙන් ඔබට ජය මංගල්‍යක් වේවා!",
                    "span": 4
                },
                {
                    "pali": "සංඝෝ මේ සරණං වරං"
                },
                {
                    "pali": "ඒතේන සච්චවජ්ජේන"
                },
                {
                    "pali": "හෝතු (තේ) ජයමංගලං"
                }
            ],
            [
                {
                    "pali": "සබ්බීතියෝ විවජ්ජන්තු",
                    "sinh": "සියලු උවදුරු දුරු වේවා! සියලු රෝග විනාශ වේවා! කිසිම අනතුරක් නොවේවා! දීර්ඝායුෂ සැප ලැබේවා!",
                    "span": 4
                },
                {
                    "pali": "සබ්බරෝගෝ විනස්සතු"
                },
                {
                    "pali": "මා (තේ) භවත්වන්තරායෝ"
                },
                {
                    "pali": "සුඛී දීඝායුකෝ භව"
                }
            ],
            [
                {
                    "pali": "භවතු සබ්බමංගලං",
                    "sinh": "හැම මංගල්‍යක්ම වේවා! සියලු දෙවියො රකිත්වා! සියලු බුදුවරුනගේ බලයෙන් ඔබට සැම දා සුව සෙත් වේවා!",
                    "span": 4
                },
                {
                    "pali": "රක්ඛන්තු සබ්බ දේවතා"
                },
                {
                    "pali": "සබ්බබුද්ධානු භාවේන"
                },
                {
                    "pali": "සදා සොත්ථි භවන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "භවතු සබ්බමංගලං",
                    "sinh": "හැම මංගල්‍යක්ම වේවා! සියලු දෙවියො රකිත්වා! සියලු ධර්මරත්නයේ බලයෙන් ඔබට සැම දා සුව සෙත් වේවා!",
                    "span": 4
                },
                {
                    "pali": "රක්ඛන්තු සබ්බ දේවතා"
                },
                {
                    "pali": "සබ්බධම්මානු භාවේන"
                },
                {
                    "pali": "සදා සොත්ථි භවන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "භවතු සබ්බමංගලං",
                    "sinh": "හැම මංගල්‍යක්ම වේවා! සියලු දෙවියො රකිත්වා! සියලු සංඝරත්නයේ බලයෙන් ඔබට සැම දා සුව සෙත් වේවා!",
                    "span": 4
                },
                {
                    "pali": "රක්ඛන්තු සබ්බ දේවතා"
                },
                {
                    "pali": "සබ්බසංඝානු භාවේන"
                },
                {
                    "pali": "සදා සොත්ථි භවන්තු (තේ)"
                }
            ],
            [
                {
                    "pali": "නක්ඛත්ත යක්ඛ භූතානං",
                    "sinh": "නක්ෂත්‍ර ග්‍රහ අපලයන් ද, යක්ෂභූතයනගෙන් හා පාපී ග්‍රහයන්ගෙන් වන දොසයන් ද, සියලු උපද්‍රවයන් ද පිරිතේ අනුහසින් දුරු වේවා!",
                    "span": 4
                },
                {
                    "pali": "පාපග්ගහනිවාරණා"
                },
                {
                    "pali": "පරිත්තස්සානු’භාවේන"
                },
                {
                    "pali": "හන්තු තේසං උපද්දවේ"
                }
            ],
            [
                {
                    "pali": "යං දුනිමිත්තං අවමංගලඤ්ච",
                    "sinh": "දුර්නිමිති, අවමංගල, අයහපත් පක්‍ෂීන් හැඩූ හඬ, පාප ග්‍රහ, දොෂ, නරක හීන පෙනීම යන සියල්ල බුද්ධානු භාවයෙන් විනාශ වෙත්වා!.",
                    "span": 4
                },
                {
                    "pali": "යො චා’ මනාපො සකුණස්ස සද්දො"
                },
                {
                    "pali": "පාපග්ගහො දුස්සුපිනං අකන්තං"
                },
                {
                    "pali": "බුද්ධා’නුභාවේන විනාසමෙන්තු"
                }
            ],
            [
                {
                    "pali": "යං දුනිමිත්තං අවමංගලඤ්ච",
                    "sinh": "දුර්නිමිති, අවමංගල, අයහපත් පක්‍ෂීන් හැඩූ හඬ, පාප ග්‍රහ, දොෂ, නරක හීන පෙනීම යන සියල්ල ධම්මානු භාවයෙන් විනාශ වෙත්වා!.",
                    "span": 4
                },
                {
                    "pali": "යො චා’ මනාපො සකුණස්ස සද්දො"
                },
                {
                    "pali": "පාපග්ගහො දුස්සුපිනං අකන්තං"
                },
                {
                    "pali": "ධම්මා’නුභාවේන විනාසමෙන්තු"
                }
            ],
            [
                {
                    "pali": "යං දුනිමිත්තං අවමංගලඤ්ච",
                    "sinh": "දුර්නිමිති, අවමංගල, අයහපත් පක්‍ෂීන් හැඩූ හඬ, පාප ග්‍රහ, දොෂ, නරක හීන පෙනීම යන සියල්ල සංඝානු භාවයෙන් විනාශ වෙත්වා!.",
                    "span": 4
                },
                {
                    "pali": "යො චා’ මනාපො සකුණස්ස සද්දො"
                },
                {
                    "pali": "පාපග්ගහො දුස්සුපිනං අකන්තං"
                },
                {
                    "pali": "සංඝා’නුභාවේන විනාසමෙන්තු"
                }
            ],
            [
                {
                    "pali": "දුක්ඛප්පත්තා ච නිද්දුක්ඛා",
                    "sinh": "දුකට පත්වූ සියලු සත්වයෝ නිදුක් වෙත්වා",
                    "span": 1
                },
                {
                    "pali": "භයප්පත්තා ච නිබ්භයා",
                    "sinh": "බියට පත්වූ සියලු සත්වයෝ බියෙන් මිදෙත්වා",
                    "span": 1
                },
                {
                    "pali": "සොකප්පත්තා ච නිස්සෝකා",
                    "sinh": "ශෝකයට පත්වූ සියලු සත්වයෝ ශෝක නොවෙත්වා!",
                    "span": 2
                },
                {
                    "pali": "හොන්තු සබ්බේපි පාණිනෝ"
                }
            ],
            [
                {
                    "pali": "දානං දදන්තු සද්ධාය",
                    "sinh": "ශ්‍රද්ධාවෙන් දන් පුදනු ලබත්වා",
                    "span": 1
                },
                {
                    "pali": "සීලං රක්ඛන්තු සබ්බදා",
                    "sinh": "හැමකල්හි සීලය සුරකිත්වා",
                    "span": 1
                },
                {
                    "pali": "භාවනාභිරතා හොන්තු",
                    "sinh": "භාවනාවේ ඇලී වසන්නෝ වෙත්වා",
                    "span": 1
                },
                {
                    "pali": "ගච්ඡන්තු දේවතාගතා",
                    "sinh": "(ඒ සියලු පිනෙන්) දෙවියන්ගේ සහභාගයට යෙත්වා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බේ බුද්ධා බලප්පත්තා",
                    "sinh": "සියලු බුදු ගුණ බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චේකානඤ්ච යං බලං",
                    "sinh": "පසේ බුදු ගුණ බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "අරහන්තානඤ්ච තේජේන",
                    "sinh": "රහතුන් ගේ ද තේජසින්",
                    "span": 1
                },
                {
                    "pali": "රක්ඛං බන්ධාම සබ්බසෝ",
                    "sinh": "සැමට රැකවරණ වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බේ බුද්ධා බලප්පත්තා",
                    "sinh": "සියලු බුදු ගුණ බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චේකානඤ්ච යං බලං",
                    "sinh": "පසේ බුදු ගුණ බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "අරහන්තානඤ්ච තේජේන",
                    "sinh": "රහතුන් ගේ ද තේජසින්",
                    "span": 1
                },
                {
                    "pali": "රක්ඛං බන්ධාම සබ්බසෝ",
                    "sinh": "සැමට රැකවරණ වේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බේ බුද්ධා බලප්පත්තා",
                    "sinh": "සියලු බුදු ගුණ බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චේකානඤ්ච යං බලං",
                    "sinh": "පසේ බුදු ගුණ බලයෙන්",
                    "span": 1
                },
                {
                    "pali": "අරහන්තානඤ්ච තේජේන",
                    "sinh": "රහතුන් ගේ ද තේජසින්",
                    "span": 1
                },
                {
                    "pali": "රක්ඛං බන්ධාම සබ්බසෝ",
                    "sinh": "සැමට රැකවරණ වේවා.",
                    "span": 1
                }
            ]
        ]
    },
    "56-jaya-parittam": {
        "labels": [
            [
                0,
                16.477644,
                1
            ],
            [
                16.477644,
                29.628071,
                2
            ],
            [
                29.628071,
                41.352548,
                3
            ],
            [
                41.352548,
                54.542585,
                4
            ],
            [
                54.542585,
                67.693012,
                5
            ],
            [
                67.693012,
                80.249293,
                6
            ],
            [
                80.249293,
                91.141966,
                7
            ],
            [
                91.141966,
                102.193078,
                8
            ],
            [
                102.193078,
                120.492769,
                9
            ],
            [
                120.492769,
                136.455486,
                10
            ],
            [
                136.455486,
                146.595574,
                11
            ],
            [
                146.595574,
                161.607658,
                12
            ],
            [
                161.607658,
                173.450965,
                13
            ],
            [
                173.450965,
                184.422857,
                14
            ],
            [
                184.422857,
                202.682938,
                15
            ]
        ],
        "text": [
            [
                {
                    "pali": "සිරි ධිති මති තේජෝ",
                    "sinh": "ශ්‍රී සෞභාග්‍ය ධෛර්ය්‍ය බුද්ධි තේජස් ඇත්තා වූ,",
                    "span": 1
                },
                {
                    "pali": "ජයසිද්ධි මහිද්ධි මහා ගුණ සාගරස්ස",
                    "sinh": "ජය සිද්ධි මහා ඉර්ධි මහා ගුණ ඇත්තා වූ,",
                    "span": 1
                },
                {
                    "pali": "අපරිමිත පුඤ්ඤාධිකාරස්ස",
                    "sinh": "අප්‍රමාණ පුණ්‍ය සම්භාරයක් ඇත්තා වූ,",
                    "span": 1
                },
                {
                    "pali": "සබ්බන්තරාය නිවාරණ සමත්ථස්ස",
                    "sinh": "සකලාන්තරාය දූරීභූත කිරිමට ශක්තිය ඇත්තා වු ද,",
                    "span": 1
                },
                {
                    "pali": "භගවතෝ අරහතෝ සම්මා සම්බුද්ධස්ස",
                    "sinh": "ඒ භාග්‍යවත් අර්හත් සම්‍යක් සම්බුද්ධයන් වහන්සේ ගේ,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ද්වත්තිංස මහාපුරිසලක්ඛණානුභාවේන",
                    "sinh": "දෙතිස් මහ පුරිස් ලකුණු අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "අසිත්‍යනුභ්‍යඤජනලක්ඛණානුභාවේන",
                    "sinh": "අසූ අනු භ්‍යඤ්ජන ලකණු අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "අට්ඨුත්තරසතමංගලලක්ඛණානුභාවේන",
                    "sinh": "එකසිය අටක් මගුල් ලකුණු අනුහසින් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඡබ්බණ්ණරංස්‍යානුභාවේන",
                    "sinh": "සවණක්ඝණ බුදුරැස් අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "කේතුමාලානුභාවේන",
                    "sinh": "කේතුමාලාවේ අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "දස පාරමිතානුභාවේන",
                    "sinh": "දස පාරමිතා අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "දස උප පාරමිතානුභාවේන",
                    "sinh": "දස උපපාරමිතා අනුහසින් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දස පරමත්ථ පාරමිතානුභාවේන",
                    "sinh": "දස පරමත්ථ පාරමිතා අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "සීලසමාධිපඤ්ඤානුභාවේන",
                    "sinh": "සිලසමාධිප්‍රඥාවන්ගේ අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "බුද්ධානුභාවේන ධම්මානුභාවේන සංඝානුභාවේන",
                    "sinh": "බුද්ධ ධම්ම සංඝ යන තෙරුවන් අනුහසින් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේජානුභාවේන",
                    "sinh": "තේජස්වල අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "ඉද්ධ්‍යානුභාවේන",
                    "sinh": "ඉර්ධියේ ආනුභාවයෙන් ද,",
                    "span": 1
                },
                {
                    "pali": "බලානුභාවේන",
                    "sinh": "බලයන්ගේ ආනුභාවයෙන් ද,",
                    "span": 1
                },
                {
                    "pali": "ඤෙය්‍යධම්මානුභාවේන",
                    "sinh": "දතයුතු සියලු ධර්මයන්ගේ ආනුභාවයෙන් ද,",
                    "span": 1
                },
                {
                    "pali": "චතුරාසීතිසහස්සධම්මඛන්ධානුභාවේන",
                    "sinh": "අසූහාරදහසක් ධර්මස්ඛන්ධයේ අනුහසින් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නවලොකුත්තරම්මානුභාවේන",
                    "sinh": "නව ලොව්තුරු දහමේ අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "අට්ඨංගිකමග්ගානුභාවේන",
                    "sinh": "ආර්යඅෂ්ටාංගික මාර්ගයේ අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "අට්ඨසමාපත්‍යානුභාවේන",
                    "sinh": "අට සමවත් අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "ඡළභිඤ්ඤානුභාවේන",
                    "sinh": "ෂඩ් අභිඤ්ඤාවන්ගේ අනුහසින් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මෙත්තා කරැණා මුදිතා උපේක්ඛානුභාවේන",
                    "sinh": "මෙත්තා කරැණා මුදිතා උපේෂාවන්ගේ ආනුභාවයෙන් ද,",
                    "span": 1
                },
                {
                    "pali": "සබ්බපාරමිතානුභාවේන",
                    "sinh": "සියළු පාරමිතාවන්ගේ අනුහසින් ද,",
                    "span": 1
                },
                {
                    "pali": "රතනත්තයසරණානුභාවේන",
                    "sinh": "තෙරුවන් සරණේ අනුහසින් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බේ (තේ) සෝක රෝග",
                    "sinh": "ඔබගේ සියළු රෝග ද, ශෝකයන් ද උපද්‍රවයන් ද,",
                    "span": 1
                },
                {
                    "pali": "දුක්ඛදොමනස්සුපායාසා",
                    "sinh": "සියළු දුක්දොම්නස් ද,",
                    "span": 1
                },
                {
                    "pali": "විනස්සන්තු",
                    "sinh": "දුරුවේවා.",
                    "span": 1
                },
                {
                    "pali": "සබ්බසංකප්පා (තුය්හං) සමිජ්ඣන්තු",
                    "sinh": "ඔබගේ සියළු පැතුම් ඉටුවේවා.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දීඝායුකෝ හෝතු සතවස්සජීවේනසමංගිකෝ හෝතු සබ්බදා",
                    "sinh": "දීර්ඝායුෂ ලබා සතවසක් ජීවත් වීමේ වාසනාව උදාවේවා.",
                    "span": 1
                },
                {
                    "pali": "ආකාස පබ්බත වනභූමි තටාක",
                    "sinh": "අහස පර්වත වන භූමි තටාකයන්ද,",
                    "span": 1
                },
                {
                    "pali": "ගංගා මහාසමුද්ද",
                    "sinh": "ගංගා හා මහා සමුද්‍රයට ද,",
                    "span": 1
                },
                {
                    "pali": "ආරක්ඛක දේවතා",
                    "sinh": "අධිගෘහිත වූ සියළු දෙවියෝ,",
                    "span": 1
                },
                {
                    "pali": "සදා තුම්හේ අනුරක්ඛන්තු",
                    "sinh": "සදාකල්හිම ඔබ රැක දේවා,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බ බුද්ධානුභාවේන සබ්බ ධම්මානුභාවේන සබ්බ සංඝානුභාවේන",
                    "sinh": "සියළු බුද්ධ ධම්ම සංඝ ආනුභාවයෙන් ද,",
                    "span": 1
                },
                {
                    "pali": "බුද්ධරතනං ධම්මරතනං සංඝරතනං තින්නං රතනානං ආනුභාවේන",
                    "sinh": "බුද්ධ ධම්ම සංඝ යන තෙරුවන් ගේ බලයෙන් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චතුරාසිති සහස්සධම්මඛන්ධානුභාවේන",
                    "sinh": "අසූහාරදහසක් ධරමස්ඛන්ධයේ ආනුභාවයෙන්ද,",
                    "span": 1
                },
                {
                    "pali": "පිටකත්තයානුභාවේන",
                    "sinh": "තුන් පිටකයේ ආනුභාවයෙන් ද,",
                    "span": 1
                },
                {
                    "pali": "ජිනසාවකානුභාවේන",
                    "sinh": "බුද්ධ ශ්‍රාවකයන්ගේ ආනුභාවයෙන් ද,",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බේ තේ රෝගා, සබ්බේ තේ භයා, සබ්බේ තේ අන්තරායා, සබ්බේ තේ උපද්දවා, සබ්බේ තේ දුන්නිමිත්තා, සබ්බේ තේ අවමංගලා විනස්සන්තු",
                    "sinh": "ඔබගේ සියළු රෝග බිය අන්තරායන් උවදුරු අසුභ නිමිති ද අවමංගල්‍යයන් ද විනාශ වේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ආයුවඩ්ඪකෝ ධනවඩ්ඪකෝ සිරිවඩ්ඪකෝ යසවඩ්ඪකෝ බලවඩ්ඪකෝ වණ්ණවඩ්ඪකෝ සුඛවඩ්ඪකෝ හෝතු සබ්බදා",
                    "sinh": "අයු වැඩේවා, ධනය දියුණු වේවා, සිරිය වැඩි වේවා, යසස බලයද දියුණු වේවා, පැහැය වැඩිවේවා, සැපය තව වැඩි වේවා නිදුක් බව වේවා, සදා කල්හිම ජයම වේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දුක්ඛා රොග භයාවේරා සොකා සබ්බේ උපද්දවා අනේකා අන්තරායාපි විනස්සන්තුච තේජසා",
                    "sinh": "සියලු දුක් රෝ බිය සෝක උවදුරු වෛරය අනතුරු අනේකය දුරුව යේවා ලැබී සාමය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජයසිද්ධි ධනං ලාභං සොත්ථිභාග්‍යං සුඛං බලං සිරි ආයුච වණ්ණෝ ච භොග වුද්ධිංච යසවා සතවස්සාච ආයූ ච ජිවසිද්ධි භවන්තු තේ",
                    "sinh": "ජය ධන ලාභ යහපත වාසනාව ද, සැප බල සිරිය ආයුෂ සිරුර පැහැය ද, සම්පත් යසස දියුණුව ලබමින් නොම ද, සියවස් ආයු ලැබ ඔබ සැරදේ නිබඳ",
                    "span": 1
                }
            ]
        ]
    },
    "57-jvara-parittam": {
        "labels": [
            [
                0,
                31.331773,
                1
            ],
            [
                31.331773,
                63.381067,
                2
            ],
            [
                63.381067,
                95.071601,
                3
            ],
            [
                95.071601,
                127.120895,
                4
            ],
            [
                127.120895,
                158.452668,
                5
            ],
            [
                158.452668,
                189.844234,
                6
            ],
            [
                189.844234,
                220.159518,
                7
            ],
            [
                220.159518,
                251.13253,
                8
            ],
            [
                251.13253,
                281.985955,
                9
            ],
            [
                281.985955,
                313.078554,
                10
            ],
            [
                313.078554,
                343.334045,
                11
            ],
            [
                343.334045,
                373.589535,
                12
            ],
            [
                373.589535,
                403.546059,
                13
            ],
            [
                403.546059,
                434.16031,
                14
            ],
            [
                434.16031,
                463.937453,
                15
            ],
            [
                463.937453,
                493.893976,
                16
            ],
            [
                493.893976,
                523.790706,
                17
            ],
            [
                523.790706,
                553.866816,
                18
            ],
            [
                553.866816,
                583.703752,
                20
            ],
            [
                583.703752,
                612.70358,
                21
            ],
            [
                612.70358,
                642.062169,
                22
            ],
            [
                642.062169,
                671.540344,
                23
            ],
            [
                671.540344,
                700.839139,
                24
            ],
            [
                700.839139,
                730.975043,
                25
            ],
            [
                730.975043,
                760.931566,
                26
            ],
            [
                760.931566,
                791.007676,
                27
            ],
            [
                791.007676,
                820.725026,
                28
            ],
            [
                820.725026,
                850.561962,
                29
            ],
            [
                850.561962,
                870.712358,
                30
            ],
            [
                870.712358,
                890.62358,
                31
            ],
            [
                890.62358,
                910.893563,
                32
            ],
            [
                910.893563,
                924.406885,
                33
            ],
            [
                924.406885,
                937.860413,
                34
            ],
            [
                937.860413,
                952.868571,
                35
            ]
        ],
        "text": [
            [
                {
                    "pali": "තණ්හංකරො නාම ජිනො පුරෙත්වා දස පාරමී",
                    "sinh": "තණ්හංකර නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මේධංකරො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "මේධංකර නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සරණංකරො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "සරණංකර නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "දීපංකරො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "දීපංකර නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කොණ්ඩඤ්ඤො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "කොණ්ඩඤ්ඤ නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මංගලො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "මංගල නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුමනො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "සුමන නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රෙවතො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "රෙවත නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොභිතො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "සොභිත නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අනෝමදස්සී නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "අනෝමදස්සී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පදුමො නාම ජිනො- පුරෙත්වා දස පාරමී",
                    "sinh": "පදුම නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "නාරදො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "නාරද නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පදුමුත්තරො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "පදුමුත්තර නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුමේධො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "සුමේධ නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සුජාතො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "සුජාත නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පියදස්සී නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "පියදස්සී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අත්ථදස්සී නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "අත්ථදස්සී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ධම්මදස්සී නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "ධම්මදස්සී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සිද්ධත්ථෝ නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "ධම්මදස්සී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තිස්සො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "තිස්ස නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඵුස්සො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "ඵුස්ස නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විපස්සී නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "විපස්සී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සිඛී නාම ජිනො - පුරෙත්වා දස පාරමී",
                    "sinh": "සිඛී නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වෙස්සභු නාම ජිනො - පුරෙත්වා දස පාරමී",
                    "sinh": "වෙස්සභු නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කුකුසන්දො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "කුකුසන්ද නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කෝනාගමනො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "කෝනාගමන නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කස්සපො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "කස්සප නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගොතමො නාම ජිනො – පුරෙත්වා දස පාරමී",
                    "sinh": "ගොතම නම් බුදුරජාණන් වහන්සේ දස පාරමිතා සම්පූර්ණ කර,",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං බුද්ධත්තං සමුපාගමේ",
                    "sinh": "මාර සෙනග පරදවා සම්බුද්ධත්වයට පත්වූ සේක.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන (පිලකා රෝගෝ) (තේ) විනස්සතු",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ පිළිකා රෝගය නිවාරණය වේවා.",
                    "span": 1
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන සබ්බේ රෝගා (තේ) විනස්සන්තු ජයසිද්ධි භවන්තු (තේ)",
                    "sinh": "එම සත්‍යයේ බලයෙන් ඔබගේ සියලු රෝග නිවාරණය වේවා. සියලු යහපත සැලසේවා",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අට්ඨ වීසති ඉමේ බුද්ධා",
                    "sinh": "මෙම අටවිසි බුදුවරු",
                    "span": 1
                },
                {
                    "pali": "පූරෙත්වා දස පාරමී",
                    "sinh": "දසපාරමී ගුණයන් සපුරා",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං",
                    "sinh": "කෙලෙස් මරුන් ජය ගෙන",
                    "span": 1
                },
                {
                    "pali": "බුදධත්තං සමුපාගමුං",
                    "sinh": "සම්මා සම්බුද්ධත්වයට පත් වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අට්ඨ වීසති ඉමේ බුද්ධා",
                    "sinh": "මෙම අටවිසි බුදුවරු",
                    "span": 1
                },
                {
                    "pali": "පූරෙත්වා දස පාරමී",
                    "sinh": "දසපාරමී ගුණයන් සපුරා",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං",
                    "sinh": "කෙලෙස් මරුන් ජය ගෙන",
                    "span": 1
                },
                {
                    "pali": "බුදධත්තං සමුපාගමුං",
                    "sinh": "සම්මා සම්බුද්ධත්වයට පත් වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අට්ඨ වීසති ඉමේ බුද්ධා",
                    "sinh": "මෙම අටවිසි බුදුවරු",
                    "span": 1
                },
                {
                    "pali": "පූරෙත්වා දස පාරමී",
                    "sinh": "දසපාරමී ගුණයන් සපුරා",
                    "span": 1
                },
                {
                    "pali": "ජෙත්වා මාරාරි සංගාමං",
                    "sinh": "කෙලෙස් මරුන් ජය ගෙන",
                    "span": 1
                },
                {
                    "pali": "බුදධත්තං සමුපාගමුං",
                    "sinh": "සම්මා සම්බුද්ධත්වයට පත් වූහ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේසං සච්චේන සීලේන",
                    "sinh": "උන්වහන්සේලා ගේ සත්‍ය වු සීල බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "ඛන්තිමෙත්ත බලේන ච",
                    "sinh": "ඉවසීමේ සහ මෛත්‍රී බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "තේපි(ත්වං) අනුරක්ඛන්තු",
                    "sinh": "සියලු දුක් නසා ඔබ රැකේවා",
                    "span": 1
                },
                {
                    "pali": "ආරෝග්‍යේන සුඛේන ච",
                    "sinh": "නිරෝගීබව සහ සැපය ගෙන දෙමින්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේසං සච්චේන සීලේන",
                    "sinh": "උන්වහන්සේලා ගේ සත්‍ය වු සීල බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "ඛන්තිමෙත්ත බලේන ච",
                    "sinh": "ඉවසීමේ සහ මෛත්‍රී බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "තේපි(ත්වං) අනුරක්ඛන්තු",
                    "sinh": "සියලු දුක් නසා ඔබ රැකේවා",
                    "span": 1
                },
                {
                    "pali": "ආරෝග්‍යේන සුඛේන ච",
                    "sinh": "නිරෝගීබව සහ සැපය ගෙන දෙමින්",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "තේසං සච්චේන සීලේන",
                    "sinh": "උන්වහන්සේලා ගේ සත්‍ය වු සීල බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "ඛන්තිමෙත්ත බලේන ච",
                    "sinh": "ඉවසීමේ සහ මෛත්‍රී බලයෙන් ද",
                    "span": 1
                },
                {
                    "pali": "තේපි(ත්වං) අනුරක්ඛන්තු",
                    "sinh": "සියලු දුක් නසා ඔබ රැකේවා",
                    "span": 1
                },
                {
                    "pali": "ආරෝග්‍යේන සුඛේන ච",
                    "sinh": "නිරෝගීබව සහ සැපය ගෙන දෙමින්",
                    "span": 1
                }
            ]
        ]
    },
    "58-antharaya-nivarana-parittam": {
        "labels": [
            [
                0,
                6.660519,
                1
            ],
            [
                6.660519,
                14.359459,
                2
            ],
            [
                14.359459,
                23.355073,
                3
            ],
            [
                23.355073,
                32.089511,
                4
            ],
            [
                32.089511,
                40.283552,
                5
            ],
            [
                40.283552,
                53.925028,
                6
            ]
        ],
        "text": [
            [
                {
                    "pali": "බුද්ධානං ජිවිතස්‍ස",
                    "sinh": "බුදුරජාණන් වහන්සේගේ ජිවිතයට",
                    "span": 1
                },
                {
                    "pali": "නසක්කා කේනචි අන්තරායෝ කාතුං",
                    "sinh": "අනතුරක් කිරිමට කිසිවකුට නොහැකිය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බුද්ධානං ඡබ්බණ්ණ රංසීනං",
                    "sinh": "බුදුරජාණන් වහන්සේගේ සවනක් ඝන රශ්මි මාලවන්ට",
                    "span": 1
                },
                {
                    "pali": "නසක්කා කේනචි අන්තරායෝ කාතුං",
                    "sinh": "අනතුරක් කිරිමට කිසිවකුට නොහැකිය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බුද්ධානං ද්වත්තිංස මාහා පුරිසලක්ඛණානං",
                    "sinh": "බුදුරජානන් වහන්සේගේ දෙතිස් මහා පුරුෂ ලක්ෂණයන්ට",
                    "span": 1
                },
                {
                    "pali": "නසක්කා කේනචි අන්තරායෝ කාතුං",
                    "sinh": "අනතුරක් කිරිමට කිසිවකුට නොහැකිය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "බුද්ධානං අබිහට චතුන්නං පච්චයානං",
                    "sinh": "බුදුරජාණන් වහන්සේ වෙත පමුනුවන ලද සිව්පසයන්ට",
                    "span": 1
                },
                {
                    "pali": "නසක්කා කේනචි අන්තරායෝ කාතුං",
                    "sinh": "අනතුරක් කිරිමට කිසිවකුට නොහැකිය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඉමෙසං චතුන්නං අච්ඡරියානං",
                    "sinh": "මෙම සතර අද්භූත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "නසක්කා කේනචි අන්තරායෝ කාතුං",
                    "sinh": "අනතුරක් කිරිමට කිසිවකුට නොහැකිය.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "‌එතේන සච්ච වජ්ජේන අන්තරායා අසේසතෝ",
                    "sinh": "මෙ සත්‍යක්‍රියා බලයෙන් සියලු අනතුරු මාර බල සියල්ල සහමුලින්ම දුරුවේවා. ඔබට ශාන්තිය උදාවේවා!",
                    "span": 2
                },
                {
                    "pali": "මාරාදයෝ විනස්සන්තු ජය සිද්ධි භවන්තු (තේ)"
                }
            ]
        ]
    },
    "59-jinapanjara-parittam": {
        "labels": [
            [
                0,
                26.916778,
                1
            ],
            [
                26.916778,
                40.282029,
                2
            ],
            [
                40.282029,
                54.392382,
                3
            ],
            [
                54.392382,
                68.083615,
                4
            ],
            [
                68.083615,
                81.728279,
                5
            ],
            [
                81.728279,
                95.745493,
                6
            ],
            [
                95.745493,
                109.623002,
                7
            ],
            [
                109.623002,
                123.779923,
                8
            ],
            [
                123.779923,
                137.610862,
                9
            ],
            [
                137.610862,
                152.093765,
                10
            ],
            [
                152.093765,
                180.081626,
                11
            ],
            [
                180.081626,
                193.214033,
                12
            ],
            [
                193.214033,
                212.120974,
                13
            ],
            [
                212.120974,
                231.260759,
                14
            ],
            [
                231.260759,
                250.121131,
                15
            ],
            [
                250.121131,
                268.981503,
                16
            ],
            [
                268.981503,
                303.395861,
                17
            ],
            [
                303.395861,
                325.795463,
                18
            ],
            [
                325.795463,
                348.334772,
                19
            ],
            [
                348.334772,
                370.12898,
                20
            ]
        ],
        "text": [
            [
                {
                    "pali": "ජයාසන ගතා වීරා",
                    "sinh": "ජය අසුන් අරා වැඩහිඳ සේනා සහිත මරසෙන් පරදවා සිවුසස් අමා රසය පානය කොට වදාළ ලෝක නායක මුනීශ්වර වූ තණ්හංකරාදි යම් අටවිසි බුදුවරු වෙත්ද, උන්වහන්සේලා (ඔබේ) මස්තකයෙහි (හිස මත) වැඩ වසන සේක.",
                    "span": 6
                },
                {
                    "pali": "ජෙත්වා මාරං සවාහිණිං,"
                },
                {
                    "pali": "චතුසච්චාමතරසං, යේ පිවිංසු නරාසහා"
                },
                {
                    "pali": "තණ්හංකරාදයො බුද්ධා,"
                },
                {
                    "pali": "අට්ඨවීසති නායකා,"
                },
                {
                    "pali": "සබ්බේ පතිටිඨිතා (තුය්හං) මත්‍ථකේ (තේ) මුනිස්සරා"
                }
            ],
            [
                {
                    "pali": "සිරේ පතිට්ඨිතා බුද්ධා,",
                    "sinh": "(ඔබේ) සිරසෙහි බුදුවරු වැඩ වෙසෙති. දෑසෙහි ධර්මය පිහිටියේ ය. ලයෙහි සියලු ගුණයට ආකරයක් වූ මහ සඟරුවන වෙසෙයි.",
                    "span": 5
                },
                {
                    "pali": "ධම්මෝ ච"
                },
                {
                    "pali": "(තව) ලොචනේ,"
                },
                {
                    "pali": "සංඝෝ පතිට්ඨිතෝ (තුය්හං)"
                },
                {
                    "pali": "උරේ සබ්බ ගුණාකරෝ"
                }
            ],
            [
                {
                    "pali": "හදයේ අනුරුද්ධෝ ච,",
                    "sinh": "හදවතේ අනුරුද්ධ තෙරුණුවෝ ද දකුණුපස සැරියුත් තෙරුණුවෝ ද පසුභාගයෙහි කොණ්ඩඤ්ඤ තෙරුණුවෝ ද වම්පස මුගලන් තෙරුණුවෝ ද වෙති.",
                    "span": 4
                },
                {
                    "pali": "සාරිපුත්තෝ ච දක්ඛිණේ"
                },
                {
                    "pali": "කොණ්ඩඤ්ඤෝ පිට්ඨිභාගස්මිං"
                },
                {
                    "pali": "මොග්ගල්ලානො සි වාමකේ"
                }
            ],
            [
                {
                    "pali": "දක්ඛිණේ සවණෙ (තුය්හං)",
                    "sinh": "දකුණු කණෙහි ආනන්ද රාහුල තෙරවරු ද වාම ශ්‍රෝතසයෙහි කාශ්‍යප මහානාම තෙරුන් වහන්සේලා වසන සේක.",
                    "span": 4
                },
                {
                    "pali": "ආහුං ආනන්ද රාහුලා"
                },
                {
                    "pali": "කස්සපෝ ච මහානාමො,"
                },
                {
                    "pali": "උභ‌ොසුං වාමසෝතකේ"
                }
            ],
            [
                {
                    "pali": "කෙසන්තේ පිට්ඨිභාගස්මිං,",
                    "sinh": "කේශාන්තයේ හා පසුභාගයෙහි සමෘද්ධි සම්පන්නව හිරුමෙන් බබළන සෝභිත නම් මුනි උතුමාණෝ පිහිටිය හ.",
                    "span": 4
                },
                {
                    "pali": "සුරියෝවිය පභංකරෝ"
                },
                {
                    "pali": "නිසින්නෝ සිරිසම්පන්නෝ"
                },
                {
                    "pali": "සෝහිතො මුනි පුංගවො"
                }
            ],
            [
                {
                    "pali": "කුමාර කස්සපෝ නාම",
                    "sinh": "විචිත්‍ර කථිකයන් අතුරෙන් අගතැන්පත් ගුණයන්ට ආකර වූ කුමාර කාශ්‍යප නම් මහා සෘෂින් වහන්සේ මුහුනෙහි නිතර පිහිටි සේක.",
                    "span": 4
                },
                {
                    "pali": "මහේසි චිත්‍රවාදකෝ"
                },
                {
                    "pali": "සො (තුය්හං) වදනේ නිච්චං,"
                },
                {
                    "pali": "පතිට්ඨාසි ගුණාකරෝ"
                }
            ],
            [
                {
                    "pali": "පුණේණෝ අංගුලිමාලෝච",
                    "sinh": "පුණ්ණ අංගුලිමාල උපාලි නන්ද, සීවලි යන පස්තෙරුන් වහන්සේලා ඔබේ නලලෙහි තිලකයක් මෙන් වසන සේක.",
                    "span": 4
                },
                {
                    "pali": "උපාලී නන්ද සීවලී"
                },
                {
                    "pali": "ථේරා පඤ්ච ඉමේ ජාතා"
                },
                {
                    "pali": "ලලා‍ටේ තිලකා (තව)"
                }
            ],
            [
                {
                    "pali": "සෙසාසීති මහාථේරා",
                    "sinh": "කෙලෙස් සතුරන් පරදවා ජයලද, සිල් තෙදින් බබලන බුදු සව් සෙසු අසූ මහා ශ්‍රාවකයන් වහන්සේලා ඔබේ අඟපසගෙහි පිහිටියාහු ය.",
                    "span": 4
                },
                {
                    "pali": "විජිතා ජිනසාවකා"
                },
                {
                    "pali": "ජලන්තා සීලතේජේන"
                },
                {
                    "pali": "අංග මංගේසු සණ්ඨිතා"
                }
            ],
            [
                {
                    "pali": "රතනං පුරතෝ ආසී",
                    "sinh": "ඔබේ පෙරටුවේ රතන සූත්‍රය පිහිටියේ ය. දකුණේ මෙත්ත සූත්‍රය ද පසුභාගයෙහි ධජග්ග සූත්‍රය ද වම් පස අංගුලිමාල සූත්‍රය ද පිහිටියේ ය.",
                    "span": 4
                },
                {
                    "pali": "දක්ඛිණේ මෙත්තසුත්තකං"
                },
                {
                    "pali": "ධජග්ගං පච්ඡතෝ ආසි,"
                },
                {
                    "pali": "වාමේ අංගුලිමාලකං"
                }
            ],
            [
                {
                    "pali": "ඛන්ධ මෝර පරිත්තංච",
                    "sinh": "කඳ පිරිත, මෝර පිරිත ආටානාටිය සූත්‍රය ඔබට අහසෙහි සෙවනක් මෙන්ද සෙසු සියලු පිරිත් ඔබ අවට ප්‍රාකාර මෙන්ද පිහිටියාහු ය.",
                    "span": 4
                },
                {
                    "pali": "ආටානාටිය සුත්තකං"
                },
                {
                    "pali": "ආකාසච්ඡදනං ආසී"
                },
                {
                    "pali": "සේසා පාකාර සඤ්ඤිතා"
                }
            ],
            [
                {
                    "pali": "ජිනානා බල සංයුත්තේ",
                    "sinh": "තථාගත සම්මා සම්බුදුරජාණන් වහන්සේගේ අණ බෙලෙන් යුතු ධර්මය නමැති ප්‍රාකාරයෙන් අලංකාර වූ සර්වඥ නමැති ජිනපඤජරයෙහි (බුදුමැදුරෙ) හැම කල්හි සිවු ඉරියව්වෙන් වෙසෙන ඔබට",
                    "span": 4
                },
                {
                    "pali": "ධම්මපාකාරලංකතේ"
                },
                {
                    "pali": "වසතෝ තේ චතුකිච්චේන"
                },
                {
                    "pali": "සදා සම්බුද්ධ පඤ්ජරේ"
                },
                {
                    "pali": "වාතපිත්තාදි සඤ්ජාතා",
                    "sinh": "වා පිත් ආදියෙන් හට ගන්නා වූද ආධ්‍යාත්මක බාහිරවූ ද සියලු උවදුරු අනන්ත ගුණ තෙදින් සර්ව ප්‍රකාරයෙන් දූරිභූත වේවා.",
                    "span": 3
                },
                {
                    "pali": "බාහිරජ්ඣත්තුපද්දවා"
                },
                {
                    "pali": "අසේසා විලයං යන්තු අනන්ත ගුණ තේජසා"
                }
            ],
            [
                {
                    "pali": "ජිනපඤ්ජර මජ්ක්‍ධට්ඨං",
                    "sinh": "ජිනපඤ්ජ මධ්‍යගතව පොළෝ තලයෙහි වාසය කරණ ඔබ ඒ සියලු පුරුෂෝත්තමයන් වහන්සේලා හැම කල්හිම ආරක්ෂා කෙරෙත්වා",
                    "span": 4
                },
                {
                    "pali": "විහරන්තං මහීතලේ"
                },
                {
                    "pali": "සදා පාලෙන්තු (ත්වං) සබ්බේ"
                },
                {
                    "pali": "තේ මහාපුරිසා’සභා"
                }
            ],
            [
                {
                    "pali": "ඉච්චේවමච්චන්ත කතෝ සුරක්ඛෝ",
                    "sinh": "මෙසේ ඒකාන්තයෙන් කරණ ලද ආරක්ෂා ඇතිව ජිනේන්ද්‍රයන් වහන්සේගේ ආනුභාවයෙන් දිනන ලද උවදුරු ඇතුව බුද්ධානුභාවයෙන් නසන ලද සතුරු සමූහයා ඇතුව සදහම් බෙලෙන් ආරක්ෂා කරන ලදුව හැසිරෙන්නේය.",
                    "span": 4
                },
                {
                    "pali": "ජිනානුභාවේන ජිතුපපද්දවො"
                },
                {
                    "pali": "බුද්ධානුභාවේන හතාරි සංඝෝ"
                },
                {
                    "pali": "චරාහි සද්ධම්මනුභාව පාලිතෝ"
                }
            ],
            [
                {
                    "pali": "ඉච්චේවමච්චන්ත කතෝ සුරක්ඛෝ",
                    "sinh": "මෙසේ ඒකාන්තයෙන් කරණ ලද ආරක්ෂා ඇතිව ජිනේන්ද්‍රයන් වහන්සේගේ ආනුභාවයෙන් දිනන ලද උවදුරු ඇතුව ධම්මානුභාවයෙන් නසන ලද සතුරු සමූහයා ඇතුව සදහම් බෙලෙන් ආරක්ෂා කරන ලදුව හැසිරෙන්නේය.",
                    "span": 4
                },
                {
                    "pali": "ජිනානුභාවේන ජිතුපපද්දවො"
                },
                {
                    "pali": "ධම්මානුභාවේන හතාරි සංඝෝ"
                },
                {
                    "pali": "චරාහි සද්ධම්මනුභාව පාලිතෝ"
                }
            ],
            [
                {
                    "pali": "ඉච්චේවමච්චන්ත කතෝ සුරක්ඛෝ",
                    "sinh": "මෙසේ ඒකාන්තයෙන් කරණ ලද ආරක්ෂා ඇතිව ජිනේන්ද්‍රයන් වහන්සේගේ ආනුභාවයෙන් දිනන ලද උවදුරු ඇතුව සංඝානුභාවයෙන් නසන ලද සතුරු සමූහයා ඇතුව සදහම් බෙලෙන් ආරක්ෂා කරන ලදුව හැසිරෙන්නේය.",
                    "span": 4
                },
                {
                    "pali": "ජිනානුභාවේන ජිතුපපද්දවො"
                },
                {
                    "pali": "සංඝසානුභාවේන හතාරි සංඝෝ"
                },
                {
                    "pali": "චරාහි සද්ධම්මනුභාව පාලිතෝ"
                }
            ],
            [
                {
                    "pali": "සද්ධම්ම පාකාර පරික්ඛිතොසි",
                    "sinh": "ඔබ සද්ධර්මය නමැති ප්‍රාකාරයෙන් වට කරන ලද්දේ වේ. ආර්යයන් වහන්සේලා අට නම අට දිශාවන්හි වෙති. මේ අතරෙහි අටබුදුවරු වෙති. ඔබට උඩුවියනක් සේ සියලු බුදුවරු වෙසෙති.",
                    "span": 4
                },
                {
                    "pali": "අට්ඨාරියා අට්ඨදිසාසු හොන්ති"
                },
                {
                    "pali": "එත්‍ථන්තරේ අට්ඨ නාථා භවන්ති"
                },
                {
                    "pali": "උද්ධං විතානං ව ජිනා ඨිතා (තේ)"
                }
            ],
            [
                {
                    "pali": "හින්‍දන්තෝ මාරසෙනං",
                    "sinh": "හිරුමෙන් ලෝවැසියාට අසහාය සරණ වූ සම්මා සම්බුදුරජාණන් වහන්සේ ජයසිරි මහ බෝ රුක්මුල විදුරසුන් අරා වැඩහිඳ, දස මරසෙන් පරදවමින් (බිඳිමින්) ඔබගේ සිරසෙහි සිටි සේක.",
                    "span": 3
                },
                {
                    "pali": "(තව) සිරසි ඨීතෝ"
                },
                {
                    "pali": "බොධිමාරුය්හ සත්ථා,"
                },
                {
                    "pali": "මොග්ගල්ලානො සි වාමේ වසති භූජතටේ දක්ඛිණේ සාරිපුත්තෝ",
                    "sinh": "මහ මුගලන් තෙරුන් වහන්සේ වම් පසෙහි ද, සැරියුත් මහ තෙරුන් වහන්සේ දකුණු පසෙහිද, වසති.",
                    "span": 1
                },
                {
                    "pali": "ධම්මෝ මජ්ඣේ උරස්මිං විහරති භවතෝ මොක්ඛතෝ මෝර යොනිං",
                    "sinh": "භවයෙන් මිදීම හේතුකොට ගෙන ධර්මය ලය මැද පවතී. මෝරයෝනියට පැමිණියා වූ බෝසතාණන් වහන්සේ පා යුවලට ගිය සේක.",
                    "span": 2
                },
                {
                    "pali": "සම්පත්තෝ බොධිසත්තෝ චරණ යුගගතෝ භාණු ලොකේක නාථො"
                }
            ],
            [
                {
                    "pali": "සබ්බාවමංගලමුපද්දවදුන්නිමිත්තං",
                    "sinh": "සියලු අවමඟුල්, උවදුරු, නපුරු නිමිති, රෝග පීඩා ග්‍රහදෝෂ නින්දා, ගර්හා, භය, නපුරු සිහින යන මේ සියල්ල බුද්ධ රත්නයේ ආනුභාවයෙන් දුරුවෙත්වා.",
                    "span": 4
                },
                {
                    "pali": "සබ්බීතිරෝග ගහදොසමසේසනින්දා"
                },
                {
                    "pali": "සබ්බන්තරාය භය දුස්සුපිනං අකන්තං"
                },
                {
                    "pali": "බුද්ධානුභාව පවරේණ පයාතුනාසං"
                }
            ],
            [
                {
                    "pali": "සබ්බාවමංගලමුපද්දවදුන්නිමිත්තං",
                    "sinh": "සියලු අවමඟුල්, උවදුරු, නපුරු නිමිති, රෝග පීඩා ග්‍රහදෝෂ නින්දා, ගර්හා, භය, නපුරු සිහින යන මේ සියල්ල ධම්ම රත්නයේ ආනුභාවයෙන් දුරුවෙත්වා.",
                    "span": 4
                },
                {
                    "pali": "සබ්බීතිරෝග ගහදොසමසේසනින්දා"
                },
                {
                    "pali": "සබ්බන්තරාය භය දුස්සුපිනං අකන්තං"
                },
                {
                    "pali": "ධම්මානුභාව පවරේණ පයාතුනාසං"
                }
            ],
            [
                {
                    "pali": "සබ්බාවමංගලමුපද්දවදුන්නිමිත්තං",
                    "sinh": "සියලු අවමඟුල්, උවදුරු, නපුරු නිමිති, රෝග පීඩා ග්‍රහදෝෂ නින්දා, ගර්හා, භය, නපුරු සිහින යන මේ සියල්ල සංඝ රත්නයේ ආනුභාවයෙන් දුරුවෙත්වා.",
                    "span": 4
                },
                {
                    "pali": "සබ්බීතිරෝග ගහදොසමසේසනින්දා"
                },
                {
                    "pali": "සබ්බන්තරාය භය දුස්සුපිනං අකන්තං"
                },
                {
                    "pali": "සංඝානුභාව පවරේණ පයාතුනාසං"
                }
            ]
        ]
    },
    "60-dasa-disa-parittam": {
        "labels": [
            [
                0,
                19.18171,
                1
            ],
            [
                19.18171,
                32.454215,
                2
            ],
            [
                32.454215,
                44.86045,
                3
            ],
            [
                44.86045,
                58.380462,
                4
            ],
            [
                58.380462,
                71.498276,
                5
            ],
            [
                71.498276,
                90.556233,
                6
            ]
        ],
        "text": [
            [
                {
                    "pali": "දිසාසු දසභාගේසු ඨිතා බුද්ධානුභාවතො",
                    "sinh": "දස දිසාවන්හි සිටියාවු බුදුවරුනගේ ආනුභාවයෙන් වෛරයෙද අනතූරුද ඉතිරි නැතිව විනාශ වෙත්වා. මේ ගූණ වලින් යුතූ පිරිතක් කියනු ලැබේ.",
                    "span": 3
                },
                {
                    "pali": "වෙරාදි අන්තරායාපි විනස්සන්තු අසේසතෝ,"
                },
                {
                    "pali": "එවමාදී ගුණෝපේතං පරිත්තං තං භණාමහෙ."
                }
            ],
            [
                {
                    "pali": "පදුමුත්තරො පුරත්ථිමායං අග්ගිනෙ චෙව රේවතො",
                    "sinh": "උතූම්වු පදුම බුදුන් නැගෙණහිර දිශාවෙන්ද,ගිණි කොණින් රේවත බුදුනද, කාශ්‍යප බුදුන් දකූණිනද් මංගල බුදුන් නිරිතෙන්ද,",
                    "span": 2
                },
                {
                    "pali": "දක්ඛිණෙ කස්සපො බුද්ධො නිරිතෙච සුමංගලො"
                }
            ],
            [
                {
                    "pali": "පච්ඡිමෙ ච සිඛී බුද්ධෝ වායඛ්‍යා මෙධංකරො",
                    "sinh": "සිඛී බුදුන් බටහිරෙන් ද, වයඹින් මේධංකර බුදුන් ද, උතූරින් පියදස්සී බුදුන් ද, ඊසානෙන් දීපංකර බුදුන් ද වැඩසිටිති.",
                    "span": 2
                },
                {
                    "pali": "උත්තරෙ පියදස්සීච ඊසානෙ දීපංකරො"
                }
            ],
            [
                {
                    "pali": "පඨවිං කකුසන්ධොච ආකාසෙ සරණංකරො",
                    "sinh": "පොළොවෙහි කකූසද බුදුන් ද, අහසෙහි සරණංකර බුදුන් ද ආදී වශයෙන් මේ දස දිසාවන්හි සියලු බුදුවරු වැඩසිටිති.",
                    "span": 2
                },
                {
                    "pali": "එවං දසදිසා චෙව සබ්බෙ බුද්ධා පතිට්ඨිතා"
                }
            ],
            [
                {
                    "pali": "අච්චන්තරායා සබ්බේ තෙ සොක රෝග භයා පි ච",
                    "sinh": "ඒ සියලු බුදුවරුන්ගේ ආනුභාවයෙන් සියලු ඉරියව්වල සියලු අනතූරු, ශොක, රෝග, භය ආදිය විනාශවේවා!",
                    "span": 2
                },
                {
                    "pali": "විනස්සන්තු සදා (තුය්හං) සබ්බිරියාපථෙසු ච"
                }
            ],
            [
                {
                    "pali": "යක්ඛාදිදෙවතාභි ච රාජචොරාදි අග්ගිහි",
                    "sinh": "යක්‍ෂ,දේව,රජ, සොර සතූරු ගිනි ආදියෙන් ඇති වන උවදුරුද, අමනුෂ්‍යනගෙන්, තිරිසන් සත්වයින් ගෙන් ඇතිවන උවදුරුද විනාශවේවා!",
                    "span": 3
                },
                {
                    "pali": "අමනුස්සෙහි සබ්බහි තිරච්ඡාන ගතෙහි ච"
                },
                {
                    "pali": "ජාතා උපද්දවා සබ්බේ විනස්සන්තු අසෙසතො"
                }
            ]
        ]
    },
    "61-bojjhanga-parittam": {
        "labels": [
            [
                0,
                2.104579,
                0
            ],
            [
                2.104579,
                18.889883,
                1
            ],
            [
                18.889883,
                35.110543,
                2
            ],
            [
                35.110543,
                51.382535,
                3
            ],
            [
                51.382535,
                68.783813,
                4
            ],
            [
                68.783813,
                85.466454,
                5
            ],
            [
                85.466454,
                102.816401,
                6
            ],
            [
                102.816401,
                121.141641,
                7
            ],
            [
                121.141641,
                138.491588,
                8
            ],
            [
                138.491588,
                155.841535,
                9
            ],
            [
                155.841535,
                173.345475,
                10
            ],
            [
                173.345475,
                198.651759,
                11
            ]
        ],
        "text": [
            [
                {
                    "pali": "බොජ්ඣංග සුත්ත",
                    "sinh": "බොජ්ඣංග සූත්‍රය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සංසාරේ සංසරන්තානං",
                    "sinh": "බොජ්ඣංග දහමින් සියලු දුක් ද සසර දික් කරමින් සිටින මරසෙන් ද නැසේ.",
                    "span": 4
                },
                {
                    "pali": "සබ්බ දුක්ඛ විනාසනේ"
                },
                {
                    "pali": "සත්තධම්මේච බොජ්ඣංගේ"
                },
                {
                    "pali": "මාරසේනාපමද්දනේ"
                }
            ],
            [
                {
                    "pali": "ඛුජ්ඣිත්වා යේ පිමේ සත්ත‌ේ",
                    "sinh": "උතුමො මේ දහම දැනගෙන තිලොව ජයගෙන රොදුක් බිය නොදෙන නිවන් සුවයෙන් සදා සැනසුනාහ,",
                    "span": 4
                },
                {
                    "pali": "තිහවා මුත්තකුත්තමා"
                },
                {
                    "pali": "අජාතිං අජරාබ්‍යාධිං"
                },
                {
                    "pali": "අමතං නිබ්භයං ගතා"
                }
            ],
            [
                {
                    "pali": "එවමාදී ගුණෝපේතං",
                    "sinh": "මෙබඳු ගුණයෙන් යුත් නොයෙක් ගුණ එක්රැස් වුණ බෙහෙතකට සම වන බොජ්ඣංග වන මෙය කියමු.",
                    "span": 4
                },
                {
                    "pali": "අනේක ගුණසංගහං"
                },
                {
                    "pali": "ඔසධං ච ඉමං මන්තං"
                },
                {
                    "pali": "බොජ්ඣංගං ච භණාමහේ"
                }
            ],
            [
                {
                    "pali": "බොජ්ඣංගෝ සති සංඛාතෝ",
                    "sinh": "සිහිය, දම් විමසුම, වීරිය, සිත සැනසුම, මැදහත් කම, සමාධි ද බොජ්ඣංග වන මෙයයි.",
                    "span": 4
                },
                {
                    "pali": "ධම්මානං විචයෝ තථා"
                },
                {
                    "pali": "විරියං පීති පස්සද්ධි"
                },
                {
                    "pali": "බොජ්ඣංගා ච තතෝ පරේ"
                }
            ],
            [
                {
                    "pali": "සමාධුපෙක්ඛා බොජ්ඣංගා",
                    "sinh": "සත් වැදැරුම් වන මේ දහම සම්බුදු හිමි විසින් මැනවින් දැන සැමවිට වඩන ලද්දේය",
                    "span": 4
                },
                {
                    "pali": "සත්තේ තේ සබ්බදස්සිනා,"
                },
                {
                    "pali": "මුනිනා සම්මදක්ඛාතා"
                },
                {
                    "pali": "භාවිතා බහුලීකතා"
                }
            ],
            [
                {
                    "pali": "සංවත්තන්ති අභිඤ්ඤාය",
                    "sinh": "උසස් ඤාණය, නිවන සහ සම්බුදු බව දෙන මේ සැබෑ වදනින් ඔබට සැමදින සුවසෙත වේවා!",
                    "span": 4
                },
                {
                    "pali": "නිබ්බාණාය ච බෝධියා,"
                },
                {
                    "pali": "එතේන සච්ච වජ්ජේන"
                },
                {
                    "pali": "සොත්ථි (තේ) හෝතු සබ්බදා"
                }
            ],
            [
                {
                    "pali": "එකස්මිං සමයේ නාථෝ",
                    "sinh": "එකලහි කස්සප හා මොග්ගල්ලාන හිමිවරු ගිලන් වී සිටිනු නෙතින් දුටු බුදුහිමි බොජ්ඣංග පිරිත දෙසූ සේක,",
                    "span": 4
                },
                {
                    "pali": "මොග්ගල්ලානඤ්ච කස්සපං,"
                },
                {
                    "pali": "ගිලානේ දුක්ඛිතේ දිස්වා"
                },
                {
                    "pali": "බොජ්ඣංගේ සත්ත දේසයි"
                }
            ],
            [
                {
                    "pali": "තේ ච තං අභිනන්දිත්වා",
                    "sinh": "එම දහම ඇසිමෙන් සැණෙකින් ‌රෝග දුරු විය. මේ සැබෑ වදනින් ඔබට සැමදින සුවසෙත වේවා !",
                    "span": 4
                },
                {
                    "pali": "රෝගා මුච්චිංසු තං ඛණේ,"
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන"
                },
                {
                    "pali": "සොත්ථි (තේ) හෝතු සබ්බදා"
                }
            ],
            [
                {
                    "pali": "ඒකදා ධම්මරාජාපි",
                    "sinh": "දිනක් බුදුහිමි ගිලන් බවෙන් පෙළී සිට විට චුන්ද තෙරණුන් ලවා මේ පිරිත කියවීය.",
                    "span": 4
                },
                {
                    "pali": "ගේලඤ්ඤේනා’භිපීළිතෝ,"
                },
                {
                    "pali": "චුන්දත්ථෙරේන තං යේව"
                },
                {
                    "pali": "භාණාපෙත්වාන සාදරං"
                }
            ],
            [
                {
                    "pali": "සම්මෝදිත්වාන ආබාධා",
                    "sinh": "ඉන් සතුටු වීමෙන් මුනිඳුන් සුවපත් වීය. මේ සැබෑ වදනින් ඔබට සැමදින සුවසෙත වේවා!",
                    "span": 4
                },
                {
                    "pali": "තම්හා වුට්ඨාසි ඨානාසෝ,"
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන"
                },
                {
                    "pali": "සොත්ථි (තේ) හෝතු සබ්බදා"
                }
            ],
            [
                {
                    "pali": "පහීණාතේච ආබාධා",
                    "sinh": "මේ උතුම් පිරිතෙන් සියලු ආබාධ සැණෙකින් දුරු වේ. මේ සැබෑ වදනින් ඔබට සැමදින සුවසෙත වේවා!",
                    "span": 6
                },
                {
                    "pali": "තිණ්ණන්නම්පි මහේසිනං"
                },
                {
                    "pali": "මග්ගාහත කිලේසාව"
                },
                {
                    "pali": "පත්තානුප්පත්ති ධම්මතං"
                },
                {
                    "pali": "ඒතේන සච්ච වජ්ජේන"
                },
                {
                    "pali": "සොත්ථි (තේ) හෝතු සබ්බදා"
                }
            ]
        ]
    },
    "62-samantha-pattana": {
        "labels": [
            [
                0,
                3.075811
            ],
            [
                3.075811,
                16.178768
            ],
            [
                16.178768,
                29.200119
            ],
            [
                29.200119,
                42.491548
            ],
            [
                42.492,
                53.725
            ],
            [
                53.725,
                65.427
            ],
            [
                65.427,
                79.19
            ],
            [
                79.31148,
                82.870774
            ],
            [
                82.975,
                100.042
            ],
            [
                100.042,
                119.193
            ],
            [
                119.193,
                134.836
            ],
            [
                135.045,
                150.532
            ],
            [
                150.532,
                165.967259
            ],
            [
                166.106158,
                181.905949
            ],
            [
                182.291382,
                204.770382
            ],
            [
                204.770382,
                220.403203
            ],
            [
                220.631983,
                242.416969
            ],
            [
                242.759083,
                261.654323
            ],
            [
                261.654323,
                277.217901
            ],
            [
                277.217901,
                293.349909
            ],
            [
                293.349909,
                310.876691
            ],
            [
                310.876691,
                332.903592
            ],
            [
                332.903592,
                354.404164
            ],
            [
                354.404164,
                373.062555
            ],
            [
                373.062555,
                391.529042
            ],
            [
                391.529042,
                410.117236
            ],
            [
                410.117236,
                428.827186
            ],
            [
                428.827186,
                446.887767
            ],
            [
                446.887767,
                465.678888
            ],
            [
                465.678888,
                484.104739
            ],
            [
                484.104739,
                503.017617
            ],
            [
                503.017617,
                521.727567
            ],
            [
                521.727567,
                536.216617
            ],
            [
                536.216617,
                551.314451
            ],
            [
                551.314451,
                566.412285
            ],
            [
                566.412285,
                582.443587
            ],
            [
                582.443587,
                599.124259
            ],
            [
                599.124259,
                615.236732
            ],
            [
                615.236732,
                631.146277
            ],
            [
                631.146277,
                654.036542
            ],
            [
                654.036542,
                675.830995
            ],
            [
                675.830995,
                694.013333
            ],
            [
                694.013333,
                712.358013
            ],
            [
                712.358013,
                730.407633
            ],
            [
                730.407633,
                748.921464
            ],
            [
                748.921464,
                767.484403
            ],
            [
                767.484403,
                785.359827
            ],
            [
                785.359827,
                803.82455
            ],
            [
                803.82455,
                822.240165
            ],
            [
                822.240165,
                840.950429
            ],
            [
                840.950429,
                855.663122
            ],
            [
                855.663122,
                870.641155
            ],
            [
                870.641155,
                885.86473
            ],
            [
                885.86473,
                900.94098
            ],
            [
                900.94098,
                916.901179
            ],
            [
                916.901179,
                932.222971
            ],
            [
                932.222971,
                947.544762
            ],
            [
                947.544762,
                970.429233
            ],
            [
                970.429233,
                984.375992
            ],
            [
                984.375992,
                994.050328
            ],
            [
                994.050328,
                1003.871989
            ],
            [
                1003.871989,
                1015.805307
            ],
            [
                1015.805307,
                1025.28321
            ],
            [
                1025.28321,
                1042.667551
            ],
            [
                1042.667551,
                1055.042844
            ],
            [
                1055.042844,
                1062.900173
            ],
            [
                1062.900173,
                1071.886993
            ],
            [
                1071.886993,
                1084.507827
            ],
            [
                1084.507827,
                1093.298214
            ],
            [
                1093.298214,
                1103.168983
            ],
            [
                1103.168983,
                1114.660327
            ],
            [
                1114.660327,
                1123.941797
            ],
            [
                1123.941797,
                1137.986772
            ],
            [
                1137.986772,
                1151.933531
            ],
            [
                1151.933531,
                1166.420481
            ],
            [
                1166.420481,
                1181.300298
            ],
            [
                1181.300298,
                1195.787248
            ],
            [
                1195.787248,
                1220.488726
            ],
            [
                1220.488726,
                1238.265933
            ],
            [
                1238.265933,
                1254.471674
            ],
            [
                1254.471674,
                1269.351491
            ],
            [
                1269.351491,
                1284.182199
            ],
            [
                1284.182199,
                1299.896857
            ],
            [
                1299.896857,
                1315.75884
            ],
            [
                1315.75884,
                1331.571714
            ],
            [
                1331.571714,
                1346.353314
            ],
            [
                1346.353314,
                1361.036698
            ],
            [
                1361.036698,
                1381.023778
            ],
            [
                1381.023778,
                1398.06436
            ],
            [
                1398.06436,
                1412.207552
            ],
            [
                1412.207552,
                1426.252528
            ],
            [
                1426.252528,
                1440.39572
            ],
            [
                1440.39572,
                1454.538912
            ],
            [
                1454.538912,
                1468.436563
            ],
            [
                1468.436563,
                1482.235997
            ],
            [
                1482.235997,
                1496.084539
            ],
            [
                1496.084539,
                1510.473273
            ],
            [
                1510.473273,
                1525.107548
            ],
            [
                1525.107548,
                1545.683928
            ],
            [
                1545.683928,
                1565.91655
            ],
            [
                1565.91655,
                1585.559872
            ],
            [
                1585.559872,
                1605.841603
            ],
            [
                1605.841603,
                1625.435817
            ],
            [
                1625.435817,
                1642.034424
            ],
            [
                1642.034424,
                1660.548255
            ],
            [
                1660.548255,
                1677.539729
            ],
            [
                1677.539729,
                1692.321329
            ],
            [
                1692.321329,
                1707.93777
            ],
            [
                1707.93777,
                1722.223893
            ],
            [
                1722.223893,
                1738.93571
            ],
            [
                1738.93571,
                1757.007567
            ],
            [
                1757.007567,
                1772.182033
            ],
            [
                1772.182033,
                1786.914525
            ],
            [
                1786.914525,
                1801.832851
            ],
            [
                1801.832851,
                1816.516235
            ],
            [
                1816.516235,
                1826.583438
            ],
            [
                1826.583438,
                1843.083828
            ],
            [
                1843.083828,
                1861.352118
            ],
            [
                1861.352118,
                1880.062383
            ],
            [
                1880.062383,
                1894.549333
            ],
            [
                1894.549333,
                1909.183608
            ],
            [
                1909.183608,
                1920.13476
            ],
            [
                1920.13476,
                1932.853811
            ],
            [
                1932.853811,
                1942.233498
            ],
            [
                1942.233498,
                1952.251592
            ],
            [
                1952.251592,
                1963.890261
            ],
            [
                1963.890261,
                1973.46638
            ],
            [
                1973.46638,
                1987.707789
            ],
            [
                1987.707789,
                2002.194739
            ],
            [
                2002.194739,
                2016.632581
            ],
            [
                2016.632581,
                2031.266856
            ],
            [
                2031.266856,
                2045.753807
            ],
            [
                2045.753807,
                2060.093432
            ],
            [
                2060.093432,
                2074.040191
            ],
            [
                2074.040191,
                2088.232491
            ],
            [
                2088.232491,
                2102.326575
            ],
            [
                2102.326575,
                2117.108175
            ],
            [
                2117.108175,
                2137.880989
            ],
            [
                2137.880989,
                2163.761066
            ],
            [
                2163.761066,
                2182.962413
            ],
            [
                2182.962413,
                2202.507519
            ],
            [
                2202.507519,
                2215.079245
            ],
            [
                2215.079245,
                2224.066065
            ],
            [
                2224.066065,
                2233.78951
            ],
            [
                2233.78951,
                2245.37907
            ],
            [
                2245.37907,
                2254.758757
            ],
            [
                2254.758757,
                2268.361757
            ],
            [
                2268.361757,
                2282.357624
            ],
            [
                2282.357624,
                2296.942791
            ],
            [
                2296.942791,
                2311.233308
            ],
            [
                2311.233308,
                2325.720259
            ],
            [
                2325.720259,
                2339.667017
            ],
            [
                2339.667017,
                2353.711993
            ],
            [
                2353.711993,
                2367.70786
            ],
            [
                2367.70786,
                2381.851052
            ],
            [
                2381.851052,
                2396.338002
            ],
            [
                2396.338002,
                2417.258141
            ],
            [
                2417.258141,
                2443.432868
            ],
            [
                2443.432868,
                2447.754399
            ]
        ],
        "text": [
            [
                {
                    "pali": "පට්ඨානඋද්දෙසපාළි",
                    "sinh": "පට්ඨාන මාතෘකා පද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "1. හෙතුපච්චයො",
                    "sinh": "හේතු ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "2. ආරම්මණපච්චයො",
                    "sinh": "ආරම්මණ ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "3. අධිපතිපච්චයො",
                    "sinh": "අධිපති ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "4. අන්තරපච්චයො",
                    "sinh": "අනන්තර ප්‍රත්‍යය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "5. සමනන්තරපච්චයො",
                    "sinh": "සමනන්තර ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "6. සහජාතපච්චයො",
                    "sinh": "සහජාත ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "7. අඤ්ඤමඤ්ඤපච්චයො",
                    "sinh": "අඤඤ්මඤ්ඤ ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "8. නිස්සයපච්චයො",
                    "sinh": "නිස්සය ප්‍රත්‍යය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "9. උපනිස්සයපච්චයො",
                    "sinh": "උපනිස්සය ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "10. පුරෙජාතපච්චයො",
                    "sinh": "පුරේජාත ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "11. පච්ඡාජාතපච්චයො",
                    "sinh": "පච්ඡාජාත ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "12. ආසෙවනපච්චයො",
                    "sinh": "ආසේවන ප්‍රත්‍යය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "13. කම්මපච්චයො",
                    "sinh": "කර්ම ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "14. විපාකපච්චයො",
                    "sinh": "විපාක ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "15. ආහාරපච්චයො",
                    "sinh": "ආහාර ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "16. ඉන්‍ද්‍රියපච්චයො",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "17. ඣානපච්චයො",
                    "sinh": "ඣාන ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "18. මග්ගපච්චයො",
                    "sinh": "මාර්ග ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "19. සම්පයුත්තපච්චයො",
                    "sinh": "සම්ප්‍රයුත්ත ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "20. විප්පයුත්තපච්චයො",
                    "sinh": "විප්පයුත්ත ප්‍රත්‍යය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "21. අත්‍ථිපච්චයො",
                    "sinh": "අත්ථි ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "22. නත්‍ථිපච්චයො",
                    "sinh": "නත්ථි ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "23. විගතපච්චයො",
                    "sinh": "විගත ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "24. අවිගතපච්චයො’ති",
                    "sinh": "අවිගත ප්‍රත්‍යය",
                    "span": 1
                },
                {
                    "pali": "පච්චයුද්දෙසො",
                    "sinh": "පච්චය මාතෘකා පද",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පච්චයනිද්දෙසො",
                    "sinh": "පච්චය විස්තරය",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "1. හෙතුපච්චයො’ති",
                    "sinh": "හේතු ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "හෙතු",
                    "sinh": "හේතූහු",
                    "span": 1
                },
                {
                    "pali": "හෙතුසම්පයුත්තකානං ධම්මානං",
                    "sinh": "හේතුසම්පයුත්ත ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා හටගන්නා වූ රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "හෙතුපච්චයෙන",
                    "sinh": "හේතු ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "2. ආරම්මණපච්චයො’ති",
                    "sinh": "ආරම්මණ ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සබ්බෙ ධම්මා",
                    "sinh": "සියළු ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං යං ධම්මං ආරබ්භ",
                    "sinh": "යම් යම් ධර්මයක් අරමුණු කොට",
                    "span": 1
                },
                {
                    "pali": "යෙ යෙ ධම්මා උප්පජ්ජන්ති චිත්තචෙතසිකා ධම්මා",
                    "sinh": "යම් යම් චිත්ත චෛතසික ධර්ම උපදිත්ද",
                    "span": 1
                },
                {
                    "pali": "තෙ තෙ ධම්මා",
                    "sinh": "ඒ ඒ අරමුණ",
                    "span": 1
                },
                {
                    "pali": "තෙසං තෙසං ධම්මානං",
                    "sinh": "ඒ ඒ ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "ආරම්මණපච්චයෙන",
                    "sinh": "ආරම්මණ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "3. අධිපතිපච්චයො’ති",
                    "sinh": "අධිපති ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "ඡන්‍දාධිපති",
                    "sinh": "ඡන්දාධිපතිය",
                    "span": 1
                },
                {
                    "pali": "ඡන්‍දසම්පයුත්තකානං ධම්මානං",
                    "sinh": "ඡන්දය යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අධිපතිපච්චයෙන",
                    "sinh": "අධිපති ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "විරියාධිපති",
                    "sinh": "විරියාධිපතිය",
                    "span": 1
                },
                {
                    "pali": "විරියසම්පයුත්තකානං ධම්මානං",
                    "sinh": "වීරිය යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අධිපතිපච්චයෙන",
                    "sinh": "අධිපති ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තාධිපති",
                    "sinh": "චිත්තාධිපතිය",
                    "span": 1
                },
                {
                    "pali": "චිත්තසම්පයුත්තකානං ධම්මානං",
                    "sinh": "චිත්තසම්පයුත්ත ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අධිපතිපච්චයෙන",
                    "sinh": "අධිපති ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "වීමංසාධිපති",
                    "sinh": "වීමංසාධිපතිය",
                    "span": 1
                },
                {
                    "pali": "වීමංසසම්පයුත්තකානං ධම්මානං",
                    "sinh": "වීමංසසම්පයුත්ත ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අධිපතිපච්චයෙන",
                    "sinh": "අධිපති ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං යං ධම්මං ගරුං කත්‍වා",
                    "sinh": "යම් යම් ධර්මයක් ගරු කොට",
                    "span": 1
                },
                {
                    "pali": "යෙ යෙ ධම්මා උප්පජ්ජන්ති චිත්තචෙතසිකාධම්මා",
                    "sinh": "යම් යම් චිත්ත චෛතසික ධර්ම උපදිත්ද",
                    "span": 1
                },
                {
                    "pali": "තෙ තෙ ධම්මා",
                    "sinh": "ඒ ඒ අරමුණ",
                    "span": 1
                },
                {
                    "pali": "තෙසං තෙසං ධම්මානං",
                    "sinh": "ඒ ඒ ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අධිපතිපච්චයෙන",
                    "sinh": "අධිපති ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "4. අනන්තරපච්චයො’ති",
                    "sinh": "අනන්තර ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතු",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතවිඤ්ඤාණධාතු",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානවිඤ්ඤාණධාතු",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතු",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායවිඤ්ඤාණධාතු",
                    "sinh": "කායවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙසං යෙසං ධම්මානං අනන්තරා",
                    "sinh": "යම් යම් ධර්මයන්ට අනතුරුව",
                    "span": 1
                },
                {
                    "pali": "යෙ යෙ ධම්මා උප්පජ්ජන්ති චිත්තචෙතසිකා ධම්මා",
                    "sinh": "යම් යම් චිත්ත චෛතසික ධර්ම උපදිත්ද",
                    "span": 1
                },
                {
                    "pali": "තෙ තෙ ධම්මා",
                    "sinh": "ඒ ඒ ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "තෙසං තෙසං ධම්මානං",
                    "sinh": "ඒ ඒ ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "අනන්තරපච්චයෙන",
                    "sinh": "අනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "5. සමනන්තරපච්චයො’ති",
                    "sinh": "සමනන්තර ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතු",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතවිඤ්ඤාණධාතු",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානවිඤ්ඤාණධාතු",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතු",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායවිඤ්ඤාණධාතු",
                    "sinh": "කායවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොධාතු",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකා ච ධම්මා",
                    "sinh": "ඒ හා යෙදුන ධර්මයෝද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවට",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "හා යෙදුන ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යෙසං යෙසං ධම්මානං සමනන්තරා",
                    "sinh": "යම් යම් ධර්මයන්ට අනතුරුව",
                    "span": 1
                },
                {
                    "pali": "යෙ යෙ ධම්මා උප්පජ්ජන්ති චිත්තචෙතසිකා ධම්මා",
                    "sinh": "යම් යම් චිත්ත චෛතසික ධර්ම උපදිත්ද",
                    "span": 1
                },
                {
                    "pali": "තෙ තෙ ධම්මා",
                    "sinh": "ඒ ඒ ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "තෙසං තෙසං ධම්මානං",
                    "sinh": "ඒ ඒ ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරපච්චයෙන",
                    "sinh": "සමනන්තර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "6. සහජාතපච්චයො’ති",
                    "sinh": "සහජාත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී  ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "සහජාතපච්චයෙන",
                    "sinh": "සහජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චත්තාරො මහාභූතා",
                    "sinh": "සතර මහාධාතූහු",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "සහජාතපච්චයෙන",
                    "sinh": "සහජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඔක්කන්තික්ඛණෙ නාමරූපං",
                    "sinh": "ප්‍රතිසන්ධික්ෂණයෙහි නාම-රූප",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "සහජාතපච්චයෙන",
                    "sinh": "සහජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "චිත්තසමුට්ඨානානං රූපානං",
                    "sinh": "චිත්තජ රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "සහජාතපච්චයෙන",
                    "sinh": "සහජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මහාභූතා",
                    "sinh": "මහාභූත සතර",
                    "span": 1
                },
                {
                    "pali": "උපාදායරූපානං",
                    "sinh": "උපාදායරූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "සහජාතපච්චයෙන",
                    "sinh": "සහජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපිනො ධම්මා අරූපීනං ධම්මානං",
                    "sinh": "වත්ථුරූපය අරූපී ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "කිඤ්චි කාලෙ සහජාතපච්චයෙන පච්චයො",
                    "sinh": "ප්‍රතිසන්ධියේදී සහජාත ප්‍රත්‍යයෙන් ප්‍රත්‍යය වේ",
                    "span": 1
                },
                {
                    "pali": "කිඤ්චි කාලෙ න සහජාතපච්චයෙන පච්චයො",
                    "sinh": "ප්‍රවෘත්තිකාලයේදී සහජාත ප්‍රත්‍යයෙන් ප්‍රත්‍යය නොවේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "7. අඤ්ඤමඤ්ඤපච්චයො’ති",
                    "sinh": "අඤ්ඤමඤ්ඤ ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤමඤ්ඤපච්චයෙන",
                    "sinh": "(ඔවුනොවුන්ට) අඤඤ්මඤ්ඤ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චත්තාරො මහාභූතා",
                    "sinh": "සතර මහාධාතූහු",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤමඤ්ඤපච්චයෙන",
                    "sinh": "(ඔවුනොවුන්ට) අඤඤ්මඤ්ඤ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඔක්කන්තික්ඛණෙ නාමරූපං",
                    "sinh": "ප්‍රතිසන්ධික්ෂණයෙහි නාම-රූප",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤමඤ්ඤපච්චයෙන",
                    "sinh": "(ඔවුනොවුන්ට) අඤඤ්මඤ්ඤ ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "8. නිස්සයපච්චයො’ති",
                    "sinh": "නිස්සය ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී  ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චත්තාරො මහාභූතා",
                    "sinh": "සතර මහාධාතූහු",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඔක්කන්තික්ඛණෙ නාමරූපං",
                    "sinh": "ප්‍රතිසන්ධික්ෂණයෙහි නාම-රූප",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "චිත්තසමුට්ඨානානං රූපානං",
                    "sinh": "චිත්තජ රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මහාභූතා",
                    "sinh": "මහාභූත සතර",
                    "span": 1
                },
                {
                    "pali": "උපාදායරූපානං",
                    "sinh": "උපාදායරූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛායතනං",
                    "sinh": "චක්ඛායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතායතනං",
                    "sinh": "සෝතායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානායතනං",
                    "sinh": "ඝානායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හායතනං",
                    "sinh": "ජිව්හායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායායතනං",
                    "sinh": "කායායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං රූපං නිස්සාය",
                    "sinh": "යම් රූපයක් නිශ්‍රයකොට",
                    "span": 1
                },
                {
                    "pali": "මනොධාතු ච",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතු ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "වත්තන්ති",
                    "sinh": "පවතිත්ද",
                    "span": 1
                },
                {
                    "pali": "තං රූපං",
                    "sinh": "ඒ රූපය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා ච",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "නිස්සයපච්චයෙන",
                    "sinh": "නිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "9. උපනිස්සයපච්චයො’ති",
                    "sinh": "උපනිස්සය ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "කෙසඤ්චි",
                    "sinh": "ඇතැම්",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "කෙසඤ්චි",
                    "sinh": "ඇතැම්",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතානං ධම්මානං",
                    "sinh": "අබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අබ්‍යාකතා ධම්මා",
                    "sinh": "අබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "උතුභොජනං’පි",
                    "sinh": "ඍතු භෝජනද",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                },
                {
                    "pali": "පුග්ගලො’පි",
                    "sinh": "පුද්ගලයාද",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                },
                {
                    "pali": "සෙනාසනං’පි",
                    "sinh": "සේනාසනයද",
                    "span": 1
                },
                {
                    "pali": "උපනිස්සයපච්චයෙන",
                    "sinh": "උපනිස්සය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "10. පුරෙජාතපච්චයො’ති",
                    "sinh": "පුරේජාත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චක්ඛායතනං",
                    "sinh": "චක්ඛායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතායතනං",
                    "sinh": "සෝතායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානායතනං",
                    "sinh": "ඝානායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හායතනං",
                    "sinh": "ජිව්හායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායායතනං",
                    "sinh": "කායායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං රූපං නිස්සාය",
                    "sinh": "යම් රූපයක් නිසා",
                    "span": 1
                },
                {
                    "pali": "මනොධාතු ච",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතු ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "වත්තන්ති",
                    "sinh": "පවතිත්ද",
                    "span": 1
                },
                {
                    "pali": "තං රූපං",
                    "sinh": "ඒ රූපය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා ච",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතපච්චයෙන",
                    "sinh": "පුරේජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "කිඤ්චි කාලෙ පුරෙජාතපච්චයෙන පච්චයො",
                    "sinh": "ප්‍රවෘත්ති කාලයෙහි පුරේජාත ප්‍රත්‍යයෙන් ප්‍රත්‍යය වේ",
                    "span": 1
                },
                {
                    "pali": "කිඤ්චි කාලෙ න පුරෙජාතපච්චයෙන පච්චයො",
                    "sinh": "ප්‍රතිසන්ධික්ෂණයෙහිදී පුරේජාත ප්‍රත්‍යයෙන් ප්‍රත්‍යය නොවේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "11. පච්ඡාජාතපච්චයො’ති",
                    "sinh": "පච්ඡාජාත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "පච්ඡාජාතා",
                    "sinh": "පසුව උපන්",
                    "span": 1
                },
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පුරෙජාතස්ස ඉමස්ස කායස්ස",
                    "sinh": "කලින් උපන් රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "පච්ඡාජාතපච්චයෙන",
                    "sinh": "පච්ඡාජාත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "12. ආසෙවනපච්චයො’ති",
                    "sinh": "ආසේවන ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කුසලා ධම්මා",
                    "sinh": "කුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කුසලානං ධම්මානං",
                    "sinh": "කුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "ආසෙවනපච්චයෙන",
                    "sinh": "ආසේවන ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "අකුසලා ධම්මා",
                    "sinh": "අකුසල ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "අකුසලානං ධම්මානං",
                    "sinh": "අකුසල ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "ආසෙවනපච්චයෙන",
                    "sinh": "ආසේවන ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පුරිමා පුරිමා",
                    "sinh": "පූර්ව පූර්ව",
                    "span": 1
                },
                {
                    "pali": "කිරියාඅබ්‍යාකතා ධම්මා",
                    "sinh": "ක්‍රියාඅබ්‍යාකත ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පච්ඡිමානං පච්ඡිමානං",
                    "sinh": "පසු පසු",
                    "span": 1
                },
                {
                    "pali": "කිරියාඅබ්‍යාකතානං ධම්මානං",
                    "sinh": "ක්‍රියාඅබ්‍යාකත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "ආසෙවනපච්චයෙන",
                    "sinh": "ආසේවන ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "13. කම්මපච්චයො’ති",
                    "sinh": "කර්ම ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "කුසලාකුසලං කම්මං",
                    "sinh": "කුසලාකුසල කර්මය",
                    "span": 1
                },
                {
                    "pali": "විපාකානං ඛන්‍ධානං",
                    "sinh": "විපාක ස්කන්ධයන්ට",
                    "span": 1
                },
                {
                    "pali": "කටත්තා ච රූපානං",
                    "sinh": "හා කර්මජ රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "කම්මපච්චයෙන",
                    "sinh": "කර්ම ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චෙතනා",
                    "sinh": "චේතනාව",
                    "span": 1
                },
                {
                    "pali": "සම්පයුත්තකානං ධම්මානං",
                    "sinh": "සම්ප්‍රයුත්ත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "හා ඒ නිසා උපදින රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "කම්මපච්චයෙන",
                    "sinh": "කර්ම ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "14. විපාකපච්චයො’ති",
                    "sinh": "විපාක ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "විපාකා චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී විපාක ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමංඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "විපාකපච්චයෙන",
                    "sinh": "විපාක ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "15. ආහාරපච්චයො’ති",
                    "sinh": "ආහාර ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "කබළිඞ්කාරො ආහාරො",
                    "sinh": "කබලිංකාර ආහාරය",
                    "span": 1
                },
                {
                    "pali": "ඉමස්ස කායස්ස",
                    "sinh": "මේ කයට",
                    "span": 1
                },
                {
                    "pali": "ආහාරපච්චයෙන",
                    "sinh": "ආහාර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අරූපිනො ආහාරා",
                    "sinh": "අරූපී ආහාර",
                    "span": 1
                },
                {
                    "pali": "සම්පයුත්තකානං ධම්මානං",
                    "sinh": "සම්ප්‍රයුත්ත ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "හා ඒ නිසා උපදින රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "ආහාරපච්චයෙන",
                    "sinh": "ආහාර ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "16. ඉන්‍ද්‍රියපච්චයො’ති",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුන්‍ද්‍රියං",
                    "sinh": "චක්ඛුන්ද්‍රිය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතින්‍ද්‍රියං",
                    "sinh": "සෝතින්ද්‍රිය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානින්‍ද්‍රියං",
                    "sinh": "ඝානින්ද්‍රිය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හින්‍ද්‍රියං",
                    "sinh": "ජිව්හින්ද්‍රිය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායින්‍ද්‍රියං",
                    "sinh": "කායින්ද්‍රිය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපජීවිතින්‍ද්‍රියං",
                    "sinh": "රූපජීවිතින්ද්‍රිය",
                    "span": 1
                },
                {
                    "pali": "කටත්තාරූපානං",
                    "sinh": "කර්මජ රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අරූපිනො ඉන්‍ද්‍රියා",
                    "sinh": "අරූපී ඉන්ද්‍රියෝ",
                    "span": 1
                },
                {
                    "pali": "සම්පයුත්තකානං ධම්මානං",
                    "sinh": "සම්ප්‍රයුත්ත ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ටද",
                    "span": 1
                },
                {
                    "pali": "ඉන්‍ද්‍රියපච්චයෙන",
                    "sinh": "ඉන්ද්‍රිය ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "17. ඣානපච්චයො’ති",
                    "sinh": "ඣාන ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "ඣානඞ්ගානි",
                    "sinh": "ඣාන අංගයෝ",
                    "span": 1
                },
                {
                    "pali": "ඣානසම්පයුත්තකානං ධම්මානං",
                    "sinh": "ඣානසම්ප්‍රයුත්ත ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "ඣානපච්චයෙන",
                    "sinh": "ඣාන ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "18. මග්ගපච්චයො’ති",
                    "sinh": "මාර්ග ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "මග්ගඞ්ගානි",
                    "sinh": "මාර්ග අංගයෝ",
                    "span": 1
                },
                {
                    "pali": "මග්ගසම්පයුත්තකානං ධම්මානං",
                    "sinh": "මාර්ගසම්ප්‍රයුත්ත ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "තංසමුට්ඨානානඤ්ච රූපානං",
                    "sinh": "ඒ නිසා උපදින රූපයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "මග්ගපච්චයෙන",
                    "sinh": "මාර්ග ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "19. සම්පයුත්තපච්චයො’ති",
                    "sinh": "සම්ප්‍රයුත්ත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "සම්පයුත්තපච්චයෙන",
                    "sinh": "සම්ප්‍රයුත්ත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "20. විප්පයුත්තපච්චයො’ති",
                    "sinh": "විප්පයුත්ත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "රූපිනො ධම්මා",
                    "sinh": "රූපී ධර්ම",
                    "span": 1
                },
                {
                    "pali": "අරූපීනං ධම්මානං",
                    "sinh": "අරූපී ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "විප්පයුත්තපච්චයෙන",
                    "sinh": "විප්පයුත්ත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "අරූපිනො ධම්මා",
                    "sinh": "අරූපී ධර්ම",
                    "span": 1
                },
                {
                    "pali": "රූපීනං ධම්මානං",
                    "sinh": "රූපී ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "විප්පයුත්තපච්චයෙන",
                    "sinh": "විප්පයුත්ත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "21. අත්‍ථිපච්චයො’ති",
                    "sinh": "අත්ථි ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී  ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චත්තාරො මහාභූතා",
                    "sinh": "සතර මහාධාතූහු",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඔක්කන්තික්ඛණෙ නාමරූපං",
                    "sinh": "ප්‍රතිසන්ධික්ෂණයෙහි නාම-රූප",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "චිත්තසමුට්ඨානානං රූපානං",
                    "sinh": "චිත්තජ රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මහාභූතා",
                    "sinh": "මහාභූත සතර",
                    "span": 1
                },
                {
                    "pali": "උපාදාරූපානං",
                    "sinh": "උපාදායරූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛායතනං",
                    "sinh": "චක්ඛායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතායතනං",
                    "sinh": "සෝතායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානායතනං",
                    "sinh": "ඝානායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හායතනං",
                    "sinh": "ජිව්හායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායායතනං",
                    "sinh": "කායායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං රූපං නිස්සාය",
                    "sinh": "යම් රූපයක් නිසා",
                    "span": 1
                },
                {
                    "pali": "මනොධාතු ච",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතු ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "වත්තන්ති",
                    "sinh": "පවතිත්ද",
                    "span": 1
                },
                {
                    "pali": "තං රූපං",
                    "sinh": "ඒ රූපය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා ච",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අත්‍ථිපච්චයෙන",
                    "sinh": "අත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "22. නත්‍ථිපච්චයො’ති",
                    "sinh": "නත්ථි ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරනිරුද්ධා",
                    "sinh": "සමනන්තර නිරුද්ධ වූ",
                    "span": 1
                },
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පටුප්පන්නානං",
                    "sinh": "වර්තමාන",
                    "span": 1
                },
                {
                    "pali": "චිත්තචෙතසිකානං ධම්මානං",
                    "sinh": "චිත්ත චෛතසික ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "නත්‍ථිපච්චයෙන",
                    "sinh": "නත්ථි ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "23. විගතපච්චයො’ති",
                    "sinh": "විගත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "සමනන්තරවිගතා",
                    "sinh": "සමනන්තර විගත වූ",
                    "span": 1
                },
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "පටුප්පන්නානං",
                    "sinh": "වර්තමාන",
                    "span": 1
                },
                {
                    "pali": "චිත්තචෙතසිකානං ධම්මානං",
                    "sinh": "චිත්ත චෛතසික ධර්මයන්ට",
                    "span": 1
                },
                {
                    "pali": "විගතපච්චයෙන",
                    "sinh": "විගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ.",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "24. අවිගතපච්චයො’ති",
                    "sinh": "අවිගත ප්‍රත්‍යය යනු",
                    "span": 1
                },
                {
                    "pali": "චත්තාරො ඛන්‍ධා අරූපිනො",
                    "sinh": "අරූපී  ස්කන්ධ සතර",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චත්තාරො මහාභූතා",
                    "sinh": "සතර මහාධාතූහු",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඔක්කන්තික්ඛණෙ නාමරූපං",
                    "sinh": "ප්‍රතිසන්ධික්ෂණයෙහි නාම-රූප",
                    "span": 1
                },
                {
                    "pali": "අඤ්ඤමඤ්ඤං",
                    "sinh": "ඔවුනොවුන්ට",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චිත්තචෙතසිකා ධම්මා",
                    "sinh": "චිත්ත චෛතසික ධර්මයෝ",
                    "span": 1
                },
                {
                    "pali": "චිත්තසමුට්ඨානානං රූපානං",
                    "sinh": "චිත්තජ රූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "මහාභූතා",
                    "sinh": "මහාභූත සතර",
                    "span": 1
                },
                {
                    "pali": "උපාදාරූපානං",
                    "sinh": "උපාදායරූපයන්ට",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "චක්ඛායතනං",
                    "sinh": "චක්ඛායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සොතායතනං",
                    "sinh": "සෝතායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඝානායතනං",
                    "sinh": "ඝානායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ජිව්හායතනං",
                    "sinh": "ජිව්හායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "කායායතනං",
                    "sinh": "කායායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "චක්ඛුවිඤ්ඤාණධාතුයා",
                    "sinh": "චක්ඛුවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "සොතවිඤ්ඤාණධාතුයා",
                    "sinh": "සෝතවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "ඝානවිඤ්ඤාණධාතුයා",
                    "sinh": "ඝානවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ජිව්හාවිඤ්ඤාණධාතුයා",
                    "sinh": "ජිව්හාවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "කායවිඤ්ඤාණධාතුයා",
                    "sinh": "කායවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "රූපායතනං",
                    "sinh": "රූපායතනය",
                    "span": 1
                },
                {
                    "pali": "සද්දායතනං",
                    "sinh": "සද්දායතනය",
                    "span": 1
                },
                {
                    "pali": "ගන්‍ධායතනං",
                    "sinh": "ගන්ධායතනය",
                    "span": 1
                },
                {
                    "pali": "රසායතනං",
                    "sinh": "රසායතනය",
                    "span": 1
                },
                {
                    "pali": "ඵොට්ඨබ්බායතනං",
                    "sinh": "ඵොට්ඨබ්බායතනය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ටද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "යං රූපං නිස්සාය",
                    "sinh": "යම් රූපයක් නිසා",
                    "span": 1
                },
                {
                    "pali": "මනොධාතු ච",
                    "sinh": "මනෝධාතුවද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතු ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවද",
                    "span": 1
                },
                {
                    "pali": "වත්තන්ති",
                    "sinh": "පවතිත්ද",
                    "span": 1
                },
                {
                    "pali": "තං රූපං",
                    "sinh": "ඒ රූපය",
                    "span": 1
                },
                {
                    "pali": "මනොධාතුයා ච",
                    "sinh": "මනෝධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "මනොවිඤ්ඤාණධාතුයා ච",
                    "sinh": "මනෝවිඤ්ඤාණධාතුවටද",
                    "span": 1
                },
                {
                    "pali": "තංසම්පයුත්තකානඤ්ච ධම්මානං",
                    "sinh": "ඒ හා යෙදුන ධර්මයන්ට ද",
                    "span": 1
                },
                {
                    "pali": "අවිගතපච්චයෙන",
                    "sinh": "අවිගත ප්‍රත්‍යයෙන්",
                    "span": 1
                },
                {
                    "pali": "පච්චයො",
                    "sinh": "ප්‍රත්‍යය වේ",
                    "span": 1
                }
            ],
            [
                {
                    "pali": "පච්චයනිද්දෙසො නිට්ඨිතො",
                    "sinh": "පච්චය විස්තරය නිමි",
                    "span": 1
                }
            ]
        ]
    }
}